import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    home: 'Home',
                    about: 'About Us',
                    srilanka: 'Sri Lanka',
                    excursions: 'Excursions',
                    tour: 'Book a Tour',
                    things: 'Things Can Do',
                    contact: {
                        navLabel: 'Contact Us',
                        getInTouch: 'Get in Touch',
                        address: 'Address',
                        mobile: 'Mobile',
                        email: 'Email',
                        website: 'Website',
                        sendMessage: 'Send Us a Message',
                        fullName: 'Full Name',
                        fullNamePlaceholder: 'Enter your full name',
                        country: 'Country',
                        countryPlaceholder: 'Enter your country',
                        emailPlaceholder: 'Enter your email',
                        subject: 'Subject',
                        subjectPlaceholder: 'Enter the subject',
                        message: 'Message',
                        messagePlaceholder: 'Enter your message',
                        reset: 'Reset',
                        submit: 'Submit',
                        ourLocation: 'Our Location',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Ashan Tours Sri Lanka Guest Message',
                        manualMessage: 'Please manually send the following message to',
                        errorMessage: 'An error occurred. Please manually send the following message to',
                    },
                    footerSection: {
                        ashanTours: 'Ashan Tours Sri Lanka',
                        getInTouch: 'Contact Us',
                        address: '293/C/3, Maradana Road, Moragalla, Beruwala, Sri Lanka',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: 'Stay Connected',
                        emailPlaceholder: 'Enter your email address',
                        socialMedia: {
                            facebook: 'Facebook',
                            instagram: 'Instagram',
                            youtube: 'YouTube',
                            twitter: 'Twitter',
                        },
                        copyright: '© {{year}} Ashan Tours Sri Lanka. All rights reserved.',
                        designedBy: 'Website Designed and Developed by Redev Solutions',
                        designedByPhone: '+94 76 460 8225',
                    },
                    aboutSection: {
                        travelWithAshan: 'Travel with Ashan Tours Sri Lanka',
                        imageAlt: 'Ashan Tours Image {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lanka is your trusted travel companion, creating unforgettable journeys across Sri Lanka. With our passion for exploration and a team of experienced professionals, we are dedicated to offering personalized itineraries, expert guidance, and exceptional service to make your holiday truly special.',
                        introParagraph2: 'Our tours are thoughtfully crafted to capture the essence of Sri Lanka — from its sun-kissed beaches and scenic hill country to its ancient cultural treasures and vibrant wildlife. At Ashan Tours Sri Lanka, we are committed to providing authentic experiences that let you discover the island’s beauty and soul.',
                        introParagraph3: 'Whether you are looking for adventure, a peaceful retreat, or cultural immersion, Ashan Tours Sri Lanka offers tailor-made packages to suit your desires. Come join us, and let us guide you on a journey filled with wonder, discovery, and lasting memories.',
                        cinnamonLuxuryVilla: 'Cinnamon Luxury Villa',
                        villaImageAlt: 'Cinnamon Luxury Villa Image {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lanka proudly presents our Cinnamon Luxury Villa, offering premium accommodations for travelers seeking comfort and elegance. Our two exclusive apartments are designed to provide a home-away-from-home experience in the heart of Sri Lanka.',
                        villaParagraph2: 'Each apartment is equipped with modern amenities, including air conditioning, attached bathrooms, deluxe double beds, and fully equipped kitchens. Whether you’re traveling solo, as a couple, or with family, our villas offer the perfect blend of luxury and convenience.',
                        villaParagraph3: 'Nestled in serene surroundings, the Cinnamon Luxury Villa allows you to relax and unwind after a day of exploring Sri Lanka’s wonders. Book your stay with Ashan Tours Sri Lanka and experience unparalleled hospitality.',
                    },
                    sriLankaSection: {
                        discoverSriLanka: 'Discover Sri Lanka',
                        mainImageAlt: 'Sri Lanka',
                        pearlOfIndianOcean: 'Pearl of the Indian Ocean',
                        introParagraph1: 'Sri Lanka, fondly known as the "{{pearl}}", is a stunning island paradise celebrated for its breathtaking scenery, deep-rooted traditions, and colorful culture.',
                        introParagraph2: 'With a civilization over 2,500 years old, Sri Lanka is home to majestic ancient capitals, sacred religious landmarks, and UNESCO World Heritage Sites. Its cultural tapestry is enriched by Indian, Arab, Portuguese, Dutch, and British influences, offering a fascinating journey through time.',
                        introParagraph3: 'The island’s landscapes are extraordinary — from golden sandy shores and rolling green tea estates to misty mountain peaks. Its wildlife reserves shelter elephants, leopards, and vibrant birdlife, making it a dream for nature lovers.',
                        introParagraph4: 'For adventure seekers, Sri Lanka offers surfing, trekking, snorkeling, and diving. The cuisine, infused with aromatic spices, fresh seafood, and tropical fruits, is bold and flavorful, telling the story of the island’s rich culinary heritage.',
                        introParagraph5: 'Whether wandering among timeless ruins, soaking in serene beaches, or savoring warm hospitality, Sri Lanka delivers an unforgettable travel experience.',
                        attractivePlaces: 'Attractive Places in Sri Lanka',
                        viewMore: 'View More',
                        placeImageAlt: '{{name}} Image {{index}}',
                        fullImagePreviewAlt: 'Full-size preview',
                        famousThingsTitle: 'Famous Things in Sri Lanka',
                        places: {
                            sigiriyaRockFortress: {
                                name: 'Sigiriya Rock Fortress',
                                description: 'Sigiriya Rock Fortress is a UNESCO World Heritage Site and one of Sri Lanka\'s most iconic landmarks. It features ancient gardens, frescoes, and breathtaking views from the summit of the rock.',
                            },
                            templeOfTheTooth: {
                                name: 'Temple of the Tooth',
                                description: 'The Temple of the Sacred Tooth Relic in Kandy is a sacred Buddhist site that houses a relic of the Buddha\'s tooth. Visitors can witness its historical and religious significance.',
                            },
                            ella: {
                                name: 'Ella',
                                description: 'Ella is a small town in the hill country of Sri Lanka, surrounded by tea plantations and waterfalls. It is famous for the Nine Arch Bridge and Little Adam’s Peak.',
                            },
                            yalaNationalPark: {
                                name: 'Yala National Park',
                                description: 'Yala National Park is renowned for its rich wildlife, including elephants, leopards, and numerous bird species. A safari here is a must for nature enthusiasts.',
                            },
                            galleFort: {
                                name: 'Galle Fort',
                                description: 'Galle Fort, built by the Portuguese and fortified by the Dutch, is a historic site with cobblestone streets, colonial architecture, and vibrant cafes.',
                            },
                            nuwaraEliya: {
                                name: 'Nuwara Eliya',
                                description: 'Known as "Little England," Nuwara Eliya is a hill station famous for its cool climate, tea plantations, and colonial-era bungalows.',
                            },
                            adamsPeak: {
                                name: 'Adam’s Peak',
                                description: 'Adam’s Peak is a sacred mountain with a unique footprint at the summit. It is a popular pilgrimage site for multiple religions.',
                            },
                            hortonPlains: {
                                name: 'Horton Plains',
                                description: 'Horton Plains National Park features rolling hills, waterfalls, and the famous World’s End viewpoint.',
                            },
                            bentotaBeach: {
                                name: 'Bentota Beach',
                                description: 'Bentota Beach is a pristine coastal destination known for its golden sands, water sports, and luxury resorts.',
                            },
                            jaffna: {
                                name: 'Jaffna',
                                description: 'Jaffna, in the northern region of Sri Lanka, is rich in Tamil culture, historical sites, and delicious cuisine.',
                            },
                            anuradhapura: {
                                name: 'Anuradhapura',
                                description: 'Anuradhapura is an ancient city known for its sacred Buddhist sites and historic ruins, including the Sri Maha Bodhi tree.',
                            },
                            polonnaruwa: {
                                name: 'Polonnaruwa',
                                description: 'Polonnaruwa is a UNESCO World Heritage Site with ancient temples, statues, and beautifully preserved ruins.',
                            },
                            unawatunaBeach: {
                                name: 'Unawatuna Beach',
                                description: 'Unawatuna Beach is a vibrant coastal destination offering snorkeling, sunbathing, and lively nightlife.',
                            },
                            colomboCity: {
                                name: 'Colombo City',
                                description: 'Colombo is the bustling capital of Sri Lanka, blending modern skyscrapers with colonial architecture and vibrant markets.',
                            },
                            udawalawaNationalPark: {
                                name: 'Udawalawa National Park',
                                description: 'Udawalawa National Park is a wildlife haven famous for its large herds of elephants, diverse bird species, and stunning landscapes, making it a must-visit destination for nature lovers.',
                            },
                            dambullaCaveTemple: {
                                name: 'Dambulla Cave Temple',
                                description: 'Dambulla Cave Temple is a UNESCO World Heritage Site featuring ancient Buddhist murals and statues within caves.',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: 'Ceylon Tea',
                                description: 'Sri Lanka is globally famous for its Ceylon Tea, known for its distinct flavor and quality. Tea from Nuwara Eliya, Uva, and Dimbula regions is particularly famous.',
                            },
                            spices: {
                                title: 'Spices',
                                description: 'Sri Lanka has been a hub for spices like cinnamon, cardamom, cloves, and nutmeg for centuries. Sri Lankan cinnamon is regarded as the best in the world.',
                            },
                            gems: {
                                title: 'Gems and Jewelry',
                                description: 'Known as the "Island of Gems," Sri Lanka is famous for its sapphires, rubies, and moonstones. The "Blue Belle of Asia," one of the largest blue sapphires, was discovered here.',
                            },
                            ayurveda: {
                                title: 'Ayurveda',
                                description: 'Sri Lanka is well-known for its Ayurvedic medicine and wellness treatments. Popular offerings include massages, herbal therapies, and Ayurveda resorts.',
                            },
                            handicrafts: {
                                title: 'Traditional Handicrafts',
                                description: 'Sri Lanka produces exquisite handicrafts, including masks from Ambalangoda, batik textiles, wooden carvings, and lacquerware.',
                            },
                            elephants: {
                                title: 'Elephants',
                                description: 'Sri Lankan elephants play a significant role in culture and festivals. Elephants adorned in grand costumes feature in processions like the Esala Perahera.',
                            },
                            food: {
                                title: 'Traditional Food',
                                description: 'Sri Lanka is famous for its flavorful cuisine, including rice and curry, hoppers, kottu roti, pol sambol, and wattalappam.',
                            },
                            festivals: {
                                title: 'Festivals',
                                description: 'Sri Lanka celebrates colorful festivals like Esala Perahera, Sinhala and Tamil New Year, and Vesak, with illuminated decorations and processions.',
                            },
                            coconut: {
                                title: 'Coconut Products',
                                description: 'Sri Lanka is famous for coconut-based products like coconut oil, milk, and coir fiber, used for ropes and mats.',
                            },
                            sarees: {
                                title: 'Sri Lankan Sarees',
                                description: 'The Kandyan saree (Osariya) is a traditional attire for women, known for its elegance and unique draping style, worn during ceremonial occasions.',
                            },
                            dances: {
                                title: 'Traditional Dances',
                                description: 'Sri Lanka’s traditional dances include Kandyan dance, devil dances, and low country dances, inspired by nature and folklore.',
                            },
                            stiltFishing: {
                                title: 'Stilt Fishing',
                                description: 'An iconic sight in Sri Lanka, stilt fishing involves fishermen balancing on poles planted in the sea, unique to the southern coastal regions.',
                            },
                            moonstones: {
                                title: 'Moonstones',
                                description: 'Sri Lanka is renowned for its moonstones, considered semi-precious gems. The moonstone mines in Meetiyagoda are particularly famous.',
                            },
                            cricket: {
                                title: 'Sri Lankan Cricket',
                                description: 'Cricket is a passion for Sri Lankans, with the country known for producing world-class players. Sri Lanka won the ICC Cricket World Cup in 1996.',
                            },
                            herbs: {
                                title: 'Ayurveda Herbs and Spices',
                                description: 'The island produces herbal remedies used in Ayurveda, such as gotu kola, cinnamon, and neem.',
                            },
                            masks: {
                                title: 'Masks',
                                description: 'Traditional Sri Lankan masks from Ambalangoda are used in cultural performances, including Yaksha (devil masks) and Kolam masks.',
                            },
                        },
                    },
                    excursionsSection: {
                        title: 'Excursions',
                        excursions: {
                            oneDay: {
                                title: 'One Day Excursions',
                                description: 'Explore stunning destinations in a single day with guided tours and local experiences.',
                                alt: 'One Day Excursion in Sri Lanka',
                            },
                            twoDays: {
                                title: 'Two Days Excursions',
                                description: 'Enjoy short trips with overnight stays to experience even more of Sri Lanka.',
                                alt: 'Two Days Excursion in Sri Lanka',
                            },
                            threeDays: {
                                title: 'Three Days Excursions',
                                description: 'Discover multiple attractions over three days of adventure and relaxation.',
                                alt: 'Three Days Excursion in Sri Lanka',
                            },
                            fourDays: {
                                title: 'Four Days Excursions',
                                description: 'Perfect for an extended journey covering multiple destinations in comfort.',
                                alt: 'Four Days Excursion in Sri Lanka',
                            },
                            twentyDays: {
                                title: '20 Days Excursions',
                                description: 'Embark on an epic journey across Sri Lanka, exploring its cultural, natural, and historical wonders.',
                                alt: '20 Days Excursion in Sri Lanka',
                            },
                        },
                        bentotaExcursions: {
                            title: 'Excursions from Bentota',
                            bentotaToYala: {
                                title: 'Bentota to Yala',
                                description: 'Bentota -> Ella -> Yala',
                            },
                            bentotaToNuwaraEliya: {
                                title: 'Bentota to Nuwara Eliya',
                                description: 'Bentota -> Ella -> Kandy -> Nuwara Eliya',
                            },
                            bentotaToMinneriya: {
                                title: 'Bentota to Minneriya National Park',
                                description: 'Bentota -> Sigiriya -> Anuradhapura -> Polonnaruwa -> Minneriya National Park',
                            },
                            bentotaToHortonPlains: {
                                title: 'Bentota to Horton Plains',
                                description: 'Bentota -> Kandy -> Nuwara Eliya -> Horton Plains',
                            },
                            images: {
                                bentotaToElla1: 'Bentota Beach View 1',
                                bentotaToElla2: 'Bentota Beach View 2',
                            },
                        },
                        airportExcursions: {
                            title: 'Excursions from Airport',
                            airportToColombo: {
                                title: 'Airport to Colombo City Tour',
                                description: 'Airport -> Colombo Fort -> Galle Face -> Gangaramaya Temple',
                                alt1: 'Colombo City Tour Image 1',
                                alt2: 'Colombo City Tour Image 2',
                            },
                            airportToSigiriya: {
                                title: 'Airport to Sigiriya',
                                description: 'Airport -> Dambulla -> Sigiriya Rock Fortress',
                                alt1: 'Sigiriya Excursion Image 1',
                                alt2: 'Sigiriya Excursion Image 2',
                            },
                            airportToKandy: {
                                title: 'Airport to Kandy',
                                description: 'Airport -> Pinnawala Elephant Orphanage -> Kandy Temple of the Tooth',
                                alt1: 'Kandy Excursion Image 1',
                                alt2: 'Kandy Excursion Image 2',
                            },
                            airportToGalle: {
                                title: 'Airport to Galle',
                                description: 'Airport -> Bentota -> Galle Fort -> Unawatuna Beach',
                                alt1: 'Galle Excursion Image 1',
                                alt2: 'Galle Excursion Image 2',
                            },
                        },
                    },
                    thingsToDoSection: {
                        title: 'Things to Do in Sri Lanka',
                        viewMore: 'View More',
                        activities: {
                            ayurveda: {
                                title: 'Ayurveda - Ancient Science of Life',
                                alt: 'Ayurveda Therapy in Sri Lanka',
                            },
                            diving: {
                                title: 'Diving in Sri Lanka',
                                alt: 'Diving Experience in Sri Lanka',
                            },
                            elephantRide: {
                                title: 'Elephant Back Ride',
                                alt: 'Elephant Back Ride in Sri Lanka',
                            },
                            fishing: {
                                title: 'Fishing in Sri Lanka',
                                alt: 'Fishing Activity in Sri Lanka',
                            },
                            ballooning: {
                                title: 'Ballooning in Sri Lanka',
                                alt: 'Hot Air Ballooning in Sri Lanka',
                            },
                            jeepSafari: {
                                title: 'Jeep Safari',
                                alt: 'Jeep Safari in Sri Lanka',
                            },
                            whiteWaterRafting: {
                                title: 'White Water Rafting',
                                alt: 'White Water Rafting in Sri Lanka',
                            },
                            riverSafari: {
                                title: 'River Safari',
                                alt: 'River Safari in Sri Lanka',
                            },
                            snorkeling: {
                                title: 'Snorkeling in Sri Lanka',
                                alt: 'Snorkeling Experience in Sri Lanka',
                            },
                            teaTasting: {
                                title: 'Tea Tasting Tour',
                                alt: 'Tea Tasting Tour in Sri Lanka',
                            },
                            templeVisit: {
                                title: 'Temple Visit',
                                alt: 'Temple Visit in Sri Lanka',
                            },
                            wildlifeSafari: {
                                title: 'Wildlife Safari',
                                alt: 'Wildlife Safari in Sri Lanka',
                            },
                        },
                    },
                    homeHeroSection: {
                        title: 'Travel with Ashan Sri Lanka',
                        subtitle: 'Explore the Enchanting Beauty of Sri Lanka with Unforgettable Adventures',
                        bookButton: 'Book Now',
                        videoFallback: 'Your browser does not support the video tag.',
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: 'Why Choose Ashan Tours Sri Lanka',
                            specialist: {
                                title: 'Travel Expertise',
                                description: 'Our team at Ashan Tours Sri Lanka consists of seasoned travel specialists who craft bespoke journeys tailored to your preferences.'
                            },
                            experience: {
                                title: 'Memorable Experiences',
                                description: 'We create unforgettable moments by showcasing Sri Lanka’s rich culture, history, and natural beauty with passion and care.'
                            },
                            priceMatch: {
                                title: 'Competitive Pricing',
                                description: 'Ashan Tours Sri Lanka guarantees the best value for your travel, ensuring quality experiences at affordable rates.'
                            },
                            support: {
                                title: 'Dedicated Support',
                                description: 'Our 24/7 customer support team is here to assist you at every step, ensuring a seamless travel experience.'
                            }
                        },
                        welcome: {
                            title: 'Welcome to Ashan Tours Sri Lanka',
                            imageAlt: 'Ashan Tours Sri Lanka Welcome Image',
                            description1: 'Embark on a remarkable journey with Ashan Tours Sri Lanka, your premier guide to exploring the wonders of this island paradise.',
                            description2: 'Discover the vibrant culture, breathtaking landscapes, and hidden gems of Sri Lanka with our expertly curated tours.',
                            description3: 'From pristine beaches to ancient ruins, our itineraries are designed to immerse you in the heart of Sri Lanka’s beauty.',
                            description4: 'Our dedicated team ensures personalized service, making your travel experience seamless and unforgettable.',
                            description5: 'Join Ashan Tours Sri Lanka and let us guide you through an adventure filled with discovery and joy.'
                        },
                        cinnamonLuxuryVilla: {
                            title: 'Cinnamon Luxury Villa',
                            imageAlt: 'Cinnamon Luxury Villa Image',
                            description1: 'Experience unparalleled comfort at Ashan Tours Sri Lanka’s Cinnamon Luxury Villa, offering premium accommodations in serene surroundings.',
                            description2: 'Our exclusive villas feature modern amenities like air conditioning, deluxe beds, and fully equipped kitchens, perfect for a relaxing stay.',
                            readMore: 'Read More'
                        },
                        tourPackages: {
                            title: 'Our Tour Packages',
                            ella: {
                                title: 'Ella Adventure',
                                subtitle: '3 Days / 2 Nights',
                                description: 'Explore the scenic beauty of Ella with Ashan Tours Sri Lanka, including visits to Nine Arch Bridge and Little Adam’s Peak.',
                                alt: 'Ella Tour Image'
                            },
                            ellaNuwaraKandy: {
                                title: 'Ella, Nuwara Eliya & Kandy',
                                subtitle: '5 Days / 4 Nights',
                                description: 'A cultural journey through Ella, Nuwara Eliya, and Kandy, featuring tea plantations and historic temples.',
                                alt: 'Ella, Nuwara Eliya & Kandy Tour Image'
                            },
                            kandyNuwaraEllaYala: {
                                title: 'Kandy, Nuwara Eliya, Ella & Yala',
                                subtitle: '7 Days / 6 Nights',
                                description: 'A comprehensive tour covering Kandy’s heritage, Nuwara Eliya’s tea estates, Ella’s landscapes, and Yala’s wildlife.',
                                alt: 'Kandy, Nuwara Eliya, Ella & Yala Tour Image'
                            },
                            viewMore: 'View More Tours'
                        },
                        popularExcursions: {
                            title: 'Popular Excursions',
                            oneDay: {
                                title: 'One Day Excursion',
                                alt: 'One Day Excursion Image'
                            },
                            twoDays: {
                                title: 'Two Day Excursion',
                                alt: 'Two Day Excursion Image'
                            },
                            threeDays: {
                                title: 'Three Day Excursion',
                                alt: 'Three Day Excursion Image'
                            },
                            fourDays: {
                                title: 'Four Day Excursion',
                                alt: 'Four Day Excursion Image'
                            },
                            viewMore: 'View More Excursions'
                        },
                        contactUs: {
                            title: 'Contact Ashan Tours Sri Lanka',
                            description: 'Ready to explore Sri Lanka? Reach out to Ashan Tours Sri Lanka to plan your dream vacation today!',
                            button: 'Get in Touch'
                        },
                        gallery: {
                            title: 'Our Gallery',
                            modalAlt: 'Gallery Image',
                            filters: {
                                all: 'All',
                                tours: 'Tours',
                                accommodation: 'Accommodation',
                                transportation: 'Transportation',
                                wildlife: 'Wildlife'
                            },
                            tours: {
                                sigiriya2: 'Sigiriya Image 2',
                                sigiriya3: 'Sigiriya Image 3',
                                kandy2: 'Kandy Image 2',
                                kandy3: 'Kandy Image 3',
                                galle2: 'Galle Image 2',
                                galle3: 'Galle Image 3',
                                ella2: 'Ella Image 2',
                                ella3: 'Ella Image 3',
                                colomboCity: 'Colombo City Image'
                            },
                            accommodation: {
                                nuwaraEliya1: 'Nuwara Eliya Accommodation Image 1',
                                nuwaraEliya2: 'Nuwara Eliya Accommodation Image 2',
                                nuwaraEliya3: 'Nuwara Eliya Accommodation Image 3',
                                nuwaraEliya4: 'Nuwara Eliya Accommodation Image 4'
                            },
                            transportation: {
                                bentotaRiverSafari1: 'Bentota River Safari Image 1',
                                bentotaRiverSafari2: 'Bentota River Safari Image 2'
                            },
                            wildlife: {
                                yalaSafari1: 'Yala Safari Image 1',
                                yalaSafari2: 'Yala Safari Image 2',
                                minneriya1: 'Minneriya Image 1',
                                minneriya2: 'Minneriya Image 2',
                                udawalawaSafari1: 'Udawalawa Safari Image 1',
                                udawalawaSafari2: 'Udawalawa Safari Image 2'
                            },
                        },
                    },
                    tourPackages: {
                        title: "Tour Packages",
                        readMore: "Read More",
                        book: "Book",
                        destinationsTitle: "Destinations",
                        destinationImageAlt: "Destination Image {{index}}",
                        clickToEnlarge: "Click to enlarge",
                        enlargedDestinationAlt: "Enlarged Destination Image",
                        bookNow: "Book Now",
                        importantNotices: "Important Notices",
                        notices: {
                            transport: "We use high-comfort transport systems for all our tours.",
                            children: "Children aged 5 years or below travel free of charge.",
                            hygiene: "All our tours are conducted with a focus on hygiene and safety.",
                            tickets: "Tour packages include destination tickets unless specified otherwise.",
                            meals: "One-day tours do not include meals unless explicitly mentioned.",
                        },
                        luxuryTransport: "Join with our Luxury Transport System",
                        luxuryTransportAlt1: "Luxury Transport Vehicle 1",
                        luxuryTransportAlt2: "Luxury Transport Vehicle 2",
                        getInTouch: "Get in Touch to Know Our Packages",
                        getInTouchDescription: "Contact us today to explore the best travel deals tailored for you.",
                        contactUs: "Contact Us",
                        bookingMessage: "Ashan Tours Booking Request\nPackage: {{title}}\nDuration: {{duration}}\nLocation: {{location}}",
                        manualBookingMessage: "Please manually send the following message to {{number}}:\n\n{{message}}",
                        errorBookingMessage: "An error occurred. Please manually send the following message to {{number}}:\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "Ella",
                                duration: "1 day",
                                location: "Ella - Sri Lanka",
                                description:
                                    "Explore the stunning natural beauty of Ella, with its lush tea plantations, breathtaking views, and iconic Nine Arch Bridge.",
                            },
                            galleFort: {
                                title: "Galle Fort",
                                duration: "1 day",
                                location: "Galle - Sri Lanka",
                                description:
                                    "Step back in time with a visit to the historic Galle Fort, a UNESCO World Heritage Site filled with colonial charm and coastal beauty.",
                            },
                            yalaSafari: {
                                title: "Yala Safari",
                                duration: "1 day",
                                location: "Yala - Sri Lanka",
                                description:
                                    "Embark on an adventurous safari in Yala National Park, home to leopards, elephants, and an array of exotic wildlife.",
                            },
                            kandy: {
                                title: "Kandy",
                                duration: "1 day",
                                location: "Kandy - Sri Lanka",
                                description:
                                    "Discover the cultural heart of Sri Lanka with a visit to Kandy, including the sacred Temple of the Tooth Relic.",
                            },
                            sigiriya: {
                                title: "Sigiriya",
                                duration: "1 day",
                                location: "Sigiriya - Sri Lanka",
                                description:
                                    "Climb the ancient Sigiriya Rock Fortress and marvel at its stunning frescoes and breathtaking panoramic views.",
                            },
                            udawalawe: {
                                title: "Udawalawe",
                                duration: "1 day",
                                location: "Udawalawe - Sri Lanka",
                                description:
                                    "Enjoy a thrilling safari in Udawalawe National Park, renowned for its large elephant population and scenic landscapes.",
                            },
                            colomboCityEscape: {
                                title: "Colombo City Escape",
                                duration: "1 day",
                                location: "Colombo - Sri Lanka",
                                description:
                                    "Explore the vibrant city of Colombo, with its bustling markets, cultural landmarks, and modern attractions.",
                            },
                            mirissaWhaleWatching: {
                                title: "Mirissa Whale Watching",
                                duration: "1 day",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Set sail on an unforgettable whale-watching adventure off the coast of Mirissa, where majestic blue whales await.",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "Mirissa Whale Watching with High Comfort Boat",
                                duration: "1 day",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Set sail on an unforgettable whale-watching adventure off the coast of Mirissa, where majestic blue whales await.",
                            },
                            bentotaRiverSafari: {
                                title: "Bentota River Safari",
                                duration: "1 day",
                                location: "Bentota - Sri Lanka",
                                description:
                                    "Cruise along the tranquil Bentota River, surrounded by lush mangroves and exotic wildlife, for a serene escape.",
                            },
                            ellaYala: {
                                title: "Ella & Yala",
                                duration: "1 day",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Experience the perfect combination of Ella’s scenic beauty and Yala’s thrilling wildlife safari in one day.",
                            },
                            ellaGalle: {
                                title: "Ella & Galle",
                                duration: "1 day",
                                location: "Ella & Galle - Sri Lanka",
                                description:
                                    "Discover the breathtaking landscapes of Ella and the colonial charm of Galle in a day filled with wonder.",
                            },
                            yalaGalle: {
                                title: "Yala & Galle",
                                duration: "1 day",
                                location: "Yala & Galle - Sri Lanka",
                                description:
                                    "Combine the excitement of a Yala safari with a visit to the picturesque Galle Fort for a truly diverse experience.",
                            },
                            ellaYalaTwoDays: {
                                title: "Ella & Yala",
                                duration: "2 days",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Spend two days exploring Ella’s scenic highlands and the wildlife-rich landscapes of Yala National Park.",
                            },
                            kandyTwoDays: {
                                title: "Kandy",
                                duration: "2 days",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Spend two days exploring Ella’s scenic highlands and the wildlife-rich landscapes of Yala National Park.",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "Ella/Nuwara Eliya/Kandy",
                                duration: "2 days",
                                location: "Ella/Nuwara Eliya/Kandy - Sri Lanka",
                                description:
                                    "Visit the tea plantations of Nuwara Eliya, Ella’s lush greenery, and the cultural gems of Kandy in this two-day tour.",
                            },
                            kandySigiriya: {
                                title: "Kandy & Sigiriya",
                                duration: "2 days",
                                location: "Kandy & Sigiriya - Sri Lanka",
                                description:
                                    "Enjoy a cultural journey to Kandy and climb the iconic Sigiriya Rock Fortress in this two-day adventure.",
                            },
                            ellaNuwaraEliya: {
                                title: "Ella & Nuwara Eliya",
                                duration: "2 days",
                                location: "Ella & Nuwara Eliya - Sri Lanka",
                                description:
                                    "Immerse yourself in Ella’s natural beauty and the cool, serene atmosphere of Nuwara Eliya over two days.",
                            },
                            sigiriKandyElla: {
                                title: "Sigiri/Kandy/Ella",
                                duration: "3 days",
                                location: "Sigiri/Kandy/Ella - Sri Lanka",
                                description:
                                    "Explore Sigiriya, the cultural landmarks of Kandy, and the scenic landscapes of Ella over three unforgettable days.",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "Kandy/Nuwara Eliya/Ella/Yala",
                                duration: "3 days",
                                location: "Kandy/Nuwara Eliya/Ella/Yala - Sri Lanka",
                                description:
                                    "Discover Sri Lanka’s diverse highlights, from Kandy’s culture to Yala’s wildlife, in a three-day immersive tour.",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "Sigiriya/Anuradhapura/Polonnaruwa/Minneriya National Park Safari",
                                duration: "3 days",
                                location: "Sigiriya/Anuradhapura/Polonnaruwa/Minneriya National Park - Sri Lanka",
                                description:
                                    "Visit the ancient cities of Sigiriya, Anuradhapura, and Polonnaruwa, and enjoy a safari in Minneriya National Park.",
                            },
                            twentyDayTour: {
                                title: "Up to 20 Days Tour Package",
                                duration: "20 days",
                                location: "Sri Lanka",
                                description:
                                    "Embark on an unforgettable 20-day journey across Sri Lanka, exploring its cultural, natural, and historical wonders from Negombo to Bentota.",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "Ravana Waterfall",
                            nineArchBridge: "Nine Arch Bridge",
                            teaPlantation: "Tea Plantation",
                            trainRide: "Train Ride",
                            littleAdamsPeak: "Little Adam’s Peak",
                            udawalaweElephant: "Udawalawe Elephant Milk Feeding Watching",
                            ayurvedicHerbalGarden: "Ayurvedic Herbal Garden",
                            templeKandeViharaya: "Temple Kande Viharaya",
                            turtleHatchery: "Turtle Hatchery",
                            boatSafari: "Boat Safari",
                            moonstoneMine: "Moonstone Mine",
                            hikkaduwaBeach: "Hikkaduwa Beach - Swimming with Turtles",
                            dutchFortGalle: "Dutch Fort Galle",
                            yala: "Yala",
                            yalaSafariJeep: "Yala Safari with Jeep",
                            kandy: "Kandy",
                            royalBotanicalGarden: "Royal Botanical Garden",
                            teaFactoryPlantation: "Tea Factory and Plantation",
                            elephantFeeding: "Elephant Feeding, Bathing, and Riding",
                            ambuluwawaTowerOrTemple: "Ambuluwawa Tower or Temple of the Tooth Relic",
                            jewelleryGemFactory: "Jewellry & Gem Factory",
                            silkFactory: "Silk Factory",
                            sigiriya: "Sigiriya",
                            sigiriyaLionRock: "Sigiriya Lion Rock",
                            dambullaGoldenTemple: "Dambulla Golden Temple",
                            villageTour: "Village Tour with Sri Lankan Traditional Food",
                            pidurangalaRock: "Pidurangala Rock",
                            udawalawe: "Udawalawe",
                            udawalaweNationalPark: "Udawalawe National Park",
                            jeepSafari: "Jeep Safari",
                            elephantMilkFeeding: "Elephant Milk Feeding",
                            lotusTower: "Lotus Tower",
                            redMosque: "Red Mosque",
                            shopping: "Shopping",
                            blueWhales: "Blue Whales",
                            mirissa: "Mirissa",
                            stiltFishing: "Stilt Fishing",
                            bentotaRiver: "Bentota River",
                            bentota: "Bentota",
                            safariYalaNationalPark: "Safari Yala National Park by Jeep",
                            gadoladeniyaTemple: "Gadoladeniya Temple",
                            templeOfTheToothRelic: "Temple of the Tooth Relic",
                            traditionalKandyanDance: "Traditional Kandyan Dance",
                            luxuryHotelStay: "Luxury Hotel Stay with breakfast and dinner",
                            teaFactory: "Tea Factory",
                            nuwaraEliyaTown: "Nuwara Eliya Town",
                            ambuluwawaTower: "Ambuluwawa Tower",
                            hinduTemple: "Hindu Temple",
                            gregoryLake: "Gregory Lake",
                            postOffice: "Post Office",
                            hortanPlains: "Hortan Plains",
                            sitaAmmanHinduKovil: "Sita Amman Hindu Kovil",
                            botanicalGarden: "Botanical Garden",
                            rambodaWaterfall: "Ramboda Waterfall",
                            sigiriyaRockFortress: "Sigiriya Rock Fortress",
                            anuradhapura: "Anuradhapura",
                            polonnaruwa: "Polonnaruwa",
                            minneriyaNationalPark: "Minneriya National Park",
                            elephants: "Elephants",
                            day1: "Day 1: Airport – Negombo: Transfer to Negombo & early check-in, Boat trip through the Muthurajawela Marsh, Relaxation – Swimming – Lounging – Hammock – Wellness – Sunbathing – Sports – Water sports, Overnight stay and breakfast in Negombo",
                            day2: "Day 2: Negombo – Anuradhapura: Sacred City of Anuradhapura (UNESCO World Heritage Site), Sri Maha Bodhi Tree, Walk around picturesque reservoirs, Overnight stay and breakfast in Anuradhapura",
                            day3: "Day 3: Anuradhapura – Minneriya – Habarana: Aukana Buddha Statue, Village safari including catamaran and tuk-tuk ride with lunch, Jeep Safari in Minneriya National Park, Overnight stay and breakfast in Habarana",
                            day4: "Day 4: Habarana – Sigiriya – Ritigala – Trincomalee: Sigiriya Rock Fortress (UNESCO World Heritage Site), Ritigala Forest Monastery, Overnight stay and breakfast in Trincomalee",
                            day5: "Day 5: Trincomalee: Relaxation – Swimming – Lounging – Hammock – Wellness – Sunbathing – Sports – Water sports, Overnight stay and breakfast in Trincomalee",
                            day6: "Day 6: Trincomalee: Trincomalee city tour, Steffi Bäuml's birthday, Relaxation – Swimming – Lounging – Hammock – Wellness – Sunbathing – Sports – Water sports, Surprise cooking class for two women, Overnight stay and breakfast in Trincomalee",
                            day7: "Day 7: Trincomalee: Snorkeling trip to Pigeon Island, Relaxation – Swimming – Lounging – Hammock – Wellness – Sunbathing – Sports – Water sports, Overnight stay and breakfast in Trincomalee",
                            day8: "Day 8: Trincomalee: Relaxation – Swimming – Lounging – Hammock – Wellness – Sunbathing – Sports – Water sports, Overnight stay and breakfast in Trincomalee",
                            day9: "Day 9: Trincomalee – Dambulla – Matale – Peradeniya – Kandy: Dambulla Cave Temple (UNESCO World Heritage Site), Spice Garden in Matale, Royal Botanic Gardens Peradeniya with picnic, Stroll through Kandy Old Town, Overnight stay and breakfast in Kandy",
                            day10: "Day 10: Kandy: Temple of the Tooth in Kandy (UNESCO World Heritage Site), Evening Kandyan dance performance, Overnight stay and breakfast in Kandy",
                            day11: "Day 11: Kandy – Nuwara Eliya – Ella: Tea plantations and tea picking, Visit to a tea factory, Ramboda Waterfalls, Nuwara Eliya – the city above the clouds, Walk through Ella, Overnight stay and breakfast in Ella",
                            day12: "Day 12: Ella – Badulla: Train ride from Ella to Badulla (2nd class), Hikes in the surroundings of Ella, Optional: Zip lining, Overnight stay and breakfast in Ella",
                            day13: "Day 13: Ella – Yala: Ravana Waterfalls, Ella Gap Valley, Jeep Safari in Yala National Park, Overnight stay and breakfast in Tissamaharama",
                            day14: "Day 14: Yala – Udawalawe – Sinharaja: Visit to the Elephant Transit Home during feeding time, Drive to Sinharaja Forest Reserve (UNESCO World Heritage Site), Overnight stay and breakfast in Sinharaja",
                            day15: "Day 15: Sinharaja: Guided hike through the Sinharaja Forest Reserve (UNESCO Natural World Heritage Site), Overnight stay and breakfast in Sinharaja",
                            day16: "Day 16: Sinharaja – Galle: Old town of Galle, Galle Fort (UNESCO World Heritage Site), Overnight stay and breakfast in Galle",
                            day17: "Day 17: Galle – Mirissa – Bentota: Offshore safari from Mirissa, Turtle Conservation Project, Overnight stay and breakfast in Bentota",
                            day18_19: "Day 18–19: Bentota: Relaxation – Swimming – Lounging – Hammock – Wellness – Sunbathing – Sports – Water sports, Overnight stay and breakfast in Bentota",
                            day20: "Day 20: Bentota – Airport: Transfer to the airport",
                        },
                    },
                    ayurvedaPage: {
                        title: "Ayurveda - The Ancient Science of Life",
                        mainDescription: "The word 'Ayurveda' has existed for more than three thousand years. In Sanskrit, the word means 'science of life.' The technique is based on the Ayurvedic healing view of disease rather than its consequences, which usually fights European medicine. It postulates the following principles:",
                        principles: {
                            energyBalance: "The body should be free of energy and maintain balance for normal metabolic and cardiac activity.",
                            muscleHormonal: "The body should have normal muscle contraction with regular hormonal activity.",
                            immuneSystem: "The body needs a healthy immune system to function properly."
                        },
                        trainingDescription: "According to recent data, in Sri Lanka, there are more than 6,000 graduates trained in Ayurveda. They undergo seven years of study and two years of practice in public hospitals. Ayurveda programs include:",
                        programs: {
                            stressRelief: "Removing stress, fatigue, and anxiety",
                            oxygenSaturation: "Oxygen saturation",
                            muscularToxins: "Stimulation of muscular systems and elimination of toxins",
                            nervousSystem: "Restoring the balance of the nervous system",
                            bloodFlow: "Restoring blood flow to internal organs",
                            endorphins: "Producing endorphins"
                        },
                        images: {
                            mainAlt: "Ayurveda",
                            faceTreatmentAlt: "Ayurveda Face Treatment",
                            massageTreatmentAlt: "Ayurveda Massage Treatment"
                        },
                        treatmentDescription: "Standard treatments include body massages and scalp massages using special oils, herbal sauna treatments, and baths infused with herbs. The most popular technique is the 'Shirodhara procedure,' where warm herbal oil is rhythmically dripped on the forehead. This helps restore balance to the nervous system and achieve relaxation.",
                        tipsTitle: "Tips for Ayurvedic Treatment",
                        tips: {
                            relaxMind: "Forget about problems. Relax and clear your mind for the best results.",
                            chooseLocation: "Choose the correct location. Select a setting that aligns with your comfort and preferences for optimal healing.",
                            selectProgram: "Select the correct program. Discuss your concerns with the doctor and try different therapies to find what suits you best.",
                            warmBath: "Take a warm bath before treatment to relax your muscles and prepare your body.",
                            lightMeal: "Eat a light meal before the procedure. Avoid heavy meals to allow proper blood flow during the massage.",
                            postRelaxation: "Relaxation after procedures is essential. Proper relaxation enhances the effectiveness of Ayurvedic treatments."
                        },
                    },
                    ballooningPage: {
                        title: "Ballooning in Sri Lanka",
                        mainDescription: "Hot air ballooning in Sri Lanka offers an unforgettable experience of floating gently above the stunning landscapes of the island. Starting at sunrise, balloon rides provide breathtaking aerial views of rolling hills, lush forests, ancient ruins, and serene villages.",
                        dambullaDescription: "The most popular ballooning destination in Sri Lanka is Dambulla, located in the heart of the cultural triangle. Balloon rides here often take you over the iconic Sigiriya Rock Fortress, offering a perspective like no other. Flights typically last 60-90 minutes, giving you ample time to soak in the beauty of Sri Lanka from above.",
                        highlightsTitle: "Why Try Hot Air Ballooning in Sri Lanka?",
                        highlightsDescription: "Hot air ballooning combines adventure with tranquility, allowing you to experience Sri Lanka’s beauty in a unique way. Some of the highlights of ballooning include:",
                        highlights: {
                            panoramicViews: "Uninterrupted panoramic views of the island’s stunning landscapes.",
                            landmarks: "Flying over iconic landmarks like Sigiriya Rock and nearby lakes.",
                            peacefulRide: "A serene and peaceful ride above lush greenery and charming villages.",
                            sunrise: "Witnessing a spectacular sunrise from the sky.",
                            photography: "Perfect for photography enthusiasts looking to capture scenic beauty from above."
                        },
                        images: {
                            mainAlt: "Hot Air Ballooning in Sri Lanka",
                            sunriseAlt: "Hot Air Ballooning Sunrise",
                            sunriseCaption: "Enjoy breathtaking views of the sunrise while floating gently in a hot air balloon.",
                            landscapeAlt: "Hot Air Ballooning Landscape",
                            landscapeCaption: "Witness stunning landscapes of Sri Lanka from above, including rolling hills and lush forests."
                        },
                        tipsTitle: "Tips for a Memorable Balloon Ride",
                        tips: {
                            bookEarly: "Book your ride early, as ballooning is weather-dependent and slots fill up quickly.",
                            clothing: "Wear comfortable clothing and carry a light jacket, as early mornings can be cool.",
                            camera: "Carry a camera or smartphone to capture the stunning views.",
                            safety: "Listen carefully to the safety instructions provided by your pilot.",
                            arriveEarly: "Arrive on time to watch the preparation and inflation of the balloon, which is a fascinating process."
                        },
                    },
                    divingPage: {
                        title: "Diving in Sri Lanka",
                        mainDescription: "A wide coral reef surrounds the coast of Sri Lanka at depths of 2 to 40 meters. The warm waters of the Indian Ocean, between 27°C and 30°C, and the high transparency of the water, from 15 to 35 meters, provide excellent conditions for diving and snorkeling. While diving in Sri Lanka, you can explore endless untouched coral reefs, old wrecks, and mesmerizing underwater caves.",
                        northeastDescription: "The northeast of the island offers a variety of more than 130 species of colorful corals, which are home to marine life such as sea turtles, clownfish, lionfish, and seahorses. Visit shipwrecks near underwater rocks and reefs for an unforgettable experience. Floating in the clear waters, you'll find yourself immersed in the fascinating past of Ceylon.",
                        facilitiesTitle: "Facilities and Best Dive Spots",
                        facilitiesDescription: "Island dive centers are equipped with the latest diving equipment from renowned manufacturers. Certified instructors with PADI and CMAS qualifications ensure safe and enjoyable dives. Dive centers are located along the southwest coast of the island, operating between mid-October and the end of April. The northeast coast, including Nilaveli and Trincomalee, is ideal for diving from March to October.",
                        popularSpots: "The coral reefs near Kalpitiya in the west and the shipwreck diving sites in Hikkaduwa are among the most popular attractions for divers.",
                        images: {
                            mainAlt: "Diving in Sri Lanka",
                            coralReefAlt: "Coral Reef Diving",
                            coralReefCaption: "Explore vibrant coral reefs that are home to diverse marine life.",
                            shipwreckAlt: "Shipwreck Diving",
                            shipwreckCaption: "Discover historic shipwrecks that offer a glimpse into Sri Lanka's maritime past."
                        },
                        tipsTitle: "Tips for Divers",
                        tips: {
                            season: "Choose the best season for diving based on the location: southwest coast (October to April) or northeast coast (March to October).",
                            certifiedCenter: "Ensure your dive center is certified and equipped with modern gear for a safe experience.",
                            instructorAdvice: "Listen to your instructor's advice, especially if you are a beginner.",
                            respectMarineLife: "Respect marine life by not touching corals or disturbing the underwater environment.",
                            camera: "Carry a waterproof camera to capture the mesmerizing beauty of Sri Lanka's underwater world."
                        },
                    },
                    elephantRidePage: {
                        title: "Elephant Back Ride",
                        mainDescription: "Elephant trekking is a fascinating, exciting activity and a unique experience in Sri Lanka. If you are staying near the cultural triangle in areas like Habarana, Sigiriya, or Dambulla, you can participate in an elephant safari. These rides start at around $30 for an hour of unforgettable adventure.",
                        rideDescription: "Before the ride, elephants are saddled with a multi-basket designed for 4 to 6 people. These gentle giants take you through scenic jungle paths, cross areas flooded with water, and navigate through lush vegetation. Elephants usually walk slowly, allowing you to fully appreciate the beauty of the surrounding nature, even though they can reach speeds of up to 40 km/h.",
                        highlightsTitle: "Highlights of an Elephant Ride",
                        highlightsDescription: "Riding an elephant in Sri Lanka provides a unique way to connect with nature and explore the countryside. Some highlights of the experience include:",
                        highlights: {
                            junglePaths: "Walking through dense jungles filled with exotic vegetation and wildlife.",
                            riverCrossing: "Crossing rivers and flooded areas, offering stunning views of the natural landscape.",
                            culturalConnection: "Learning about the close relationship between elephants and Sri Lankan culture.",
                            comfortableRide: "Relaxing on a comfortable saddle while the elephant gently carries you through various terrains."
                        },
                        images: {
                            mainAlt: "Elephant Back Ride",
                            jungleAlt: "Elephant Ride Jungle Path",
                            jungleCaption: "Explore dense jungles and scenic paths while riding on an elephant.",
                            waterAlt: "Elephant Crossing Water",
                            waterCaption: "Cross rivers and enjoy the tranquil beauty of the water and vegetation."
                        },
                        tipsTitle: "Tips for a Safe and Enjoyable Elephant Ride",
                        tips: {
                            clothing: "Wear comfortable clothing and footwear suitable for outdoor activities.",
                            guideInstructions: "Follow the instructions of your guide for a safe and enjoyable ride.",
                            ethicalPractices: "Ensure that the elephants are well-treated and the ride provider follows ethical practices.",
                            camera: "Bring a camera to capture the breathtaking scenery and moments.",
                            respectElephants: "Respect the elephants and avoid actions that might stress or harm them."
                        },
                    },
                    fishingPage: {
                        title: "Fishing in Sri Lanka",
                        mainDescription: "Sri Lanka, with its vast coastline and abundance of freshwater lakes and rivers, offers an unparalleled fishing experience. Whether you're a professional angler or a hobbyist, Sri Lanka has something to offer. From deep-sea fishing expeditions to the traditional stilt fishing practiced by local fishermen, you'll have an unforgettable adventure.",
                        destinationsDescription: "Popular fishing destinations include the southern coast around Galle and Mirissa, the Negombo lagoon, and the calm waters of Trincomalee. Depending on your preference, you can try different fishing techniques such as trolling, bottom fishing, or fly fishing.",
                        experiencesTitle1: "Fishing Experiences in Sri Lanka",
                        experiencesDescription: "Fishing in Sri Lanka is not just about catching fish; it is an opportunity to immerse yourself in the culture and traditions of the island. Some unique fishing experiences include:",
                        experiences: {
                            stiltFishingTitle: "Stilt Fishing",
                            stiltFishing: "A traditional method where fishermen perch on stilts to catch fish near the shore, a practice unique to Sri Lanka.",
                            deepSeaFishingTitle: "Deep-Sea Fishing",
                            deepSeaFishing: "Venture into the Indian Ocean to catch marlins, tunas, barracudas, and other large fish species.",
                            lagoonFishingTitle: "Lagoon and River Fishing",
                            lagoonFishing: "Relax while fishing in serene lagoons and rivers teeming with fish like tilapia and catfish.",
                            nightFishingTitle: "Night Fishing",
                            nightFishing: "Experience the thrill of fishing under the stars, a common practice in coastal villages."
                        },
                        images: {
                            mainAlt: "Fishing in Sri Lanka",
                            stiltFishingAlt: "Stilt Fishing in Sri Lanka",
                            stiltFishingCaption: "Stilt fishing is a traditional method and an iconic image of Sri Lanka's fishing heritage.",
                            deepSeaFishingAlt: "Deep Sea Fishing in Sri Lanka",
                            deepSeaFishingCaption: "Deep-sea fishing offers an adventurous experience, targeting large fish species in the Indian Ocean."
                        },
                        tipsTitle: "Tips for an Enjoyable Fishing Trip",
                        tips: {
                            season: "Choose the right season for your fishing expedition; October to April is ideal for the southern coast, while March to October suits the eastern coast.",
                            protection: "Bring sunscreen, a hat, and protective clothing to stay comfortable during your trip.",
                            guide: "Book a fishing guide or charter to make the most of your experience and learn from the experts.",
                            environment: "Respect the local environment by avoiding littering and adhering to sustainable fishing practices.",
                            hydration: "Stay hydrated and carry snacks for longer fishing trips."
                        },
                    },
                    jeepSafariPage: {
                        title: "Jeep Safari in Sri Lanka",
                        mainDescription: "Sri Lanka's national parks offer a thrilling jeep safari experience, allowing you to explore the island's rich biodiversity and witness wildlife in their natural habitats. Yala National Park, Wilpattu National Park, and Udawalawe National Park are among the most popular destinations for jeep safaris.",
                        wildlifeDescription: "These safaris provide a chance to see elephants, leopards, sloth bears, water buffalo, crocodiles, and a wide variety of bird species. Guided by experienced naturalists and trackers, jeep safaris are perfect for wildlife enthusiasts and photographers alike.",
                        whyChooseTitle: "Why Choose a Jeep Safari?",
                        whyChooseDescription: "Jeep safaris are one of the best ways to explore the diverse wildlife of Sri Lanka. Here are some highlights:",
                        whyChoose: {
                            encounters: "Close encounters with iconic species like elephants and leopards.",
                            remoteAreas: "Access to remote and scenic areas within national parks.",
                            photography: "Opportunities for wildlife photography in a natural setting.",
                            guidance: "Guidance from knowledgeable naturalists and park rangers.",
                            adventure: "An adventure suitable for all age groups, combining excitement with education."
                        },
                        images: {
                            mainAlt: "Jeep Safari in Sri Lanka",
                            wildlifeAlt: "Wildlife in Jeep Safari",
                            wildlifeCaption: "Witness iconic wildlife like leopards, elephants, and crocodiles during your safari.",
                            landscapeAlt: "Jeep Safari Landscape",
                            landscapeCaption: "Explore the stunning landscapes of Sri Lanka's national parks, from dense forests to open plains."
                        },
                        tipsTitle: "Tips for an Enjoyable Jeep Safari",
                        tips: {
                            clothing: "Wear comfortable, neutral-colored clothing to blend in with the environment.",
                            protection: "Carry sunscreen, a hat, and insect repellent for protection.",
                            equipment: "Bring binoculars and a camera to enhance your experience and capture wildlife.",
                            guide: "Follow the guide's instructions to ensure safety and respect for the animals.",
                            booking: "Book your safari early, especially during peak seasons, to secure a spot."
                        },
                    },
                    riverSafariPage: {
                        title: "River Safari in Sri Lanka",
                        mainDescription: "A river safari in Sri Lanka offers a unique way to explore the island's rich biodiversity and scenic beauty. Glide along tranquil waterways surrounded by lush mangroves, spot exotic wildlife, and enjoy picturesque sunsets that will leave you mesmerized.",
                        destinationsDescription: "Popular river safari destinations include the Madu Ganga (Madu River) and Bentota River. These safaris provide a chance to witness various bird species, monitor lizards, crocodiles, and even monkeys in their natural habitats. The serene environment is perfect for nature lovers and photographers.",
                        whyChooseTitle: "Why Choose a River Safari?",
                        whyChooseDescription: "A river safari is a relaxing and immersive experience that combines nature, wildlife, and cultural exploration. Here are some highlights:",
                        whyChoose: {
                            mangroves: "Explore lush mangroves teeming with life.",
                            wildlife: "Spot exotic birds, crocodiles, and other wildlife.",
                            villages: "Visit small islands and local villages along the river.",
                            tranquility: "Enjoy the tranquility and picturesque beauty of Sri Lanka's waterways.",
                            suitable: "Perfect for families, couples, and solo travelers seeking a peaceful escape."
                        },
                        images: {
                            mainAlt: "River Safari in Sri Lanka",
                            mangrovesAlt: "Mangroves in River Safari",
                            mangrovesCaption: "Discover the lush mangroves that line Sri Lanka’s scenic waterways.",
                            wildlifeAlt: "Wildlife in River Safari",
                            wildlifeCaption: "Spot exotic wildlife like crocodiles, monitor lizards, and colorful birds during your safari."
                        },
                        tipsTitle: "Tips for an Enjoyable River Safari",
                        tips: {
                            clothing: "Wear comfortable clothing and bring a hat and sunscreen for protection.",
                            binoculars: "Carry binoculars to spot distant wildlife and birds.",
                            camera: "Bring a camera or smartphone to capture the stunning scenery and wildlife.",
                            guide: "Follow the instructions of your guide for a safe and enjoyable experience.",
                            environment: "Respect the natural environment by avoiding littering and disturbing wildlife."
                        },
                    },
                    snorkelingPage: {
                        title: "Snorkeling in Sri Lanka",
                        mainDescription: "Snorkeling in Sri Lanka offers an unforgettable underwater experience, where you can explore vibrant coral reefs and diverse marine life. With its crystal-clear waters and abundant aquatic ecosystems, Sri Lanka is a paradise for snorkelers of all skill levels.",
                        destinationsDescription: "Some of the most popular snorkeling spots include Hikkaduwa, known for its colorful coral gardens and turtles, Pigeon Island in Trincomalee, famous for its pristine reefs, and Mirissa, where you might even spot a whale or two during the snorkeling season.",
                        whyChooseTitle: "Why Choose Snorkeling in Sri Lanka?",
                        whyChooseDescription: "Snorkeling in Sri Lanka is a magical experience, combining adventure and natural beauty. Here are some highlights:",
                        whyChoose: {
                            coralReefs: "Explore vibrant coral reefs teeming with life.",
                            marineLife: "Swim alongside colorful tropical fish, turtles, and even reef sharks.",
                            landscapes: "Discover pristine underwater landscapes in clear, warm waters.",
                            suitable: "Suitable for both beginners and experienced snorkelers.",
                            accessible: "Accessible from some of the best beach destinations in Sri Lanka."
                        },
                        images: {
                            mainAlt: "Snorkeling in Sri Lanka",
                            coralReefAlt: "Coral Reefs in Sri Lanka",
                            coralReefCaption: "Discover stunning coral reefs and their vibrant ecosystems.",
                            marineLifeAlt: "Marine Life in Sri Lanka",
                            marineLifeCaption: "Encounter diverse marine life, including turtles, tropical fish, and more."
                        },
                        tipsTitle: "Tips for a Memorable Snorkeling Experience",
                        tips: {
                            mask: "Wear a comfortable mask and snorkel to ensure a clear view underwater.",
                            sunscreen: "Apply reef-safe sunscreen to protect both your skin and marine life.",
                            swimGently: "Swim gently to avoid disturbing coral reefs and aquatic creatures.",
                            hydration: "Stay hydrated and take breaks between sessions.",
                            guidedTour: "Join a guided tour for the best snorkeling spots and safety tips."
                        },
                    },
                    teaTastingPage: {
                        title: "Tea Tasting Tour in Sri Lanka",
                        mainDescription: "Sri Lanka, often referred to as the 'Pearl of the Indian Ocean,' is famous for its world-class tea production. Embark on a tea tasting tour and explore the lush tea plantations in regions like Nuwara Eliya, Ella, and Kandy. Learn about the art of tea cultivation, the meticulous process of tea production, and savor the rich flavors of authentic Ceylon tea.",
                        heritageDescription: "Whether you're a tea enthusiast or simply curious, a tea tasting tour offers a unique opportunity to delve into Sri Lanka’s tea heritage and experience the serene beauty of its highlands.",
                        whyChooseTitle: "Why Choose a Tea Tasting Tour?",
                        whyChooseDescription: "A tea tasting tour in Sri Lanka is not just about tasting tea—it's an immersive cultural experience. Here are some highlights:",
                        whyChoose: {
                            plantations: "Visit picturesque tea plantations nestled in the cool highlands.",
                            history: "Learn about the history and significance of Ceylon tea.",
                            production: "Participate in tea plucking and observe the production process in tea factories.",
                            varieties: "Savor different varieties of tea, from black to green to flavored blends.",
                            scenery: "Enjoy the breathtaking scenery of misty mountains and cascading waterfalls."
                        },
                        images: {
                            mainAlt: "Tea Tasting Tour in Sri Lanka",
                            teaPlantationAlt: "Tea Plantation in Sri Lanka",
                            teaPlantationCaption: "Explore lush tea plantations and learn about tea cultivation.",
                            teaPreparationAlt: "Tea Preparation in Sri Lanka",
                            teaPreparationCaption: "Discover the art of tea preparation and savor authentic Ceylon tea."
                        },
                        tipsTitle: "Tips for an Enjoyable Tea Tasting Tour",
                        tips: {
                            clothing: "Wear comfortable clothing and footwear for walking through plantations.",
                            jacket: "Bring a light jacket, as highland regions can be cool and misty.",
                            varieties: "Try different varieties of tea and take some favorites home as souvenirs.",
                            questions: "Ask questions during the tour to learn more about the tea-making process.",
                            attractions: "Combine your tea tour with visits to nearby attractions like waterfalls and viewpoints."
                        },
                    },
                    templeVisitPage: {
                        title: "Temple Visit in Sri Lanka",
                        mainDescription: "Sri Lanka, known as the Land of Buddha, is home to ancient temples that reflect its rich spiritual and cultural heritage. Embark on a journey to explore iconic temples such as the Temple of the Tooth in Kandy, the Dambulla Cave Temple, and Ruwanwelisaya in Anuradhapura.",
                        spiritualDescription: "These sacred sites, adorned with intricate carvings, murals, and statues, offer a glimpse into the island's spiritual traditions and architectural brilliance. A temple visit is not only a cultural experience but also an opportunity to find peace and tranquility.",
                        whyVisitTitle: "Why Visit Temples in Sri Lanka?",
                        whyVisitDescription: "Visiting temples in Sri Lanka offers a unique opportunity to connect with the island’s history, culture, and spirituality. Here are some highlights:",
                        whyVisit: {
                            architecture: "Admire the intricate architecture and centuries-old statues.",
                            traditions: "Learn about Buddhist traditions and rituals from knowledgeable guides.",
                            heritage: "Explore UNESCO World Heritage Sites like the Golden Temple of Dambulla.",
                            serenity: "Experience the serenity and spiritual ambiance of sacred spaces.",
                            festivals: "Witness vibrant festivals like Esala Perahera at the Temple of the Tooth."
                        },
                        images: {
                            mainAlt: "Temple Visit in Sri Lanka",
                            templeInteriorAlt: "Temple Interior",
                            templeInteriorCaption: "Marvel at the stunning interiors adorned with intricate carvings and murals.",
                            sacredTempleAlt: "Sacred Temple in Sri Lanka",
                            sacredTempleCaption: "Visit sacred temples like Ruwanwelisaya and immerse yourself in spiritual traditions."
                        },
                        tipsTitle: "Tips for Visiting Temples in Sri Lanka",
                        tips: {
                            dress: "Dress modestly, covering your shoulders and knees, as a sign of respect.",
                            shoes: "Remove your shoes before entering temple premises.",
                            touching: "Refrain from touching statues or sacred objects.",
                            donation: "Bring a small donation for the temple if you wish to contribute.",
                            silence: "Respect the silence and spiritual atmosphere during your visit."
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "White Water Rafting in Sri Lanka",
                        mainDescription: "White water rafting in Sri Lanka is an exhilarating experience, especially in Kitulgala, the adventure capital of the island. The Kelani River, with its roaring rapids and scenic surroundings, offers a perfect setting for both beginners and experienced rafters.",
                        destinationsDescription: "Rafting expeditions typically cover a 5-kilometer stretch with rapids ranging from Grade 2 to Grade 4. Participants can enjoy the thrill of navigating challenging currents while taking in the lush greenery and breathtaking views of the riverbanks.",
                        whyChooseTitle: "Why Choose White Water Rafting in Sri Lanka?",
                        whyChooseDescription: "White water rafting in Sri Lanka offers a unique combination of adventure and natural beauty. Here are some highlights of the experience:",
                        whyChoose: {
                            rapids: "Navigate through thrilling rapids under the guidance of experienced instructors.",
                            views: "Enjoy stunning views of the surrounding rainforest and mountainous terrain.",
                            activities: "Combine rafting with other activities like trekking, birdwatching, and canyoning in Kitulgala.",
                            suitable: "Perfect for groups, families, or solo travelers looking for an adrenaline rush."
                        },
                        images: {
                            mainAlt: "White Water Rafting in Sri Lanka",
                            actionRaftingAlt: "White Water Rafting Action",
                            actionRaftingCaption: "Feel the adrenaline rush as you conquer challenging rapids on the Kelani River.",
                            scenicRaftingAlt: "White Water Rafting Scenic Views",
                            scenicRaftingCaption: "Enjoy the serene beauty of the lush surroundings during your rafting adventure."
                        },
                        tipsTitle: "Tips for a Safe and Exciting Rafting Trip",
                        tips: {
                            safetyGear: "Wear a life jacket and helmet provided by your rafting guide for safety.",
                            instructions: "Listen carefully to the safety instructions before starting your trip.",
                            clothing: "Wear comfortable, quick-drying clothing and secure footwear like water shoes.",
                            changeOfClothes: "Carry a change of clothes and a towel for after the trip.",
                            operator: "Book your rafting trip with a reputable operator to ensure a safe and enjoyable experience."
                        },
                    },
                    wildlifeSafariPage: {
                        title: "Wildlife Safari in Sri Lanka",
                        mainDescription: "Sri Lanka, known for its rich biodiversity, offers incredible wildlife safaris in national parks like Yala, Wilpattu, Minneriya, and Udawalawe. These safaris provide a chance to witness elephants, leopards, sloth bears, and a variety of bird species in their natural habitats.",
                        destinationsDescription: "Explore diverse landscapes ranging from dense forests to open grasslands, and capture unforgettable moments of wildlife in action. With expert guides and well-maintained safari jeeps, a wildlife safari in Sri Lanka is a must for nature enthusiasts and adventure seekers.",
                        whyChooseTitle: "Why Choose a Wildlife Safari?",
                        whyChooseDescription: "A wildlife safari in Sri Lanka offers a unique opportunity to connect with nature and explore the island's remarkable biodiversity. Highlights include:",
                        whyChoose: {
                            species: "Witnessing iconic species like elephants, leopards, and crocodiles.",
                            landscapes: "Exploring lush forests, wetlands, and open plains teeming with wildlife.",
                            photography: "Capturing stunning wildlife photography in natural settings.",
                            elusiveAnimals: "Experiencing the thrill of spotting elusive animals like the Sri Lankan leopard.",
                            conservation: "Learning about conservation efforts from experienced guides and naturalists."
                        },
                        images: {
                            mainAlt: "Wildlife Safari in Sri Lanka",
                            elephantsAlt: "Elephants in Sri Lanka",
                            elephantsCaption: "Witness majestic elephants roaming freely in Sri Lanka's national parks.",
                            leopardAlt: "Sri Lankan Leopard",
                            leopardCaption: "Spot the elusive Sri Lankan leopard, a highlight of any wildlife safari."
                        },
                        tipsTitle: "Tips for an Exciting Wildlife Safari",
                        tips: {
                            clothing: "Wear neutral-colored clothing to blend into the environment.",
                            protection: "Carry sunscreen, a hat, and insect repellent for protection.",
                            equipment: "Bring binoculars and a camera to spot and capture wildlife.",
                            guide: "Follow your guide's instructions for a safe and enjoyable experience.",
                            booking: "Book early, especially during peak seasons, to secure a spot in popular parks."
                        },
                    },
                },
            },
            de: {
                translation: {
                    home: 'Startseite',
                    about: 'Über uns',
                    srilanka: 'Sri Lanka',
                    excursions: 'Ausflüge',
                    tour: 'Tour buchen',
                    things: 'Aktivitäten',
                    contact: {
                        navLabel: 'Kontaktieren Sie uns',
                        getInTouch: 'In Kontakt treten',
                        address: 'Adresse',
                        mobile: 'Mobil',
                        email: 'E-Mail',
                        website: 'Website',
                        sendMessage: 'Senden Sie uns eine Nachricht',
                        fullName: 'Vollständiger Name',
                        fullNamePlaceholder: 'Geben Sie Ihren vollständigen Namen ein',
                        country: 'Land',
                        countryPlaceholder: 'Geben Sie Ihr Land ein',
                        emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
                        subject: 'Betreff',
                        subjectPlaceholder: 'Geben Sie den Betreff ein',
                        message: 'Nachricht',
                        messagePlaceholder: 'Geben Sie Ihre Nachricht ein',
                        reset: 'Zurücksetzen',
                        submit: 'Absenden',
                        ourLocation: 'Unser Standort',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Gastnachricht von Ashan Tours Sri Lanka',
                        manualMessage: 'Bitte senden Sie die folgende Nachricht manuell an',
                        errorMessage: 'Ein Fehler ist aufgetreten. Bitte senden Sie die folgende Nachricht manuell an',
                    },
                    footerSection: {
                        ashanTours: 'Ashan Tours Sri Lanka',
                        getInTouch: 'Kontaktieren Sie uns',
                        address: '293/C/3, Maradana Road, Moragalla, Beruwala, Sri Lanka',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: 'In Verbindung bleiben',
                        emailPlaceholder: 'Geben Sie Ihre E-Mail-Adresse ein',
                        socialMedia: {
                            facebook: 'Facebook',
                            instagram: 'Instagram',
                            youtube: 'YouTube',
                            twitter: 'Twitter',
                        },
                        copyright: '© {{year}} Ashan Tours Sri Lanka. Alle Rechte vorbehalten.',
                        designedBy: 'Website entworfen und entwickelt von Redev Solutions',
                        designedByPhone: '+94 76 460 8225',
                    },
                    aboutSection: {
                        travelWithAshan: 'Reisen mit Ashan Tours Sri Lanka',
                        imageAlt: 'Ashan Tours Bild {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lanka ist Ihr vertrauenswürdiger Reisebegleiter und schafft unvergessliche Reisen durch Sri Lanka. Mit unserer Leidenschaft für Entdeckungen und einem Team erfahrener Profis sind wir bestrebt, personalisierte Reiserouten, fachkundige Beratung und außergewöhnlichen Service zu bieten, um Ihren Urlaub unvergesslich zu machen.',
                        introParagraph2: 'Unsere Touren sind sorgfältig gestaltet, um die Essenz Sri Lankas einzufangen – von den sonnenverwöhnten Stränden und malerischen Hügellandschaften bis hin zu den antiken kulturellen Schätzen und der lebendigen Tierwelt. Bei Ashan Tours Sri Lanka sind wir bestrebt, authentische Erlebnisse zu bieten, die die Schönheit und Seele der Insel entdecken lassen.',
                        introParagraph3: 'Ob Abenteuer, eine ruhige Auszeit oder kulturelles Eintauchen – Ashan Tours Sri Lanka bietet maßgeschneiderte Pakete, die Ihren Wünschen entsprechen. Begleiten Sie uns und lassen Sie sich auf eine Reise voller Wunder, Entdeckungen und bleibender Erinnerungen führen.',
                        cinnamonLuxuryVilla: 'Cinnamon Luxusvilla',
                        villaImageAlt: 'Cinnamon Luxusvilla Bild {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lanka präsentiert stolz unsere Cinnamon Luxusvilla, die erstklassige Unterkünfte für Reisende bietet, die Komfort und Eleganz suchen. Unsere zwei exklusiven Apartments sind darauf ausgelegt, ein Zuhause fern von Zuhause im Herzen Sri Lankas zu bieten.',
                        villaParagraph2: 'Jedes Apartment ist mit modernen Annehmlichkeiten ausgestattet, einschließlich Klimaanlage, angeschlossenen Badezimmern, luxuriösen Doppelbetten und voll ausgestatteten Küchen. Ob Sie alleine, als Paar oder mit der Familie reisen, unsere Villen bieten die perfekte Kombination aus Luxus und Komfort.',
                        villaParagraph3: 'Eingebettet in eine ruhige Umgebung ermöglicht die Cinnamon Luxusvilla Entspannung nach einem Tag voller Erkundungen der Wunder Sri Lankas. Buchen Sie Ihren Aufenthalt bei Ashan Tours Sri Lanka und erleben Sie unvergleichliche Gastfreundschaft.',
                    },
                    sriLankaSection: {
                        discoverSriLanka: 'Entdecken Sie Sri Lanka',
                        mainImageAlt: 'Sri Lanka',
                        pearlOfIndianOcean: 'Perle des Indischen Ozeans',
                        introParagraph1: 'Sri Lanka, liebevoll bekannt als die "{{pearl}}", ist ein atemberaubendes Inselparadies, gefeiert für seine beeindruckenden Landschaften, tief verwurzelten Traditionen und farbenfrohe Kultur.',
                        introParagraph2: 'Mit einer über 2.500 Jahre alten Zivilisation beherbergt Sri Lanka majestätische antike Hauptstädte, heilige religiöse Wahrzeichen und UNESCO-Welterbestätten. Sein kultureller Reichtum wird durch indische, arabische, portugiesische, niederländische und britische Einflüsse bereichert und bietet eine faszinierende Reise durch die Zeit.',
                        introParagraph3: 'Die Landschaften der Insel sind außergewöhnlich – von goldenen Sandstränden und sanften grünen Teeplantagen bis hin zu nebligen Berggipfeln. Die Wildreservate beherbergen Elefanten, Leoparden und farbenfrohe Vogelarten und sind ein Traum für Naturliebhaber.',
                        introParagraph4: 'Für Abenteuerlustige bietet Sri Lanka Surfen, Trekking, Schnorcheln und Tauchen. Die Küche, durchzogen von aromatischen Gewürzen, frischem Fisch und tropischen Früchten, ist kräftig und geschmackvoll und erzählt die Geschichte des reichen kulinarischen Erbes der Insel.',
                        introParagraph5: 'Ob Sie durch zeitlose Ruinen schlendern, an ruhigen Stränden entspannen oder die herzliche Gastfreundschaft genießen, Sri Lanka bietet ein unvergessliches Reiseerlebnis.',
                        attractivePlaces: 'Attraktive Orte in Sri Lanka',
                        viewMore: 'Mehr ansehen',
                        placeImageAlt: 'Bild von {{name}} {{index}}',
                        fullImagePreviewAlt: 'Vollbildvorschau',
                        famousThingsTitle: 'Berühmte Dinge in Sri Lanka',
                        places: {
                            sigiriyaRockFortress: {
                                name: 'Sigiriya Felsfestung',
                                description: 'Die Sigiriya Felsfestung ist ein UNESCO-Welterbe und eines der bekanntesten Wahrzeichen Sri Lankas. Sie bietet antike Gärten, Fresken und atemberaubende Ausblicke vom Gipfel des Felsens.',
                            },
                            templeOfTheTooth: {
                                name: 'Tempel des Zahns',
                                description: 'Der Tempel der Heiligen Zahnreliquie in Kandy ist ein heiliger buddhistischer Ort, der eine Reliquie des Zahns Buddhas beherbergt. Besucher können seine historische und religiöse Bedeutung erleben.',
                            },
                            ella: {
                                name: 'Ella',
                                description: 'Ella ist eine kleine Stadt im Hügelland von Sri Lanka, umgeben von Teeplantagen und Wasserfällen. Sie ist berühmt für die Neun-Bogen-Brücke und den Kleinen Adams Peak.',
                            },
                            yalaNationalPark: {
                                name: 'Yala Nationalpark',
                                description: 'Der Yala Nationalpark ist bekannt für seine reiche Tierwelt, darunter Elefanten, Leoparden und zahlreiche Vogelarten. Eine Safari hier ist ein Muss für Naturliebhaber.',
                            },
                            galleFort: {
                                name: 'Galle Fort',
                                description: 'Das Galle Fort, erbaut von den Portugiesen und befestigt von den Niederländern, ist eine historische Stätte mit Kopfsteinpflasterstraßen, kolonialer Architektur und lebhaften Cafés.',
                            },
                            nuwaraEliya: {
                                name: 'Nuwara Eliya',
                                description: 'Bekannt als "Klein-England", ist Nuwara Eliya eine Bergstation, berühmt für ihr kühles Klima, Teeplantagen und koloniale Bungalows.',
                            },
                            adamsPeak: {
                                name: 'Adams Peak',
                                description: 'Der Adams Peak ist ein heiliger Berg mit einem einzigartigen Fußabdruck am Gipfel. Er ist ein beliebtes Pilgerziel für mehrere Religionen.',
                            },
                            hortonPlains: {
                                name: 'Horton Plains',
                                description: 'Der Horton Plains Nationalpark bietet sanfte Hügel, Wasserfälle und den berühmten Aussichtspunkt World’s End.',
                            },
                            bentotaBeach: {
                                name: 'Bentota Strand',
                                description: 'Der Bentota Strand ist ein unberührtes Küstenziel, bekannt für seine goldenen Sandstrände, Wassersport und Luxusresorts.',
                            },
                            jaffna: {
                                name: 'Jaffna',
                                description: 'Jaffna, im Norden Sri Lankas, ist reich an tamilischer Kultur, historischen Stätten und köstlicher Küche.',
                            },
                            anuradhapura: {
                                name: 'Anuradhapura',
                                description: 'Anuradhapura ist eine antike Stadt, bekannt für ihre heiligen buddhistischen Stätten und historischen Ruinen, einschließlich des Sri Maha Bodhi-Baums.',
                            },
                            polonnaruwa: {
                                name: 'Polonnaruwa',
                                description: 'Polonnaruwa ist ein UNESCO-Welterbe mit antiken Tempeln, Statuen und wunderschön erhaltenen Ruinen.',
                            },
                            unawatunaBeach: {
                                name: 'Unawatuna Strand',
                                description: 'Der Unawatuna Strand ist ein lebendiges Küstenziel, das Schnorcheln, Sonnenbaden und ein pulsierendes Nachtleben bietet.',
                            },
                            colomboCity: {
                                name: 'Colombo Stadt',
                                description: 'Colombo ist die geschäftige Hauptstadt Sri Lankas, die moderne Wolkenkratzer mit kolonialer Architektur und lebhaften Märkten verbindet.',
                            },
                            udawalawaNationalPark: {
                                name: 'Udawalawa Nationalpark',
                                description: 'Der Udawalawa Nationalpark ist ein Paradies für Wildtiere, berühmt für seine großen Elefantenherden, vielfältigen Vogelarten und atemberaubenden Landschaften, was ihn zu einem Muss für Naturliebhaber macht.',
                            },
                            dambullaCaveTemple: {
                                name: 'Dambulla Höhlentempel',
                                description: 'Der Dambulla Höhlentempel ist ein UNESCO-Welterbe mit antiken buddhistischen Wandmalereien und Statuen in Höhlen.',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: 'Ceylon Tee',
                                description: 'Sri Lanka ist weltweit bekannt für seinen Ceylon Tee, der für seinen einzigartigen Geschmack und seine Qualität geschätzt wird. Tee aus den Regionen Nuwara Eliya, Uva und Dimbula ist besonders berühmt.',
                            },
                            spices: {
                                title: 'Gewürze',
                                description: 'Sri Lanka ist seit Jahrhunderten ein Zentrum für Gewürze wie Zimt, Kardamom, Nelken und Muskatnuss. Sri-lankischer Zimt gilt als der beste der Welt.',
                            },
                            gems: {
                                title: 'Edelsteine und Schmuck',
                                description: 'Bekannt als die "Insel der Edelsteine", ist Sri Lanka berühmt für seine Saphire, Rubine und Mondsteine. Der "Blue Belle of Asia", einer der größten blauen Saphire, wurde hier entdeckt.',
                            },
                            ayurveda: {
                                title: 'Ayurveda',
                                description: 'Sri Lanka ist bekannt für seine ayurvedische Medizin und Wellness-Behandlungen. Beliebte Angebote umfassen Massagen, Kräutertherapien und Ayurveda-Resorts.',
                            },
                            handicrafts: {
                                title: 'Traditionelles Handwerk',
                                description: 'Sri Lanka produziert exquisite Handwerksartikel, darunter Masken aus Ambalangoda, Batik-Textilien, Holzschnitzereien und Lackarbeiten.',
                            },
                            elephants: {
                                title: 'Elefanten',
                                description: 'Sri-lankische Elefanten spielen eine bedeutende Rolle in der Kultur und bei Festen. Prachtvoll geschmückte Elefanten sind Teil von Prozessionen wie der Esala Perahera.',
                            },
                            food: {
                                title: 'Traditionelles Essen',
                                description: 'Sri Lanka ist berühmt für seine geschmackvolle Küche, einschließlich Reis und Curry, Hoppers, Kottu Roti, Pol Sambol und Wattalappam.',
                            },
                            festivals: {
                                title: 'Feste',
                                description: 'Sri Lanka feiert farbenfrohe Feste wie Esala Perahera, das singhalesische und tamilische Neujahr und Vesak mit beleuchteten Dekorationen und Prozessionen.',
                            },
                            coconut: {
                                title: 'Kokosnussprodukte',
                                description: 'Sri Lanka ist bekannt für kokosnussbasierte Produkte wie Kokosöl, Milch und Kokosfaser, die für Seile und Matten verwendet werden.',
                            },
                            sarees: {
                                title: 'Sri-lankische Saris',
                                description: 'Der Kandyan-Sari (Osariya) ist ein traditionelles Kleidungsstück für Frauen, bekannt für seine Eleganz und einzigartige Drapierungsweise, getragen bei zeremoniellen Anlässen.',
                            },
                            dances: {
                                title: 'Traditionelle Tänze',
                                description: 'Die traditionellen Tänze Sri Lankas umfassen den Kandyan-Tanz, Teufelstänze und Tänze der Tiefebene, inspiriert von Natur und Folklore.',
                            },
                            stiltFishing: {
                                title: 'Stelzenfischen',
                                description: 'Ein ikonisches Bild in Sri Lanka: Beim Stelzenfischen balancieren Fischer auf in das Meer gepflanzten Stangen, einzigartig für die südlichen Küstenregionen.',
                            },
                            moonstones: {
                                title: 'Mondsteine',
                                description: 'Sri Lanka ist bekannt für seine Mondsteine, die als Halbedelsteine gelten. Die Mondsteinminen in Meetiyagoda sind besonders berühmt.',
                            },
                            cricket: {
                                title: 'Sri-lankischer Cricket',
                                description: 'Cricket ist eine Leidenschaft für die Sri-Lanker, und das Land ist bekannt für seine Weltklasse-Spieler. Sri Lanka gewann 1996 den ICC Cricket-Weltcup.',
                            },
                            herbs: {
                                title: 'Ayurveda-Kräuter und Gewürze',
                                description: 'Die Insel produziert pflanzliche Heilmittel, die in der Ayurveda verwendet werden, wie Gotu Kola, Zimt und Neem.',
                            },
                            masks: {
                                title: 'Masken',
                                description: 'Traditionelle sri-lankische Masken aus Ambalangoda werden in kulturellen Aufführungen verwendet, einschließlich Yaksha (Teufelsmasken) und Kolam-Masken.',
                            },
                        },
                    },
                    excursionsSection: {
                        title: 'Ausflüge',
                        excursions: {
                            oneDay: {
                                title: 'Eintägige Ausflüge',
                                description: 'Erkunden Sie atemberaubende Ziele an einem einzigen Tag mit geführten Touren und lokalen Erlebnissen.',
                                alt: 'Eintägiger Ausflug in Sri Lanka',
                            },
                            twoDays: {
                                title: 'Zweitägige Ausflüge',
                                description: 'Genießen Sie kurze Reisen mit Übernachtungen, um noch mehr von Sri Lanka zu erleben.',
                                alt: 'Zweitägiger Ausflug in Sri Lanka',
                            },
                            threeDays: {
                                title: 'Dreitägige Ausflüge',
                                description: 'Entdecken Sie mehrere Attraktionen über drei Tage voller Abenteuer und Entspannung.',
                                alt: 'Dreitägiger Ausflug in Sri Lanka',
                            },
                            fourDays: {
                                title: 'Viertägige Ausflüge',
                                description: 'Perfekt für eine ausgedehnte Reise, die mehrere Ziele in Komfort abdeckt.',
                                alt: 'Viertägiger Ausflug in Sri Lanka',
                            },
                            twentyDays: {
                                title: '20-Tägige Ausflüge',
                                description: 'Begeben Sie sich auf eine epische Reise durch Sri Lanka und erkunden Sie seine kulturellen, natürlichen und historischen Wunder.',
                                alt: '20-Tägiger Ausflug in Sri Lanka',
                            },
                        },
                        bentotaExcursions: {
                            title: 'Ausflüge von Bentota',
                            bentotaToYala: {
                                title: 'Bentota nach Yala',
                                description: 'Bentota -> Ella -> Yala',
                            },
                            bentotaToNuwaraEliya: {
                                title: 'Bentota nach Nuwara Eliya',
                                description: 'Bentota -> Ella -> Kandy -> Nuwara Eliya',
                            },
                            bentotaToMinneriya: {
                                title: 'Bentota zum Minneriya Nationalpark',
                                description: 'Bentota -> Sigiriya -> Anuradhapura -> Polonnaruwa -> Minneriya Nationalpark',
                            },
                            bentotaToHortonPlains: {
                                title: 'Bentota zu den Horton Plains',
                                description: 'Bentota -> Kandy -> Nuwara Eliya -> Horton Plains',
                            },
                            images: {
                                bentotaToElla1: 'Bentota Strandansicht 1',
                                bentotaToElla2: 'Bentota Strandansicht 2',
                            },
                        },
                        airportExcursions: {
                            title: 'Ausflüge vom Flughafen',
                            airportToColombo: {
                                title: 'Flughafen zur Colombo Stadtrundfahrt',
                                description: 'Flughafen -> Colombo Fort -> Galle Face -> Gangaramaya Tempel',
                                alt1: 'Colombo Stadtrundfahrt Bild 1',
                                alt2: 'Colombo Stadtrundfahrt Bild 2',
                            },
                            airportToSigiriya: {
                                title: 'Flughafen nach Sigiriya',
                                description: 'Flughafen -> Dambulla -> Sigiriya Felsfestung',
                                alt1: 'Sigiriya Ausflug Bild 1',
                                alt2: 'Sigiriya Ausflug Bild 2',
                            },
                            airportToKandy: {
                                title: 'Flughafen nach Kandy',
                                description: 'Flughafen -> Pinnawala Elefantenwaisenhaus -> Kandy Tempel des Zahns',
                                alt1: 'Kandy Ausflug Bild 1',
                                alt2: 'Kandy Ausflug Bild 2',
                            },
                            airportToGalle: {
                                title: 'Flughafen nach Galle',
                                description: 'Flughafen -> Bentota -> Galle Fort -> Unawatuna Strand',
                                alt1: 'Galle Ausflug Bild 1',
                                alt2: 'Galle Ausflug Bild 2',
                            },
                        },
                    },
                    thingsToDoSection: {
                        title: 'Aktivitäten in Sri Lanka',
                        viewMore: 'Mehr ansehen',
                        activities: {
                            ayurveda: {
                                title: 'Ayurveda - Alte Wissenschaft des Lebens',
                                alt: 'Ayurveda-Therapie in Sri Lanka',
                            },
                            diving: {
                                title: 'Tauchen in Sri Lanka',
                                alt: 'Taucherlebnis in Sri Lanka',
                            },
                            elephantRide: {
                                title: 'Elefantenritt',
                                alt: 'Elefantenritt in Sri Lanka',
                            },
                            fishing: {
                                title: 'Angeln in Sri Lanka',
                                alt: 'Angelaktivität in Sri Lanka',
                            },
                            ballooning: {
                                title: 'Ballonfahrten in Sri Lanka',
                                alt: 'Heißluftballonfahrten in Sri Lanka',
                            },
                            jeepSafari: {
                                title: 'Jeep-Safari',
                                alt: 'Jeep-Safari in Sri Lanka',
                            },
                            whiteWaterRafting: {
                                title: 'Wildwasser-Rafting',
                                alt: 'Wildwasser-Rafting in Sri Lanka',
                            },
                            riverSafari: {
                                title: 'Fluss-Safari',
                                alt: 'Fluss-Safari in Sri Lanka',
                            },
                            snorkeling: {
                                title: 'Schnorcheln in Sri Lanka',
                                alt: 'Schnorchelerlebnis in Sri Lanka',
                            },
                            teaTasting: {
                                title: 'Teeverkostungstour',
                                alt: 'Teeverkostungstour in Sri Lanka',
                            },
                            templeVisit: {
                                title: 'Tempelbesuch',
                                alt: 'Tempelbesuch in Sri Lanka',
                            },
                            wildlifeSafari: {
                                title: 'Wildtier-Safari',
                                alt: 'Wildtier-Safari in Sri Lanka',
                            },
                        },
                    },
                    homeHeroSection: {
                        title: 'Reisen mit Ashan Sri Lanka',
                        subtitle: 'Entdecken Sie die bezaubernde Schönheit Sri Lankas mit unvergesslichen Abenteuern',
                        bookButton: 'Buchen Sie Ihre Reise',
                        videoFallback: 'Ihr Browser unterstützt das Video-Tag nicht.',
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: 'Warum Ashan Tours Sri Lanka wählen',
                            specialist: {
                                title: 'Reiseexpertise',
                                description: 'Unser Team bei Ashan Tours Sri Lanka besteht aus erfahrenen Reiseexperten, die maßgeschneiderte Reisen nach Ihren Wünschen gestalten.'
                            },
                            experience: {
                                title: 'Unvergessliche Erlebnisse',
                                description: 'Wir schaffen bleibende Erinnerungen, indem wir die reiche Kultur, Geschichte und natürliche Schönheit Sri Lankas mit Leidenschaft präsentieren.'
                            },
                            priceMatch: {
                                title: 'Wettbewerbsfähige Preise',
                                description: 'Ashan Tours Sri Lanka garantiert den besten Wert für Ihre Reise und bietet hochwertige Erlebnisse zu erschwinglichen Preisen.'
                            },
                            support: {
                                title: 'Engagierter Support',
                                description: 'Unser rund um die Uhr verfügbares Kundensupport-Team steht Ihnen bei jedem Schritt zur Seite und sorgt für ein reibungsloses Reiseerlebnis.'
                            }
                        },
                        welcome: {
                            title: 'Willkommen bei Ashan Tours Sri Lanka',
                            imageAlt: 'Willkommensbild von Ashan Tours Sri Lanka',
                            description1: 'Begeben Sie sich auf eine außergewöhnliche Reise mit Ashan Tours Sri Lanka, Ihrem führenden Führer durch die Wunder dieses Inselparadieses.',
                            description2: 'Entdecken Sie die lebendige Kultur, atemberaubende Landschaften und verborgene Schätze Sri Lankas mit unseren sorgfältig zusammengestellten Touren.',
                            description3: 'Von unberührten Stränden bis hin zu antiken Ruinen sind unsere Reiserouten darauf ausgelegt, Sie in die Schönheit Sri Lankas einzutauchen.',
                            description4: 'Unser engagiertes Team sorgt für einen persönlichen Service und macht Ihr Reiseerlebnis unvergesslich und nahtlos.',
                            description5: 'Schließen Sie sich Ashan Tours Sri Lanka an und lassen Sie sich auf ein Abenteuer voller Entdeckungen und Freude führen.'
                        },
                        cinnamonLuxuryVilla: {
                            title: 'Cinnamon Luxusvilla',
                            imageAlt: 'Bild der Cinnamon Luxusvilla',
                            description1: 'Genießen Sie unvergleichlichen Komfort in der Cinnamon Luxusvilla von Ashan Tours Sri Lanka, die erstklassige Unterkünfte in ruhiger Umgebung bietet.',
                            description2: 'Unsere exklusiven Villen verfügen über moderne Annehmlichkeiten wie Klimaanlage, luxuriöse Betten und voll ausgestattete Küchen, ideal für einen entspannten Aufenthalt.',
                            readMore: 'Mehr erfahren'
                        },
                        tourPackages: {
                            title: 'Unsere Reisepakete',
                            ella: {
                                title: 'Ella Abenteuer',
                                subtitle: '3 Tage / 2 Nächte',
                                description: 'Erkunden Sie die malerische Schönheit von Ella mit Ashan Tours Sri Lanka, einschließlich Besuchen der Nine Arch Bridge und Little Adam’s Peak.',
                                alt: 'Ella Tour Bild'
                            },
                            ellaNuwaraKandy: {
                                title: 'Ella, Nuwara Eliya & Kandy',
                                subtitle: '5 Tage / 4 Nächte',
                                description: 'Eine kulturelle Reise durch Ella, Nuwara Eliya und Kandy mit Teefeldern und historischen Tempeln.',
                                alt: 'Ella, Nuwara Eliya & Kandy Tour Bild'
                            },
                            kandyNuwaraEllaYala: {
                                title: 'Kandy, Nuwara Eliya, Ella & Yala',
                                subtitle: '7 Tage / 6 Nächte',
                                description: 'Ein umfassender Rundgang durch das Erbe von Kandy, die Teefelder von Nuwara Eliya, die Landschaften von Ella und die Tierwelt von Yala.',
                                alt: 'Kandy, Nuwara Eliya, Ella & Yala Tour Bild'
                            },
                            viewMore: 'Weitere Touren ansehen'
                        },
                        popularExcursions: {
                            title: 'Beliebte Ausflüge',
                            oneDay: {
                                title: 'Eintägiger Ausflug',
                                alt: 'Eintägiger Ausflug Bild'
                            },
                            twoDays: {
                                title: 'Zweitägiger Ausflug',
                                alt: 'Zweitägiger Ausflug Bild'
                            },
                            threeDays: {
                                title: 'Dreitägiger Ausflug',
                                alt: 'Dreitägiger Ausflug Bild'
                            },
                            fourDays: {
                                title: 'Viertägiger Ausflug',
                                alt: 'Viertägiger Ausflug Bild'
                            },
                            viewMore: 'Weitere Ausflüge ansehen'
                        },
                        contactUs: {
                            title: 'Kontaktieren Sie Ashan Tours Sri Lanka',
                            description: 'Bereit, Sri Lanka zu erkunden? Kontaktieren Sie Ashan Tours Sri Lanka, um Ihren Traumurlaub noch heute zu planen!',
                            button: 'In Kontakt treten'
                        },
                        gallery: {
                            title: 'Unsere Galerie',
                            modalAlt: 'Galerie Bild',
                            filters: {
                                all: 'Alle',
                                tours: 'Touren',
                                accommodation: 'Unterkünfte',
                                transportation: 'Transport',
                                wildlife: 'Tierwelt'
                            },
                            tours: {
                                sigiriya2: 'Sigiriya Bild 2',
                                sigiriya3: 'Sigiriya Bild 3',
                                kandy2: 'Kandy Bild 2',
                                kandy3: 'Kandy Bild 3',
                                galle2: 'Galle Bild 2',
                                galle3: 'Galle Bild 3',
                                ella2: 'Ella Bild 2',
                                ella3: 'Ella Bild 3',
                                colomboCity: 'Colombo Stadt Bild'
                            },
                            accommodation: {
                                nuwaraEliya1: 'Nuwara Eliya Unterkunft Bild 1',
                                nuwaraEliya2: 'Nuwara Eliya Unterkunft Bild 2',
                                nuwaraEliya3: 'Nuwara Eliya Unterkunft Bild 3',
                                nuwaraEliya4: 'Nuwara Eliya Unterkunft Bild 4'
                            },
                            transportation: {
                                bentotaRiverSafari1: 'Bentota Fluss Safari Bild 1',
                                bentotaRiverSafari2: 'Bentota Fluss Safari Bild 2'
                            },
                            wildlife: {
                                yalaSafari1: 'Yala Safari Bild 1',
                                yalaSafari2: 'Yala Safari Bild 2',
                                minneriya1: 'Minneriya Bild 1',
                                minneriya2: 'Minneriya Bild 2',
                                udawalawaSafari1: 'Udawalawa Safari Bild 1',
                                udawalawaSafari2: 'Udawalawa Safari Bild 2'
                            },
                        },
                    },
                    tourPackages: {
                        title: "Tourenpakete",
                        readMore: "Mehr erfahren",
                        book: "Buchen",
                        destinationsTitle: "Reiseziele",
                        destinationImageAlt: "Reisezielbild {{index}}",
                        clickToEnlarge: "Klicken zum Vergrößern",
                        enlargedDestinationAlt: "Vergrößertes Reisezielbild",
                        bookNow: "Jetzt buchen",
                        importantNotices: "Wichtige Hinweise",
                        notices: {
                            transport: "Wir verwenden für alle unsere Touren komfortable Transportsysteme.",
                            children: "Kinder bis 5 Jahre reisen kostenlos.",
                            hygiene: "Alle unsere Touren werden mit Fokus auf Hygiene und Sicherheit durchgeführt.",
                            tickets: "Tourenpakete beinhalten Eintrittskarten, sofern nicht anders angegeben.",
                            meals: "Eintägige Touren beinhalten keine Mahlzeiten, sofern nicht ausdrücklich erwähnt.",
                        },
                        luxuryTransport: "Schließen Sie sich unserem luxuriösen Transportsystem an",
                        luxuryTransportAlt1: "Luxusfahrzeug 1",
                        luxuryTransportAlt2: "Luxusfahrzeug 2",
                        getInTouch: "Kontaktieren Sie uns, um unsere Pakete kennenzulernen",
                        getInTouchDescription: "Kontaktieren Sie uns heute, um die besten Reiseangebote für Sie zu entdecken.",
                        contactUs: "Kontaktieren Sie uns",
                        bookingMessage: "Ashan Tours Buchungsanfrage\nPaket: {{title}}\nDauer: {{duration}}\nOrt: {{location}}",
                        manualBookingMessage: "Bitte senden Sie die folgende Nachricht manuell an {{number}}:\n\n{{message}}",
                        errorBookingMessage: "Ein Fehler ist aufgetreten. Bitte senden Sie die folgende Nachricht manuell an {{number}}:\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "Ella",
                                duration: "1 Tag",
                                location: "Ella - Sri Lanka",
                                description:
                                    "Erkunden Sie die atemberaubende natürliche Schönheit von Ella mit seinen üppigen Teeplantagen, atemberaubenden Aussichten und der ikonischen Nine Arch Bridge.",
                            },
                            galleFort: {
                                title: "Galle Fort",
                                duration: "1 Tag",
                                location: "Galle - Sri Lanka",
                                description:
                                    "Reisen Sie zurück in die Zeit mit einem Besuch des historischen Galle Fort, einem UNESCO-Weltkulturerbe voller kolonialem Charme und Küstenschönheit.",
                            },
                            yalaSafari: {
                                title: "Yala Safari",
                                duration: "1 Tag",
                                location: "Yala - Sri Lanka",
                                description:
                                    "Begeben Sie sich auf ein abenteuerliches Safari im Yala-Nationalpark, Heimat von Leoparden, Elefanten und einer Vielzahl exotischer Wildtiere.",
                            },
                            kandy: {
                                title: "Kandy",
                                duration: "1 Tag",
                                location: "Kandy - Sri Lanka",
                                description:
                                    "Entdecken Sie das kulturelle Herz Sri Lankas mit einem Besuch in Kandy, einschließlich des heiligen Tempels der Zahnreliquie.",
                            },
                            sigiriya: {
                                title: "Sigiriya",
                                duration: "1 Tag",
                                location: "Sigiriya - Sri Lanka",
                                description:
                                    "Erklimmen Sie die antike Sigiriya-Felsfestung und bestaunen Sie ihre atemberaubenden Fresken und die beeindruckenden Panoramablicke.",
                            },
                            udawalawe: {
                                title: "Udawalawe",
                                duration: "1 Tag",
                                location: "Udawalawe - Sri Lanka",
                                description:
                                    "Genießen Sie ein aufregendes Safari im Udawalawe-Nationalpark, bekannt für seine große Elefantenpopulation und malerische Landschaften.",
                            },
                            colomboCityEscape: {
                                title: "Colombo Stadtabenteuer",
                                duration: "1 Tag",
                                location: "Colombo - Sri Lanka",
                                description:
                                    "Erkunden Sie die lebendige Stadt Colombo mit ihren geschäftigen Märkten, kulturellen Wahrzeichen und modernen Attraktionen.",
                            },
                            mirissaWhaleWatching: {
                                title: "Mirissa Walbeobachtung",
                                duration: "1 Tag",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Segeln Sie auf ein unvergessliches Walbeobachtungsabenteuer vor der Küste von Mirissa, wo majestätische Blauwale auf Sie warten.",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "Mirissa Walbeobachtung mit komfortablem Boot",
                                duration: "1 Tag",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Segeln Sie auf ein unvergessliches Walbeobachtungsabenteuer vor der Küste von Mirissa, wo majestätische Blauwale auf Sie warten.",
                            },
                            bentotaRiverSafari: {
                                title: "Bentota Fluss-Safari",
                                duration: "1 Tag",
                                location: "Bentota - Sri Lanka",
                                description:
                                    "Kreuzen Sie entlang des ruhigen Bentota-Flusses, umgeben von üppigen Mangroven und exotischen Wildtieren, für eine friedliche Auszeit.",
                            },
                            ellaYala: {
                                title: "Ella & Yala",
                                duration: "1 Tag",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Erleben Sie die perfekte Kombination aus Ellas malerischer Schönheit und Yalas aufregendem Wildtier-Safari an einem Tag.",
                            },
                            ellaGalle: {
                                title: "Ella & Galle",
                                duration: "1 Tag",
                                location: "Ella & Galle - Sri Lanka",
                                description:
                                    "Entdecken Sie die atemberaubenden Landschaften von Ella und den kolonialen Charme von Galle an einem Tag voller Wunder.",
                            },
                            yalaGalle: {
                                title: "Yala & Galle",
                                duration: "1 Tag",
                                location: "Yala & Galle - Sri Lanka",
                                description:
                                    "Kombinieren Sie die Aufregung eines Yala-Safaris mit einem Besuch des malerischen Galle Fort für ein wirklich vielfältiges Erlebnis.",
                            },
                            ellaYalaTwoDays: {
                                title: "Ella & Yala",
                                duration: "2 Tage",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Verbringen Sie zwei Tage damit, Ellas malerische Hochlande und die wildtierfreundlichen Landschaften des Yala-Nationalparks zu erkunden.",
                            },
                            kandyTwoDays: {
                                title: "Kandy",
                                duration: "2 Tage",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Verbringen Sie zwei Tage damit, Ellas malerische Hochlande und die wildtierfreundlichen Landschaften des Yala-Nationalparks zu erkunden.",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "Ella/Nuwara Eliya/Kandy",
                                duration: "2 Tage",
                                location: "Ella/Nuwara Eliya/Kandy - Sri Lanka",
                                description:
                                    "Besuchen Sie die Teeplantagen von Nuwara Eliya, Ellas üppiges Grün und die kulturellen Schätze von Kandy in dieser zweitägigen Tour.",
                            },
                            kandySigiriya: {
                                title: "Kandy & Sigiriya",
                                duration: "2 Tage",
                                location: "Kandy & Sigiriya - Sri Lanka",
                                description:
                                    "Genießen Sie eine kulturelle Reise nach Kandy und erklimmen Sie die ikonische Sigiriya-Felsfestung in diesem zweitägigen Abenteuer.",
                            },
                            ellaNuwaraEliya: {
                                title: "Ella & Nuwara Eliya",
                                duration: "2 Tage",
                                location: "Ella & Nuwara Eliya - Sri Lanka",
                                description:
                                    "Tauchen Sie ein in Ellas natürliche Schönheit und die kühle, ruhige Atmosphäre von Nuwara Eliya über zwei Tage.",
                            },
                            sigiriKandyElla: {
                                title: "Sigiriya/Kandy/Ella",
                                duration: "3 Tage",
                                location: "Sigiriya/Kandy/Ella - Sri Lanka",
                                description:
                                    "Erkunden Sie Sigiriya, die kulturellen Wahrzeichen von Kandy und die malerischen Landschaften von Ella über drei unvergessliche Tage.",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "Kandy/Nuwara Eliya/Ella/Yala",
                                duration: "3 Tage",
                                location: "Kandy/Nuwara Eliya/Ella/Yala - Sri Lanka",
                                description:
                                    "Entdecken Sie die vielfältigen Highlights Sri Lankas, von Kandys Kultur bis zu Yalas Wildtieren, in einer dreitägigen immersiven Tour.",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "Sigiriya/Anuradhapura/Polonnaruwa/Minneriya Nationalpark Safari",
                                duration: "3 Tage",
                                location: "Sigiriya/Anuradhapura/Polonnaruwa/Minneriya Nationalpark - Sri Lanka",
                                description:
                                    "Besuchen Sie die antiken Städte Sigiriya, Anuradhapura und Polonnaruwa und genießen Sie ein Safari im Minneriya-Nationalpark.",
                            },
                            twentyDayTour: {
                                title: "Bis zu 20 Tage Tourenpaket",
                                duration: "20 Tage",
                                location: "Sri Lanka",
                                description:
                                    "Begeben Sie sich auf eine unvergessliche 20-tägige Reise durch Sri Lanka und erkunden Sie seine kulturellen, natürlichen und historischen Wunder von Negombo bis Bentota.",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "Ravana-Wasserfall",
                            nineArchBridge: "Neun-Bogen-Brücke",
                            teaPlantation: "Teeplantage",
                            trainRide: "Zugfahrt",
                            littleAdamsPeak: "Kleiner Adams Peak",
                            udawalaweElephant: "Udawalawe Elefantenmilchfütterung",
                            ayurvedicHerbalGarden: "Ayurvedischer Kräutergarten",
                            templeKandeViharaya: "Tempel Kande Viharaya",
                            turtleHatchery: "Schildkrötenaufzuchtstation",
                            boatSafari: "Bootssafari",
                            moonstoneMine: "Mondsteinmine",
                            hikkaduwaBeach: "Hikkaduwa Strand - Schwimmen mit Schildkröten",
                            dutchFortGalle: "Holländisches Fort Galle",
                            yala: "Yala",
                            yalaSafariJeep: "Yala Safari mit Jeep",
                            kandy: "Kandy",
                            royalBotanicalGarden: "Königlicher Botanischer Garten",
                            teaFactoryPlantation: "Teefabrik und Plantage",
                            elephantFeeding: "Elefantenfütterung, Baden und Reiten",
                            ambuluwawaTowerOrTemple: "Ambuluwawa-Turm oder Tempel der Zahnreliquie",
                            jewelleryGemFactory: "Schmuck- und Edelsteinfabrik",
                            silkFactory: "Seidenfabrik",
                            sigiriya: "Sigiriya",
                            sigiriyaLionRock: "Sigiriya Löwenfelsen",
                            dambullaGoldenTemple: "Dambulla Goldener Tempel",
                            villageTour: "Dorfbesichtigung mit traditionellem sri-lankischem Essen",
                            pidurangalaRock: "Pidurangala Felsen",
                            udawalawe: "Udawalawe",
                            udawalaweNationalPark: "Udawalawe Nationalpark",
                            jeepSafari: "Jeep-Safari",
                            elephantMilkFeeding: "Elefantenmilchfütterung",
                            lotusTower: "Lotus-Turm",
                            redMosque: "Rote Moschee",
                            shopping: "Einkaufen",
                            blueWhales: "Blauwale",
                            mirissa: "Mirissa",
                            stiltFishing: "Stelzenfischen",
                            bentotaRiver: "Bentota Fluss",
                            bentota: "Bentota",
                            safariYalaNationalPark: "Safari Yala Nationalpark mit Jeep",
                            gadoladeniyaTemple: "Gadoladeniya Tempel",
                            templeOfTheToothRelic: "Tempel der Zahnreliquie",
                            traditionalKandyanDance: "Traditioneller Kandyan-Tanz",
                            luxuryHotelStay: "Luxushotelaufenthalt mit Frühstück und Abendessen",
                            teaFactory: "Teefabrik",
                            nuwaraEliyaTown: "Nuwara Eliya Stadt",
                            ambuluwawaTower: "Ambuluwawa-Turm",
                            hinduTemple: "Hindu-Tempel",
                            gregoryLake: "Gregory-See",
                            postOffice: "Postamt",
                            hortanPlains: "Hortan-Ebenen",
                            sitaAmmanHinduKovil: "Sita Amman Hindu Kovil",
                            botanicalGarden: "Botanischer Garten",
                            rambodaWaterfall: "Ramboda-Wasserfall",
                            sigiriyaRockFortress: "Sigiriya Felsfestung",
                            anuradhapura: "Anuradhapura",
                            polonnaruwa: "Polonnaruwa",
                            minneriyaNationalPark: "Minneriya Nationalpark",
                            elephants: "Elefanten",
                            day1: "Tag 1: Flughafen – Negombo: Transfer nach Negombo & frühes Einchecken, Bootstour durch das Muthurajawela-Sumpfgebiet, Entspannung – Schwimmen – Loungen – Hängematte – Wellness – Sonnenbaden – Sport – Wassersport, Übernachtung und Frühstück in Negombo",
                            day2: "Tag 2: Negombo – Anuradhapura: Heilige Stadt Anuradhapura (UNESCO-Weltkulturerbe), Sri Maha Bodhi Baum, Spaziergang um malerische Stauseen, Übernachtung und Frühstück in Anuradhapura",
                            day3: "Tag 3: Anuradhapura – Minneriya – Habarana: Aukana Buddha-Statue, Dorfsafari inklusive Katamaran- und Tuk-Tuk-Fahrt mit Mittagessen, Jeep-Safari im Minneriya-Nationalpark, Übernachtung und Frühstück in Habarana",
                            day4: "Tag 4: Habarana – Sigiriya – Ritigala – Trincomalee: Sigiriya Felsfestung (UNESCO-Weltkulturerbe), Ritigala Waldkloster, Übernachtung und Frühstück in Trincomalee",
                            day5: "Tag 5: Trincomalee: Entspannung – Schwimmen – Loungen – Hängematte – Wellness – Sonnenbaden – Sport – Wassersport, Übernachtung und Frühstück in Trincomalee",
                            day6: "Tag 6: Trincomalee: Stadtrundfahrt Trincomalee, Geburtstag von Steffi Bäuml, Entspannung – Schwimmen – Loungen – Hängematte – Wellness – Sonnenbaden – Sport – Wassersport, Überraschungskochkurs für zwei Frauen, Übernachtung und Frühstück in Trincomalee",
                            day7: "Tag 7: Trincomalee: Schnorcheltrip zur Pigeon Island, Entspannung – Schwimmen – Loungen – Hängematte – Wellness – Sonnenbaden – Sport – Wassersport, Übernachtung und Frühstück in Trincomalee",
                            day8: "Tag 8: Trincomalee: Entspannung – Schwimmen – Loungen – Hängematte – Wellness – Sonnenbaden – Sport – Wassersport, Übernachtung und Frühstück in Trincomalee",
                            day9: "Tag 9: Trincomalee – Dambulla – Matale – Peradeniya – Kandy: Dambulla Höhlentempel (UNESCO-Weltkulturerbe), Gewürzgarten in Matale, Königliche Botanische Gärten Peradeniya mit Picknick, Spaziergang durch die Altstadt von Kandy, Übernachtung und Frühstück in Kandy",
                            day10: "Tag 10: Kandy: Tempel der Zahnreliquie in Kandy (UNESCO-Weltkulturerbe), Abendliche Kandyan-Tanzvorführung, Übernachtung und Frühstück in Kandy",
                            day11: "Tag 11: Kandy – Nuwara Eliya – Ella: Teeplantagen und Teepflücken, Besuch einer Teefabrik, Ramboda-Wasserfälle, Nuwara Eliya – die Stadt über den Wolken, Spaziergang durch Ella, Übernachtung und Frühstück in Ella",
                            day12: "Tag 12: Ella – Badulla: Zugfahrt von Ella nach Badulla (2. Klasse), Wanderungen in der Umgebung von Ella, Optional: Seilrutsche, Übernachtung und Frühstück in Ella",
                            day13: "Tag 13: Ella – Yala: Ravana-Wasserfälle, Ella Gap Valley, Jeep-Safari im Yala-Nationalpark, Übernachtung und Frühstück in Tissamaharama",
                            day14: "Tag 14: Yala – Udawalawe – Sinharaja: Besuch des Elefanten-Transit-Heims während der Fütterungszeit, Fahrt zum Sinharaja-Waldreservat (UNESCO-Weltkulturerbe), Übernachtung und Frühstück in Sinharaja",
                            day15: "Tag 15: Sinharaja: Geführte Wanderung durch das Sinharaja-Waldreservat (UNESCO-Naturerbe), Übernachtung und Frühstück in Sinharaja",
                            day16: "Tag 16: Sinharaja – Galle: Altstadt von Galle, Galle Fort (UNESCO-Weltkulturerbe), Übernachtung und Frühstück in Galle",
                            day17: "Tag 17: Galle – Mirissa – Bentota: Offshore-Safari von Mirissa, Schildkröten-Schutzprojekt, Übernachtung und Frühstück in Bentota",
                            day18_19: "Tag 18–19: Bentota: Entspannung – Schwimmen – Loungen – Hängematte – Wellness – Sonnenbaden – Sport – Wassersport, Übernachtung und Frühstück in Bentota",
                            day20: "Tag 20: Bentota – Flughafen: Transfer zum Flughafen",
                        },
                    },
                    ayurvedaPage: {
                        title: "Ayurveda - Die alte Wissenschaft des Lebens",
                        mainDescription: "Das Wort 'Ayurveda' existiert seit über dreitausend Jahren. Im Sanskrit bedeutet das Wort 'Wissenschaft des Lebens'. Die Technik basiert auf der ayurvedischen Heilsicht der Krankheit anstelle ihrer Folgen, die normalerweise die europäische Medizin bekämpft. Sie postuliert die folgenden Prinzipien:",
                        principles: {
                            energyBalance: "Der Körper sollte frei von Energie sein und ein Gleichgewicht für normale Stoffwechsel- und Herzaktivität aufrechterhalten.",
                            muscleHormonal: "Der Körper sollte normale Muskelkontraktionen mit regelmäßiger hormoneller Aktivität haben.",
                            immuneSystem: "Der Körper benötigt ein gesundes Immunsystem, um richtig zu funktionieren."
                        },
                        trainingDescription: "Laut aktuellen Daten gibt es in Sri Lanka über 6.000 Absolventen, die in Ayurveda ausgebildet sind. Sie durchlaufen sieben Jahre Studium und zwei Jahre Praxis in öffentlichen Krankenhäusern. Ayurveda-Programme umfassen:",
                        programs: {
                            stressRelief: "Beseitigung von Stress, Müdigkeit und Angst",
                            oxygenSaturation: "Sauerstoffsättigung",
                            muscularToxins: "Stimulation der Muskelsysteme und Beseitigung von Toxinen",
                            nervousSystem: "Wiederherstellung des Gleichgewichts des Nervensystems",
                            bloodFlow: "Wiederherstellung des Blutflusses zu den inneren Organen",
                            endorphins: "Produktion von Endorphinen"
                        },
                        images: {
                            mainAlt: "Ayurveda",
                            faceTreatmentAlt: "Ayurveda-Gesichtsbehandlung",
                            massageTreatmentAlt: "Ayurveda-Massagebehandlung"
                        },
                        treatmentDescription: "Standardbehandlungen umfassen Körpermassagen und Kopfhautmassagen mit speziellen Ölen, Kräutersauna-Behandlungen und Bädern mit Kräutern. Die beliebteste Technik ist das 'Shirodhara-Verfahren', bei dem warmes Kräuteröl rhythmisch auf die Stirn getropft wird. Dies hilft, das Gleichgewicht des Nervensystems wiederherzustellen und Entspannung zu erreichen.",
                        tipsTitle: "Tipps für ayurvedische Behandlungen",
                        tips: {
                            relaxMind: "Vergessen Sie Probleme. Entspannen Sie sich und klären Sie Ihren Geist für die besten Ergebnisse.",
                            chooseLocation: "Wählen Sie den richtigen Ort. Wählen Sie eine Umgebung, die Ihren Komfort und Vorlieben entspricht, für optimale Heilung.",
                            selectProgram: "Wählen Sie das richtige Programm. Besprechen Sie Ihre Anliegen mit dem Arzt und probieren Sie verschiedene Therapien, um herauszufinden, was am besten zu Ihnen passt.",
                            warmBath: "Nehmen Sie vor der Behandlung ein warmes Bad, um Ihre Muskeln zu entspannen und Ihren Körper vorzubereiten.",
                            lightMeal: "Essen Sie vor dem Verfahren eine leichte Mahlzeit. Vermeiden Sie schwere Mahlzeiten, um einen ordnungsgemäßen Blutfluss während der Massage zu ermöglichen.",
                            postRelaxation: "Entspannung nach den Verfahren ist essenziell. Eine angemessene Entspannung erhöht die Wirksamkeit ayurvedischer Behandlungen."
                        },
                    },
                    ballooningPage: {
                        title: "Ballonfahren in Sri Lanka",
                        mainDescription: "Heißluftballonfahren in Sri Lanka bietet ein unvergessliches Erlebnis, sanft über die atemberaubenden Landschaften der Insel zu schweben. Die Ballonfahrten beginnen bei Sonnenaufgang und bieten spektakuläre Luftaufnahmen von hügeligen Landschaften, üppigen Wäldern, antiken Ruinen und ruhigen Dörfern.",
                        dambullaDescription: "Das beliebteste Ziel für Ballonfahrten in Sri Lanka ist Dambulla, im Herzen des kulturellen Dreiecks gelegen. Ballonfahrten hier führen oft über die ikonische Sigiriya-Felsfestung und bieten eine unvergleichliche Perspektive. Die Flüge dauern in der Regel 60-90 Minuten, sodass Sie ausreichend Zeit haben, die Schönheit Sri Lankas von oben zu genießen.",
                        highlightsTitle: "Warum Heißluftballonfahren in Sri Lanka ausprobieren?",
                        highlightsDescription: "Heißluftballonfahren kombiniert Abenteuer mit Ruhe und ermöglicht es Ihnen, die Schönheit Sri Lankas auf einzigartige Weise zu erleben. Zu den Highlights des Ballonfahrens gehören:",
                        highlights: {
                            panoramicViews: "Ununterbrochene Panoramablicke auf die atemberaubenden Landschaften der Insel.",
                            landmarks: "Überfliegen ikonischer Wahrzeichen wie der Sigiriya-Felsfestung und nahegelegener Seen.",
                            peacefulRide: "Eine ruhige und friedliche Fahrt über üppiges Grün und charmante Dörfer.",
                            sunrise: "Das Erleben eines spektakulären Sonnenaufgangs vom Himmel aus.",
                            photography: "Perfekt für Fotografiebegeisterte, die die landschaftliche Schönheit von oben einfangen möchten."
                        },
                        images: {
                            mainAlt: "Heißluftballonfahren in Sri Lanka",
                            sunriseAlt: "Sonnenaufgang im Heißluftballon",
                            sunriseCaption: "Genießen Sie atemberaubende Ausblicke auf den Sonnenaufgang, während Sie sanft in einem Heißluftballon schweben.",
                            landscapeAlt: "Landschaft im Heißluftballon",
                            landscapeCaption: "Erleben Sie die atemberaubenden Landschaften Sri Lankas von oben, einschließlich hügeliger Landschaften und üppiger Wälder."
                        },
                        tipsTitle: "Tipps für eine unvergessliche Ballonfahrt",
                        tips: {
                            bookEarly: "Buchen Sie Ihre Fahrt frühzeitig, da Ballonfahrten wetterabhängig sind und die Plätze schnell vergriffen sind.",
                            clothing: "Tragen Sie bequeme Kleidung und nehmen Sie eine leichte Jacke mit, da die frühen Morgenstunden kühl sein können.",
                            camera: "Nehmen Sie eine Kamera oder ein Smartphone mit, um die atemberaubenden Ausblicke festzuhalten.",
                            safety: "Hören Sie aufmerksam auf die Sicherheitsanweisungen Ihres Piloten.",
                            arriveEarly: "Kommen Sie pünktlich, um die Vorbereitung und das Aufblasen des Ballons zu beobachten, ein faszinierender Prozess."
                        },
                    },
                    divingPage: {
                        title: "Tauchen in Sri Lanka",
                        mainDescription: "Ein breites Korallenriff umgibt die Küste Sri Lankas in Tiefen von 2 bis 40 Metern. Die warmen Gewässer des Indischen Ozeans, zwischen 27°C und 30°C, und die hohe Transparenz des Wassers, von 15 bis 35 Metern, bieten hervorragende Bedingungen für Tauchen und Schnorcheln. Beim Tauchen in Sri Lanka können Sie unberührte Korallenriffe, alte Wracks und faszinierende Unterwasserhöhlen erkunden.",
                        northeastDescription: "Der Nordosten der Insel bietet eine Vielfalt von über 130 Arten farbenfroher Korallen, die Heimat von Meereslebewesen wie Meeresschildkröten, Clownfischen, Löwenfischen und Seepferdchen sind. Besuchen Sie Schiffswracks in der Nähe von Unterwasserfelsen und Riffen für ein unvergessliches Erlebnis. Während Sie in den klaren Gewässern schweben, tauchen Sie in die faszinierende Vergangenheit Ceylons ein.",
                        facilitiesTitle: "Einrichtungen und beste Tauchplätze",
                        facilitiesDescription: "Die Tauchzentren der Insel sind mit modernster Tauchausrüstung von renommierten Herstellern ausgestattet. Zertifizierte Instruktoren mit PADI- und CMAS-Qualifikationen sorgen für sichere und angenehme Tauchgänge. Tauchzentren befinden sich entlang der Südwestküste der Insel und sind von Mitte Oktober bis Ende April in Betrieb. Die Nordostküste, einschließlich Nilaveli und Trincomalee, ist ideal zum Tauchen von März bis Oktober.",
                        popularSpots: "Die Korallenriffe in der Nähe von Kalpitiya im Westen und die Schiffswrack-Tauchplätze in Hikkaduwa gehören zu den beliebtesten Attraktionen für Taucher.",
                        images: {
                            mainAlt: "Tauchen in Sri Lanka",
                            coralReefAlt: "Korallenriff-Tauchen",
                            coralReefCaption: "Erkunden Sie lebendige Korallenriffe, die Heimat einer vielfältigen Meeresfauna sind.",
                            shipwreckAlt: "Schiffswrack-Tauchen",
                            shipwreckCaption: "Entdecken Sie historische Schiffswracks, die einen Einblick in die maritime Vergangenheit Sri Lankas bieten."
                        },
                        tipsTitle: "Tipps für Taucher",
                        tips: {
                            season: "Wählen Sie die beste Jahreszeit zum Tauchen basierend auf dem Standort: Südwestküste (Oktober bis April) oder Nordostküste (März bis Oktober).",
                            certifiedCenter: "Stellen Sie sicher, dass Ihr Tauchzentrum zertifiziert ist und mit moderner Ausrüstung für ein sicheres Erlebnis ausgestattet ist.",
                            instructorAdvice: "Hören Sie auf die Ratschläge Ihres Instruktors, besonders wenn Sie Anfänger sind.",
                            respectMarineLife: "Respektieren Sie das Meeresleben, indem Sie Korallen nicht berühren oder die Unterwasserumgebung stören.",
                            camera: "Nehmen Sie eine wasserdichte Kamera mit, um die faszinierende Schönheit der Unterwasserwelt Sri Lankas festzuhalten."
                        },
                    },
                    elephantRidePage: {
                        title: "Elefantenritt",
                        mainDescription: "Elefantentrekking ist eine faszinierende, aufregende Aktivität und ein einzigartiges Erlebnis in Sri Lanka. Wenn Sie in der Nähe des kulturellen Dreiecks in Gebieten wie Habarana, Sigiriya oder Dambulla übernachten, können Sie an einer Elefantensafari teilnehmen. Diese Ausflüge beginnen bei etwa 30 US-Dollar für eine Stunde unvergesslichen Abenteuers.",
                        rideDescription: "Vor dem Ritt werden die Elefanten mit einem Mehrpersonenkorb ausgestattet, der für 4 bis 6 Personen ausgelegt ist. Diese sanften Riesen führen Sie durch malerische Dschungelpfade, überqueren überschwemmte Gebiete und navigieren durch üppige Vegetation. Elefanten gehen normalerweise langsam, sodass Sie die Schönheit der umliegenden Natur voll und ganz genießen können, obwohl sie Geschwindigkeiten von bis zu 40 km/h erreichen können.",
                        highlightsTitle: "Highlights eines Elefantenritts",
                        highlightsDescription: "Ein Elefantenritt in Sri Lanka bietet eine einzigartige Möglichkeit, mit der Natur in Kontakt zu treten und die Landschaft zu erkunden. Zu den Highlights des Erlebnisses gehören:",
                        highlights: {
                            junglePaths: "Durch dichte Dschungel mit exotischer Vegetation und Tierwelt spazieren.",
                            riverCrossing: "Flüsse und überschwemmte Gebiete überqueren, die atemberaubende Ausblicke auf die natürliche Landschaft bieten.",
                            culturalConnection: "Erfahren Sie mehr über die enge Beziehung zwischen Elefanten und der sri-lankischen Kultur.",
                            comfortableRide: "Entspannen Sie sich auf einem bequemen Sattel, während der Elefant Sie sanft durch verschiedene Landschaften trägt."
                        },
                        images: {
                            mainAlt: "Elefantenritt",
                            jungleAlt: "Elefantenritt Dschungelpfad",
                            jungleCaption: "Erkunden Sie dichte Dschungel und malerische Pfade, während Sie auf einem Elefanten reiten.",
                            waterAlt: "Elefant überquert Wasser",
                            waterCaption: "Überqueren Sie Flüsse und genießen Sie die ruhige Schönheit des Wassers und der Vegetation."
                        },
                        tipsTitle: "Tipps für einen sicheren und angenehmen Elefantenritt",
                        tips: {
                            clothing: "Tragen Sie bequeme Kleidung und Schuhe, die für Outdoor-Aktivitäten geeignet sind.",
                            guideInstructions: "Folgen Sie den Anweisungen Ihres Führers für eine sichere und angenehme Fahrt.",
                            ethicalPractices: "Stellen Sie sicher, dass die Elefanten gut behandelt werden und der Anbieter ethische Praktiken einhält.",
                            camera: "Bringen Sie eine Kamera mit, um die atemberaubende Landschaft und Momente festzuhalten.",
                            respectElephants: "Respektieren Sie die Elefanten und vermeiden Sie Handlungen, die sie stressen oder schädigen könnten."
                        },
                    },
                    fishingPage: {
                        title: "Angeln in Sri Lanka",
                        mainDescription: "Sri Lanka bietet mit seiner ausgedehnten Küste und zahlreichen Süßwasserseen und Flüssen ein unvergleichliches Angelerlebnis. Ob Sie ein professioneller Angler oder ein Hobbyist sind, Sri Lanka hat etwas zu bieten. Von Hochseeangel-Expeditionen bis hin zum traditionellen Stelzenfischen der lokalen Fischer erwartet Sie ein unvergessliches Abenteuer.",
                        destinationsDescription: "Beliebte Angelziele sind die Südküste rund um Galle und Mirissa, die Negombo-Lagune und die ruhigen Gewässer von Trincomalee. Je nach Vorliebe können Sie verschiedene Angeltechniken wie Schleppangeln, Grundangeln oder Fliegenfischen ausprobieren.",
                        experiencesTitle1: "Angelerlebnisse in Sri Lanka",
                        experiencesDescription: "Angeln in Sri Lanka bedeutet nicht nur Fische fangen; es ist eine Gelegenheit, in die Kultur und Traditionen der Insel einzutauchen. Einige einzigartige Angelerlebnisse sind:",
                        experiences: {
                            stiltFishingTitle: "Stelzenfischen",
                            stiltFishing: "Eine traditionelle Methode, bei der Fischer auf Stelzen sitzen, um in Küstennähe Fische zu fangen, eine Praxis, die einzigartig für Sri Lanka ist.",
                            deepSeaFishingTitle: "Hochseeangeln",
                            deepSeaFishing: "Begeben Sie sich in den Indischen Ozean, um Marline, Thunfische, Barrakudas und andere große Fischarten zu fangen.",
                            lagoonFishingTitle: "Lagunen- und Flussangeln",
                            lagoonFishing: "Entspannen Sie sich beim Angeln in ruhigen Lagunen und Flüssen, die von Fischen wie Tilapia und Wels wimmeln.",
                            nightFishingTitle: "Nachtangeln",
                            nightFishing: "Erleben Sie den Nervenkitzel des Angelns unter den Sternen, eine gängige Praxis in Küstendörfern."
                        },
                        images: {
                            mainAlt: "Angeln in Sri Lanka",
                            stiltFishingAlt: "Stelzenfischen in Sri Lanka",
                            stiltFishingCaption: "Stelzenfischen ist eine traditionelle Methode und ein ikonisches Bild des Fischererbes Sri Lankas.",
                            deepSeaFishingAlt: "Hochseeangeln in Sri Lanka",
                            deepSeaFishingCaption: "Hochseeangeln bietet ein abenteuerliches Erlebnis, das auf große Fischarten im Indischen Ozean abzielt."
                        },
                        tipsTitle: "Tipps für einen angenehmen Angelausflug",
                        tips: {
                            season: "Wählen Sie die richtige Jahreszeit für Ihre Angel-Expedition; Oktober bis April ist ideal für die Südküste, während März bis Oktober für die Ostküste geeignet ist.",
                            protection: "Bringen Sie Sonnencreme, einen Hut und Schutzkleidung mit, um während Ihrer Reise komfortabel zu bleiben.",
                            guide: "Buchen Sie einen Angelguide oder eine Charter, um das Beste aus Ihrem Erlebnis herauszuholen und von Experten zu lernen.",
                            environment: "Respektieren Sie die lokale Umwelt, indem Sie keinen Müll hinterlassen und nachhaltige Angelpraktiken einhalten.",
                            hydration: "Bleiben Sie hydriert und nehmen Sie Snacks für längere Angelausflüge mit."
                        },
                    },
                    jeepSafariPage: {
                        title: "Jeep-Safari in Sri Lanka",
                        mainDescription: "Die Nationalparks Sri Lankas bieten ein aufregendes Jeep-Safari-Erlebnis, das es Ihnen ermöglicht, die reiche Artenvielfalt der Insel zu erkunden und Wildtiere in ihren natürlichen Lebensräumen zu beobachten. Der Yala-Nationalpark, der Wilpattu-Nationalpark und der Udawalawe-Nationalpark gehören zu den beliebtesten Zielen für Jeep-Safaris.",
                        wildlifeDescription: "Diese Safaris bieten die Möglichkeit, Elefanten, Leoparden, Faultiere, Wasserbüffel, Krokodile und eine Vielzahl von Vogelarten zu sehen. Geleitet von erfahrenen Naturforschern und Trackern sind Jeep-Safaris ideal für Wildtierliebhaber und Fotografen.",
                        whyChooseTitle: "Warum eine Jeep-Safari wählen?",
                        whyChooseDescription: "Jeep-Safaris sind eine der besten Möglichkeiten, die vielfältige Tierwelt Sri Lankas zu erkunden. Hier sind einige Highlights:",
                        whyChoose: {
                            encounters: "Nahe Begegnungen mit ikonischen Arten wie Elefanten und Leoparden.",
                            remoteAreas: "Zugang zu abgelegenen und malerischen Gebieten innerhalb der Nationalparks.",
                            photography: "Möglichkeiten für Wildtierfotografie in einer natürlichen Umgebung.",
                            guidance: "Führung durch kenntnisreiche Naturforscher und Parkranger.",
                            adventure: "Ein Abenteuer, das für alle Altersgruppen geeignet ist und Spannung mit Bildung verbindet."
                        },
                        images: {
                            mainAlt: "Jeep-Safari in Sri Lanka",
                            wildlifeAlt: "Wildtiere auf Jeep-Safari",
                            wildlifeCaption: "Beobachten Sie ikonische Wildtiere wie Leoparden, Elefanten und Krokodile während Ihrer Safari.",
                            landscapeAlt: "Jeep-Safari-Landschaft",
                            landscapeCaption: "Erkunden Sie die atemberaubenden Landschaften der Nationalparks Sri Lankas, von dichten Wäldern bis hin zu offenen Ebenen."
                        },
                        tipsTitle: "Tipps für eine angenehme Jeep-Safari",
                        tips: {
                            clothing: "Tragen Sie bequeme, neutralfarbene Kleidung, um sich in die Umgebung einzufügen.",
                            protection: "Bringen Sie Sonnencreme, einen Hut und Insektenschutzmittel zum Schutz mit.",
                            equipment: "Nehmen Sie ein Fernglas und eine Kamera mit, um Ihr Erlebnis zu verbessern und Wildtiere einzufangen.",
                            guide: "Folgen Sie den Anweisungen des Führers, um Sicherheit und Respekt vor den Tieren zu gewährleisten.",
                            booking: "Buchen Sie Ihre Safari frühzeitig, besonders in der Hochsaison, um einen Platz zu sichern."
                        },
                    },
                    riverSafariPage: {
                        title: "Fluss-Safari in Sri Lanka",
                        mainDescription: "Eine Fluss-Safari in Sri Lanka bietet eine einzigartige Möglichkeit, die reiche Artenvielfalt und die malerische Schönheit der Insel zu erkunden. Gleiten Sie entlang ruhiger Wasserwege, umgeben von üppigen Mangroven, entdecken Sie exotische Wildtiere und genießen Sie malerische Sonnenuntergänge, die Sie in Staunen versetzen werden.",
                        destinationsDescription: "Beliebte Fluss-Safari-Ziele sind der Madu Ganga (Madu-Fluss) und der Bentota-Fluss. Diese Safaris bieten die Möglichkeit, verschiedene Vogelarten, Warane, Krokodile und sogar Affen in ihren natürlichen Lebensräumen zu beobachten. Die ruhige Umgebung ist perfekt für Naturliebhaber und Fotografen.",
                        whyChooseTitle: "Warum eine Fluss-Safari wählen?",
                        whyChooseDescription: "Eine Fluss-Safari ist ein entspannendes und immersives Erlebnis, das Natur, Wildtiere und kulturelle Erkundungen kombiniert. Hier sind einige Highlights:",
                        whyChoose: {
                            mangroves: "Erkunden Sie üppige Mangroven voller Leben.",
                            wildlife: "Entdecken Sie exotische Vögel, Krokodile und andere Wildtiere.",
                            villages: "Besuchen Sie kleine Inseln und lokale Dörfer entlang des Flusses.",
                            tranquility: "Genießen Sie die Ruhe und die malerische Schönheit der Wasserwege Sri Lankas.",
                            suitable: "Perfekt für Familien, Paare und Alleinreisende, die einen friedlichen Rückzugsort suchen."
                        },
                        images: {
                            mainAlt: "Fluss-Safari in Sri Lanka",
                            mangrovesAlt: "Mangroven auf Fluss-Safari",
                            mangrovesCaption: "Entdecken Sie die üppigen Mangroven, die die malerischen Wasserwege Sri Lankas säumen.",
                            wildlifeAlt: "Wildtiere auf Fluss-Safari",
                            wildlifeCaption: "Entdecken Sie exotische Wildtiere wie Krokodile, Warane und farbenfrohe Vögel während Ihrer Safari."
                        },
                        tipsTitle: "Tipps für eine angenehme Fluss-Safari",
                        tips: {
                            clothing: "Tragen Sie bequeme Kleidung und bringen Sie einen Hut und Sonnencreme zum Schutz mit.",
                            binoculars: "Nehmen Sie ein Fernglas mit, um entfernte Wildtiere und Vögel zu entdecken.",
                            camera: "Bringen Sie eine Kamera oder ein Smartphone mit, um die atemberaubende Landschaft und Wildtiere einzufangen.",
                            guide: "Folgen Sie den Anweisungen Ihres Führers für ein sicheres und angenehmes Erlebnis.",
                            environment: "Respektieren Sie die natürliche Umgebung, indem Sie keinen Müll hinterlassen und Wildtiere nicht stören."
                        },
                    },
                    snorkelingPage: {
                        title: "Schnorcheln in Sri Lanka",
                        mainDescription: "Schnorcheln in Sri Lanka bietet ein unvergessliches Unterwassererlebnis, bei dem Sie lebendige Korallenriffe und vielfältiges Meeresleben erkunden können. Mit seinen kristallklaren Gewässern und reichen aquatischen Ökosystemen ist Sri Lanka ein Paradies für Schnorchler aller Erfahrungsstufen.",
                        destinationsDescription: "Zu den beliebtesten Schnorchelplätzen gehören Hikkaduwa, bekannt für seine farbenfrohen Korallengärten und Schildkröten, Pigeon Island in Trincomalee, berühmt für seine unberührten Riffe, und Mirissa, wo Sie während der Schnorchelsaison sogar einen Wal oder zwei entdecken könnten.",
                        whyChooseTitle: "Warum Schnorcheln in Sri Lanka wählen?",
                        whyChooseDescription: "Schnorcheln in Sri Lanka ist ein magisches Erlebnis, das Abenteuer und natürliche Schönheit verbindet. Hier sind einige Highlights:",
                        whyChoose: {
                            coralReefs: "Erkunden Sie lebendige Korallenriffe voller Leben.",
                            marineLife: "Schwimmen Sie neben bunten Tropenfischen, Schildkröten und sogar Riffhaien.",
                            landscapes: "Entdecken Sie unberührte Unterwasserlandschaften in klarem, warmem Wasser.",
                            suitable: "Geeignet für Anfänger und erfahrene Schnorchler.",
                            accessible: "Zugänglich von einigen der besten Stranddestinationen in Sri Lanka."
                        },
                        images: {
                            mainAlt: "Schnorcheln in Sri Lanka",
                            coralReefAlt: "Korallenriffe in Sri Lanka",
                            coralReefCaption: "Entdecken Sie atemberaubende Korallenriffe und ihre lebendigen Ökosysteme.",
                            marineLifeAlt: "Meeresleben in Sri Lanka",
                            marineLifeCaption: "Begegnen Sie vielfältigem Meeresleben, einschließlich Schildkröten, Tropenfischen und mehr."
                        },
                        tipsTitle: "Tipps für ein unvergessliches Schnorchelerlebnis",
                        tips: {
                            mask: "Tragen Sie eine bequeme Maske und einen Schnorchel, um eine klare Sicht unter Wasser zu gewährleisten.",
                            sunscreen: "Verwenden Sie riffschonende Sonnencreme, um Ihre Haut und das Meeresleben zu schützen.",
                            swimGently: "Schwimmen Sie sanft, um Korallenriffe und Wasserlebewesen nicht zu stören.",
                            hydration: "Bleiben Sie hydriert und machen Sie Pausen zwischen den Sessions.",
                            guidedTour: "Nehmen Sie an einer geführten Tour teil, um die besten Schnorchelplätze und Sicherheitstipps zu erfahren."
                        },
                    },
                    teaTastingPage: {
                        title: "Teeverkostungstour in Sri Lanka",
                        mainDescription: "Sri Lanka, oft als die 'Perle des Indischen Ozeans' bezeichnet, ist berühmt für seine erstklassige Teepproduktion. Begeben Sie sich auf eine Teeverkostungstour und erkunden Sie die üppigen Teeplantagen in Regionen wie Nuwara Eliya, Ella und Kandy. Lernen Sie die Kunst des Teeanbaus, den sorgfältigen Prozess der Teeproduktion und genießen Sie die reichen Aromen authentischen Ceylon-Tees.",
                        heritageDescription: "Ob Sie ein Teeliebhaber oder einfach neugierig sind, eine Teeverkostungstour bietet eine einzigartige Gelegenheit, in das Teeerbe Sri Lankas einzutauchen und die ruhige Schönheit seiner Hochlande zu erleben.",
                        whyChooseTitle: "Warum eine Teeverkostungstour wählen?",
                        whyChooseDescription: "Eine Teeverkostungstour in Sri Lanka ist nicht nur eine Verkostung von Tee – es ist ein immersives kulturelles Erlebnis. Hier sind einige Highlights:",
                        whyChoose: {
                            plantations: "Besuchen Sie malerische Teeplantagen, die in den kühlen Hochlanden liegen.",
                            history: "Lernen Sie die Geschichte und Bedeutung des Ceylon-Tees kennen.",
                            production: "Nehmen Sie am Teepflücken teil und beobachten Sie den Produktionsprozess in Teefabriken.",
                            varieties: "Genießen Sie verschiedene Teesorten, von Schwarz- bis Grüntee bis hin zu aromatisierten Mischungen.",
                            scenery: "Erfreuen Sie sich an der atemberaubenden Landschaft aus nebligen Bergen und kaskadenartigen Wasserfällen."
                        },
                        images: {
                            mainAlt: "Teeverkostungstour in Sri Lanka",
                            teaPlantationAlt: "Teeplantage in Sri Lanka",
                            teaPlantationCaption: "Erkunden Sie üppige Teeplantagen und lernen Sie über den Teeanbau.",
                            teaPreparationAlt: "Teezubereitung in Sri Lanka",
                            teaPreparationCaption: "Entdecken Sie die Kunst der Teezubereitung und genießen Sie authentischen Ceylon-Tee."
                        },
                        tipsTitle: "Tipps für eine angenehme Teeverkostungstour",
                        tips: {
                            clothing: "Tragen Sie bequeme Kleidung und Schuhe für Spaziergänge durch Plantagen.",
                            jacket: "Bringen Sie eine leichte Jacke mit, da Hochlandregionen kühl und neblig sein können.",
                            varieties: "Probieren Sie verschiedene Teesorten und nehmen Sie Ihre Favoriten als Souvenirs mit nach Hause.",
                            questions: "Stellen Sie während der Tour Fragen, um mehr über den Teezubereitungsprozess zu erfahren.",
                            attractions: "Kombinieren Sie Ihre Teetour mit Besuchen in nahegelegenen Attraktionen wie Wasserfällen und Aussichtspunkten."
                        },
                    },
                    templeVisitPage: {
                        title: "Tempelbesuch in Sri Lanka",
                        mainDescription: "Sri Lanka, bekannt als das Land Buddhas, beherbergt alte Tempel, die sein reiches spirituelles und kulturelles Erbe widerspiegeln. Begeben Sie sich auf eine Reise, um ikonische Tempel wie den Tempel des Zahns in Kandy, den Dambulla-Höhlentempel und Ruwanwelisaya in Anuradhapura zu erkunden.",
                        spiritualDescription: "Diese heiligen Stätten, geschmückt mit aufwendigen Schnitzereien, Wandmalereien und Statuen, bieten einen Einblick in die spirituellen Traditionen und die architektonische Brillanz der Insel. Ein Tempelbesuch ist nicht nur ein kulturelles Erlebnis, sondern auch eine Gelegenheit, Frieden und Ruhe zu finden.",
                        whyVisitTitle: "Warum Tempel in Sri Lanka besuchen?",
                        whyVisitDescription: "Der Besuch von Tempeln in Sri Lanka bietet eine einzigartige Gelegenheit, sich mit der Geschichte, Kultur und Spiritualität der Insel zu verbinden. Hier sind einige Highlights:",
                        whyVisit: {
                            architecture: "Bewundern Sie die aufwendige Architektur und jahrhundertealte Statuen.",
                            traditions: "Lernen Sie buddhistische Traditionen und Rituale von kenntnisreichen Führern kennen.",
                            heritage: "Erkunden Sie UNESCO-Welterbestätten wie den Goldenen Tempel von Dambulla.",
                            serenity: "Erleben Sie die Gelassenheit und spirituelle Atmosphäre heiliger Räume.",
                            festivals: "Erleben Sie lebendige Feste wie Esala Perahera im Tempel des Zahns."
                        },
                        images: {
                            mainAlt: "Tempelbesuch in Sri Lanka",
                            templeInteriorAlt: "Tempelinneres",
                            templeInteriorCaption: "Bewundern Sie die atemberaubenden Innenräume, die mit aufwendigen Schnitzereien und Wandmalereien geschmückt sind.",
                            sacredTempleAlt: "Heiliger Tempel in Sri Lanka",
                            sacredTempleCaption: "Besuchen Sie heilige Tempel wie Ruwanwelisaya und tauchen Sie ein in spirituelle Traditionen."
                        },
                        tipsTitle: "Tipps für den Besuch von Tempeln in Sri Lanka",
                        tips: {
                            dress: "Kleiden Sie sich bescheiden und bedecken Sie Schultern und Knie als Zeichen des Respekts.",
                            shoes: "Ziehen Sie Ihre Schuhe aus, bevor Sie das Tempelgelände betreten.",
                            touching: "Vermeiden Sie es, Statuen oder heilige Objekte zu berühren.",
                            donation: "Bringen Sie eine kleine Spende für den Tempel mit, wenn Sie beitragen möchten.",
                            silence: "Respektieren Sie die Stille und die spirituelle Atmosphäre während Ihres Besuchs."
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "Wildwasser-Rafting in Sri Lanka",
                        mainDescription: "Wildwasser-Rafting in Sri Lanka ist ein aufregendes Erlebnis, insbesondere in Kitulgala, der Abenteuerhauptstadt der Insel. Der Kelani-Fluss mit seinen tosenden Stromschnellen und malerischen Umgebungen bietet die perfekte Kulisse für Anfänger und erfahrene Rafting-Enthusiasten.",
                        destinationsDescription: "Rafting-Expeditionen erstrecken sich in der Regel über eine 5-Kilometer-Strecke mit Stromschnellen von Grad 2 bis Grad 4. Die Teilnehmer können den Nervenkitzel beim Navigieren durch herausfordernde Strömungen genießen und dabei die üppige Vegetation und atemberaubende Ausblicke auf die Flussufer erleben.",
                        whyChooseTitle: "Warum Wildwasser-Rafting in Sri Lanka wählen?",
                        whyChooseDescription: "Wildwasser-Rafting in Sri Lanka bietet eine einzigartige Kombination aus Abenteuer und natürlicher Schönheit. Hier sind einige Highlights des Erlebnisses:",
                        whyChoose: {
                            rapids: "Navigieren Sie durch aufregende Stromschnellen unter der Anleitung erfahrener Instruktoren.",
                            views: "Genießen Sie atemberaubende Ausblicke auf den umliegenden Regenwald und das bergige Gelände.",
                            activities: "Kombinieren Sie Rafting mit anderen Aktivitäten wie Trekking, Vogelbeobachtung und Canyoning in Kitulgala.",
                            suitable: "Perfekt für Gruppen, Familien oder Alleinreisende, die einen Adrenalinkick suchen."
                        },
                        images: {
                            mainAlt: "Wildwasser-Rafting in Sri Lanka",
                            actionRaftingAlt: "Wildwasser-Rafting-Aktion",
                            actionRaftingCaption: "Spüren Sie den Adrenalinkick, während Sie herausfordernde Stromschnellen auf dem Kelani-Fluss bezwingen.",
                            scenicRaftingAlt: "Wildwasser-Rafting-Aussichten",
                            scenicRaftingCaption: "Genießen Sie die ruhige Schönheit der üppigen Umgebung während Ihres Rafting-Abenteuers."
                        },
                        tipsTitle: "Tipps für eine sichere und aufregende Rafting-Tour",
                        tips: {
                            safetyGear: "Tragen Sie zur Sicherheit eine Schwimmweste und einen Helm, die von Ihrem Rafting-Guide bereitgestellt werden.",
                            instructions: "Hören Sie vor Beginn der Tour sorgfältig auf die Sicherheitsanweisungen.",
                            clothing: "Tragen Sie bequeme, schnell trocknende Kleidung und sicheres Schuhwerk wie Wasserschuhe.",
                            changeOfClothes: "Bringen Sie Wechselkleidung und ein Handtuch für nach der Tour mit.",
                            operator: "Buchen Sie Ihre Rafting-Tour bei einem seriösen Anbieter, um ein sicheres und angenehmes Erlebnis zu gewährleisten."
                        },
                    },
                    wildlifeSafariPage: {
                        title: "Wildlife-Safari in Sri Lanka",
                        mainDescription: "Sri Lanka, bekannt für seine reiche Biodiversität, bietet unglaubliche Wildlife-Safaris in Nationalparks wie Yala, Wilpattu, Minneriya und Udawalawe. Diese Safaris bieten die Möglichkeit, Elefanten, Leoparden, Faultiere und eine Vielzahl von Vogelarten in ihren natürlichen Lebensräumen zu beobachten.",
                        destinationsDescription: "Erkunden Sie vielfältige Landschaften, von dichten Wäldern bis hin zu offenen Graslandschaften, und halten Sie unvergessliche Momente der Tierwelt fest. Mit erfahrenen Führern und gut gewarteten Safari-Jeeps ist eine Wildlife-Safari in Sri Lanka ein Muss für Naturliebhaber und Abenteuersuchende.",
                        whyChooseTitle: "Warum eine Wildlife-Safari wählen?",
                        whyChooseDescription: "Eine Wildlife-Safari in Sri Lanka bietet eine einzigartige Gelegenheit, sich mit der Natur zu verbinden und die bemerkenswerte Biodiversität der Insel zu erkunden. Highlights sind:",
                        whyChoose: {
                            species: "Beobachtung ikonischer Arten wie Elefanten, Leoparden und Krokodile.",
                            landscapes: "Erkundung üppiger Wälder, Feuchtgebiete und offener Ebenen voller Wildtiere.",
                            photography: "Aufnahme beeindruckender Wildtierfotografien in natürlicher Umgebung.",
                            elusiveAnimals: "Erleben Sie den Nervenkitzel, schwer fassbare Tiere wie den srilankischen Leoparden zu entdecken.",
                            conservation: "Erfahren Sie mehr über Naturschutzbemühungen von erfahrenen Führern und Naturforschern."
                        },
                        images: {
                            mainAlt: "Wildlife-Safari in Sri Lanka",
                            elephantsAlt: "Elefanten in Sri Lanka",
                            elephantsCaption: "Erleben Sie majestätische Elefanten, die frei in den Nationalparks Sri Lankas umherstreifen.",
                            leopardAlt: "Srilankischer Leopard",
                            leopardCaption: "Entdecken Sie den schwer fassbaren srilankischen Leoparden, ein Highlight jeder Wildlife-Safari."
                        },
                        tipsTitle: "Tipps für eine aufregende Wildlife-Safari",
                        tips: {
                            clothing: "Tragen Sie neutralfarbene Kleidung, um sich in die Umgebung einzufügen.",
                            protection: "Bringen Sie Sonnenschutz, einen Hut und Insektenschutzmittel mit.",
                            equipment: "Bringen Sie Fernglas und eine Kamera mit, um Wildtiere zu beobachten und festzuhalten.",
                            guide: "Folgen Sie den Anweisungen Ihres Führers für ein sicheres und angenehmes Erlebnis.",
                            booking: "Buchen Sie frühzeitig, insbesondere in der Hochsaison, um einen Platz in beliebten Parks zu sichern."
                        },
                    },
                },
            },
            ru: {
                translation: {
                    home: 'Главная',
                    about: 'О нас',
                    srilanka: 'Шри-Ланка',
                    excursions: 'Экскурсии',
                    tour: 'Забронировать тур',
                    things: 'Чем заняться',
                    contact: {
                        navLabel: 'Связаться с нами',
                        getInTouch: 'Связаться',
                        address: 'Адрес',
                        mobile: 'Мобильный',
                        email: 'Электронная почта',
                        website: 'Веб-сайт',
                        sendMessage: 'Отправьте нам сообщение',
                        fullName: 'Полное имя',
                        fullNamePlaceholder: 'Введите ваше полное имя',
                        country: 'Страна',
                        countryPlaceholder: 'Введите вашу страну',
                        emailPlaceholder: 'Введите вашу электронную почту',
                        subject: 'Тема',
                        subjectPlaceholder: 'Введите тему',
                        message: 'Сообщение',
                        messagePlaceholder: 'Введите ваше сообщение',
                        reset: 'Сбросить',
                        submit: 'Отправить',
                        ourLocation: 'Наше местоположение',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Сообщение гостя Ashan Tours Sri Lanka',
                        manualMessage: 'Пожалуйста, отправьте следующее сообщение вручную на',
                        errorMessage: 'Произошла ошибка. Пожалуйста, отправьте следующее сообщение вручную на',
                    },
                    footerSection: {
                        ashanTours: 'Ashan Tours Шри-Ланка',
                        getInTouch: 'Свяжитесь с нами',
                        address: '293/C/3, Мардана Роуд, Морагалла, Брувала, Шри-Ланка',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: 'Оставайтесь на связи',
                        emailPlaceholder: 'Введите ваш адрес электронной почты',
                        socialMedia: {
                            facebook: 'Фейсбук',
                            instagram: 'Инстаграм',
                            youtube: 'Ютуб',
                            twitter: 'Твиттер',
                        },
                        copyright: '© {{year}} Ashan Tours Шри-Ланка. Все права защищены.',
                        designedBy: 'Веб-сайт разработан и создан компанией Redev Solutions',
                        designedByPhone: '+94 76 460 8225',
                    },
                    aboutSection: {
                        travelWithAshan: 'Путешествуйте с Ashan Tours Sri Lanka',
                        imageAlt: 'Изображение Ashan Tours {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lanka — ваш надежный спутник в путешествиях, создающий незабываемые поездки по Шри-Ланке. С нашей страстью к исследованиям и командой опытных профессионалов мы стремимся предлагать персонализированные маршруты, экспертное сопровождение и исключительный сервис, чтобы сделать ваш отпуск поистине особенным.',
                        introParagraph2: 'Наши туры тщательно разработаны, чтобы передать суть Шри-Ланки — от залитых солнцем пляжей и живописных холмов до древних культурных сокровищ и яркой дикой природы. В Ashan Tours Sri Lanka мы стремимся предоставлять аутентичные впечатления, позволяющие открыть красоту и душу острова.',
                        introParagraph3: 'Ищете ли вы приключения, спокойный отдых или культурное погружение, Ashan Tours Sri Lanka предлагает индивидуальные пакеты, соответствующие вашим желаниям. Присоединяйтесь к нам, и мы проведем вас в путешествие, полное чудес, открытий и незабываемых воспоминаний.',
                        cinnamonLuxuryVilla: 'Вилла Cinnamon Luxury',
                        villaImageAlt: 'Изображение виллы Cinnamon Luxury {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lanka с гордостью представляет нашу виллу Cinnamon Luxury, предлагающую премиальные апартаменты для путешественников, ищущих комфорт и элегантность. Наши два эксклюзивных апартамента созданы для того, чтобы обеспечить домашний уют в самом сердце Шри-Ланки.',
                        villaParagraph2: 'Каждый апартамент оснащен современными удобствами, включая кондиционер, собственную ванную комнату, роскошные двуспальные кровати и полностью оборудованные кухни. Путешествуете ли вы в одиночку, парой или с семьей, наши виллы предлагают идеальное сочетание роскоши и удобства.',
                        villaParagraph3: 'Расположенная в спокойной обстановке, вилла Cinnamon Luxury позволяет расслабиться и отдохнуть после дня, проведенного в исследовании чудес Шри-Ланки. Забронируйте пребывание с Ashan Tours Sri Lanka и ощутите непревзойденное гостеприимство.',
                    },
                    sriLankaSection: {
                        discoverSriLanka: 'Откройте для себя Шри-Ланку',
                        mainImageAlt: 'Шри-Ланка',
                        pearlOfIndianOcean: 'Жемчужина Индийского океана',
                        introParagraph1: 'Шри-Ланка, ласково называемая "{{pearl}}", — это потрясающий островной рай, прославленный своими захватывающими пейзажами, глубоко укоренёнными традициями и яркой культурой.',
                        introParagraph2: 'С цивилизацией, насчитывающей более 2500 лет, Шри-Ланка является домом для величественных древних столиц, священных религиозных достопримечательностей и объектов Всемирного наследия ЮНЕСКО. Её культурное наследие обогащено индийскими, арабскими, португальскими, голландскими и британскими влияниями, предлагая увлекательное путешествие во времени.',
                        introParagraph3: 'Пейзажи острова необыкновенны — от золотых песчаных берегов и холмистых зелёных чайных плантаций до туманных горных вершин. Её заповедники укрывают слонов, леопардов и ярких птиц, что делает её мечтой для любителей природы.',
                        introParagraph4: 'Для искателей приключений Шри-Ланка предлагает сёрфинг, треккинг, сноркелинг и дайвинг. Кухня, пропитанная ароматными специями, свежими морепродуктами и тропическими фруктами, смелая и вкусная, рассказывая историю богатого кулинарного наследия острова.',
                        introParagraph5: 'Будь то прогулки среди вечных руин, отдых на спокойных пляжах или наслаждение тёплым гостеприимством, Шри-Ланка дарит незабываемые впечатления от путешествия.',
                        attractivePlaces: 'Привлекательные места в Шри-Ланке',
                        viewMore: 'Посмотреть больше',
                        placeImageAlt: 'Изображение {{name}} {{index}}',
                        fullImagePreviewAlt: 'Полноразмерный просмотр',
                        famousThingsTitle: 'Известные вещи в Шри-Ланке',
                        places: {
                            sigiriyaRockFortress: {
                                name: 'Скальная крепость Сигирия',
                                description: 'Скальная крепость Сигирия — объект Всемирного наследия ЮНЕСКО и одна из самых знаковых достопримечательностей Шри-Ланки. Здесь можно увидеть древние сады, фрески и захватывающие виды с вершины скалы.',
                            },
                            templeOfTheTooth: {
                                name: 'Храм Зуба Будды',
                                description: 'Храм Священной Зубной Реликвии в Канди — священное буддийское место, где хранится реликвия зуба Будды. Посетители могут ощутить его историческое и религиозное значение.',
                            },
                            ella: {
                                name: 'Элла',
                                description: 'Элла — небольшой городок в горной местности Шри-Ланки, окружённый чайными плантациями и водопадами. Он знаменит мостом Девяти Арок и Малым Пиком Адама.',
                            },
                            yalaNationalPark: {
                                name: 'Национальный парк Яла',
                                description: 'Национальный парк Яла известен своим богатым животным миром, включая слонов, леопардов и множество видов птиц. Сафари здесь обязательно для любителей природы.',
                            },
                            galleFort: {
                                name: 'Форт Галле',
                                description: 'Форт Галле, построенный португальцами и укреплённый голландцами, — историческое место с мощеными улицами, колониальной архитектурой и оживлёнными кафе.',
                            },
                            nuwaraEliya: {
                                name: 'Нувара-Элия',
                                description: 'Известная как "Маленькая Англия", Нувара-Элия — горная станция, знаменитая своим прохладным климатом, чайными плантациями и колониальными бунгало.',
                            },
                            adamsPeak: {
                                name: 'Пик Адама',
                                description: 'Пик Адама — священная гора с уникальным отпечатком на вершине. Это популярное место паломничества для нескольких религий.',
                            },
                            hortonPlains: {
                                name: 'Равнины Хортон',
                                description: 'Национальный парк Равнины Хортон включает холмистые пейзажи, водопады и знаменитую смотровую площадку Конец Света.',
                            },
                            bentotaBeach: {
                                name: 'Пляж Бентота',
                                description: 'Пляж Бентота — нетронутое прибрежное место, известное своими золотыми песками, водными видами спорта и роскошными курортами.',
                            },
                            jaffna: {
                                name: 'Джафна',
                                description: 'Джафна, в северной части Шри-Ланки, богата тамильской культурой, историческими местами и вкусной кухней.',
                            },
                            anuradhapura: {
                                name: 'Анурадхапура',
                                description: 'Анурадхапура — древний город, известный своими священными буддийскими местами и историческими руинами, включая дерево Шри Маха Бодхи.',
                            },
                            polonnaruwa: {
                                name: 'Полоннарува',
                                description: 'Полоннарува — объект Всемирного наследия ЮНЕСКО с древними храмами, статуями и прекрасно сохранившимися руинами.',
                            },
                            unawatunaBeach: {
                                name: 'Пляж Унаватуна',
                                description: 'Пляж Унаватуна — оживлённое прибрежное место, предлагающее сноркелинг, солнечные ванны и яркую ночную жизнь.',
                            },
                            colomboCity: {
                                name: 'Город Коломбо',
                                description: 'Коломбо — оживлённая столица Шри-Ланки, сочетающая современные небоскрёбы с колониальной архитектурой и яркими рынками.',
                            },
                            udawalawaNationalPark: {
                                name: 'Национальный парк Удавалаве',
                                description: 'Национальный парк Удавалаве — рай для дикой природы, известный своими большими стадами слонов, разнообразными видами птиц и потрясающими пейзажами, что делает его обязательным местом для любителей природы.',
                            },
                            dambullaCaveTemple: {
                                name: 'Пещерный храм Дамбулла',
                                description: 'Пещерный храм Дамбулла — объект Всемирного наследия ЮНЕСКО, известный древними буддийскими фресками и статуями в пещерах.',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: 'Цейлонский чай',
                                description: 'Шри-Ланка всемирно известна своим цейлонским чаем, который славится своим уникальным вкусом и качеством. Чай из регионов Нувара-Элия, Ува и Димбула особенно знаменит.',
                            },
                            spices: {
                                title: 'Специи',
                                description: 'Шри-Ланка веками была центром торговли специями, такими как корица, кардамон, гвоздика и мускатный орех. Шри-ланкийская корица считается лучшей в мире.',
                            },
                            gems: {
                                title: 'Драгоценные камни и ювелирные изделия',
                                description: 'Известная как "Остров драгоценных камней", Шри-Ланка славится своими сапфирами, рубинами и лунными камнями. "Голубая красавица Азии", один из крупнейших голубых сапфиров, был найден здесь.',
                            },
                            ayurveda: {
                                title: 'Аюрведа',
                                description: 'Шри-Ланка известна своей аюрведической медициной и оздоровительными процедурами. Популярные предложения включают массажи, травяные терапии и аюрведические курорты.',
                            },
                            handicrafts: {
                                title: 'Традиционные ремёсла',
                                description: 'Шри-Ланка производит изысканные ремесленные изделия, включая маски из Амбалангоды, батик, резьбу по дереву и лаковые изделия.',
                            },
                            elephants: {
                                title: 'Слоны',
                                description: 'Шри-ланкийские слоны играют важную роль в культуре и фестивалях. Слоны, украшенные роскошными костюмами, участвуют в процессиях, таких как Эсала Перахера.',
                            },
                            food: {
                                title: 'Традиционная еда',
                                description: 'Шри-Ланка славится своей вкусной кухней, включая рис с карри, хопперы, котту роти, пол самбол и ватталаппам.',
                            },
                            festivals: {
                                title: 'Фестивали',
                                description: 'Шри-Ланка празднует яркие фестивали, такие как Эсала Перахера, сингальский и тамильский Новый год и Весак, с яркими украшениями и процессиями.',
                            },
                            coconut: {
                                title: 'Кокосовые продукты',
                                description: 'Шри-Ланка известна продуктами на основе кокоса, такими как кокосовое масло, молоко и кокосовое волокно, используемые для верёвок и циновок.',
                            },
                            sarees: {
                                title: 'Шри-ланкийские сари',
                                description: 'Кандийский сари (Осория) — традиционная одежда для женщин, известная своей элегантностью и уникальным стилем драпировки, используемая на церемониальных мероприятиях.',
                            },
                            dances: {
                                title: 'Традиционные танцы',
                                description: 'Традиционные танцы Шри-Ланки включают кандийский танец, дьявольские танцы и танцы низменностей, вдохновлённые природой и фольклором.',
                            },
                            stiltFishing: {
                                title: 'Рыбалка на ходулях',
                                description: 'Иконическая картина Шри-Ланки: рыбалка на ходулях, когда рыбаки балансируют на шестах, установленных в море, уникальна для южных прибрежных регионов.',
                            },
                            moonstones: {
                                title: 'Лунные камни',
                                description: 'Шри-Ланка известна своими лунными камнями, считающимися полудрагоценными. Шахты лунного камня в Метиягода особенно знамениты.',
                            },
                            cricket: {
                                title: 'Шри-ланкийский крикет',
                                description: 'Крикет — страсть для жителей Шри-Ланки, и страна известна своими игроками мирового класса. Шри-Ланка выиграла Кубок мира по крикету ICC в 1996 году.',
                            },
                            herbs: {
                                title: 'Аюрведические травы и специи',
                                description: 'Остров производит травяные средства, используемые в аюрведе, такие как готу кола, корица и ним.',
                            },
                            masks: {
                                title: 'Маски',
                                description: 'Традиционные шри-ланкийские маски из Амбалангоды используются в культурных представлениях, включая маски Якша (дьявольские) и Колам.',
                            },
                        },
                    },
                    excursionsSection: {
                        title: 'Экскурсии',
                        excursions: {
                            oneDay: {
                                title: 'Однодневные экскурсии',
                                description: 'Исследуйте потрясающие места за один день с экскурсиями и местными впечатлениями.',
                                alt: 'Однодневная экскурсия по Шри-Ланке',
                            },
                            twoDays: {
                                title: 'Двухдневные экскурсии',
                                description: 'Наслаждайтесь короткими поездками с ночёвкой, чтобы увидеть ещё больше Шри-Ланки.',
                                alt: 'Двухдневная экскурсия по Шри-Ланке',
                            },
                            threeDays: {
                                title: 'Трёхдневные экскурсии',
                                description: 'Откройте для себя множество достопримечательностей за три дня приключений и отдыха.',
                                alt: 'Трёхдневная экскурсия по Шри-Ланке',
                            },
                            fourDays: {
                                title: 'Четырёхдневные экскурсии',
                                description: 'Идеально для продолжительного путешествия, охватывающего несколько мест в комфорте.',
                                alt: 'Четырёхдневная экскурсия по Шри-Ланке',
                            },
                            twentyDays: {
                                title: '20-дневные экскурсии',
                                description: 'Отправляйтесь в эпическое путешествие по Шри-Ланке, исследуя её культурные, природные и исторические чудеса.',
                                alt: '20-дневная экскурсия по Шри-Ланке',
                            },
                        },
                        bentotaExcursions: {
                            title: 'Экскурсии из Бентоты',
                            bentotaToYala: {
                                title: 'Бентота в Яла',
                                description: 'Бентота -> Элла -> Яла',
                            },
                            bentotaToNuwaraEliya: {
                                title: 'Бентота в Нувара-Элия',
                                description: 'Бентота -> Элла -> Канди -> Нувара-Элия',
                            },
                            bentotaToMinneriya: {
                                title: 'Бентота в национальный парк Миннерия',
                                description: 'Бентота -> Сигирия -> Анурадхапура -> Полоннарува -> Национальный парк Миннерия',
                            },
                            bentotaToHortonPlains: {
                                title: 'Бентота в Равнины Хортон',
                                description: 'Бентота -> Канди -> Нувара-Элия -> Равнины Хортон',
                            },
                            images: {
                                bentotaToElla1: 'Вид на пляж Бентота 1',
                                bentotaToElla2: 'Вид на пляж Бентота 2',
                            },
                        },
                        airportExcursions: {
                            title: 'Экскурсии из аэропорта',
                            airportToColombo: {
                                title: 'Из аэропорта в тур по Коломбо',
                                description: 'Аэропорт -> Форт Коломбо -> Галле Фейс -> Храм Гангарамая',
                                alt1: 'Изображение тура по Коломбо 1',
                                alt2: 'Изображение тура по Коломбо 2',
                            },
                            airportToSigiriya: {
                                title: 'Из аэропорта в Сигирию',
                                description: 'Аэропорт -> Дамбулла -> Скальная крепость Сигирия',
                                alt1: 'Изображение экскурсии в Сигирию 1',
                                alt2: 'Изображение экскурсии в Сигирию 2',
                            },
                            airportToKandy: {
                                title: 'Из аэропорта в Канди',
                                description: 'Аэропорт -> Приют для слонов Пиннавела -> Храм Зуба Будды в Канди',
                                alt1: 'Изображение экскурсии в Канди 1',
                                alt2: 'Изображение экскурсии в Канди 2',
                            },
                            airportToGalle: {
                                title: 'Из аэропорта в Галле',
                                description: 'Аэропорт -> Бентота -> Форт Галле -> Пляж Унаватуна',
                                alt1: 'Изображение экскурсии в Галле 1',
                                alt2: 'Изображение экскурсии в Галле 2',
                            },
                        },
                    },
                    thingsToDoSection: {
                        title: 'Чем заняться в Шри-Ланке',
                        viewMore: 'Посмотреть больше',
                        activities: {
                            ayurveda: {
                                title: 'Аюрведа - Древняя наука о жизни',
                                alt: 'Аюрведическая терапия в Шри-Ланке',
                            },
                            diving: {
                                title: 'Дайвинг в Шри-Ланке',
                                alt: 'Дайвинг в Шри-Ланке',
                            },
                            elephantRide: {
                                title: 'Катание на слонах',
                                alt: 'Катание на слонах в Шри-Ланке',
                            },
                            fishing: {
                                title: 'Рыбалка в Шри-Ланке',
                                alt: 'Рыбалка в Шри-Ланке',
                            },
                            ballooning: {
                                title: 'Полёты на воздушном шаре в Шри-Ланке',
                                alt: 'Полёты на воздушном шаре в Шри-Ланке',
                            },
                            jeepSafari: {
                                title: 'Джип-сафари',
                                alt: 'Джип-сафари в Шри-Ланке',
                            },
                            whiteWaterRafting: {
                                title: 'Сплав по бурным рекам',
                                alt: 'Сплав по бурным рекам в Шри-Ланке',
                            },
                            riverSafari: {
                                title: 'Речное сафари',
                                alt: 'Речное сафари в Шри-Ланке',
                            },
                            snorkeling: {
                                title: 'Сноркелинг в Шри-Ланке',
                                alt: 'Сноркелинг в Шри-Ланке',
                            },
                            teaTasting: {
                                title: 'Тур по дегустации чая',
                                alt: 'Тур по дегустации чая в Шри-Ланке',
                            },
                            templeVisit: {
                                title: 'Посещение храма',
                                alt: 'Посещение храма в Шри-Ланке',
                            },
                            wildlifeSafari: {
                                title: 'Сафари по дикой природе',
                                alt: 'Сафари по дикой природе в Шри-Ланке',
                            },
                        },
                    },
                    homeHeroSection: {
                        title: 'Путешествуйте с Ashan Sri Lanka',
                        subtitle: 'Исследуйте завораживающую красоту Шри-Ланки с незабываемыми приключениями',
                        bookButton: 'Забронируйте свое путешествие',
                        videoFallback: 'Ваш браузер не поддерживает тег видео.',
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: 'Почему выбирают Ashan Tours Sri Lanka',
                            specialist: {
                                title: 'Экспертиза в путешествиях',
                                description: 'Наша команда в Ashan Tours Sri Lanka состоит из опытных специалистов, создающих индивидуальные путешествия по вашим предпочтениям.'
                            },
                            experience: {
                                title: 'Незабываемые впечатления',
                                description: 'Мы создаем яркие моменты, показывая богатую культуру, историю и природную красоту Шри-Ланки с заботой и страстью.'
                            },
                            priceMatch: {
                                title: 'Конкурентные цены',
                                description: 'Ashan Tours Sri Lanka гарантирует лучшее соотношение цены и качества, предлагая качественные впечатления по доступным ценам.'
                            },
                            support: {
                                title: 'Круглосуточная поддержка',
                                description: 'Наша команда поддержки клиентов доступна 24/7, чтобы помочь вам на каждом этапе, обеспечивая безупречный опыт путешествия.'
                            }
                        },
                        welcome: {
                            title: 'Добро пожаловать в Ashan Tours Sri Lanka',
                            imageAlt: 'Приветственное изображение Ashan Tours Sri Lanka',
                            description1: 'Отправляйтесь в удивительное путешествие с Ashan Tours Sri Lanka, вашим главным гидом по чудесам этого островного рая.',
                            description2: 'Откройте для себя яркую культуру, захватывающие дух пейзажи и скрытые сокровища Шри-Ланки с нашими тщательно подобранными турами.',
                            description3: 'От нетронутых пляжей до древних руин наши маршруты созданы для погружения в сердце красоты Шри-Ланки.',
                            description4: 'Наша преданная команда обеспечивает индивидуальный сервис, делая ваше путешествие незабываемым и плавным.',
                            description5: 'Присоединяйтесь к Ashan Tours Sri Lanka и позвольте нам провести вас через приключение, полное открытий и радости.'
                        },
                        cinnamonLuxuryVilla: {
                            title: 'Вилла Cinnamon Luxury',
                            imageAlt: 'Изображение виллы Cinnamon Luxury',
                            description1: 'Ощутите непревзойденный комфорт в вилле Cinnamon Luxury от Ashan Tours Sri Lanka, предлагающей роскошные апартаменты в спокойной обстановке.',
                            description2: 'Наши эксклюзивные виллы оснащены современными удобствами, такими как кондиционер, роскошные кровати и полностью оборудованные кухни, идеально подходящие для расслабляющего отдыха.',
                            readMore: 'Узнать больше'
                        },
                        tourPackages: {
                            title: 'Наши туристические пакеты',
                            ella: {
                                title: 'Приключение в Элле',
                                subtitle: '3 дня / 2 ночи',
                                description: 'Исследуйте живописную красоту Эллы с Ashan Tours Sri Lanka, включая посещение Моста Девяти Арок и Маленького Пике Адама.',
                                alt: 'Изображение тура в Эллу'
                            },
                            ellaNuwaraKandy: {
                                title: 'Элла, Нувара Элия и Канди',
                                subtitle: '5 дней / 4 ночи',
                                description: 'Культурное путешествие через Эллу, Нувара Элию и Канди с чайными плантациями и историческими храмами.',
                                alt: 'Изображение тура по Элле, Нувара Элии и Канди'
                            },
                            kandyNuwaraEllaYala: {
                                title: 'Канди, Нувара Элия, Элла и Яла',
                                subtitle: '7 дней / 6 ночей',
                                description: 'Полный тур, охватывающий наследие Канди, чайные плантации Нувара Элии, пейзажи Эллы и дикую природу Ялы.',
                                alt: 'Изображение тура по Канди, Нувара Элии, Элле и Яле'
                            },
                            viewMore: 'Посмотреть больше туров'
                        },
                        popularExcursions: {
                            title: 'Популярные экскурсии',
                            oneDay: {
                                title: 'Однодневная экскурсия',
                                alt: 'Изображение однодневной экскурсии'
                            },
                            twoDays: {
                                title: 'Двухдневная экскурсия',
                                alt: 'Изображение двухдневной экскурсии'
                            },
                            threeDays: {
                                title: 'Трехдневная экскурсия',
                                alt: 'Изображение трехдневной экскурсии'
                            },
                            fourDays: {
                                title: 'Четырехдневная экскурсия',
                                alt: 'Изображение четырехдневной экскурсии'
                            },
                            viewMore: 'Посмотреть больше экскурсий'
                        },
                        contactUs: {
                            title: 'Свяжитесь с Ashan Tours Sri Lanka',
                            description: 'Готовы исследовать Шри-Ланку? Свяжитесь с Ashan Tours Sri Lanka, чтобы спланировать отпуск вашей мечты уже сегодня!',
                            button: 'Связаться'
                        },
                        gallery: {
                            title: 'Наша галерея',
                            modalAlt: 'Изображение галереи',
                            filters: {
                                all: 'Все',
                                tours: 'Туры',
                                accommodation: 'Проживание',
                                transportation: 'Транспорт',
                                wildlife: 'Дикая природа'
                            },
                            tours: {
                                sigiriya2: 'Изображение Сигирии 2',
                                sigiriya3: 'Изображение Сигирии 3',
                                kandy2: 'Изображение Канди 2',
                                kandy3: 'Изображение Канди 3',
                                galle2: 'Изображение Галле 2',
                                galle3: 'Изображение Галле 3',
                                ella2: 'Изображение Эллы 2',
                                ella3: 'Изображение Эллы 3',
                                colomboCity: 'Изображение города Коломбо'
                            },
                            accommodation: {
                                nuwaraEliya1: 'Изображение проживания в Нувара Элии 1',
                                nuwaraEliya2: 'Изображение проживания в Нувара Элии 2',
                                nuwaraEliya3: 'Изображение проживания в Нувара Элии 3',
                                nuwaraEliya4: 'Изображение проживания в Нувара Элии 4'
                            },
                            transportation: {
                                bentotaRiverSafari1: 'Изображение сафари по реке Бентота 1',
                                bentotaRiverSafari2: 'Изображение сафари по реке Бентота 2'
                            },
                            wildlife: {
                                yalaSafari1: 'Изображение сафари в Яле 1',
                                yalaSafari2: 'Изображение сафари в Яле 2',
                                minneriya1: 'Изображение Миннерии 1',
                                minneriya2: 'Изображение Миннерии 2',
                                udawalawaSafari1: 'Изображение сафари в Удавалаве 1',
                                udawalawaSafari2: 'Изображение сафари в Удавалаве 2'
                            },
                        },
                    },
                    tourPackages: {
                        title: "Турпакеты",
                        readMore: "Узнать больше",
                        book: "Забронировать",
                        destinationsTitle: "Направления",
                        destinationImageAlt: "Изображение направления {{index}}",
                        clickToEnlarge: "Нажмите, чтобы увеличить",
                        enlargedDestinationAlt: "Увеличенное изображение направления",
                        bookNow: "Забронировать сейчас",
                        importantNotices: "Важные уведомления",
                        notices: {
                            transport: "Мы используем комфортабельные транспортные системы для всех наших туров.",
                            children: "Дети до 5 лет путешествуют бесплатно.",
                            hygiene: "Все наши туры проводятся с акцентом на гигиену и безопасность.",
                            tickets: "Турпакеты включают входные билеты, если не указано иное.",
                            meals: "Однодневные туры не включают питание, если не указано явно.",
                        },
                        luxuryTransport: "Присоединяйтесь к нашей системе люксового транспорта",
                        luxuryTransportAlt1: "Люксовый транспорт 1",
                        luxuryTransportAlt2: "Люксовый транспорт 2",
                        getInTouch: "Свяжитесь с нами, чтобы узнать о наших пакетах",
                        getInTouchDescription: "Свяжитесь с нами сегодня, чтобы найти лучшие туристические предложения, подобранные для вас.",
                        contactUs: "Свяжитесь с нами",
                        bookingMessage: "Запрос на бронирование Ashan Tours\nПакет: {{title}}\nПродолжительность: {{duration}}\nМесто: {{location}}",
                        manualBookingMessage: "Пожалуйста, отправьте следующее сообщение вручную на {{number}}:\n\n{{message}}",
                        errorBookingMessage: "Произошла ошибка. Пожалуйста, отправьте следующее сообщение вручную на {{number}}:\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "Элла",
                                duration: "1 день",
                                location: "Элла - Шри-Ланка",
                                description:
                                    "Исследуйте потрясающую природную красоту Эллы с ее пышными чайными плантациями, захватывающими видами и знаменитым мостом Девяти арок.",
                            },
                            galleFort: {
                                title: "Форт Галле",
                                duration: "1 день",
                                location: "Галле - Шри-Ланка",
                                description:
                                    "Перенеситесь в прошлое с посещением исторического форта Галле, объекта всемирного наследия ЮНЕСКО, полного колониального шарма и прибрежной красоты.",
                            },
                            yalaSafari: {
                                title: "Сафари в Яле",
                                duration: "1 день",
                                location: "Яла - Шри-Ланка",
                                description:
                                    "Отправляйтесь в увлекательное сафари в национальном парке Яла, где обитают леопарды, слоны и множество экзотических животных.",
                            },
                            kandy: {
                                title: "Канди",
                                duration: "1 день",
                                location: "Канди - Шри-Ланка",
                                description:
                                    "Откройте для себя культурное сердце Шри-Ланки с посещением Канди, включая священный Храм Зуба Будды.",
                            },
                            sigiriya: {
                                title: "Сигирия",
                                duration: "1 день",
                                location: "Сигирия - Шри-Ланка",
                                description:
                                    "Поднимитесь на древнюю скальную крепость Сигирия и полюбуйтесь ее потрясающими фресками и захватывающими панорамными видами.",
                            },
                            udawalawe: {
                                title: "Удавалаве",
                                duration: "1 день",
                                location: "Удавалаве - Шри-Ланка",
                                description:
                                    "Насладитесь захватывающим сафари в национальном парке Удавалаве, известном своей большой популяцией слонов и живописными пейзажами.",
                            },
                            colomboCityEscape: {
                                title: "Побег в город Коломбо",
                                duration: "1 день",
                                location: "Коломбо - Шри-Ланка",
                                description:
                                    "Исследуйте оживленный город Коломбо с его шумными рынками, культурными достопримечательностями и современными аттракционами.",
                            },
                            mirissaWhaleWatching: {
                                title: "Наблюдение за китами в Мириссе",
                                duration: "1 день",
                                location: "Мирисса - Шри-Ланка",
                                description:
                                    "Отправляйтесь в незабываемое приключение по наблюдению за китами у побережья Мириссы, где вас ждут величественные голубые киты.",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "Наблюдение за китами в Мириссе на комфортабельной лодке",
                                duration: "1 день",
                                location: "Мирисса - Шри-Ланка",
                                description:
                                    "Отправляйтесь в незабываемое приключение по наблюдению за китами у побережья Мириссы, где вас ждут величественные голубые киты.",
                            },
                            bentotaRiverSafari: {
                                title: "Речное сафари в Бентоте",
                                duration: "1 день",
                                location: "Бентота - Шри-Ланка",
                                description:
                                    "Прокатитесь по спокойной реке Бентота, окруженной пышными мангровыми зарослями и экзотическими животными, для умиротворяющего отдыха.",
                            },
                            ellaYala: {
                                title: "Элла и Яла",
                                duration: "1 день",
                                location: "Элла и Яла - Шри-Ланка",
                                description:
                                    "Испытайте идеальное сочетание живописной красоты Эллы и захватывающего сафари в Яле за один день.",
                            },
                            ellaGalle: {
                                title: "Элла и Галле",
                                duration: "1 день",
                                location: "Элла и Галле - Шри-Ланка",
                                description:
                                    "Откройте для себя захватывающие пейзажи Эллы и колониальный шарм Галле за день, полный чудес.",
                            },
                            yalaGalle: {
                                title: "Яла и Галле",
                                duration: "1 день",
                                location: "Яла и Галле - Шри-Ланка",
                                description:
                                    "Сочетайте азарт сафари в Яле с посещением живописного форта Галле для поистине разнообразного опыта.",
                            },
                            ellaYalaTwoDays: {
                                title: "Элла и Яла",
                                duration: "2 дня",
                                location: "Элла и Яла - Шри-Ланка",
                                description:
                                    "Проведите два дня, исследуя живописные возвышенности Эллы и богатые дикой природой пейзажи национального парка Яла.",
                            },
                            kandyTwoDays: {
                                title: "Канди",
                                duration: "2 дня",
                                location: "Элла и Яла - Шри-Ланка",
                                description:
                                    "Проведите два дня, исследуя живописные возвышенности Эллы и богатые дикой природой пейзажи национального парка Яла.",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "Элла/Нувара-Элия/Канди",
                                duration: "2 дня",
                                location: "Элла/Нувара-Элия/Канди - Шри-Ланка",
                                description:
                                    "Посетите чайные плантации Нувара-Элии, пышную зелень Эллы и культурные сокровища Канди в этом двухдневном туре.",
                            },
                            kandySigiriya: {
                                title: "Канди и Сигирия",
                                duration: "2 дня",
                                location: "Канди и Сигирия - Шри-Ланка",
                                description:
                                    "Насладитесь культурным путешествием в Канди и поднимитесь на знаковую скальную крепость Сигирия в этом двухдневном приключении.",
                            },
                            ellaNuwaraEliya: {
                                title: "Элла и Нувара-Элия",
                                duration: "2 дня",
                                location: "Элла и Нувара-Элия - Шри-Ланка",
                                description:
                                    "Погрузитесь в природную красоту Эллы и прохладную, спокойную атмосферу Нувара-Элии в течение двух дней.",
                            },
                            sigiriKandyElla: {
                                title: "Сигирия/Канди/Элла",
                                duration: "3 дня",
                                location: "Сигирия/Канди/Элла - Шри-Ланка",
                                description:
                                    "Исследуйте Сигирию, культурные достопримечательности Канди и живописные пейзажи Эллы в течение трех незабываемых дней.",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "Канди/Нувара-Элия/Элла/Яла",
                                duration: "3 дня",
                                location: "Канди/Нувара-Элия/Элла/Яла - Шри-Ланка",
                                description:
                                    "Откройте для себя разнообразные достопримечательности Шри-Ланки, от культуры Канди до дикой природы Ялы, в трехдневном погружении.",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "Сигирия/Анурадхапура/Полоннарува/Национальный парк Миннерия",
                                duration: "3 дня",
                                location: "Сигирия/Анурадхапура/Полоннарува/Национальный парк Миннерия - Шри-Ланка",
                                description:
                                    "Посетите древние города Сигирия, Анурадхапура и Полоннарува и насладитесь сафари в национальном парке Миннерия.",
                            },
                            twentyDayTour: {
                                title: "Турпакет до 20 дней",
                                duration: "20 дней",
                                location: "Шри-Ланка",
                                description:
                                    "Отправляйтесь в незабываемое 20-дневное путешествие по Шри-Ланке, исследуя ее культурные, природные и исторические чудеса от Негомбо до Бентоты.",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "Водопад Равана",
                            nineArchBridge: "Мост Девяти арок",
                            teaPlantation: "Чайная плантация",
                            trainRide: "Поездка на поезде",
                            littleAdamsPeak: "Малый пик Адама",
                            udawalaweElephant: "Наблюдение за кормлением слонов в Удавалаве",
                            ayurvedicHerbalGarden: "Аюрведический травяной сад",
                            templeKandeViharaya: "Храм Канде Вихарая",
                            turtleHatchery: "Черепаший питомник",
                            boatSafari: "Лодочное сафари",
                            moonstoneMine: "Лунный рудник",
                            hikkaduwaBeach: "Пляж Хиккадува - Плавание с черепахами",
                            dutchFortGalle: "Голландский форт Галле",
                            yala: "Яла",
                            yalaSafariJeep: "Сафари в Яле на джипе",
                            kandy: "Канди",
                            royalBotanicalGarden: "Королевский ботанический сад",
                            teaFactoryPlantation: "Чайная фабрика и плантация",
                            elephantFeeding: "Кормление, купание и катание на слонах",
                            ambuluwawaTowerOrTemple: "Башня Амбулувава или Храм Зуба Будды",
                            jewelleryGemFactory: "Фабрика ювелирных изделий и драгоценных камней",
                            silkFactory: "Шелковая фабрика",
                            sigiriya: "Сигирия",
                            sigiriyaLionRock: "Скала Льва Сигирия",
                            dambullaGoldenTemple: "Золотой храм Дамбулла",
                            villageTour: "Экскурсия по деревне с традиционной шри-ланкийской едой",
                            pidurangalaRock: "Скала Пидурангала",
                            udawalawe: "Удавалаве",
                            udawalaweNationalPark: "Национальный парк Удавалаве",
                            jeepSafari: "Сафари на джипе",
                            elephantMilkFeeding: "Кормление слонов молоком",
                            lotusTower: "Башня Лотоса",
                            redMosque: "Красная мечеть",
                            shopping: "Шопинг",
                            blueWhales: "Голубые киты",
                            mirissa: "Мирисса",
                            stiltFishing: "Рыбалка на ходулях",
                            bentotaRiver: "Река Бентота",
                            bentota: "Бентота",
                            safariYalaNationalPark: "Сафари в национальном парке Яла на джипе",
                            gadoladeniyaTemple: "Храм Гадоладения",
                            templeOfTheToothRelic: "Храм Зуба Будды",
                            traditionalKandyanDance: "Традиционный танец Канди",
                            luxuryHotelStay: "Проживание в роскошном отеле с завтраком и ужином",
                            teaFactory: "Чайная фабрика",
                            nuwaraEliyaTown: "Город Нувара-Элия",
                            ambuluwawaTower: "Башня Амбулувава",
                            hinduTemple: "Индуистский храм",
                            gregoryLake: "Озеро Грегори",
                            postOffice: "Почтовое отделение",
                            hortanPlains: "Равнины Хортон",
                            sitaAmmanHinduKovil: "Индуистский храм Сита Амман",
                            botanicalGarden: "Ботанический сад",
                            rambodaWaterfall: "Водопад Рамбода",
                            sigiriyaRockFortress: "Скальная крепость Сигирия",
                            anuradhapura: "Анурадхапура",
                            polonnaruwa: "Полоннарува",
                            minneriyaNationalPark: "Национальный парк Миннерия",
                            elephants: "Слоны",
                            day1: "День 1: Аэропорт – Негомбо: Трансфер в Негомбо и ранняя регистрация, Лодочная прогулка по болоту Мутураджавела, Отдых – Плавание – Лежание – Гамак – Велнес – Загорание – Спорт – Водные виды спорта, Ночь и завтрак в Негомбо",
                            day2: "День 2: Негомбо – Анурадхапура: Священный город Анурадхапура (объект всемирного наследия ЮНЕСКО), Дерево Шри Маха Бодхи, Прогулка вокруг живописных водохранилищ, Ночь и завтрак в Анурадхапуре",
                            day3: "День 3: Анурадхапура – Миннерия – Хабарана: Статуя Будды Аукана, Деревенское сафари, включая катание на катамаране и тук-туке с обедом, Сафари на джипе в национальном парке Миннерия, Ночь и завтрак в Хабаране",
                            day4: "День 4: Хабарана – Сигирия – Ритигала – Тринкомали: Скальная крепость Сигирия (объект всемирного наследия ЮНЕСКО), Лесной монастырь Ритигала, Ночь и завтрак в Тринкомали",
                            day5: "День 5: Тринкомали: Отдых – Плавание – Лежание – Гамак – Велнес – Загорание – Спорт – Водные виды спорта, Ночь и завтрак в Тринкомали",
                            day6: "День 6: Тринкомали: Экскурсия по городу Тринкомали, День рождения Стеффи Баумль, Отдых – Плавание – Лежание – Гамак – Велнес – Загорание – Спорт – Водные виды спорта, Сюрприз-кулинарный мастер-класс для двух женщин, Ночь и завтрак в Тринкомали",
                            day7: "День 7: Тринкомали: Поездка для снорклинга на остров Пиджин, Отдых – Плавание – Лежание – Гамак – Велнес – Загорание – Спорт – Водные виды спорта, Ночь и завтрак в Тринкомали",
                            day8: "День 8: Тринкомали: Отдых – Плавание – Лежание – Гамак – Велнес – Загорание – Спорт – Водные виды спорта, Ночь и завтрак в Тринкомали",
                            day9: "День 9: Тринкомали – Дамбулла – Матале – Перадения – Канди: Пещерный храм Дамбулла (объект всемирного наследия ЮНЕСКО), Сад специй в Матале, Королевские ботанические сады Перадения с пикником, Прогулка по старому городу Канди, Ночь и завтрак в Канди",
                            day10: "День 10: Канди: Храм Зуба Будды в Канди (объект всемирного наследия ЮНЕСКО), Вечернее представление танца Канди, Ночь и завтрак в Канди",
                            day11: "День 11: Канди – Нувара-Элия – Элла: Чайные плантации и сбор чая, Посещение чайной фабрики, Водопады Рамбода, Нувара-Элия – город над облаками, Прогулка по Элле, Ночь и завтрак в Элле",
                            day12: "День 12: Элла – Бадулла: Поездка на поезде из Эллы в Бадуллу (2-й класс), Походы в окрестностях Эллы, Опционально: Зиплайнинг, Ночь и завтрак в Элле",
                            day13: "День 13: Элла – Яла: Водопады Равана, Долина Элла Гэп, Сафари на джипе в национальном парке Яла, Ночь и завтрак в Тиссамахараме",
                            day14: "День 14: Яла – Удавалаве – Синхараджа: Посещение приюта для слонов во время кормления, Поездка в лесной заповедник Синхараджа (объект всемирного наследия ЮНЕСКО), Ночь и завтрак в Синхарадже",
                            day15: "День 15: Синхараджа: Экскурсия с гидом по лесному заповеднику Синхараджа (объект природного наследия ЮНЕСКО), Ночь и завтрак в Синхарадже",
                            day16: "День 16: Синхараджа – Галле: Старый город Галле, Форт Галле (объект всемирного наследия ЮНЕСКО), Ночь и завтрак в Галле",
                            day17: "День 17: Галле – Мирисса – Бентота: Оффшорное сафари из Мириссы, Проект по сохранению черепах, Ночь и завтрак в Бентоте",
                            day18_19: "День 18–19: Бентота: Отдых – Плавание – Лежание – Гамак – Велнес – Загорание – Спорт – Водные виды спорта, Ночь и завтрак в Бентоте",
                            day20: "День 20: Бентота – Аэропорт: Трансфер в аэропорт",
                        },
                    },
                    ayurvedaPage: {
                        title: "Аюрведа - Древняя наука о жизни",
                        mainDescription: "Слово 'Аюрведа' существует более трех тысяч лет. На санскрите это слово означает 'наука о жизни'. Техника основана на аюрведическом подходе к исцелению болезни, а не ее последствий, что обычно противоречит европейской медицине. Она постулирует следующие принципы:",
                        principles: {
                            energyBalance: "Тело должно быть свободно от энергии и поддерживать баланс для нормальной метаболической и сердечной деятельности.",
                            muscleHormonal: "Тело должно иметь нормальное сокращение мышц с регулярной гормональной активностью.",
                            immuneSystem: "Тело нуждается в здоровой иммунной системе для правильного функционирования."
                        },
                        trainingDescription: "Согласно последним данным, в Шри-Ланке более 6 000 выпускников, обученных аюрведе. Они проходят семь лет обучения и два года практики в государственных больницах. Программы аюрведы включают:",
                        programs: {
                            stressRelief: "Снятие стресса, усталости и тревоги",
                            oxygenSaturation: "Насыщение кислородом",
                            muscularToxins: "Стимуляция мышечных систем и выведение токсинов",
                            nervousSystem: "Восстановление баланса нервной системы",
                            bloodFlow: "Восстановление кровотока к внутренним органам",
                            endorphins: "Выработка эндорфинов"
                        },
                        images: {
                            mainAlt: "Аюрведа",
                            faceTreatmentAlt: "Аюрведическое лечение лица",
                            massageTreatmentAlt: "Аюрведический массаж"
                        },
                        treatmentDescription: "Стандартные процедуры включают массажи тела и головы с использованием специальных масел, травяные сауны и ванны с травами. Самая популярная техника - это процедура 'Широдхара', при которой теплое травяное масло ритмично капают на лоб. Это помогает восстановить баланс нервной системы и достичь расслабления.",
                        tipsTitle: "Советы по аюрведическому лечению",
                        tips: {
                            relaxMind: "Забудьте о проблемах. Расслабьтесь и очистите разум для достижения лучших результатов.",
                            chooseLocation: "Выберите правильное место. Выберите обстановку, соответствующую вашему комфорту и предпочтениям, для оптимального исцеления.",
                            selectProgram: "Выберите правильную программу. Обсудите свои проблемы с врачом и попробуйте разные терапии, чтобы найти наиболее подходящую.",
                            warmBath: "Примите теплую ванну перед процедурой, чтобы расслабить мышцы и подготовить тело.",
                            lightMeal: "Съешьте легкую пищу перед процедурой. Избегайте тяжелых блюд, чтобы обеспечить нормальный кровоток во время массажа.",
                            postRelaxation: "Расслабление после процедур крайне важно. Правильное расслабление повышает эффективность аюрведических процедур."
                        },
                    },
                    ballooningPage: {
                        title: "Полеты на воздушном шаре в Шри-Ланке",
                        mainDescription: "Полеты на воздушном шаре в Шри-Ланке предлагают незабываемый опыт плавного парения над потрясающими пейзажами острова. Начинающиеся на рассвете, полеты на воздушном шаре обеспечивают захватывающие виды с воздуха на холмистые пейзажи, пышные леса, древние руины и спокойные деревни.",
                        dambullaDescription: "Самое популярное место для полетов на воздушном шаре в Шри-Ланке — это Дамбулла, расположенная в самом сердце культурного треугольника. Полеты здесь часто проходят над культовой скальной крепостью Сигирия, предлагая уникальную перспективу. Полеты обычно длятся 60-90 минут, предоставляя достаточно времени, чтобы насладиться красотой Шри-Ланки с высоты.",
                        highlightsTitle: "Почему стоит попробовать полет на воздушном шаре в Шри-Ланке?",
                        highlightsDescription: "Полеты на воздушном шаре сочетают приключение с умиротворением, позволяя вам испытать красоту Шри-Ланки уникальным образом. Основные преимущества полетов включают:",
                        highlights: {
                            panoramicViews: "Непрерывные панорамные виды на потрясающие пейзажи острова.",
                            landmarks: "Полеты над культовыми достопримечательностями, такими как скальная крепость Сигирия и близлежащие озера.",
                            peacefulRide: "Спокойный и мирный полет над пышной зеленью и очаровательными деревнями.",
                            sunrise: "Наблюдение за великолепным рассветом с неба.",
                            photography: "Идеально подходит для любителей фотографии, желающих запечатлеть живописную красоту с высоты."
                        },
                        images: {
                            mainAlt: "Полеты на воздушном шаре в Шри-Ланке",
                            sunriseAlt: "Рассвет на воздушном шаре",
                            sunriseCaption: "Наслаждайтесь захватывающими видами рассвета, плавно паря в воздушном шаре.",
                            landscapeAlt: "Пейзажи на воздушном шаре",
                            landscapeCaption: "Увидьте потрясающие пейзажи Шри-Ланки с высоты, включая холмистые пейзажи и пышные леса."
                        },
                        tipsTitle: "Советы для незабываемого полета на воздушном шаре",
                        tips: {
                            bookEarly: "Бронируйте полет заранее, так как полеты зависят от погоды, и места быстро заполняются.",
                            clothing: "Носите удобную одежду и возьмите легкую куртку, так как ранние утра могут быть прохладными.",
                            camera: "Возьмите с собой камеру или смартфон, чтобы запечатлеть потрясающие виды.",
                            safety: "Внимательно слушайте инструкции по безопасности, предоставленные вашим пилотом.",
                            arriveEarly: "Приезжайте вовремя, чтобы понаблюдать за подготовкой и надуванием воздушного шара — это увлекательный процесс."
                        },
                    },
                    divingPage: {
                        title: "Дайвинг в Шри-Ланке",
                        mainDescription: "Широкий коралловый риф окружает побережье Шри-Ланки на глубинах от 2 до 40 метров. Тёплые воды Индийского океана, от 27°C до 30°C, и высокая прозрачность воды, от 15 до 35 метров, создают отличные условия для дайвинга и снорклинга. Во время дайвинга в Шри-Ланке вы можете исследовать бесконечные нетронутые коралловые рифы, старые затонувшие корабли и завораживающие подводные пещеры.",
                        northeastDescription: "Северо-восток острова предлагает разнообразие из более чем 130 видов ярких кораллов, которые являются домом для морских обитателей, таких как морские черепахи, рыбы-клоуны, рыбы-львы и морские коньки. Посетите затонувшие корабли у подводных скал и рифов для незабываемого опыта. Погружаясь в прозрачные воды, вы окунётесь в увлекательное прошлое Цейлона.",
                        facilitiesTitle: "Удобства и лучшие места для дайвинга",
                        facilitiesDescription: "Дайвинг-центры на острове оснащены новейшим оборудованием для дайвинга от известных производителей. Сертифицированные инструкторы с квалификацией PADI и CMAS обеспечивают безопасные и приятные погружения. Дайвинг-центры расположены вдоль юго-западного побережья острова и работают с середины октября до конца апреля. Северо-восточное побережье, включая Нилавели и Тринкомали, идеально для дайвинга с марта по октябрь.",
                        popularSpots: "Коралловые рифы у Калпитии на западе и места для дайвинга к затонувшим кораблям в Хиккадуве являются одними из самых популярных достопримечательностей для дайверов.",
                        images: {
                            mainAlt: "Дайвинг в Шри-Ланке",
                            coralReefAlt: "Дайвинг на коралловых рифах",
                            coralReefCaption: "Исследуйте яркие коралловые рифы, которые являются домом для разнообразной морской жизни.",
                            shipwreckAlt: "Дайвинг к затонувшим кораблям",
                            shipwreckCaption: "Откройте для себя исторические затонувшие корабли, которые дают представление о морском прошлом Шри-Ланки."
                        },
                        tipsTitle: "Советы для дайверов",
                        tips: {
                            season: "Выбирайте лучшее время для дайвинга в зависимости от места: юго-западное побережье (октябрь-апрель) или северо-восточное побережье (март-октябрь).",
                            certifiedCenter: "Убедитесь, что ваш дайвинг-центр сертифицирован и оснащён современным оборудованием для безопасного опыта.",
                            instructorAdvice: "Слушайте советы вашего инструктора, особенно если вы новичок.",
                            respectMarineLife: "Уважайте морскую жизнь, не трогая кораллы и не нарушая подводную среду.",
                            camera: "Возьмите водонепроницаемую камеру, чтобы запечатлеть завораживающую красоту подводного мира Шри-Ланки."
                        },
                    },
                    elephantRidePage: {
                        title: "Катание на слонах",
                        mainDescription: "Катание на слонах — это захватывающая, увлекательная активность и уникальный опыт в Шри-Ланке. Если вы остановились недалеко от культурного треугольника в таких местах, как Хабарана, Сигирия или Дамбулла, вы можете принять участие в сафари на слонах. Эти поездки начинаются примерно от 30 долларов за час незабываемого приключения.",
                        rideDescription: "Перед поездкой слоны оснащаются многоместной корзиной, рассчитанной на 4–6 человек. Эти добродушные гиганты проведут вас по живописным джунглевым тропам, пересекают затопленные водой участки и пробираются через густую растительность. Слоны обычно идут медленно, позволяя вам в полной мере насладиться красотой окружающей природы, хотя они могут развивать скорость до 40 км/ч.",
                        highlightsTitle: "Основные моменты катания на слонах",
                        highlightsDescription: "Катание на слонах в Шри-Ланке предоставляет уникальную возможность соединиться с природой и исследовать сельскую местность. Некоторые из основных моментов этого опыта включают:",
                        highlights: {
                            junglePaths: "Прогулки по густым джунглям, полным экзотической растительности и дикой природы.",
                            riverCrossing: "Переправа через реки и затопленные участки, открывающая потрясающие виды на природный ландшафт.",
                            culturalConnection: "Изучение тесной связи между слонами и культурой Шри-Ланки.",
                            comfortableRide: "Отдых на удобном седле, пока слон мягко несёт вас через различные ландшафты."
                        },
                        images: {
                            mainAlt: "Катание на слонах",
                            jungleAlt: "Катание на слонах по джунглевому пути",
                            jungleCaption: "Исследуйте густые джунгли и живописные тропы, катаясь на слоне.",
                            waterAlt: "Слон пересекает воду",
                            waterCaption: "Пересеките реки и наслаждайтесь спокойной красотой воды и растительности."
                        },
                        tipsTitle: "Советы для безопасного и приятного катания на слонах",
                        tips: {
                            clothing: "Носите удобную одежду и обувь, подходящую для активного отдыха на природе.",
                            guideInstructions: "Следуйте инструкциям вашего гида для безопасной и приятной поездки.",
                            ethicalPractices: "Убедитесь, что со слонами хорошо обращаются, и провайдер придерживается этических практик.",
                            camera: "Возьмите с собой камеру, чтобы запечатлеть захватывающие пейзажи и моменты.",
                            respectElephants: "Уважайте слонов и избегайте действий, которые могут вызвать у них стресс или вред."
                        },
                    },
                    fishingPage: {
                        title: "Рыбалка в Шри-Ланке",
                        mainDescription: "Шри-Ланка, с ее обширной береговой линией и множеством пресноводных озер и рек, предлагает непревзойденный опыт рыбалки. Будь вы профессиональным рыболовом или любителем, Шри-Ланка найдет, что предложить. От экспедиций по глубоководной рыбалке до традиционной рыбалки на ходулях, практикуемой местными рыбаками, вас ждет незабываемое приключение.",
                        destinationsDescription: "Популярные места для рыбалки включают южное побережье вокруг Галле и Мириссы, лагуну Негомбо и спокойные воды Тринкомали. В зависимости от ваших предпочтений вы можете попробовать различные техники рыбалки, такие как троллинг, донная рыбалка или нахлыст.",
                        experiencesTitle1: "Рыболовные впечатления в Шри-Ланке",
                        experiencesDescription: "Рыбалка в Шри-Ланке — это не только ловля рыбы; это возможность погрузиться в культуру и традиции острова. Некоторые уникальные рыболовные впечатления включают:",
                        experiences: {
                            stiltFishingTitle: "Рыбалка на ходулях",
                            stiltFishing: "Традиционный метод, при котором рыбаки сидят на ходулях, чтобы ловить рыбу у берега, практика, уникальная для Шри-Ланки.",
                            deepSeaFishingTitle: "Глубоководная рыбалка",
                            deepSeaFishing: "Отправляйтесь в Индийский океан, чтобы поймать марлинов, тунцов, барракуд и других крупных видов рыб.",
                            lagoonFishingTitle: "Рыбалка в лагунах и реках",
                            lagoonFishing: "Расслабьтесь, ловя рыбу в спокойных лагунах и реках, изобилующих такими видами, как тилапия и сом.",
                            nightFishingTitle: "Ночная рыбалка",
                            nightFishing: "Испытайте азарт рыбалки под звездами, распространенная практика в прибрежных деревнях."
                        },
                        images: {
                            mainAlt: "Рыбалка в Шри-Ланке",
                            stiltFishingAlt: "Рыбалка на ходулях в Шри-Ланке",
                            stiltFishingCaption: "Рыбалка на ходулях — это традиционный метод и культовый образ рыболовного наследия Шри-Ланки.",
                            deepSeaFishingAlt: "Глубоководная рыбалка в Шри-Ланке",
                            deepSeaFishingCaption: "Глубоководная рыбалка предлагает приключенческий опыт, нацеленный на крупные виды рыб в Индийском океане."
                        },
                        tipsTitle: "Советы для приятной рыбалки",
                        tips: {
                            season: "Выберите подходящий сезон для рыболовной экспедиции; с октября по апрель идеально подходит для южного побережья, а с марта по октябрь — для восточного.",
                            protection: "Возьмите солнцезащитный крем, шляпу и защитную одежду, чтобы чувствовать себя комфортно во время поездки.",
                            guide: "Забронируйте рыболовного гида или чартер, чтобы максимально использовать свой опыт и учиться у экспертов.",
                            environment: "Уважайте местную окружающую среду, избегая мусора и придерживаясь устойчивых методов рыболовства.",
                            hydration: "Оставайтесь гидратированными и берите с собой закуски для длительных рыболовных поездок."
                        },
                    },
                    jeepSafariPage: {
                        title: "Джип-сафари в Шри-Ланке",
                        mainDescription: "Национальные парки Шри-Ланки предлагают захватывающее джип-сафари, позволяющее исследовать богатое биоразнообразие острова и наблюдать за дикими животными в их естественной среде обитания. Национальные парки Яла, Вилпатту и Удавалаве являются одними из самых популярных направлений для джип-сафари.",
                        wildlifeDescription: "Эти сафари дают возможность увидеть слонов, леопардов, ленивцев, буйволов, крокодилов и множество видов птиц. Под руководством опытных натуралистов и следопытов, джип-сафари идеально подходят для любителей дикой природы и фотографов.",
                        whyChooseTitle: "Почему выбрать джип-сафари?",
                        whyChooseDescription: "Джип-сафари — один из лучших способов исследовать разнообразную дикую природу Шри-Ланки. Вот некоторые из основных моментов:",
                        whyChoose: {
                            encounters: "Близкие встречи с культовыми видами, такими как слоны и леопарды.",
                            remoteAreas: "Доступ к отдаленным и живописным районам в национальных парках.",
                            photography: "Возможности для фотосъемки дикой природы в естественной среде.",
                            guidance: "Руководство от знающих натуралистов и рейнджеров парка.",
                            adventure: "Приключение, подходящее для всех возрастных групп, сочетающее азарт и образование."
                        },
                        images: {
                            mainAlt: "Джип-сафари в Шри-Ланке",
                            wildlifeAlt: "Дикая природа на джип-сафари",
                            wildlifeCaption: "Наблюдайте за культовыми дикими животными, такими как леопарды, слоны и крокодилы, во время сафари.",
                            landscapeAlt: "Ландшафт джип-сафари",
                            landscapeCaption: "Исследуйте потрясающие ландшафты национальных парков Шри-Ланки, от густых лесов до открытых равнин."
                        },
                        tipsTitle: "Советы для приятного джип-сафари",
                        tips: {
                            clothing: "Носите удобную одежду нейтральных цветов, чтобы сливаться с окружающей средой.",
                            protection: "Возьмите солнцезащитный крем, шляпу и средство от насекомых для защиты.",
                            equipment: "Принесите бинокль и камеру, чтобы улучшить впечатления и запечатлеть дикую природу.",
                            guide: "Следуйте инструкциям гида, чтобы обеспечить безопасность и уважение к животным.",
                            booking: "Бронируйте сафари заранее, особенно в пиковые сезоны, чтобы забронировать место."
                        },
                    },
                    riverSafariPage: {
                        title: "Речное сафари в Шри-Ланке",
                        mainDescription: "Речное сафари в Шри-Ланке предлагает уникальный способ исследовать богатое биоразнообразие острова и его живописную красоту. Скользите по спокойным водным путям, окруженным пышными мангровыми зарослями, наблюдайте за экзотическими животными и наслаждайтесь живописными закатами, которые оставят вас в восторге.",
                        destinationsDescription: "Популярные направления для речных сафари включают Маду Ганга (река Маду) и реку Бентота. Эти сафари предоставляют возможность увидеть различные виды птиц, варанов, крокодилов и даже обезьян в их естественной среде обитания. Спокойная обстановка идеальна для любителей природы и фотографов.",
                        whyChooseTitle: "Почему выбрать речное сафари?",
                        whyChooseDescription: "Речное сафари — это расслабляющий и погружающий опыт, который сочетает природу, дикую природу и культурные исследования. Вот некоторые из основных моментов:",
                        whyChoose: {
                            mangroves: "Исследуйте пышные мангровые заросли, полные жизни.",
                            wildlife: "Наблюдайте за экзотическими птицами, крокодилами и другими дикими животными.",
                            villages: "Посетите небольшие острова и местные деревни вдоль реки.",
                            tranquility: "Наслаждайтесь спокойствием и живописной красотой водных путей Шри-Ланки.",
                            suitable: "Идеально подходит для семей, пар и одиночных путешественников, ищущих спокойный отдых."
                        },
                        images: {
                            mainAlt: "Речное сафари в Шри-Ланке",
                            mangrovesAlt: "Мангровые заросли на речном сафари",
                            mangrovesCaption: "Откройте для себя пышные мангровые заросли, окаймляющие живописные водные пути Шри-Ланки.",
                            wildlifeAlt: "Дикая природа на речном сафари",
                            wildlifeCaption: "Наблюдайте за экзотическими дикими животными, такими как крокодилы, вараны и разноцветные птицы, во время сафари."
                        },
                        tipsTitle: "Советы для приятного речного сафари",
                        tips: {
                            clothing: "Носите удобную одежду и возьмите шляпу и солнцезащитный крем для защиты.",
                            binoculars: "Возьмите бинокль, чтобы разглядеть далеких животных и птиц.",
                            camera: "Принесите камеру или смартфон, чтобы запечатлеть потрясающие пейзажи и дикую природу.",
                            guide: "Следуйте инструкциям вашего гида для безопасного и приятного опыта.",
                            environment: "Уважайте природную среду, избегая мусора и не беспокоя диких животных."
                        },
                    },
                    snorkelingPage: {
                        title: "Сноркелинг в Шри-Ланке",
                        mainDescription: "Сноркелинг в Шри-Ланке предлагает незабываемый подводный опыт, позволяя исследовать яркие коралловые рифы и разнообразную морскую жизнь. Благодаря кристально чистым водам и богатым водным экосистемам Шри-Ланка является раем для сноркелеров всех уровней подготовки.",
                        destinationsDescription: "Некоторые из самых популярных мест для сноркелинга включают Хиккадуву, известную своими красочными коралловыми садами и черепахами, остров Пиджин в Тринкомали, знаменитый своими нетронутыми рифами, и Мириссу, где во время сезона сноркелинга можно даже увидеть кита или двух.",
                        whyChooseTitle: "Почему стоит выбрать сноркелинг в Шри-Ланке?",
                        whyChooseDescription: "Сноркелинг в Шри-Ланке — это магический опыт, сочетающий приключения и природную красоту. Вот некоторые из основных моментов:",
                        whyChoose: {
                            coralReefs: "Исследуйте яркие коралловые рифы, полные жизни.",
                            marineLife: "Плавайте рядом с разноцветными тропическими рыбами, черепахами и даже рифовыми акулами.",
                            landscapes: "Откройте для себя нетронутые подводные ландшафты в чистых и теплых водах.",
                            suitable: "Подходит как для новичков, так и для опытных сноркелеров.",
                            accessible: "Доступно из лучших пляжных направлений Шри-Ланки."
                        },
                        images: {
                            mainAlt: "Сноркелинг в Шри-Ланке",
                            coralReefAlt: "Коралловые рифы в Шри-Ланке",
                            coralReefCaption: "Откройте для себя потрясающие коралловые рифы и их яркие экосистемы.",
                            marineLifeAlt: "Морская жизнь в Шри-Ланке",
                            marineLifeCaption: "Встречайте разнообразную морскую жизнь, включая черепах, тропических рыб и многое другое."
                        },
                        tipsTitle: "Советы для незабываемого сноркелинга",
                        tips: {
                            mask: "Носите удобную маску и трубку, чтобы обеспечить четкий обзор под водой.",
                            sunscreen: "Используйте безопасный для рифов солнцезащитный крем, чтобы защитить кожу и морскую жизнь.",
                            swimGently: "Плавайте осторожно, чтобы не повредить коралловые рифы и водных обитателей.",
                            hydration: "Оставайтесь гидратированными и делайте перерывы между сеансами.",
                            guidedTour: "Присоединяйтесь к экскурсии с гидом, чтобы найти лучшие места для сноркелинга и получить советы по безопасности."
                        },
                    },
                    teaTastingPage: {
                        title: "Тур по дегустации чая в Шри-Ланке",
                        mainDescription: "Шри-Ланка, часто называемая 'Жемчужиной Индийского океана', славится своим чаем мирового класса. Отправляйтесь в тур по дегустации чая и исследуйте пышные чайные плантации в регионах, таких как Нувара-Элия, Элла и Канди. Узнайте об искусстве выращивания чая, тщательном процессе производства чая и насладитесь богатыми вкусами аутентичного цейлонского чая.",
                        heritageDescription: "Будь вы энтузиаст чая или просто любопытны, тур по дегустации чая предлагает уникальную возможность погрузиться в чайное наследие Шри-Ланки и испытать спокойную красоту ее высокогорья.",
                        whyChooseTitle: "Почему стоит выбрать тур по дегустации чая?",
                        whyChooseDescription: "Тур по дегустации чая в Шри-Ланке — это не только дегустация чая, это погружение в культуру. Вот некоторые из основных моментов:",
                        whyChoose: {
                            plantations: "Посетите живописные чайные плантации, расположенные в прохладных высокогорьях.",
                            history: "Узнайте об истории и значении цейлонского чая.",
                            production: "Участвуйте в сборе чая и наблюдайте за процессом производства на чайных фабриках.",
                            varieties: "Попробуйте различные сорта чая, от черного до зеленого и ароматизированных смесей.",
                            scenery: "Наслаждайтесь захватывающей дух природой с туманными горами и каскадными водопадами."
                        },
                        images: {
                            mainAlt: "Тур по дегустации чая в Шри-Ланке",
                            teaPlantationAlt: "Чайная плантация в Шри-Ланке",
                            teaPlantationCaption: "Исследуйте пышные чайные плантации и узнайте о выращивании чая.",
                            teaPreparationAlt: "Приготовление чая в Шри-Ланке",
                            teaPreparationCaption: "Откройте для себя искусство приготовления чая и насладитесь аутентичным цейлонским чаем."
                        },
                        tipsTitle: "Советы для приятного тура по дегустации чая",
                        tips: {
                            clothing: "Носите удобную одежду и обувь для прогулок по плантациям.",
                            jacket: "Возьмите легкую куртку, так как в высокогорьях может быть прохладно и туманно.",
                            varieties: "Попробуйте разные сорта чая и возьмите свои любимые в качестве сувениров.",
                            questions: "Задавайте вопросы во время тура, чтобы узнать больше о процессе приготовления чая.",
                            attractions: "Сочетайте тур по чаю с посещением близлежащих достопримечательностей, таких как водопады и смотровые площадки."
                        },
                    },
                    templeVisitPage: {
                        title: "Посещение храмов в Шри-Ланке",
                        mainDescription: "Шри-Ланка, известная как Земля Будды, является домом для древних храмов, отражающих ее богатое духовное и культурное наследие. Отправляйтесь в путешествие, чтобы исследовать культовые храмы, такие как Храм Зуба Будды в Канди, пещерный храм Дамбулла и Руванвелисая в Анурадхапуре.",
                        spiritualDescription: "Эти священные места, украшенные сложной резьбой, фресками и статуями, дают представление о духовных традициях и архитектурном великолепии острова. Посещение храма — это не только культурный опыт, но и возможность обрести покой и умиротворение.",
                        whyVisitTitle: "Почему стоит посещать храмы в Шри-Ланке?",
                        whyVisitDescription: "Посещение храмов в Шри-Ланке предоставляет уникальную возможность связаться с историей, культурой и духовностью острова. Вот некоторые из основных моментов:",
                        whyVisit: {
                            architecture: "Восхищайтесь сложной архитектурой и многовековыми статуями.",
                            traditions: "Узнайте о буддийских традициях и ритуалах от знающих гидов.",
                            heritage: "Исследуйте объекты всемирного наследия ЮНЕСКО, такие как Золотой храм Дамбуллы.",
                            serenity: "Ощутите спокойствие и духовную атмосферу священных мест.",
                            festivals: "Станьте свидетелем ярких фестивалей, таких как Эсала Перахера в Храме Зуба Будды."
                        },
                        images: {
                            mainAlt: "Посещение храмов в Шри-Ланке",
                            templeInteriorAlt: "Интерьер храма",
                            templeInteriorCaption: "Восхищайтесь потрясающими интерьерами, украшенными сложной резьбой и фресками.",
                            sacredTempleAlt: "Священный храм в Шри-Ланке",
                            sacredTempleCaption: "Посетите священные храмы, такие как Руванвелисая, и погрузитесь в духовные традиции."
                        },
                        tipsTitle: "Советы для посещения храмов в Шри-Ланке",
                        tips: {
                            dress: "Одевайтесь скромно, прикрывая плечи и колени, в знак уважения.",
                            shoes: "Снимайте обувь перед входом на территорию храма.",
                            touching: "Воздержитесь от прикосновения к статуям или священным объектам.",
                            donation: "Возьмите небольшое пожертвование для храма, если хотите внести вклад.",
                            silence: "Уважайте тишину и духовную атмосферу во время посещения."
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "Сплав по бурным рекам в Шри-Ланке",
                        mainDescription: "Сплав по бурным рекам в Шри-Ланке — это захватывающее приключение, особенно в Китулгале, приключенческой столице острова. Река Келани с ее бурными порогами и живописными окрестностями создает идеальные условия как для новичков, так и для опытных сплавщиков.",
                        destinationsDescription: "Экспедиции по сплаву обычно охватывают участок реки длиной 5 километров с порогами от 2-го до 4-го уровня сложности. Участники могут насладиться азартом преодоления сложных течений, любуясь пышной зеленью и захватывающими видами берегов реки.",
                        whyChooseTitle: "Почему стоит выбрать сплав по бурным рекам в Шри-Ланке?",
                        whyChooseDescription: "Сплав по бурным рекам в Шри-Ланке предлагает уникальное сочетание приключений и природной красоты. Вот некоторые из основных моментов:",
                        whyChoose: {
                            rapids: "Преодолевайте захватывающие пороги под руководством опытных инструкторов.",
                            views: "Наслаждайтесь потрясающими видами окружающего тропического леса и горной местности.",
                            activities: "Комбинируйте сплав с другими активностями, такими как треккинг, наблюдение за птицами и каньонинг в Китулгале.",
                            suitable: "Идеально подходит для групп, семей или одиночных путешественников, ищущих прилив адреналина."
                        },
                        images: {
                            mainAlt: "Сплав по бурным рекам в Шри-Ланке",
                            actionRaftingAlt: "Действие сплава по бурным рекам",
                            actionRaftingCaption: "Почувствуйте прилив адреналина, преодолевая сложные пороги на реке Келани.",
                            scenicRaftingAlt: "Живописные виды сплава",
                            scenicRaftingCaption: "Наслаждайтесь безмятежной красотой пышных окрестностей во время вашего приключения по сплаву."
                        },
                        tipsTitle: "Советы для безопасного и захватывающего сплава",
                        tips: {
                            safetyGear: "Носите спасательный жилет и шлем, предоставленные вашим гидом по сплаву, для безопасности.",
                            instructions: "Внимательно слушайте инструкции по безопасности перед началом поездки.",
                            clothing: "Носите удобную, быстро сохнущую одежду и надежную обувь, например, водные ботинки.",
                            changeOfClothes: "Возьмите с собой сменную одежду и полотенце на время после поездки.",
                            operator: "Бронируйте сплав у надежного оператора, чтобы обеспечить безопасный и приятный опыт."
                        },
                    },
                    wildlifeSafariPage: {
                        title: "Сафари по дикой природе в Шри-Ланке",
                        mainDescription: "Шри-Ланка, известная своим богатым биоразнообразием, предлагает невероятные сафари в национальных парках, таких как Яла, Вилпатту, Миннерия и Удавалаве. Эти сафари дают возможность увидеть слонов, леопардов, ленивцев и множество видов птиц в их естественной среде обитания.",
                        destinationsDescription: "Исследуйте разнообразные ландшафты, от густых лесов до открытых лугов, и запечатлейте незабываемые моменты дикой природы в действии. С опытными гидами и хорошо обслуживаемыми сафари-джипами сафари в Шри-Ланке обязательно для любителей природы и искателей приключений.",
                        whyChooseTitle: "Почему стоит выбрать сафари по дикой природе?",
                        whyChooseDescription: "Сафари по дикой природе в Шри-Ланке предоставляет уникальную возможность соединиться с природой и исследовать удивительное биоразнообразие острова. Основные моменты включают:",
                        whyChoose: {
                            species: "Наблюдение за культовыми видами, такими как слоны, леопарды и крокодилы.",
                            landscapes: "Исследование пышных лесов, водно-болотных угодий и открытых равнин, изобилующих дикой природой.",
                            photography: "Создание потрясающих фотографий дикой природы в естественной среде.",
                            elusiveAnimals: "Ощущение азарта от обнаружения неуловимых животных, таких как шри-ланкийский леопард.",
                            conservation: "Узнайте о природоохранных усилиях от опытных гидов и натуралистов."
                        },
                        images: {
                            mainAlt: "Сафари по дикой природе в Шри-Ланке",
                            elephantsAlt: "Слоны в Шри-Ланке",
                            elephantsCaption: "Увидьте величественных слонов, свободно бродящих по национальным паркам Шри-Ланки.",
                            leopardAlt: "Шри-ланкийский леопард",
                            leopardCaption: "Обнаружьте неуловимого шри-ланкийского леопарда, изюминку любого сафари."
                        },
                        tipsTitle: "Советы для захватывающего сафари по дикой природе",
                        tips: {
                            clothing: "Носите одежду нейтральных цветов, чтобы слиться с окружающей средой.",
                            protection: "Возьмите солнцезащитный крем, шляпу и средство от насекомых для защиты.",
                            equipment: "Возьмите бинокль и камеру, чтобы наблюдать и фотографировать дикую природу.",
                            guide: "Следуйте инструкциям вашего гида для безопасного и приятного опыта.",
                            booking: "Бронируйте заранее, особенно в пиковые сезоны, чтобы обеспечить место в популярных парках."
                        },
                    },
                },
            },
            fr: {
                translation: {
                    home: 'Accueil',
                    about: 'À propos',
                    srilanka: 'Sri Lanka',
                    excursions: 'Excursions',
                    tour: 'Réserver un tour',
                    things: 'Activités',
                    contact: {
                        navLabel: 'Contactez-nous',
                        getInTouch: 'Prendre contact',
                        address: 'Adresse',
                        mobile: 'Mobile',
                        email: 'E-mail',
                        website: 'Site web',
                        sendMessage: 'Envoyez-nous un message',
                        fullName: 'Nom complet',
                        fullNamePlaceholder: 'Entrez votre nom complet',
                        country: 'Pays',
                        countryPlaceholder: 'Entrez votre pays',
                        emailPlaceholder: 'Entrez votre e-mail',
                        subject: 'Sujet',
                        subjectPlaceholder: 'Entrez le sujet',
                        message: 'Message',
                        messagePlaceholder: 'Entrez votre message',
                        reset: 'Réinitialiser',
                        submit: 'Soumettre',
                        ourLocation: 'Notre emplacement',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Message des invités d’Ashan Tours Sri Lanka',
                        manualMessage: 'Veuillez envoyer manuellement le message suivant à',
                        errorMessage: 'Une erreur s’est produite. Veuillez envoyer manuellement le message suivant à',
                    },
                    footerSection: {
                        ashanTours: 'Ashan Tours Sri Lanka',
                        getInTouch: 'Nous contacter',
                        address: '293/C/3, Route de Maradana, Moragalla, Beruwala, Sri Lanka',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: 'Restez connecté',
                        emailPlaceholder: 'Entrez votre adresse e-mail',
                        socialMedia: {
                            facebook: 'Facebook',
                            instagram: 'Instagram',
                            youtube: 'YouTube',
                            twitter: 'Twitter',
                        },
                        copyright: '© {{year}} Ashan Tours Sri Lanka. Tous droits réservés.',
                        designedBy: 'Site web conçu et développé par Redev Solutions',
                        designedByPhone: '+94 76 460 8225',
                    },
                    aboutSection: {
                        travelWithAshan: 'Voyagez avec Ashan Tours Sri Lanka',
                        imageAlt: 'Image Ashan Tours {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lanka est votre compagnon de voyage de confiance, créant des voyages inoubliables à travers le Sri Lanka. Avec notre passion pour l’exploration et une équipe de professionnels expérimentés, nous nous engageons à offrir des itinéraires personnalisés, des conseils d’experts et un service exceptionnel pour rendre vos vacances vraiment spéciales.',
                        introParagraph2: 'Nos circuits sont soigneusement conçus pour capturer l’essence du Sri Lanka — des plages ensoleillées et des collines pittoresques aux trésors culturels anciens et à la faune vibrante. Chez Ashan Tours Sri Lanka, nous nous engageons à fournir des expériences authentiques qui vous permettent de découvrir la beauté et l’âme de l’île.',
                        introParagraph3: 'Que vous recherchiez l’aventure, une retraite paisible ou une immersion culturelle, Ashan Tours Sri Lanka propose des forfaits sur mesure adaptés à vos désirs. Rejoignez-nous et laissez-nous vous guider dans un voyage rempli d’émerveillement, de découverte et de souvenirs durables.',
                        cinnamonLuxuryVilla: 'Villa de Luxe Cinnamon',
                        villaImageAlt: 'Image de la Villa de Luxe Cinnamon {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lanka présente fièrement notre Villa de Luxe Cinnamon, offrant des hébergements haut de gamme pour les voyageurs en quête de confort et d’élégance. Nos deux appartements exclusifs sont conçus pour offrir une expérience de chez-soi au cœur du Sri Lanka.',
                        villaParagraph2: 'Chaque appartement est équipé de commodités modernes, y compris la climatisation, des salles de bains attenantes, des lits doubles de luxe et des cuisines entièrement équipées. Que vous voyagiez seul, en couple ou en famille, nos villas offrent le mélange parfait de luxe et de commodité.',
                        villaParagraph3: 'Nichée dans un cadre serein, la Villa de Luxe Cinnamon vous permet de vous détendre et de vous relaxer après une journée d’exploration des merveilles du Sri Lanka. Réservez votre séjour avec Ashan Tours Sri Lanka et découvrez une hospitalité inégalée.',
                    },
                    sriLankaSection: {
                        discoverSriLanka: 'Découvrez le Sri Lanka',
                        mainImageAlt: 'Sri Lanka',
                        pearlOfIndianOcean: 'Perle de l’océan Indien',
                        introParagraph1: 'Le Sri Lanka, affectueusement surnommé la "{{pearl}}", est un paradis insulaire magnifique, célébré pour ses paysages à couper le souffle, ses traditions profondément enracinées et sa culture colorée.',
                        introParagraph2: 'Avec une civilisation de plus de 2 500 ans, le Sri Lanka abrite des capitales anciennes majestueuses, des monuments religieux sacrés et des sites du patrimoine mondial de l’UNESCO. Sa richesse culturelle est enrichie par des influences indiennes, arabes, portugaises, néerlandaises et britanniques, offrant un voyage fascinant à travers le temps.',
                        introParagraph3: 'Les paysages de l’île sont extraordinaires — des plages de sable doré et des plantations de thé verdoyantes aux sommets montagneux brumeux. Ses réserves fauniques abritent des éléphants, des léopards et une faune aviaire vibrante, en faisant un rêve pour les amoureux de la nature.',
                        introParagraph4: 'Pour les amateurs d’aventure, le Sri Lanka propose du surf, du trekking, de la plongée avec tuba et de la plongée sous-marine. La cuisine, infusée d’épices aromatiques, de fruits de mer frais et de fruits tropicaux, est audacieuse et savoureuse, racontant l’histoire du riche patrimoine culinaire de l’île.',
                        introParagraph5: 'Que vous vous promeniez parmi des ruines intemporelles, vous détendiez sur des plages sereines ou savouriez l’hospitalité chaleureuse, le Sri Lanka offre une expérience de voyage inoubliable.',
                        attractivePlaces: 'Lieux attractifs au Sri Lanka',
                        viewMore: 'Voir plus',
                        placeImageAlt: 'Image de {{name}} {{index}}',
                        fullImagePreviewAlt: 'Aperçu en pleine taille',
                        famousThingsTitle: 'Choses célèbres au Sri Lanka',
                        places: {
                            sigiriyaRockFortress: {
                                name: 'Forteresse de Sigiriya',
                                description: 'La forteresse de Sigiriya est un site du patrimoine mondial de l’UNESCO et l’un des monuments les plus emblématiques du Sri Lanka. Elle présente des jardins anciens, des fresques et des vues imprenables depuis le sommet de la roche.',
                            },
                            templeOfTheTooth: {
                                name: 'Temple de la Dent',
                                description: 'Le Temple de la Relique de la Dent Sacrée à Kandy est un site bouddhiste sacré qui abrite une relique de la dent de Bouddha. Les visiteurs peuvent découvrir son importance historique et religieuse.',
                            },
                            ella: {
                                name: 'Ella',
                                description: 'Ella est une petite ville dans les hautes terres du Sri Lanka, entourée de plantations de thé et de cascades. Elle est célèbre pour le pont des neuf arches et le Petit Pic d’Adam.',
                            },
                            yalaNationalPark: {
                                name: 'Parc national de Yala',
                                description: 'Le parc national de Yala est réputé pour sa riche faune, incluant des éléphants, des léopards et de nombreuses espèces d’oiseaux. Une safari ici est incontournable pour les amateurs de nature.',
                            },
                            galleFort: {
                                name: 'Fort de Galle',
                                description: 'Le fort de Galle, construit par les Portugais et fortifié par les Néerlandais, est un site historique avec des rues pavées, une architecture coloniale et des cafés animés.',
                            },
                            nuwaraEliya: {
                                name: 'Nuwara Eliya',
                                description: 'Surnommée "Petite Angleterre", Nuwara Eliya est une station de montagne célèbre pour son climat frais, ses plantations de thé et ses bungalows de l’époque coloniale.',
                            },
                            adamsPeak: {
                                name: 'Pic d’Adam',
                                description: 'Le Pic d’Adam est une montagne sacrée avec une empreinte unique au sommet. C’est un lieu de pèlerinage populaire pour plusieurs religions.',
                            },
                            hortonPlains: {
                                name: 'Plaines de Horton',
                                description: 'Le parc national des Plaines de Horton présente des collines vallonnées, des cascades et le célèbre point de vue de la Fin du Monde.',
                            },
                            bentotaBeach: {
                                name: 'Plage de Bentota',
                                description: 'La plage de Bentota est une destination côtière immaculée, connue pour ses sables dorés, ses sports nautiques et ses complexes hôteliers de luxe.',
                            },
                            jaffna: {
                                name: 'Jaffna',
                                description: 'Jaffna, dans la région nord du Sri Lanka, est riche en culture tamoule, sites historiques et cuisine délicieuse.',
                            },
                            anuradhapura: {
                                name: 'Anuradhapura',
                                description: 'Anuradhapura est une ville ancienne connue pour ses sites bouddhistes sacrés et ses ruines historiques, y compris l’arbre Sri Maha Bodhi.',
                            },
                            polonnaruwa: {
                                name: 'Polonnaruwa',
                                description: 'Polonnaruwa est un site du patrimoine mondial de l’UNESCO avec des temples anciens, des statues et des ruines magnifiquement préservées.',
                            },
                            unawatunaBeach: {
                                name: 'Plage d’Unawatuna',
                                description: 'La plage d’Unawatuna est une destination côtière animée offrant plongée avec tuba, bains de soleil et vie nocturne animée.',
                            },
                            colomboCity: {
                                name: 'Ville de Colombo',
                                description: 'Colombo est la capitale animée du Sri Lanka, mêlant gratte-ciel modernes, architecture coloniale et marchés vibrants.',
                            },
                            udawalawaNationalPark: {
                                name: 'Parc national d’Udawalawa',
                                description: 'Le parc national d’Udawalawa est un havre de faune célèbre pour ses grands troupeaux d’éléphants, ses diverses espèces d’oiseaux et ses paysages époustouflants, en faisant une destination incontournable pour les amoureux de la nature.',
                            },
                            dambullaCaveTemple: {
                                name: 'Temple des grottes de Dambulla',
                                description: 'Le temple des grottes de Dambulla est un site du patrimoine mondial de l’UNESCO présentant des peintures murales bouddhistes anciennes et des statues dans des grottes.',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: 'Thé de Ceylan',
                                description: 'Le Sri Lanka est mondialement célèbre pour son thé de Ceylan, connu pour sa saveur distinctive et sa qualité. Le thé des régions de Nuwara Eliya, Uva et Dimbula est particulièrement renommé.',
                            },
                            spices: {
                                title: 'Épices',
                                description: 'Le Sri Lanka est un centre pour les épices comme la cannelle, la cardamome, les clous de girofle et la muscade depuis des siècles. La cannelle sri-lankaise est considérée comme la meilleure au monde.',
                            },
                            gems: {
                                title: 'Gemmes et bijoux',
                                description: 'Connu comme l’"Île des gemmes", le Sri Lanka est célèbre pour ses saphirs, rubis et pierres de lune. La "Blue Belle of Asia", l’un des plus grands saphirs bleus, a été découverte ici.',
                            },
                            ayurveda: {
                                title: 'Ayurveda',
                                description: 'Le Sri Lanka est réputé pour sa médecine ayurvédique et ses traitements de bien-être. Les offres populaires incluent des massages, des thérapies à base de plantes et des complexes ayurvédiques.',
                            },
                            handicrafts: {
                                title: 'Artisanat traditionnel',
                                description: 'Le Sri Lanka produit des objets artisanaux exquis, y compris des masques d’Ambalangoda, des textiles batik, des sculptures sur bois et des objets laqués.',
                            },
                            elephants: {
                                title: 'Éléphants',
                                description: 'Les éléphants sri-lankais jouent un rôle important dans la culture et les festivals. Les éléphants parés de costumes grandioses participent à des processions comme l’Esala Perahera.',
                            },
                            food: {
                                title: 'Cuisine traditionnelle',
                                description: 'Le Sri Lanka est célèbre pour sa cuisine savoureuse, incluant du riz et curry, des hoppers, du kottu roti, du pol sambol et du wattalappam.',
                            },
                            festivals: {
                                title: 'Festivals',
                                description: 'Le Sri Lanka célèbre des festivals colorés comme l’Esala Perahera, le Nouvel An cinghalais et tamoul, et Vesak, avec des décorations lumineuses et des processions.',
                            },
                            coconut: {
                                title: 'Produits de noix de coco',
                                description: 'Le Sri Lanka est célèbre pour ses produits à base de noix de coco comme l’huile de coco, le lait et la fibre de coco, utilisée pour les cordes et les tapis.',
                            },
                            sarees: {
                                title: 'Saris sri-lankais',
                                description: 'Le sari kandyan (Osariya) est un vêtement traditionnel pour les femmes, connu pour son élégance et son style de drapé unique, porté lors des occasions cérémonielles.',
                            },
                            dances: {
                                title: 'Danses traditionnelles',
                                description: 'Les danses traditionnelles du Sri Lanka incluent la danse kandyan, les danses du diable et les danses des basses terres, inspirées par la nature et le folklore.',
                            },
                            stiltFishing: {
                                title: 'Pêche sur pilotis',
                                description: 'Une image emblématique du Sri Lanka, la pêche sur pilotis implique des pêcheurs qui s’équilibrent sur des poteaux plantés dans la mer, unique aux régions côtières du sud.',
                            },
                            moonstones: {
                                title: 'Pierres de lune',
                                description: 'Le Sri Lanka est réputé pour ses pierres de lune, considérées comme des gemmes semi-précieuses. Les mines de pierres de lune à Meetiyagoda sont particulièrement célèbres.',
                            },
                            cricket: {
                                title: 'Cricket sri-lankais',
                                description: 'Le cricket est une passion pour les Sri-Lankais, le pays étant connu pour produire des joueurs de classe mondiale. Le Sri Lanka a remporté la Coupe du monde de cricket ICC en 1996.',
                            },
                            herbs: {
                                title: 'Herbes et épices ayurvédiques',
                                description: 'L’île produit des remèdes à base de plantes utilisés en ayurveda, comme le gotu kola, la cannelle et le neem.',
                            },
                            masks: {
                                title: 'Masques',
                                description: 'Les masques traditionnels sri-lankais d’Ambalangoda sont utilisés dans des performances culturelles, y compris les masques Yaksha (diables) et Kolam.',
                            },
                        },
                    },
                    excursionsSection: {
                        title: 'Excursions',
                        excursions: {
                            oneDay: {
                                title: 'Excursions d’une journée',
                                description: 'Découvrez des destinations magnifiques en une seule journée avec des visites guidées et des expériences locales.',
                                alt: 'Excursion d’une journée au Sri Lanka',
                            },
                            twoDays: {
                                title: 'Excursions de deux jours',
                                description: 'Profitez de courts séjours avec nuitée pour découvrir encore plus du Sri Lanka.',
                                alt: 'Excursion de deux jours au Sri Lanka',
                            },
                            threeDays: {
                                title: 'Excursions de trois jours',
                                description: 'Explorez plusieurs attractions sur trois jours d’aventure et de détente.',
                                alt: 'Excursion de trois jours au Sri Lanka',
                            },
                            fourDays: {
                                title: 'Excursions de quatre jours',
                                description: 'Parfait pour un voyage prolongé couvrant plusieurs destinations en tout confort.',
                                alt: 'Excursion de quatre jours au Sri Lanka',
                            },
                            twentyDays: {
                                title: 'Excursions de 20 jours',
                                description: 'Embarquez pour un voyage épique à travers le Sri Lanka, en explorant ses merveilles culturelles, naturelles et historiques.',
                                alt: 'Excursion de 20 jours au Sri Lanka',
                            },
                        },
                        bentotaExcursions: {
                            title: 'Excursions depuis Bentota',
                            bentotaToYala: {
                                title: 'Bentota à Yala',
                                description: 'Bentota -> Ella -> Yala',
                            },
                            bentotaToNuwaraEliya: {
                                title: 'Bentota à Nuwara Eliya',
                                description: 'Bentota -> Ella -> Kandy -> Nuwara Eliya',
                            },
                            bentotaToMinneriya: {
                                title: 'Bentota au parc national de Minneriya',
                                description: 'Bentota -> Sigiriya -> Anuradhapura -> Polonnaruwa -> Parc national de Minneriya',
                            },
                            bentotaToHortonPlains: {
                                title: 'Bentota aux plaines de Horton',
                                description: 'Bentota -> Kandy -> Nuwara Eliya -> Plaines de Horton',
                            },
                            images: {
                                bentotaToElla1: 'Vue de la plage de Bentota 1',
                                bentotaToElla2: 'Vue de la plage de Bentota 2',
                            },
                        },
                        airportExcursions: {
                            title: 'Excursions depuis l’aéroport',
                            airportToColombo: {
                                title: 'De l’aéroport à la visite de la ville de Colombo',
                                description: 'Aéroport -> Fort de Colombo -> Galle Face -> Temple Gangaramaya',
                                alt1: 'Image de la visite de Colombo 1',
                                alt2: 'Image de la visite de Colombo 2',
                            },
                            airportToSigiriya: {
                                title: 'De l’aéroport à Sigiriya',
                                description: 'Aéroport -> Dambulla -> Forteresse de Sigiriya',
                                alt1: 'Image de l’excursion à Sigiriya 1',
                                alt2: 'Image de l’excursion à Sigiriya 2',
                            },
                            airportToKandy: {
                                title: 'De l’aéroport à Kandy',
                                description: 'Aéroport -> Orphelinat des éléphants de Pinnawala -> Temple de la Dent à Kandy',
                                alt1: 'Image de l’excursion à Kandy 1',
                                alt2: 'Image de l’excursion à Kandy 2',
                            },
                            airportToGalle: {
                                title: 'De l’aéroport à Galle',
                                description: 'Aéroport -> Bentota -> Fort de Galle -> Plage d’Unawatuna',
                                alt1: 'Image de l’excursion à Galle 1',
                                alt2: 'Image de l’excursion à Galle 2',
                            },
                        },
                    },
                    thingsToDoSection: {
                        title: 'Choses à faire au Sri Lanka',
                        viewMore: 'Voir plus',
                        activities: {
                            ayurveda: {
                                title: 'Ayurveda - Science ancienne de la vie',
                                alt: 'Thérapie ayurvédique au Sri Lanka',
                            },
                            diving: {
                                title: 'Plongée au Sri Lanka',
                                alt: 'Expérience de plongée au Sri Lanka',
                            },
                            elephantRide: {
                                title: 'Balade à dos d’éléphant',
                                alt: 'Balade à dos d’éléphant au Sri Lanka',
                            },
                            fishing: {
                                title: 'Pêche au Sri Lanka',
                                alt: 'Activité de pêche au Sri Lanka',
                            },
                            ballooning: {
                                title: 'Montgolfière au Sri Lanka',
                                alt: 'Vol en montgolfière au Sri Lanka',
                            },
                            jeepSafari: {
                                title: 'Safari en jeep',
                                alt: 'Safari en jeep au Sri Lanka',
                            },
                            whiteWaterRafting: {
                                title: 'Rafting en eaux vives',
                                alt: 'Rafting en eaux vives au Sri Lanka',
                            },
                            riverSafari: {
                                title: 'Safari fluvial',
                                alt: 'Safari fluvial au Sri Lanka',
                            },
                            snorkeling: {
                                title: 'Plongée avec tuba au Sri Lanka',
                                alt: 'Expérience de plongée avec tuba au Sri Lanka',
                            },
                            teaTasting: {
                                title: 'Visite de dégustation de thé',
                                alt: 'Visite de dégustation de thé au Sri Lanka',
                            },
                            templeVisit: {
                                title: 'Visite de temple',
                                alt: 'Visite de temple au Sri Lanka',
                            },
                            wildlifeSafari: {
                                title: 'Safari animalier',
                                alt: 'Safari animalier au Sri Lanka',
                            },
                        },
                    },
                    homeHeroSection: {
                        title: 'Voyagez avec Ashan Sri Lanka',
                        subtitle: 'Découvrez la beauté enchanteresse du Sri Lanka avec des aventures inoubliables',
                        bookButton: 'Réservez votre voyage',
                        videoFallback: 'Votre navigateur ne prend pas en charge la balise vidéo.',
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: 'Pourquoi choisir Ashan Tours Sri Lanka',
                            specialist: {
                                title: 'Expertise en voyage',
                                description: 'Notre équipe chez Ashan Tours Sri Lanka est composée de spécialistes du voyage qui créent des itinéraires sur mesure adaptés à vos envies.'
                            },
                            experience: {
                                title: 'Expériences mémorables',
                                description: 'Nous créons des moments inoubliables en mettant en avant la riche culture, l’histoire et la beauté naturelle du Sri Lanka avec passion.'
                            },
                            priceMatch: {
                                title: 'Prix compétitifs',
                                description: 'Ashan Tours Sri Lanka garantit le meilleur rapport qualité-prix, offrant des expériences de qualité à des tarifs abordables.'
                            },
                            support: {
                                title: 'Support dédié',
                                description: 'Notre équipe d’assistance clientèle est disponible 24/7 pour vous accompagner à chaque étape, assurant une expérience de voyage fluide.'
                            }
                        },
                        welcome: {
                            title: 'Bienvenue chez Ashan Tours Sri Lanka',
                            imageAlt: 'Image de bienvenue d’Ashan Tours Sri Lanka',
                            description1: 'Embarquez pour un voyage extraordinaire avec Ashan Tours Sri Lanka, votre guide principal pour explorer les merveilles de ce paradis insulaire.',
                            description2: 'Découvrez la culture vibrante, les paysages époustouflants et les trésors cachés du Sri Lanka avec nos circuits soigneusement conçus.',
                            description3: 'Des plages immaculées aux ruines anciennes, nos itinéraires sont conçus pour vous immerger dans le cœur de la beauté du Sri Lanka.',
                            description4: 'Notre équipe dévouée assure un service personnalisé, rendant votre expérience de voyage fluide et inoubliable.',
                            description5: 'Rejoignez Ashan Tours Sri Lanka et laissez-nous vous guider à travers une aventure pleine de découvertes et de joie.'
                        },
                        cinnamonLuxuryVilla: {
                            title: 'Villa de Luxe Cinnamon',
                            imageAlt: 'Image de la Villa de Luxe Cinnamon',
                            description1: 'Découvrez un confort inégalé à la Villa de Luxe Cinnamon d’Ashan Tours Sri Lanka, offrant des hébergements haut de gamme dans un cadre paisible.',
                            description2: 'Nos villas exclusives sont équipées de commodités modernes telles que la climatisation, des lits de luxe et des cuisines entièrement équipées, parfaites pour un séjour reposant.',
                            readMore: 'En savoir plus'
                        },
                        tourPackages: {
                            title: 'Nos forfaits touristiques',
                            ella: {
                                title: 'Aventure à Ella',
                                subtitle: '3 jours / 2 nuits',
                                description: 'Explorez la beauté pittoresque d’Ella avec Ashan Tours Sri Lanka, incluant des visites au Pont des Neuf Arches et au Petit Pic d’Adam.',
                                alt: 'Image du circuit à Ella'
                            },
                            ellaNuwaraKandy: {
                                title: 'Ella, Nuwara Eliya & Kandy',
                                subtitle: '5 jours / 4 nuits',
                                description: 'Un voyage culturel à travers Ella, Nuwara Eliya et Kandy, avec des plantations de thé et des temples historiques.',
                                alt: 'Image du circuit Ella, Nuwara Eliya & Kandy'
                            },
                            kandyNuwaraEllaYala: {
                                title: 'Kandy, Nuwara Eliya, Ella & Yala',
                                subtitle: '7 jours / 6 nuits',
                                description: 'Un circuit complet couvrant l’héritage de Kandy, les plantations de thé de Nuwara Eliya, les paysages d’Ella et la faune de Yala.',
                                alt: 'Image du circuit Kandy, Nuwara Eliya, Ella & Yala'
                            },
                            viewMore: 'Voir plus de circuits'
                        },
                        popularExcursions: {
                            title: 'Excursions populaires',
                            oneDay: {
                                title: 'Excursion d’une journée',
                                alt: 'Image d’excursion d’une journée'
                            },
                            twoDays: {
                                title: 'Excursion de deux jours',
                                alt: 'Image d’excursion de deux jours'
                            },
                            threeDays: {
                                title: 'Excursion de trois jours',
                                alt: 'Image d’excursion de trois jours'
                            },
                            fourDays: {
                                title: 'Excursion de quatre jours',
                                alt: 'Image d’excursion de quatre jours'
                            },
                            viewMore: 'Voir plus d’excursions'
                        },
                        contactUs: {
                            title: 'Contactez Ashan Tours Sri Lanka',
                            description: 'Prêt à explorer le Sri Lanka ? Contactez Ashan Tours Sri Lanka pour planifier vos vacances de rêve dès aujourd’hui !',
                            button: 'Prendre contact'
                        },
                        gallery: {
                            title: 'Notre galerie',
                            modalAlt: 'Image de la galerie',
                            filters: {
                                all: 'Tous',
                                tours: 'Circuits',
                                accommodation: 'Hébergement',
                                transportation: 'Transport',
                                wildlife: 'Faune'
                            },
                            tours: {
                                sigiriya2: 'Image de Sigiriya 2',
                                sigiriya3: 'Image de Sigiriya 3',
                                kandy2: 'Image de Kandy 2',
                                kandy3: 'Image de Kandy 3',
                                galle2: 'Image de Galle 2',
                                galle3: 'Image de Galle 3',
                                ella2: 'Image d’Ella 2',
                                ella3: 'Image d’Ella 3',
                                colomboCity: 'Image de la ville de Colombo'
                            },
                            accommodation: {
                                nuwaraEliya1: 'Image d’hébergement à Nuwara Eliya 1',
                                nuwaraEliya2: 'Image d’hébergement à Nuwara Eliya 2',
                                nuwaraEliya3: 'Image d’hébergement à Nuwara Eliya 3',
                                nuwaraEliya4: 'Image d’hébergement à Nuwara Eliya 4'
                            },
                            transportation: {
                                bentotaRiverSafari1: 'Image de safari sur la rivière Bentota 1',
                                bentotaRiverSafari2: 'Image de safari sur la rivière Bentota 2'
                            },
                            wildlife: {
                                yalaSafari1: 'Image de safari à Yala 1',
                                yalaSafari2: 'Image de safari à Yala 2',
                                minneriya1: 'Image de Minneriya 1',
                                minneriya2: 'Image de Minneriya 2',
                                udawalawaSafari1: 'Image de safari à Udawalawa 1',
                                udawalawaSafari2: 'Image de safari à Udawalawa 2'
                            },
                        },
                    },
                    tourPackages: {
                        title: "Forfaits touristiques",
                        readMore: "En savoir plus",
                        book: "Réserver",
                        destinationsTitle: "Destinations",
                        destinationImageAlt: "Image de destination {{index}}",
                        clickToEnlarge: "Cliquer pour agrandir",
                        enlargedDestinationAlt: "Image de destination agrandie",
                        bookNow: "Réserver maintenant",
                        importantNotices: "Informations importantes",
                        notices: {
                            transport: "Nous utilisons des systèmes de transport hautement confortables pour toutes nos visites.",
                            children: "Les enfants de 5 ans ou moins voyagent gratuitement.",
                            hygiene: "Toutes nos visites sont réalisées avec un accent sur l'hygiène et la sécurité.",
                            tickets: "Les forfaits touristiques incluent les billets d'entrée, sauf indication contraire.",
                            meals: "Les visites d'une journée n'incluent pas les repas, sauf mention explicite.",
                        },
                        luxuryTransport: "Rejoignez notre système de transport de luxe",
                        luxuryTransportAlt1: "Véhicule de luxe 1",
                        luxuryTransportAlt2: "Véhicule de luxe 2",
                        getInTouch: "Contactez-nous pour découvrir nos forfaits",
                        getInTouchDescription: "Contactez-nous aujourd'hui pour explorer les meilleures offres de voyage adaptées à vos besoins.",
                        contactUs: "Contactez-nous",
                        bookingMessage: "Demande de réservation Ashan Tours\nForfait : {{title}}\nDurée : {{duration}}\nLieu : {{location}}",
                        manualBookingMessage: "Veuillez envoyer manuellement le message suivant à {{number}} :\n\n{{message}}",
                        errorBookingMessage: "Une erreur s'est produite. Veuillez envoyer manuellement le message suivant à {{number}} :\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "Ella",
                                duration: "1 jour",
                                location: "Ella - Sri Lanka",
                                description:
                                    "Explorez la beauté naturelle époustouflante d'Ella, avec ses plantations de thé luxuriantes, ses vues à couper le souffle et le célèbre pont des neuf arches.",
                            },
                            galleFort: {
                                title: "Fort de Galle",
                                duration: "1 jour",
                                location: "Galle - Sri Lanka",
                                description:
                                    "Remontez le temps avec une visite du fort historique de Galle, un site du patrimoine mondial de l'UNESCO, rempli de charme colonial et de beauté côtière.",
                            },
                            yalaSafari: {
                                title: "Safari à Yala",
                                duration: "1 jour",
                                location: "Yala - Sri Lanka",
                                description:
                                    "Embarquez pour un safari aventureux dans le parc national de Yala, abritant des léopards, des éléphants et une variété d'animaux exotiques.",
                            },
                            kandy: {
                                title: "Kandy",
                                duration: "1 jour",
                                location: "Kandy - Sri Lanka",
                                description:
                                    "Découvrez le cœur culturel du Sri Lanka avec une visite à Kandy, y compris le sacré Temple de la Dent.",
                            },
                            sigiriya: {
                                title: "Sigiriya",
                                duration: "1 jour",
                                location: "Sigiriya - Sri Lanka",
                                description:
                                    "Grimpez la forteresse rocheuse antique de Sigiriya et émerveillez-vous devant ses fresques époustouflantes et ses vues panoramiques à couper le souffle.",
                            },
                            udawalawe: {
                                title: "Udawalawe",
                                duration: "1 jour",
                                location: "Udawalawe - Sri Lanka",
                                description:
                                    "Profitez d'un safari palpitant dans le parc national d'Udawalawe, réputé pour sa grande population d'éléphants et ses paysages pittoresques.",
                            },
                            colomboCityEscape: {
                                title: "Évasion en ville à Colombo",
                                duration: "1 jour",
                                location: "Colombo - Sri Lanka",
                                description:
                                    "Explorez la ville animée de Colombo, avec ses marchés animés, ses monuments culturels et ses attractions modernes.",
                            },
                            mirissaWhaleWatching: {
                                title: "Observation des baleines à Mirissa",
                                duration: "1 jour",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Partez pour une aventure inoubliable d'observation des baleines au large de Mirissa, où vous attendent de majestueuses baleines bleues.",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "Observation des baleines à Mirissa avec bateau confortable",
                                duration: "1 jour",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Partez pour une aventure inoubliable d'observation des baleines au large de Mirissa, où vous attendent de majestueuses baleines bleues.",
                            },
                            bentotaRiverSafari: {
                                title: "Safari sur la rivière Bentota",
                                duration: "1 jour",
                                location: "Bentota - Sri Lanka",
                                description:
                                    "Naviguez le long de la tranquille rivière Bentota, entourée de mangroves luxuriantes et d'animaux exotiques, pour une escapade paisible.",
                            },
                            ellaYala: {
                                title: "Ella & Yala",
                                duration: "1 jour",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Vivez la combinaison parfaite de la beauté pittoresque d'Ella et du safari palpitant de Yala en une seule journée.",
                            },
                            ellaGalle: {
                                title: "Ella & Galle",
                                duration: "1 jour",
                                location: "Ella & Galle - Sri Lanka",
                                description:
                                    "Découvrez les paysages époustouflants d'Ella et le charme colonial de Galle en une journée pleine de merveilles.",
                            },
                            yalaGalle: {
                                title: "Yala & Galle",
                                duration: "1 jour",
                                location: "Yala & Galle - Sri Lanka",
                                description:
                                    "Combinez l'excitation d'un safari à Yala avec une visite du pittoresque fort de Galle pour une expérience véritablement diversifiée.",
                            },
                            ellaYalaTwoDays: {
                                title: "Ella & Yala",
                                duration: "2 jours",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Passez deux jours à explorer les hauts plateaux pittoresques d'Ella et les paysages riches en faune du parc national de Yala.",
                            },
                            kandyTwoDays: {
                                title: "Kandy",
                                duration: "2 jours",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Passez deux jours à explorer les hauts plateaux pittoresques d'Ella et les paysages riches en faune du parc national de Yala.",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "Ella/Nuwara Eliya/Kandy",
                                duration: "2 jours",
                                location: "Ella/Nuwara Eliya/Kandy - Sri Lanka",
                                description:
                                    "Visitez les plantations de thé de Nuwara Eliya, la verdure luxuriante d'Ella et les trésors culturels de Kandy dans ce tour de deux jours.",
                            },
                            kandySigiriya: {
                                title: "Kandy & Sigiriya",
                                duration: "2 jours",
                                location: "Kandy & Sigiriya - Sri Lanka",
                                description:
                                    "Profitez d'un voyage culturel à Kandy et grimpez la forteresse rocheuse emblématique de Sigiriya dans cette aventure de deux jours.",
                            },
                            ellaNuwaraEliya: {
                                title: "Ella & Nuwara Eliya",
                                duration: "2 jours",
                                location: "Ella & Nuwara Eliya - Sri Lanka",
                                description:
                                    "Plongez dans la beauté naturelle d'Ella et l'atmosphère fraîche et sereine de Nuwara Eliya pendant deux jours.",
                            },
                            sigiriKandyElla: {
                                title: "Sigiriya/Kandy/Ella",
                                duration: "3 jours",
                                location: "Sigiriya/Kandy/Ella - Sri Lanka",
                                description:
                                    "Explorez Sigiriya, les monuments culturels de Kandy et les paysages pittoresques d'Ella pendant trois jours inoubliables.",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "Kandy/Nuwara Eliya/Ella/Yala",
                                duration: "3 jours",
                                location: "Kandy/Nuwara Eliya/Ella/Yala - Sri Lanka",
                                description:
                                    "Découvrez les points forts variés du Sri Lanka, de la culture de Kandy à la faune de Yala, dans un tour immersif de trois jours.",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "Sigiriya/Anuradhapura/Polonnaruwa/Parc national de Minneriya",
                                duration: "3 jours",
                                location: "Sigiriya/Anuradhapura/Polonnaruwa/Parc national de Minneriya - Sri Lanka",
                                description:
                                    "Visitez les anciennes villes de Sigiriya, Anuradhapura et Polonnaruwa, et profitez d'un safari dans le parc national de Minneriya.",
                            },
                            twentyDayTour: {
                                title: "Forfait touristique jusqu'à 20 jours",
                                duration: "20 jours",
                                location: "Sri Lanka",
                                description:
                                    "Embarquez pour un voyage inoubliable de 20 jours à travers le Sri Lanka, en explorant ses merveilles culturelles, naturelles et historiques de Negombo à Bentota.",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "Chute d'eau de Ravana",
                            nineArchBridge: "Pont des neuf arches",
                            teaPlantation: "Plantation de thé",
                            trainRide: "Voyage en train",
                            littleAdamsPeak: "Petit pic d'Adam",
                            udawalaweElephant: "Observation de l'alimentation des éléphants à Udawalawe",
                            ayurvedicHerbalGarden: "Jardin d'herbes ayurvédiques",
                            templeKandeViharaya: "Temple Kande Viharaya",
                            turtleHatchery: "Écloserie de tortues",
                            boatSafari: "Safari en bateau",
                            moonstoneMine: "Mine de pierre de lune",
                            hikkaduwaBeach: "Plage de Hikkaduwa - Nager avec les tortues",
                            dutchFortGalle: "Fort hollandais de Galle",
                            yala: "Yala",
                            yalaSafariJeep: "Safari à Yala en jeep",
                            kandy: "Kandy",
                            royalBotanicalGarden: "Jardin botanique royal",
                            teaFactoryPlantation: "Usine et plantation de thé",
                            elephantFeeding: "Alimentation, baignade et promenade à dos d'éléphant",
                            ambuluwawaTowerOrTemple: "Tour Ambuluwawa ou Temple de la Dent",
                            jewelleryGemFactory: "Usine de bijoux et de gemmes",
                            silkFactory: "Usine de soie",
                            sigiriya: "Sigiriya",
                            sigiriyaLionRock: "Rocher du Lion de Sigiriya",
                            dambullaGoldenTemple: "Temple doré de Dambulla",
                            villageTour: "Visite de village avec nourriture traditionnelle sri-lankaise",
                            pidurangalaRock: "Rocher Pidurangala",
                            udawalawe: "Udawalawe",
                            udawalaweNationalPark: "Parc national d'Udawalawe",
                            jeepSafari: "Safari en jeep",
                            elephantMilkFeeding: "Alimentation au lait des éléphants",
                            lotusTower: "Tour du Lotus",
                            redMosque: "Mosquée rouge",
                            shopping: "Shopping",
                            blueWhales: "Baleines bleues",
                            mirissa: "Mirissa",
                            stiltFishing: "Pêche sur échasses",
                            bentotaRiver: "Rivière Bentota",
                            bentota: "Bentota",
                            safariYalaNationalPark: "Safari au parc national de Yala en jeep",
                            gadoladeniyaTemple: "Temple Gadoladeniya",
                            templeOfTheToothRelic: "Temple de la Dent",
                            traditionalKandyanDance: "Danse traditionnelle de Kandy",
                            luxuryHotelStay: "Séjour dans un hôtel de luxe avec petit-déjeuner et dîner",
                            teaFactory: "Usine de thé",
                            nuwaraEliyaTown: "Ville de Nuwara Eliya",
                            ambuluwawaTower: "Tour Ambuluwawa",
                            hinduTemple: "Temple hindou",
                            gregoryLake: "Lac Gregory",
                            postOffice: "Bureau de poste",
                            hortanPlains: "Plaines de Horton",
                            sitaAmmanHinduKovil: "Kovil hindou Sita Amman",
                            botanicalGarden: "Jardin botanique",
                            rambodaWaterfall: "Chute d'eau de Ramboda",
                            sigiriyaRockFortress: "Forteresse rocheuse de Sigiriya",
                            anuradhapura: "Anuradhapura",
                            polonnaruwa: "Polonnaruwa",
                            minneriyaNationalPark: "Parc national de Minneriya",
                            elephants: "Éléphants",
                            day1: "Jour 1 : Aéroport – Negombo : Transfert à Negombo et enregistrement anticipé, Excursion en bateau dans le marais de Muthurajawela, Détente – Natation – Repos – Hamac – Bien-être – Bronzage – Sports – Sports nautiques, Nuit et petit-déjeuner à Negombo",
                            day2: "Jour 2 : Negombo – Anuradhapura : Ville sacrée d'Anuradhapura (site du patrimoine mondial de l'UNESCO), Arbre Sri Maha Bodhi, Promenade autour des réservoirs pittoresques, Nuit et petit-déjeuner à Anuradhapura",
                            day3: "Jour 3 : Anuradhapura – Minneriya – Habarana : Statue de Bouddha Aukana, Safari villageois incluant promenade en catamaran et tuk-tuk avec déjeuner, Safari en jeep dans le parc national de Minneriya, Nuit et petit-déjeuner à Habarana",
                            day4: "Jour 4 : Habarana – Sigiriya – Ritigala – Trincomalee : Forteresse rocheuse de Sigiriya (site du patrimoine mondial de l'UNESCO), Monastère forestier de Ritigala, Nuit et petit-déjeuner à Trincomalee",
                            day5: "Jour 5 : Trincomalee : Détente – Natation – Repos – Hamac – Bien-être – Bronzage – Sports – Sports nautiques, Nuit et petit-déjeuner à Trincomalee",
                            day6: "Jour 6 : Trincomalee : Visite de la ville de Trincomalee, Anniversaire de Steffi Bäuml, Détente – Natation – Repos – Hamac – Bien-être – Bronzage – Sports – Sports nautiques, Cours de cuisine surprise pour deux femmes, Nuit et petit-déjeuner à Trincomalee",
                            day7: "Jour 7 : Trincomalee : Excursion de plongée avec tuba à l'île Pigeon, Détente – Natation – Repos – Hamac – Bien-être – Bronzage – Sports – Sports nautiques, Nuit et petit-déjeuner à Trincomalee",
                            day8: "Jour 8 : Trincomalee : Détente – Natation – Repos – Hamac – Bien-être – Bronzage – Sports – Sports nautiques, Nuit et petit-déjeuner à Trincomalee",
                            day9: "Jour 9 : Trincomalee – Dambulla – Matale – Peradeniya – Kandy : Temple des grottes de Dambulla (site du patrimoine mondial de l'UNESCO), Jardin d'épices à Matale, Jardins botaniques royaux de Peradeniya avec pique-nique, Promenade dans la vieille ville de Kandy, Nuit et petit-déjeuner à Kandy",
                            day10: "Jour 10 : Kandy : Temple de la Dent à Kandy (site du patrimoine mondial de l'UNESCO), Spectacle de danse kandyenne en soirée, Nuit et petit-déjeuner à Kandy",
                            day11: "Jour 11 : Kandy – Nuwara Eliya – Ella : Plantations de thé et cueillette de thé, Visite d'une usine de thé, Chutes de Ramboda, Nuwara Eliya – la ville au-dessus des nuages, Promenade à Ella, Nuit et petit-déjeuner à Ella",
                            day12: "Jour 12 : Ella – Badulla : Voyage en train d'Ella à Badulla (2e classe), Randonnées dans les environs d'Ella, En option : Tyrolienne, Nuit et petit-déjeuner à Ella",
                            day13: "Jour 13 : Ella – Yala : Chutes de Ravana, Vallée d'Ella Gap, Safari en jeep dans le parc national de Yala, Nuit et petit-déjeuner à Tissamaharama",
                            day14: "Jour 14 : Yala – Udawalawe – Sinharaja : Visite du centre de transit des éléphants pendant l'heure du nourrissage, Route vers la réserve forestière de Sinharaja (site du patrimoine mondial de l'UNESCO), Nuit et petit-déjeuner à Sinharaja",
                            day15: "Jour 15 : Sinharaja : Randonnée guidée dans la réserve forestière de Sinharaja (site du patrimoine naturel mondial de l'UNESCO), Nuit et petit-déjeuner à Sinharaja",
                            day16: "Jour 16 : Sinharaja – Galle : Vieille ville de Galle, Fort de Galle (site du patrimoine mondial de l'UNESCO), Nuit et petit-déjeuner à Galle",
                            day17: "Jour 17 : Galle – Mirissa – Bentota : Safari en mer au large de Mirissa, Projet de conservation des tortues, Nuit et petit-déjeuner à Bentota",
                            day18_19: "Jour 18–19 : Bentota : Détente – Natation – Repos – Hamac – Bien-être – Bronzage – Sports – Sports nautiques, Nuit et petit-déjeuner à Bentota",
                            day20: "Jour 20 : Bentota – Aéroport : Transfert à l'aéroport",
                        },
                    },
                    ayurvedaPage: {
                        title: "Ayurveda - La science ancienne de la vie",
                        mainDescription: "Le mot 'Ayurveda' existe depuis plus de trois mille ans. En sanskrit, il signifie 'science de la vie'. La technique repose sur la vision ayurvédique de la guérison de la maladie plutôt que de ses conséquences, ce qui est souvent en opposition avec la médecine européenne. Elle postule les principes suivants :",
                        principles: {
                            energyBalance: "Le corps doit être libre d'énergie et maintenir un équilibre pour une activité métabolique et cardiaque normale.",
                            muscleHormonal: "Le corps doit avoir une contraction musculaire normale avec une activité hormonale régulière.",
                            immuneSystem: "Le corps a besoin d'un système immunitaire sain pour fonctionner correctement."
                        },
                        trainingDescription: "Selon les données récentes, à Sri Lanka, il y a plus de 6 000 diplômés formés en Ayurveda. Ils suivent sept ans d'études et deux ans de pratique dans des hôpitaux publics. Les programmes d'Ayurveda incluent :",
                        programs: {
                            stressRelief: "Élimination du stress, de la fatigue et de l'anxiété",
                            oxygenSaturation: "Saturation en oxygène",
                            muscularToxins: "Stimulation des systèmes musculaires et élimination des toxines",
                            nervousSystem: "Restauration de l'équilibre du système nerveux",
                            bloodFlow: "Restauration de la circulation sanguine vers les organes internes",
                            endorphins: "Production d'endorphines"
                        },
                        images: {
                            mainAlt: "Ayurveda",
                            faceTreatmentAlt: "Traitement facial ayurvédique",
                            massageTreatmentAlt: "Massage ayurvédique"
                        },
                        treatmentDescription: "Les traitements standard incluent des massages corporels et du cuir chevelu avec des huiles spéciales, des saunas aux herbes et des bains infusés aux herbes. La technique la plus populaire est la procédure 'Shirodhara', où de l'huile chaude aux herbes est versée rythmiquement sur le front. Cela aide à restaurer l'équilibre du système nerveux et à atteindre la relaxation.",
                        tipsTitle: "Conseils pour les traitements ayurvédiques",
                        tips: {
                            relaxMind: "Oubliez les problèmes. Détendez-vous et libérez votre esprit pour obtenir les meilleurs résultats.",
                            chooseLocation: "Choisissez le bon emplacement. Sélectionnez un cadre qui correspond à votre confort et à vos préférences pour une guérison optimale.",
                            selectProgram: "Choisissez le bon programme. Discutez de vos préoccupations avec le médecin et essayez différentes thérapies pour trouver celle qui vous convient le mieux.",
                            warmBath: "Prenez un bain chaud avant le traitement pour détendre vos muscles et préparer votre corps.",
                            lightMeal: "Mangez un repas léger avant la procédure. Évitez les repas lourds pour permettre une bonne circulation sanguine pendant le massage.",
                            postRelaxation: "La relaxation après les procédures est essentielle. Une relaxation appropriée améliore l'efficacité des traitements ayurvédiques."
                        },
                    },
                    ballooningPage: {
                        title: "Vol en montgolfière à Sri Lanka",
                        mainDescription: "Le vol en montgolfière à Sri Lanka offre une expérience inoubliable de flottaison douce au-dessus des paysages époustouflants de l’île. Débutant au lever du soleil, les vols en montgolfière offrent des vues aériennes à couper le souffle sur des collines ondulantes, des forêts luxuriantes, des ruines anciennes et des villages paisibles.",
                        dambullaDescription: "La destination la plus populaire pour le vol en montgolfière à Sri Lanka est Dambulla, située au cœur du triangle culturel. Les vols ici passent souvent au-dessus de la forteresse rocheuse emblématique de Sigiriya, offrant une perspective unique. Les vols durent généralement de 60 à 90 minutes, vous laissant amplement le temps de vous imprégner de la beauté de Sri Lanka depuis le ciel.",
                        highlightsTitle: "Pourquoi essayer le vol en montgolfière à Sri Lanka ?",
                        highlightsDescription: "Le vol en montgolfière combine aventure et tranquillité, vous permettant de découvrir la beauté de Sri Lanka d’une manière unique. Parmi les points forts du vol en montgolfière, on trouve :",
                        highlights: {
                            panoramicViews: "Vues panoramiques ininterrompues des paysages époustouflants de l’île.",
                            landmarks: "Survol des monuments emblématiques comme la forteresse de Sigiriya et les lacs à proximité.",
                            peacefulRide: "Un vol serein et paisible au-dessus de la verdure luxuriante et des villages charmants.",
                            sunrise: "Assister à un lever de soleil spectaculaire depuis le ciel.",
                            photography: "Parfait pour les amateurs de photographie souhaitant capturer la beauté pittoresque depuis le ciel."
                        },
                        images: {
                            mainAlt: "Vol en montgolfière à Sri Lanka",
                            sunriseAlt: "Lever de soleil en montgolfière",
                            sunriseCaption: "Profitez de vues à couper le souffle sur le lever du soleil tout en flottant doucement dans une montgolfière.",
                            landscapeAlt: "Paysage en montgolfière",
                            landscapeCaption: "Découvrez les paysages époustouflants de Sri Lanka depuis le ciel, y compris les collines ondulantes et les forêts luxuriantes."
                        },
                        tipsTitle: "Conseils pour un vol en montgolfière mémorable",
                        tips: {
                            bookEarly: "Réservez votre vol tôt, car le vol en montgolfière dépend de la météo et les places se remplissent rapidement.",
                            clothing: "Portez des vêtements confortables et emportez une veste légère, car les matins tôt peuvent être frais.",
                            camera: "Apportez un appareil photo ou un smartphone pour capturer les vues magnifiques.",
                            safety: "Écoutez attentivement les consignes de sécurité fournies par votre pilote.",
                            arriveEarly: "Arrivez à l’heure pour observer la préparation et le gonflage de la montgolfière, un processus fascinant."
                        },
                    },
                    divingPage: {
                        title: "Plongée à Sri Lanka",
                        mainDescription: "Un large récif corallien entoure la côte de Sri Lanka à des profondeurs de 2 à 40 mètres. Les eaux chaudes de l’océan Indien, entre 27°C et 30°C, et la grande transparence de l’eau, de 15 à 35 mètres, offrent d’excellentes conditions pour la plongée et le snorkeling. En plongeant à Sri Lanka, vous pouvez explorer des récifs coralliens intacts, des épaves anciennes et des grottes sous-marines fascinantes.",
                        northeastDescription: "Le nord-est de l’île offre une variété de plus de 130 espèces de coraux colorés, qui abritent une vie marine telle que des tortues de mer, des poissons-clowns, des poissons-lions et des hippocampes. Visitez les épaves près des rochers et récifs sous-marins pour une expérience inoubliable. En flottant dans les eaux claires, vous serez immergé dans le passé fascinant de Ceylan.",
                        facilitiesTitle: "Installations et meilleurs spots de plongée",
                        facilitiesDescription: "Les centres de plongée de l’île sont équipés du matériel de plongée dernier cri de fabricants renommés. Des instructeurs certifiés PADI et CMAS garantissent des plongées sûres et agréables. Les centres de plongée sont situés le long de la côte sud-ouest de l’île, en activité de mi-octobre à fin avril. La côte nord-est, y compris Nilaveli et Trincomalee, est idéale pour la plongée de mars à octobre.",
                        popularSpots: "Les récifs coralliens près de Kalpitiya à l’ouest et les sites de plongée sur épaves à Hikkaduwa sont parmi les attractions les plus populaires pour les plongeurs.",
                        images: {
                            mainAlt: "Plongée à Sri Lanka",
                            coralReefAlt: "Plongée sur récif corallien",
                            coralReefCaption: "Explorez des récifs coralliens vibrants, abritant une vie marine diversifiée.",
                            shipwreckAlt: "Plongée sur épaves",
                            shipwreckCaption: "Découvrez des épaves historiques qui offrent un aperçu du passé maritime de Sri Lanka."
                        },
                        tipsTitle: "Conseils pour les plongeurs",
                        tips: {
                            season: "Choisissez la meilleure saison pour plonger en fonction du lieu : côte sud-ouest (octobre à avril) ou côte nord-est (mars à octobre).",
                            certifiedCenter: "Assurez-vous que votre centre de plongée est certifié et équipé de matériel moderne pour une expérience sûre.",
                            instructorAdvice: "Écoutez les conseils de votre instructeur, surtout si vous êtes débutant.",
                            respectMarineLife: "Respectez la vie marine en ne touchant pas les coraux et en ne perturbant pas l’environnement sous-marin.",
                            camera: "Apportez un appareil photo étanche pour capturer la beauté envoûtante du monde sous-marin de Sri Lanka."
                        },
                    },
                    elephantRidePage: {
                        title: "Balade à dos d'éléphant",
                        mainDescription: "La randonnée à dos d’éléphant est une activité fascinante, excitante et une expérience unique à Sri Lanka. Si vous séjournez près du triangle culturel dans des zones comme Habarana, Sigiriya ou Dambulla, vous pouvez participer à un safari à dos d’éléphant. Ces balades commencent à environ 30 $ pour une heure d’aventure inoubliable.",
                        rideDescription: "Avant la balade, les éléphants sont équipés d’un panier multiplaces conçu pour 4 à 6 personnes. Ces gentils géants vous emmènent à travers des sentiers pittoresques dans la jungle, traversent des zones inondées et naviguent à travers une végétation luxuriante. Les éléphants marchent généralement lentement, vous permettant d’apprécier pleinement la beauté de la nature environnante, bien qu’ils puissent atteindre des vitesses allant jusqu’à 40 km/h.",
                        highlightsTitle: "Points forts d’une balade à dos d’éléphant",
                        highlightsDescription: "Monter un éléphant à Sri Lanka offre une manière unique de se connecter avec la nature et d’explorer la campagne. Parmi les points forts de l’expérience, on trouve :",
                        highlights: {
                            junglePaths: "Marcher à travers des jungles denses remplies de végétation exotique et de faune.",
                            riverCrossing: "Traverser des rivières et des zones inondées, offrant des vues époustouflantes sur le paysage naturel.",
                            culturalConnection: "En apprendre davantage sur la relation étroite entre les éléphants et la culture sri-lankaise.",
                            comfortableRide: "Se détendre sur une selle confortable pendant que l’éléphant vous transporte doucement à travers divers terrains."
                        },
                        images: {
                            mainAlt: "Balade à dos d’éléphant",
                            jungleAlt: "Balade à dos d’éléphant dans la jungle",
                            jungleCaption: "Explorez des jungles denses et des sentiers pittoresques en montant un éléphant.",
                            waterAlt: "Éléphant traversant l’eau",
                            waterCaption: "Traversez des rivières et profitez de la beauté tranquille de l’eau et de la végétation."
                        },
                        tipsTitle: "Conseils pour une balade à dos d’éléphant sûre et agréable",
                        tips: {
                            clothing: "Portez des vêtements et des chaussures confortables adaptés aux activités de plein air.",
                            guideInstructions: "Suivez les instructions de votre guide pour une balade sûre et agréable.",
                            ethicalPractices: "Assurez-vous que les éléphants sont bien traités et que le prestataire respecte des pratiques éthiques.",
                            camera: "Apportez un appareil photo pour capturer les paysages et moments à couper le souffle.",
                            respectElephants: "Respectez les éléphants et évitez les actions qui pourraient les stresser ou leur nuire."
                        },
                    },
                    fishingPage: {
                        title: "Pêche à Sri Lanka",
                        mainDescription: "Sri Lanka, avec son vaste littoral et ses nombreux lacs et rivières d’eau douce, offre une expérience de pêche inégalée. Que vous soyez un pêcheur professionnel ou amateur, Sri Lanka a quelque chose à offrir. Des expéditions de pêche en haute mer à la pêche traditionnelle sur pilotis pratiquée par les pêcheurs locaux, vous vivrez une aventure inoubliable.",
                        destinationsDescription: "Les destinations de pêche populaires incluent la côte sud autour de Galle et Mirissa, la lagune de Negombo et les eaux calmes de Trincomalee. Selon vos préférences, vous pouvez essayer différentes techniques de pêche telles que la traîne, la pêche de fond ou la pêche à la mouche.",
                        experiencesTitle1: "Expériences de pêche à Sri Lanka",
                        experiencesDescription: "Pêcher à Sri Lanka ne se limite pas à attraper du poisson ; c’est une occasion de s’immerger dans la culture et les traditions de l’île. Certaines expériences de pêche uniques incluent :",
                        experiences: {
                            stiltFishingTitle: "Pêche sur pilotis",
                            stiltFishing: "Une méthode traditionnelle où les pêcheurs se perchent sur des pilotis pour attraper du poisson près du rivage, une pratique unique à Sri Lanka.",
                            deepSeaFishingTitle: "Pêche en haute mer",
                            deepSeaFishing: "Aventurez-vous dans l’océan Indien pour attraper des marlins, des thons, des barracudas et d’autres grandes espèces de poissons.",
                            lagoonFishingTitle: "Pêche en lagune et rivière",
                            lagoonFishing: "Détendez-vous en pêchant dans des lagunes et rivières tranquilles regorgeant de poissons comme le tilapia et le poisson-chat.",
                            nightFishingTitle: "Pêche de nuit",
                            nightFishing: "Vivez l’excitation de pêcher sous les étoiles, une pratique courante dans les villages côtiers."
                        },
                        images: {
                            mainAlt: "Pêche à Sri Lanka",
                            stiltFishingAlt: "Pêche sur pilotis à Sri Lanka",
                            stiltFishingCaption: "La pêche sur pilotis est une méthode traditionnelle et une image emblématique de l’héritage de pêche de Sri Lanka.",
                            deepSeaFishingAlt: "Pêche en haute mer à Sri Lanka",
                            deepSeaFishingCaption: "La pêche en haute mer offre une expérience aventureuse, ciblant de grandes espèces de poissons dans l’océan Indien."
                        },
                        tipsTitle: "Conseils pour un voyage de pêche agréable",
                        tips: {
                            season: "Choisissez la bonne saison pour votre expédition de pêche ; octobre à avril est idéal pour la côte sud, tandis que mars à octobre convient à la côte est.",
                            protection: "Apportez de la crème solaire, un chapeau et des vêtements de protection pour rester confortable pendant votre voyage.",
                            guide: "Réservez un guide de pêche ou une charte pour tirer le meilleur parti de votre expérience et apprendre des experts.",
                            environment: "Respectez l’environnement local en évitant de jeter des déchets et en adhérant à des pratiques de pêche durables.",
                            hydration: "Restez hydraté et apportez des collations pour les longs voyages de pêche."
                        },
                    },
                    jeepSafariPage: {
                        title: "Safari en jeep à Sri Lanka",
                        mainDescription: "Les parcs nationaux de Sri Lanka offrent une expérience de safari en jeep palpitante, vous permettant d’explorer la riche biodiversité de l’île et d’observer la faune dans ses habitats naturels. Le parc national de Yala, le parc national de Wilpattu et le parc national d’Udawalawe sont parmi les destinations les plus populaires pour les safaris en jeep.",
                        wildlifeDescription: "Ces safaris offrent l’occasion de voir des éléphants, des léopards, des ours paresseux, des buffles d’eau, des crocodiles et une grande variété d’espèces d’oiseaux. Guidés par des naturalistes et des pisteurs expérimentés, les safaris en jeep sont parfaits pour les amateurs de faune et les photographes.",
                        whyChooseTitle: "Pourquoi choisir un safari en jeep ?",
                        whyChooseDescription: "Les safaris en jeep sont l’un des meilleurs moyens d’explorer la faune diversifiée de Sri Lanka. Voici quelques points forts :",
                        whyChoose: {
                            encounters: "Rencontres rapprochées avec des espèces emblématiques comme les éléphants et les léopards.",
                            remoteAreas: "Accès à des zones reculées et pittoresques des parcs nationaux.",
                            photography: "Opportunités de photographie animalière dans un cadre naturel.",
                            guidance: "Accompagnement par des naturalistes et des rangers de parc compétents.",
                            adventure: "Une aventure adaptée à tous les âges, combinant excitation et éducation."
                        },
                        images: {
                            mainAlt: "Safari en jeep à Sri Lanka",
                            wildlifeAlt: "Faune lors d’un safari en jeep",
                            wildlifeCaption: "Observez une faune emblématique comme les léopards, les éléphants et les crocodiles pendant votre safari.",
                            landscapeAlt: "Paysage de safari en jeep",
                            landscapeCaption: "Explorez les paysages époustouflants des parcs nationaux de Sri Lanka, des forêts denses aux plaines ouvertes."
                        },
                        tipsTitle: "Conseils pour un safari en jeep agréable",
                        tips: {
                            clothing: "Portez des vêtements confortables de couleur neutre pour vous fondre dans l’environnement.",
                            protection: "Apportez de la crème solaire, un chapeau et un répulsif contre les insectes pour vous protéger.",
                            equipment: "Apportez des jumelles et un appareil photo pour améliorer votre expérience et capturer la faune.",
                            guide: "Suivez les instructions du guide pour garantir la sécurité et le respect des animaux.",
                            booking: "Réservez votre safari tôt, surtout pendant les saisons de pointe, pour sécuriser une place."
                        },
                    },
                    riverSafariPage: {
                        title: "Safari fluvial à Sri Lanka",
                        mainDescription: "Un safari fluvial à Sri Lanka offre une manière unique d’explorer la riche biodiversité et la beauté pittoresque de l’île. Glissez le long de voies navigables tranquilles entourées de mangroves luxuriantes, repérez une faune exotique et profitez de couchers de soleil pittoresques qui vous laisseront émerveillé.",
                        destinationsDescription: "Les destinations populaires de safari fluvial incluent le Madu Ganga (rivière Madu) et la rivière Bentota. Ces safaris offrent l’occasion d’observer diverses espèces d’oiseaux, des varans, des crocodiles et même des singes dans leurs habitats naturels. L’environnement serein est parfait pour les amoureux de la nature et les photographes.",
                        whyChooseTitle: "Pourquoi choisir un safari fluvial ?",
                        whyChooseDescription: "Un safari fluvial est une expérience relaxante et immersive qui combine la nature, la faune et l’exploration culturelle. Voici quelques points forts :",
                        whyChoose: {
                            mangroves: "Explorez des mangroves luxuriantes regorgeant de vie.",
                            wildlife: "Repérez des oiseaux exotiques, des crocodiles et autres animaux sauvages.",
                            villages: "Visitez de petites îles et des villages locaux le long de la rivière.",
                            tranquility: "Profitez de la tranquillité et de la beauté pittoresque des voies navigables de Sri Lanka.",
                            suitable: "Parfait pour les familles, les couples et les voyageurs en solo à la recherche d’une escapade paisible."
                        },
                        images: {
                            mainAlt: "Safari fluvial à Sri Lanka",
                            mangrovesAlt: "Mangroves lors d’un safari fluvial",
                            mangrovesCaption: "Découvrez les mangroves luxuriantes qui bordent les voies navigables pittoresques de Sri Lanka.",
                            wildlifeAlt: "Faune lors d’un safari fluvial",
                            wildlifeCaption: "Repérez une faune exotique comme des crocodiles, des varans et des oiseaux colorés pendant votre safari."
                        },
                        tipsTitle: "Conseils pour un safari fluvial agréable",
                        tips: {
                            clothing: "Portez des vêtements confortables et apportez un chapeau et de la crème solaire pour vous protéger.",
                            binoculars: "Apportez des jumelles pour repérer la faune et les oiseaux à distance.",
                            camera: "Apportez un appareil photo ou un smartphone pour capturer les paysages époustouflants et la faune.",
                            guide: "Suivez les instructions de votre guide pour une expérience sûre et agréable.",
                            environment: "Respectez l’environnement naturel en évitant de jeter des déchets et en ne perturbant pas la faune."
                        },
                    },
                    snorkelingPage: {
                        title: "Plongée avec tuba à Sri Lanka",
                        mainDescription: "La plongée avec tuba à Sri Lanka offre une expérience sous-marine inoubliable, où vous pouvez explorer des récifs coralliens vibrants et une vie marine diversifiée. Avec ses eaux cristallines et ses écosystèmes aquatiques abondants, Sri Lanka est un paradis pour les plongeurs de tous niveaux.",
                        destinationsDescription: "Certains des spots de plongée avec tuba les plus populaires incluent Hikkaduwa, connu pour ses jardins de coraux colorés et ses tortues, l'île de Pigeon à Trincomalee, célèbre pour ses récifs préservés, et Mirissa, où vous pourriez même apercevoir une ou deux baleines pendant la saison de plongée.",
                        whyChooseTitle: "Pourquoi choisir la plongée avec tuba à Sri Lanka ?",
                        whyChooseDescription: "La plongée avec tuba à Sri Lanka est une expérience magique, combinant aventure et beauté naturelle. Voici quelques points forts :",
                        whyChoose: {
                            coralReefs: "Explorez des récifs coralliens vibrants regorgeant de vie.",
                            marineLife: "Nagez aux côtés de poissons tropicaux colorés, de tortues et même de requins de récif.",
                            landscapes: "Découvrez des paysages sous-marins immaculés dans des eaux claires et chaudes.",
                            suitable: "Convient aux débutants comme aux plongeurs expérimentés.",
                            accessible: "Accessible depuis certaines des meilleures destinations balnéaires de Sri Lanka."
                        },
                        images: {
                            mainAlt: "Plongée avec tuba à Sri Lanka",
                            coralReefAlt: "Récifs coralliens à Sri Lanka",
                            coralReefCaption: "Découvrez des récifs coralliens époustouflants et leurs écosystèmes vibrants.",
                            marineLifeAlt: "Vie marine à Sri Lanka",
                            marineLifeCaption: "Rencontrez une vie marine diversifiée, y compris des tortues, des poissons tropicaux et plus encore."
                        },
                        tipsTitle: "Conseils pour une expérience de plongée avec tuba mémorable",
                        tips: {
                            mask: "Portez un masque et un tuba confortables pour assurer une vision claire sous l'eau.",
                            sunscreen: "Appliquez un écran solaire sans danger pour les récifs pour protéger votre peau et la vie marine.",
                            swimGently: "Nagez doucement pour éviter de perturber les récifs coralliens et les créatures aquatiques.",
                            hydration: "Restez hydraté et prenez des pauses entre les sessions.",
                            guidedTour: "Rejoignez une visite guidée pour découvrir les meilleurs spots de plongée et des conseils de sécurité."
                        },
                    },
                    teaTastingPage: {
                        title: "Tour de dégustation de thé à Sri Lanka",
                        mainDescription: "Sri Lanka, souvent surnommé la 'Perle de l'océan Indien', est célèbre pour sa production de thé de classe mondiale. Embarquez pour un tour de dégustation de thé et explorez les luxuriantes plantations de thé dans des régions comme Nuwara Eliya, Ella et Kandy. Découvrez l'art de la culture du thé, le processus méticuleux de production du thé et savourez les riches saveurs du thé de Ceylan authentique.",
                        heritageDescription: "Que vous soyez un passionné de thé ou simplement curieux, un tour de dégustation de thé offre une occasion unique de plonger dans l'héritage théicole de Sri Lanka et de découvrir la beauté sereine de ses hauts plateaux.",
                        whyChooseTitle: "Pourquoi choisir un tour de dégustation de thé ?",
                        whyChooseDescription: "Un tour de dégustation de thé à Sri Lanka ne se limite pas à goûter du thé – c'est une expérience culturelle immersive. Voici quelques points forts :",
                        whyChoose: {
                            plantations: "Visitez des plantations de thé pittoresques nichées dans les hauts plateaux frais.",
                            history: "Découvrez l'histoire et l'importance du thé de Ceylan.",
                            production: "Participez à la cueillette du thé et observez le processus de production dans les usines de thé.",
                            varieties: "Savourez différentes variétés de thé, du noir au vert en passant par les mélanges aromatisés.",
                            scenery: "Profitez du paysage à couper le souffle des montagnes brumeuses et des cascades."
                        },
                        images: {
                            mainAlt: "Tour de dégustation de thé à Sri Lanka",
                            teaPlantationAlt: "Plantation de thé à Sri Lanka",
                            teaPlantationCaption: "Explorez les luxuriantes plantations de thé et découvrez la culture du thé.",
                            teaPreparationAlt: "Préparation du thé à Sri Lanka",
                            teaPreparationCaption: "Découvrez l'art de la préparation du thé et savourez un thé de Ceylan authentique."
                        },
                        tipsTitle: "Conseils pour un tour de dégustation de thé agréable",
                        tips: {
                            clothing: "Portez des vêtements et des chaussures confortables pour marcher dans les plantations.",
                            jacket: "Apportez une veste légère, car les régions des hauts plateaux peuvent être fraîches et brumeuses.",
                            varieties: "Goûtez différentes variétés de thé et rapportez vos préférées comme souvenirs.",
                            questions: "Posez des questions pendant le tour pour en savoir plus sur le processus de fabrication du thé.",
                            attractions: "Combinez votre tour de thé avec des visites d'attractions à proximité comme des cascades et des points de vue."
                        },
                    },
                    templeVisitPage: {
                        title: "Visite de temples à Sri Lanka",
                        mainDescription: "Sri Lanka, connu comme le Pays du Bouddha, abrite des temples anciens qui reflètent son riche héritage spirituel et culturel. Embarquez pour un voyage afin d'explorer des temples emblématiques tels que le Temple de la Dent à Kandy, le Temple de la Grotte de Dambulla et Ruwanwelisaya à Anuradhapura.",
                        spiritualDescription: "Ces sites sacrés, ornés de sculptures complexes, de fresques et de statues, offrent un aperçu des traditions spirituelles et de la brillance architecturale de l'île. Une visite de temple est non seulement une expérience culturelle, mais aussi une occasion de trouver paix et tranquillité.",
                        whyVisitTitle: "Pourquoi visiter les temples à Sri Lanka ?",
                        whyVisitDescription: "Visiter les temples à Sri Lanka offre une occasion unique de se connecter avec l'histoire, la culture et la spiritualité de l'île. Voici quelques points forts :",
                        whyVisit: {
                            architecture: "Admirez l'architecture complexe et les statues vieilles de plusieurs siècles.",
                            traditions: "Découvrez les traditions et rituels bouddhistes auprès de guides compétents.",
                            heritage: "Explorez des sites du patrimoine mondial de l'UNESCO comme le Temple d'Or de Dambulla.",
                            serenity: "Vivez la sérénité et l'ambiance spirituelle des espaces sacrés.",
                            festivals: "Assistez à des festivals vibrants comme Esala Perahera au Temple de la Dent."
                        },
                        images: {
                            mainAlt: "Visite de temples à Sri Lanka",
                            templeInteriorAlt: "Intérieur de temple",
                            templeInteriorCaption: "Admirez les intérieurs époustouflants ornés de sculptures complexes et de fresques.",
                            sacredTempleAlt: "Temple sacré à Sri Lanka",
                            sacredTempleCaption: "Visitez des temples sacrés comme Ruwanwelisaya et plongez dans les traditions spirituelles."
                        },
                        tipsTitle: "Conseils pour visiter les temples à Sri Lanka",
                        tips: {
                            dress: "Habillez-vous modestement, en couvrant vos épaules et vos genoux, en signe de respect.",
                            shoes: "Retirez vos chaussures avant d'entrer dans les lieux du temple.",
                            touching: "Abstenez-vous de toucher les statues ou les objets sacrés.",
                            donation: "Apportez une petite donation pour le temple si vous souhaitez contribuer.",
                            silence: "Respectez le silence et l'atmosphère spirituelle pendant votre visite."
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "Rafting en eaux vives à Sri Lanka",
                        mainDescription: "Le rafting en eaux vives à Sri Lanka est une expérience exaltante, surtout à Kitulgala, la capitale de l'aventure de l'île. La rivière Kelani, avec ses rapides rugissants et ses environs pittoresques, offre un cadre parfait pour les débutants comme pour les rafteurs expérimentés.",
                        destinationsDescription: "Les expéditions de rafting couvrent généralement une section de 5 kilomètres avec des rapides allant de la classe 2 à la classe 4. Les participants peuvent profiter du frisson de naviguer dans des courants difficiles tout en admirant la verdure luxuriante et les vues imprenables sur les rives de la rivière.",
                        whyChooseTitle: "Pourquoi choisir le rafting en eaux vives à Sri Lanka ?",
                        whyChooseDescription: "Le rafting en eaux vives à Sri Lanka offre une combinaison unique d'aventure et de beauté naturelle. Voici quelques points forts de l'expérience :",
                        whyChoose: {
                            rapids: "Naviguez à travers des rapides palpitants sous la direction d'instructeurs expérimentés.",
                            views: "Profitez de vues magnifiques sur la forêt tropicale environnante et le terrain montagneux.",
                            activities: "Combinez le rafting avec d'autres activités comme la randonnée, l'observation des oiseaux et le canyoning à Kitulgala.",
                            suitable: "Parfait pour les groupes, les familles ou les voyageurs en solo à la recherche d'une montée d'adrénaline."
                        },
                        images: {
                            mainAlt: "Rafting en eaux vives à Sri Lanka",
                            actionRaftingAlt: "Action de rafting en eaux vives",
                            actionRaftingCaption: "Ressentez la montée d'adrénaline en conquérant les rapides difficiles de la rivière Kelani.",
                            scenicRaftingAlt: "Vues pittoresques du rafting",
                            scenicRaftingCaption: "Profitez de la beauté sereine des environs luxuriants pendant votre aventure de rafting."
                        },
                        tipsTitle: "Conseils pour un voyage de rafting sûr et excitant",
                        tips: {
                            safetyGear: "Portez un gilet de sauvetage et un casque fournis par votre guide de rafting pour votre sécurité.",
                            instructions: "Écoutez attentivement les consignes de sécurité avant de commencer votre voyage.",
                            clothing: "Portez des vêtements confortables à séchage rapide et des chaussures sécurisées comme des chaussures d'eau.",
                            changeOfClothes: "Apportez des vêtements de rechange et une serviette pour après le voyage.",
                            operator: "Réservez votre voyage de rafting avec un opérateur réputé pour garantir une expérience sûre et agréable."
                        },
                    },
                    wildlifeSafariPage: {
                        title: "Safari animalier à Sri Lanka",
                        mainDescription: "Sri Lanka, connu pour sa riche biodiversité, offre des safaris animaliers incroyables dans des parcs nationaux comme Yala, Wilpattu, Minneriya et Udawalawe. Ces safaris offrent l'opportunité d'observer des éléphants, des léopards, des ours paresseux et une variété d'espèces d'oiseaux dans leurs habitats naturels.",
                        destinationsDescription: "Explorez des paysages variés allant des forêts denses aux prairies ouvertes, et capturez des moments inoubliables de la faune en action. Avec des guides experts et des jeeps de safari bien entretenues, un safari animalier à Sri Lanka est incontournable pour les amateurs de nature et les aventuriers.",
                        whyChooseTitle: "Pourquoi choisir un safari animalier ?",
                        whyChooseDescription: "Un safari animalier à Sri Lanka offre une opportunité unique de se connecter avec la nature et d'explorer la remarquable biodiversité de l'île. Les points forts incluent :",
                        whyChoose: {
                            species: "Observer des espèces emblématiques comme les éléphants, les léopards et les crocodiles.",
                            landscapes: "Explorer des forêts luxuriantes, des zones humides et des plaines ouvertes regorgeant de faune.",
                            photography: "Capturer des photographies animalières époustouflantes dans des cadres naturels.",
                            elusiveAnimals: "Vivre le frisson de repérer des animaux insaisissables comme le léopard sri-lankais.",
                            conservation: "En apprendre davantage sur les efforts de conservation auprès de guides et naturalistes expérimentés."
                        },
                        images: {
                            mainAlt: "Safari animalier à Sri Lanka",
                            elephantsAlt: "Éléphants à Sri Lanka",
                            elephantsCaption: "Observez des éléphants majestueux errant librement dans les parcs nationaux de Sri Lanka.",
                            leopardAlt: "Léopard sri-lankais",
                            leopardCaption: "Repérez le léopard sri-lankais insaisissable, un moment fort de tout safari animalier."
                        },
                        tipsTitle: "Conseils pour un safari animalier excitant",
                        tips: {
                            clothing: "Portez des vêtements de couleur neutre pour vous fondre dans l'environnement.",
                            protection: "Apportez un écran solaire, un chapeau et un répulsif contre les insectes pour votre protection.",
                            equipment: "Apportez des jumelles et un appareil photo pour repérer et capturer la faune.",
                            guide: "Suivez les instructions de votre guide pour une expérience sûre et agréable.",
                            booking: "Réservez tôt, surtout pendant les saisons de pointe, pour sécuriser une place dans les parcs populaires."
                        },
                    },
                },
            },
            nl: {
                translation: {
                    home: 'Home',
                    about: 'Over ons',
                    srilanka: 'Sri Lanka',
                    excursions: 'Excursies',
                    tour: 'Boek een tour',
                    things: 'Dingen om te doen',
                    contact: {
                        navLabel: 'Contacteer ons',
                        getInTouch: 'Neem contact op',
                        address: 'Adres',
                        mobile: 'Mobiel',
                        email: 'E-mail',
                        website: 'Website',
                        sendMessage: 'Stuur ons een bericht',
                        fullName: 'Volledige naam',
                        fullNamePlaceholder: 'Voer uw volledige naam in',
                        country: 'Land',
                        countryPlaceholder: 'Voer uw land in',
                        emailPlaceholder: 'Voer uw e-mail in',
                        subject: 'Onderwerp',
                        subjectPlaceholder: 'Voer het onderwerp in',
                        message: 'Bericht',
                        messagePlaceholder: 'Voer uw bericht in',
                        reset: 'Resetten',
                        submit: 'Verzenden',
                        ourLocation: 'Onze locatie',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Gastbericht van Ashan Tours Sri Lanka',
                        manualMessage: 'Stuur het volgende bericht handmatig naar',
                        errorMessage: 'Er is een fout opgetreden. Stuur het volgende bericht handmatig naar',
                    },
                    footerSection: {
                        ashanTours: 'Ashan Tours Sri Lanka',
                        getInTouch: 'Neem contact op',
                        address: '293/C/3, Maradana Road, Moragalla, Beruwala, Sri Lanka',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: 'Blijf verbonden',
                        emailPlaceholder: 'Voer uw e-mailadres in',
                        socialMedia: {
                            facebook: 'Facebook',
                            instagram: 'Instagram',
                            youtube: 'YouTube',
                            twitter: 'Twitter',
                        },
                        copyright: '© {{year}} Ashan Tours Sri Lanka. Alle rechten voorbehouden.',
                        designedBy: 'Website ontworpen en ontwikkeld door Redev Solutions',
                        designedByPhone: '+94 76 460 8225',
                    },
                    aboutSection: {
                        travelWithAshan: 'Reis met Ashan Tours Sri Lanka',
                        imageAlt: 'Ashan Tours Afbeelding {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lanka is uw vertrouwde reisgenoot, die onvergetelijke reizen door Sri Lanka creëert. Met onze passie voor verkenning en een team van ervaren professionals zijn we toegewijd aan het aanbieden van gepersonaliseerde reisroutes, deskundige begeleiding en uitzonderlijke service om uw vakantie echt speciaal te maken.',
                        introParagraph2: 'Onze tours zijn zorgvuldig ontworpen om de essentie van Sri Lanka vast te leggen — van de zonovergoten stranden en schilderachtige heuvellandschappen tot de oude culturele schatten en levendige wilde dieren. Bij Ashan Tours Sri Lanka zijn we toegewijd aan het bieden van authentieke ervaringen die u de schoonheid en ziel van het eiland laten ontdekken.',
                        introParagraph3: 'Of u nu op zoek bent naar avontuur, een vredige retraite of culturele onderdompeling, Ashan Tours Sri Lanka biedt op maat gemaakte pakketten die aansluiten bij uw wensen. Ga met ons mee en laat ons u leiden op een reis vol verwondering, ontdekking en blijvende herinneringen.',
                        cinnamonLuxuryVilla: 'Cinnamon Luxe Villa',
                        villaImageAlt: 'Cinnamon Luxe Villa Afbeelding {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lanka presenteert met trots onze Cinnamon Luxe Villa, die premium accommodaties biedt voor reizigers die comfort en elegantie zoeken. Onze twee exclusieve appartementen zijn ontworpen om een thuis-weg-van-huis ervaring te bieden in het hart van Sri Lanka.',
                        villaParagraph2: 'Elk appartement is uitgerust met moderne voorzieningen, waaronder airconditioning, aangrenzende badkamers, luxe tweepersoonsbedden en volledig uitgeruste keukens. Of u nu alleen reist, als stel of met familie, onze villa’s bieden de perfecte combinatie van luxe en gemak.',
                        villaParagraph3: 'Gelegen in een serene omgeving stelt de Cinnamon Luxe Villa u in staat om te ontspannen en tot rust te komen na een dag van het verkennen van de wonderen van Sri Lanka. Boek uw verblijf bij Ashan Tours Sri Lanka en ervaar ongeëvenaarde gastvrijheid.',
                    },
                    sriLankaSection: {
                        discoverSriLanka: 'Ontdek Sri Lanka',
                        mainImageAlt: 'Sri Lanka',
                        pearlOfIndianOcean: 'Parel van de Indische Oceaan',
                        introParagraph1: 'Sri Lanka, liefkozend bekend als de "{{pearl}}", is een prachtig eilandparadijs dat wordt geprezen om zijn adembenemende landschappen, diepgewortelde tradities en kleurrijke cultuur.',
                        introParagraph2: 'Met een beschaving van meer dan 2500 jaar oud is Sri Lanka de thuisbasis van majestueuze oude hoofdsteden, heilige religieuze monumenten en UNESCO-werelderfgoedlocaties. Het culturele tapijt is verrijkt met Indiase, Arabische, Portugese, Nederlandse en Britse invloeden, wat een fascinerende reis door de tijd biedt.',
                        introParagraph3: 'De landschappen van het eiland zijn buitengewoon — van gouden zandstranden en glooiende groene theeplantages tot mistige bergtoppen. De natuurreservaten bieden onderdak aan olifanten, luipaarden en kleurrijke vogels, waardoor het een droom is voor natuurliefhebbers.',
                        introParagraph4: 'Voor avonturiers biedt Sri Lanka surfen, trekking, snorkelen en duiken. De keuken, doordrenkt met aromatische kruiden, verse zeevruchten en tropisch fruit, is krachtig en smaakvol en vertelt het verhaal van het rijke culinaire erfgoed van het eiland.',
                        introParagraph5: 'Of je nu dwaalt tussen tijdloze ruïnes, ontspant op serene stranden of geniet van warme gastvrijheid, Sri Lanka biedt een onvergetelijke reiservaring.',
                        attractivePlaces: 'Aantrekkelijke plaatsen in Sri Lanka',
                        viewMore: 'Meer bekijken',
                        placeImageAlt: 'Afbeelding van {{name}} {{index}}',
                        fullImagePreviewAlt: 'Volledige grootte voorbeeld',
                        famousThingsTitle: 'Beroemde dingen in Sri Lanka',
                        places: {
                            sigiriyaRockFortress: {
                                name: 'Sigiriya Rotsfort',
                                description: 'Het Sigiriya Rotsfort is een UNESCO-werelderfgoed en een van de meest iconische bezienswaardigheden van Sri Lanka. Het biedt oude tuinen, fresco’s en adembenemende uitzichten vanaf de top van de rots.',
                            },
                            templeOfTheTooth: {
                                name: 'Tempel van de Tand',
                                description: 'De Tempel van de Heilige Tandreliquie in Kandy is een heilige boeddhistische plek die een relikwie van de tand van Boeddha herbergt. Bezoekers kunnen de historische en religieuze betekenis ervaren.',
                            },
                            ella: {
                                name: 'Ella',
                                description: 'Ella is een kleine stad in het heuvelland van Sri Lanka, omringd door theeplantages en watervallen. Het is beroemd om de Negen Bogen Brug en de Kleine Adams Peak.',
                            },
                            yalaNationalPark: {
                                name: 'Yala Nationaal Park',
                                description: 'Het Yala Nationaal Park is bekend om zijn rijke fauna, waaronder olifanten, luipaarden en talrijke vogelsoorten. Een safari hier is een must voor natuurliefhebbers.',
                            },
                            galleFort: {
                                name: 'Galle Fort',
                                description: 'Het Galle Fort, gebouwd door de Portugezen en versterkt door de Nederlanders, is een historische locatie met geplaveide straten, koloniale architectuur en bruisende cafés.',
                            },
                            nuwaraEliya: {
                                name: 'Nuwara Eliya',
                                description: 'Bekend als "Klein Engeland", is Nuwara Eliya een bergstation beroemd om zijn koele klimaat, theeplantages en koloniale bungalows.',
                            },
                            adamsPeak: {
                                name: 'Adams Peak',
                                description: 'Adams Peak is een heilige berg met een unieke voetafdruk op de top. Het is een populaire pelgrimslocatie voor meerdere religies.',
                            },
                            hortonPlains: {
                                name: 'Horton Plains',
                                description: 'Het Horton Plains Nationaal Park biedt glooiende heuvels, watervallen en het beroemde World’s End uitkijkpunt.',
                            },
                            bentotaBeach: {
                                name: 'Bentota Strand',
                                description: 'Het Bentota Strand is een ongerechte kustbestemming, bekend om zijn gouden zandstranden, watersporten en luxe resorts.',
                            },
                            jaffna: {
                                name: 'Jaffna',
                                description: 'Jaffna, in het noordelijke deel van Sri Lanka, is rijk aan Tamil-cultuur, historische locaties en heerlijke gerechten.',
                            },
                            anuradhapura: {
                                name: 'Anuradhapura',
                                description: 'Anuradhapura is een oude stad, bekend om zijn heilige boeddhistische plaatsen en historische ruïnes, waaronder de Sri Maha Bodhi-boom.',
                            },
                            polonnaruwa: {
                                name: 'Polonnaruwa',
                                description: 'Polonnaruwa is een UNESCO-werelderfgoed met oude tempels, standbeelden en prachtig bewaarde ruïnes.',
                            },
                            unawatunaBeach: {
                                name: 'Unawatuna Strand',
                                description: 'Het Unawatuna Strand is een bruisende kustbestemming die snorkelen, zonnebaden en een levendig nachtleven biedt.',
                            },
                            colomboCity: {
                                name: 'Colombo Stad',
                                description: 'Colombo is de bruisende hoofdstad van Sri Lanka, die moderne wolkenkrabbers combineert met koloniale architectuur en levendige markten.',
                            },
                            udawalawaNationalPark: {
                                name: 'Udawalawa Nationaal Park',
                                description: 'Het Udawalawa Nationaal Park is een toevluchtsoord voor wilde dieren, beroemd om zijn grote kuddes olifanten, diverse vogelsoorten en adembenemende landschappen, wat het een must-visit maakt voor natuurliefhebbers.',
                            },
                            dambullaCaveTemple: {
                                name: 'Dambulla Grottempel',
                                description: 'De Dambulla Grottempel is een UNESCO-werelderfgoed met oude boeddhistische muurschilderingen en standbeelden in grotten.',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: 'Ceylon Thee',
                                description: 'Sri Lanka is wereldwijd bekend om zijn Ceylon thee, die geliefd is om zijn unieke smaak en kwaliteit. Thee uit de regio’s Nuwara Eliya, Uva en Dimbula is bijzonder beroemd.',
                            },
                            spices: {
                                title: 'Kruiden',
                                description: 'Sri Lanka is al eeuwenlang een centrum voor kruiden zoals kaneel, kardemom, kruidnagel en nootmuskaat. Sri Lankaanse kaneel wordt beschouwd als de beste ter wereld.',
                            },
                            gems: {
                                title: 'Edelstenen en Sieraden',
                                description: 'Bekend als het "Eiland van Edelstenen", is Sri Lanka beroemd om zijn saffieren, robijnen en maanstenen. De "Blue Belle of Asia", een van de grootste blauwe saffieren, werd hier ontdekt.',
                            },
                            ayurveda: {
                                title: 'Ayurveda',
                                description: 'Sri Lanka is bekend om zijn ayurvedische geneeskunde en wellnessbehandelingen. Populaire aanbiedingen omvatten massages, kruidenbehandelingen en ayurveda-resorts.',
                            },
                            handicrafts: {
                                title: 'Traditioneel Handwerk',
                                description: 'Sri Lanka produceert prachtige handgemaakte producten, waaronder maskers uit Ambalangoda, batiktextiel, houtsnijwerk en lakwerk.',
                            },
                            elephants: {
                                title: 'Olifanten',
                                description: 'Sri Lankaanse olifanten spelen een belangrijke rol in de cultuur en festivals. Prachtig versierde olifanten zijn te zien in optochten zoals de Esala Perahera.',
                            },
                            food: {
                                title: 'Traditioneel Eten',
                                description: 'Sri Lanka is beroemd om zijn smaakvolle keuken, waaronder rijst met curry, hoppers, kottu roti, pol sambol en wattalappam.',
                            },
                            festivals: {
                                title: 'Festivals',
                                description: 'Sri Lanka viert kleurrijke festivals zoals Esala Perahera, het Singalees en Tamil Nieuwjaar en Vesak, met verlichte decoraties en optochten.',
                            },
                            coconut: {
                                title: 'Kokosproducten',
                                description: 'Sri Lanka is beroemd om zijn kokosproducten zoals kokosolie, melk en kokosvezel, gebruikt voor touwen en matten.',
                            },
                            sarees: {
                                title: 'Sri Lankaanse Sari’s',
                                description: 'De Kandyan sari (Osariya) is een traditioneel kledingstuk voor vrouwen, bekend om zijn elegantie en unieke drapering, gedragen tijdens ceremoniële gelegenheden.',
                            },
                            dances: {
                                title: 'Traditionele Dansen',
                                description: 'De traditionele dansen van Sri Lanka omvatten de Kandyan dans, duivelsdansen en laaglanddansen, geïnspireerd door natuur en folklore.',
                            },
                            stiltFishing: {
                                title: 'Paalvissen',
                                description: 'Een iconisch beeld in Sri Lanka: paalvissen, waarbij vissers balanceren op palen die in de zee zijn geplaatst, uniek voor de zuidelijke kustregio’s.',
                            },
                            moonstones: {
                                title: 'Maanstenen',
                                description: 'Sri Lanka is bekend om zijn maanstenen, beschouwd als halfedelstenen. De maansteenmijnen in Meetiyagoda zijn bijzonder beroemd.',
                            },
                            cricket: {
                                title: 'Sri Lankaanse Cricket',
                                description: 'Cricket is een passie voor Sri Lankanen, en het land is bekend om het produceren van wereldklasse spelers. Sri Lanka won de ICC Cricket World Cup in 1996.',
                            },
                            herbs: {
                                title: 'Ayurvedische Kruiden en Specerijen',
                                description: 'Het eiland produceert kruidengeneesmiddelen die in ayurveda worden gebruikt, zoals gotu kola, kaneel en neem.',
                            },
                            masks: {
                                title: 'Maskers',
                                description: 'Traditionele Sri Lankaanse maskers uit Ambalangoda worden gebruikt in culturele optredens, waaronder Yaksha (duivelsmaskers) en Kolam-maskers.',
                            },
                        },
                    },
                    excursionsSection: {
                        title: 'Excursies',
                        excursions: {
                            oneDay: {
                                title: 'Eendaagse Excursies',
                                description: 'Ontdek adembenemende bestemmingen in één dag met rondleidingen en lokale ervaringen.',
                                alt: 'Eendaagse Excursie in Sri Lanka',
                            },
                            twoDays: {
                                title: 'Tweedagse Excursies',
                                description: 'Geniet van korte reizen met overnachtingen om nog meer van Sri Lanka te ervaren.',
                                alt: 'Tweedagse Excursie in Sri Lanka',
                            },
                            threeDays: {
                                title: 'Driedaagse Excursies',
                                description: 'Verken meerdere attracties tijdens drie dagen vol avontuur en ontspanning.',
                                alt: 'Driedaagse Excursie in Sri Lanka',
                            },
                            fourDays: {
                                title: 'Vierdaagse Excursies',
                                description: 'Perfect voor een uitgebreide reis die meerdere bestemmingen comfortabel bestrijkt.',
                                alt: 'Vierdaagse Excursie in Sri Lanka',
                            },
                            twentyDays: {
                                title: '20-Daagse Excursies',
                                description: 'Ga op een epische reis door Sri Lanka en verken zijn culturele, natuurlijke en historische wonderen.',
                                alt: '20-Daagse Excursie in Sri Lanka',
                            },
                        },
                        bentotaExcursions: {
                            title: 'Excursies vanuit Bentota',
                            bentotaToYala: {
                                title: 'Bentota naar Yala',
                                description: 'Bentota -> Ella -> Yala',
                            },
                            bentotaToNuwaraEliya: {
                                title: 'Bentota naar Nuwara Eliya',
                                description: 'Bentota -> Ella -> Kandy -> Nuwara Eliya',
                            },
                            bentotaToMinneriya: {
                                title: 'Bentota naar Minneriya Nationaal Park',
                                description: 'Bentota -> Sigiriya -> Anuradhapura -> Polonnaruwa -> Minneriya Nationaal Park',
                            },
                            bentotaToHortonPlains: {
                                title: 'Bentota naar Horton Plains',
                                description: 'Bentota -> Kandy -> Nuwara Eliya -> Horton Plains',
                            },
                            images: {
                                bentotaToElla1: 'Bentota Strandzicht 1',
                                bentotaToElla2: 'Bentota Strandzicht 2',
                            },
                        },
                        airportExcursions: {
                            title: 'Excursies vanuit de Luchthaven',
                            airportToColombo: {
                                title: 'Van Luchthaven naar Colombo Stadstour',
                                description: 'Luchthaven -> Colombo Fort -> Galle Face -> Gangaramaya Tempel',
                                alt1: 'Colombo Stadstour Afbeelding 1',
                                alt2: 'Colombo Stadstour Afbeelding 2',
                            },
                            airportToSigiriya: {
                                title: 'Van Luchthaven naar Sigiriya',
                                description: 'Luchthaven -> Dambulla -> Sigiriya Rotsfort',
                                alt1: 'Sigiriya Excursie Afbeelding 1',
                                alt2: 'Sigiriya Excursie Afbeelding 2',
                            },
                            airportToKandy: {
                                title: 'Van Luchthaven naar Kandy',
                                description: 'Luchthaven -> Pinnawala Olifantenweeshuis -> Kandy Tempel van de Tand',
                                alt1: 'Kandy Excursie Afbeelding 1',
                                alt2: 'Kandy Excursie Afbeelding 2',
                            },
                            airportToGalle: {
                                title: 'Van Luchthaven naar Galle',
                                description: 'Luchthaven -> Bentota -> Galle Fort -> Unawatuna Strand',
                                alt1: 'Galle Excursie Afbeelding 1',
                                alt2: 'Galle Excursie Afbeelding 2',
                            },
                        },
                    },
                    thingsToDoSection: {
                        title: 'Dingen om te doen in Sri Lanka',
                        viewMore: 'Meer bekijken',
                        activities: {
                            ayurveda: {
                                title: 'Ayurveda - Oude wetenschap van het leven',
                                alt: 'Ayurveda-therapie in Sri Lanka',
                            },
                            diving: {
                                title: 'Duiken in Sri Lanka',
                                alt: 'Duikervaring in Sri Lanka',
                            },
                            elephantRide: {
                                title: 'Olifantenrit',
                                alt: 'Olifantenrit in Sri Lanka',
                            },
                            fishing: {
                                title: 'Vissen in Sri Lanka',
                                alt: 'Visactiviteit in Sri Lanka',
                            },
                            ballooning: {
                                title: 'Ballonvaren in Sri Lanka',
                                alt: 'Luchtballonvaart in Sri Lanka',
                            },
                            jeepSafari: {
                                title: 'Jeep Safari',
                                alt: 'Jeep Safari in Sri Lanka',
                            },
                            whiteWaterRafting: {
                                title: 'Wildwaterraften',
                                alt: 'Wildwaterraften in Sri Lanka',
                            },
                            riverSafari: {
                                title: 'Rivier Safari',
                                alt: 'Rivier Safari in Sri Lanka',
                            },
                            snorkeling: {
                                title: 'Snorkelen in Sri Lanka',
                                alt: 'Snorkelervaring in Sri Lanka',
                            },
                            teaTasting: {
                                title: 'Theeproeverij Tour',
                                alt: 'Theeproeverij Tour in Sri Lanka',
                            },
                            templeVisit: {
                                title: 'Tempelbezoek',
                                alt: 'Tempelbezoek in Sri Lanka',
                            },
                            wildlifeSafari: {
                                title: 'Wildlife Safari',
                                alt: 'Wildlife Safari in Sri Lanka',
                            },
                        },
                    },
                    homeHeroSection: {
                        title: 'Reis met Ashan Sri Lanka',
                        subtitle: 'Ontdek de betoverende schoonheid van Sri Lanka met onvergetelijke avonturen',
                        bookButton: 'Boek uw reis',
                        videoFallback: 'Uw browser ondersteunt de videotag niet.',
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: 'Waarom kiezen voor Ashan Tours Sri Lanka',
                            specialist: {
                                title: 'Reisexpertise',
                                description: 'Ons team bij Ashan Tours Sri Lanka bestaat uit ervaren reisexperts die op maat gemaakte reizen samenstellen volgens uw wensen.'
                            },
                            experience: {
                                title: 'Onvergetelijke ervaringen',
                                description: 'Wij creëren blijvende herinneringen door de rijke cultuur, geschiedenis en natuurlijke schoonheid van Sri Lanka met passie te presenteren.'
                            },
                            priceMatch: {
                                title: 'Competitieve prijzen',
                                description: 'Ashan Tours Sri Lanka garandeert de beste waarde voor uw reis, met hoogwaardige ervaringen tegen betaalbare tarieven.'
                            },
                            support: {
                                title: 'Toegewijde ondersteuning',
                                description: 'Ons klantenserviceteam staat 24/7 voor u klaar om u bij elke stap te helpen en een naadloze reiservaring te garanderen.'
                            }
                        },
                        welcome: {
                            title: 'Welkom bij Ashan Tours Sri Lanka',
                            imageAlt: 'Welkomstafbeelding van Ashan Tours Sri Lanka',
                            description1: 'Ga op een buitengewone reis met Ashan Tours Sri Lanka, uw belangrijkste gids voor het verkennen van de wonderen van dit eilandparadijs.',
                            description2: 'Ontdek de levendige cultuur, adembenemende landschappen en verborgen schatten van Sri Lanka met onze zorgvuldig samengestelde tours.',
                            description3: 'Van ongerepte stranden tot oude ruïnes, onze reisroutes zijn ontworpen om u onder te dompelen in het hart van de schoonheid van Sri Lanka.',
                            description4: 'Ons toegewijde team zorgt voor persoonlijke service, waardoor uw reiservaring soepel en onvergetelijk wordt.',
                            description5: 'Sluit u aan bij Ashan Tours Sri Lanka en laat ons u leiden door een avontuur vol ontdekkingen en vreugde.'
                        },
                        cinnamonLuxuryVilla: {
                            title: 'Cinnamon Luxe Villa',
                            imageAlt: 'Afbeelding van Cinnamon Luxe Villa',
                            description1: 'Ervaar ongeëvenaard comfort in de Cinnamon Luxe Villa van Ashan Tours Sri Lanka, met premium accommodaties in een serene omgeving.',
                            description2: 'Onze exclusieve villa’s bieden moderne gemakken zoals airconditioning, luxe bedden en volledig uitgeruste keukens, perfect voor een ontspannen verblijf.',
                            readMore: 'Lees meer'
                        },
                        tourPackages: {
                            title: 'Onze reispakketten',
                            ella: {
                                title: 'Ella Avontuur',
                                subtitle: '3 dagen / 2 nachten',
                                description: 'Verken de schilderachtige schoonheid van Ella met Ashan Tours Sri Lanka, inclusief bezoeken aan de Negen Bogen Brug en Little Adam’s Peak.',
                                alt: 'Ella Tour Afbeelding'
                            },
                            ellaNuwaraKandy: {
                                title: 'Ella, Nuwara Eliya & Kandy',
                                subtitle: '5 dagen / 4 nachten',
                                description: 'Een culturele reis door Ella, Nuwara Eliya en Kandy, met theeplantages en historische tempels.',
                                alt: 'Ella, Nuwara Eliya & Kandy Tour Afbeelding'
                            },
                            kandyNuwaraEllaYala: {
                                title: 'Kandy, Nuwara Eliya, Ella & Yala',
                                subtitle: '7 dagen / 6 nachten',
                                description: 'Een uitgebreide tour met het erfgoed van Kandy, de theeplantages van Nuwara Eliya, de landschappen van Ella en de wilde dieren van Yala.',
                                alt: 'Kandy, Nuwara Eliya, Ella & Yala Tour Afbeelding'
                            },
                            viewMore: 'Bekijk meer tours'
                        },
                        popularExcursions: {
                            title: 'Populaire excursies',
                            oneDay: {
                                title: 'Eendaagse excursie',
                                alt: 'Eendaagse excursie afbeelding'
                            },
                            twoDays: {
                                title: 'Tweedaagse excursie',
                                alt: 'Tweedaagse excursie afbeelding'
                            },
                            threeDays: {
                                title: 'Driedaagse excursie',
                                alt: 'Driedaagse excursie afbeelding'
                            },
                            fourDays: {
                                title: 'Vierdaagse excursie',
                                alt: 'Vierdaagse excursie afbeelding'
                            },
                            viewMore: 'Bekijk meer excursies'
                        },
                        contactUs: {
                            title: 'Contacteer Ashan Tours Sri Lanka',
                            description: 'Klaar om Sri Lanka te ontdekken? Neem contact op met Ashan Tours Sri Lanka om uw droomvakantie vandaag te plannen!',
                            button: 'Neem contact op'
                        },
                        gallery: {
                            title: 'Onze galerij',
                            modalAlt: 'Galerij afbeelding',
                            filters: {
                                all: 'Alles',
                                tours: 'Tours',
                                accommodation: 'Accommodatie',
                                transportation: 'Vervoer',
                                wildlife: 'Wildleven'
                            },
                            tours: {
                                sigiriya2: 'Sigiriya Afbeelding 2',
                                sigiriya3: 'Sigiriya Afbeelding 3',
                                kandy2: 'Kandy Afbeelding 2',
                                kandy3: 'Kandy Afbeelding 3',
                                galle2: 'Galle Afbeelding 2',
                                galle3: 'Galle Afbeelding 3',
                                ella2: 'Ella Afbeelding 2',
                                ella3: 'Ella Afbeelding 3',
                                colomboCity: 'Colombo Stad Afbeelding'
                            },
                            accommodation: {
                                nuwaraEliya1: 'Nuwara Eliya Accommodatie Afbeelding 1',
                                nuwaraEliya2: 'Nuwara Eliya Accommodatie Afbeelding 2',
                                nuwaraEliya3: 'Nuwara Eliya Accommodatie Afbeelding 3',
                                nuwaraEliya4: 'Nuwara Eliya Accommodatie Afbeelding 4'
                            },
                            transportation: {
                                bentotaRiverSafari1: 'Bentota Rivier Safari Afbeelding 1',
                                bentotaRiverSafari2: 'Bentota Rivier Safari Afbeelding 2'
                            },
                            wildlife: {
                                yalaSafari1: 'Yala Safari Afbeelding 1',
                                yalaSafari2: 'Yala Safari Afbeelding 2',
                                minneriya1: 'Minneriya Afbeelding 1',
                                minneriya2: 'Minneriya Afbeelding 2',
                                udawalawaSafari1: 'Udawalawa Safari Afbeelding 1',
                                udawalawaSafari2: 'Udawalawa Safari Afbeelding 2'
                            },
                        },
                    },
                    tourPackages: {
                        title: "Reispakketten",
                        readMore: "Lees meer",
                        book: "Boeken",
                        destinationsTitle: "Bestemmingen",
                        destinationImageAlt: "Bestemmingsafbeelding {{index}}",
                        clickToEnlarge: "Klik om te vergroten",
                        enlargedDestinationAlt: "Vergrote bestemmingsafbeelding",
                        bookNow: "Nu boeken",
                        importantNotices: "Belangrijke mededelingen",
                        notices: {
                            transport: "We gebruiken zeer comfortabele transportsystemen voor al onze tours.",
                            children: "Kinderen van 5 jaar of jonger reizen gratis.",
                            hygiene: "Al onze tours worden uitgevoerd met een focus op hygiëne en veiligheid.",
                            tickets: "Reispakketten zijn inclusief toegangskaarten, tenzij anders vermeld.",
                            meals: "Eendaagse tours zijn exclusief maaltijden, tenzij expliciet vermeld.",
                        },
                        luxuryTransport: "Sluit je aan bij ons luxe transportsysteem",
                        luxuryTransportAlt1: "Luxe voertuig 1",
                        luxuryTransportAlt2: "Luxe voertuig 2",
                        getInTouch: "Neem contact op om onze pakketten te ontdekken",
                        getInTouchDescription: "Neem vandaag nog contact met ons op om de beste reisaanbiedingen voor jou te ontdekken.",
                        contactUs: "Neem contact op",
                        bookingMessage: "Ashan Tours Boekingsverzoek\nPakket: {{title}}\nDuur: {{duration}}\nLocatie: {{location}}",
                        manualBookingMessage: "Stuur het volgende bericht handmatig naar {{number}}:\n\n{{message}}",
                        errorBookingMessage: "Er is een fout opgetreden. Stuur het volgende bericht handmatig naar {{number}}:\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "Ella",
                                duration: "1 dag",
                                location: "Ella - Sri Lanka",
                                description:
                                    "Verken de adembenemende natuurlijke schoonheid van Ella, met zijn weelderige theeplantages, adembenemende uitzichten en de iconische Nine Arch Bridge.",
                            },
                            galleFort: {
                                title: "Galle Fort",
                                duration: "1 dag",
                                location: "Galle - Sri Lanka",
                                description:
                                    "Stap terug in de tijd met een bezoek aan het historische Galle Fort, een UNESCO-werelderfgoed vol met koloniale charme en kustschoonheid.",
                            },
                            yalaSafari: {
                                title: "Yala Safari",
                                duration: "1 dag",
                                location: "Yala - Sri Lanka",
                                description:
                                    "Ga op een avontuurlijke safari in het Yala Nationaal Park, de thuisbasis van luipaarden, olifanten en een scala aan exotische wilde dieren.",
                            },
                            kandy: {
                                title: "Kandy",
                                duration: "1 dag",
                                location: "Kandy - Sri Lanka",
                                description:
                                    "Ontdek het culturele hart van Sri Lanka met een bezoek aan Kandy, inclusief de heilige Tempel van de Tandrelikwie.",
                            },
                            sigiriya: {
                                title: "Sigiriya",
                                duration: "1 dag",
                                location: "Sigiriya - Sri Lanka",
                                description:
                                    "Beklim de oude Sigiriya Rotsvesting en bewonder de verbluffende fresco's en adembenemende panoramische uitzichten.",
                            },
                            udawalawe: {
                                title: "Udawalawe",
                                duration: "1 dag",
                                location: "Udawalawe - Sri Lanka",
                                description:
                                    "Geniet van een spannende safari in het Udawalawe Nationaal Park, bekend om zijn grote olifantenpopulatie en schilderachtige landschappen.",
                            },
                            colomboCityEscape: {
                                title: "Colombo Stadontsnapping",
                                duration: "1 dag",
                                location: "Colombo - Sri Lanka",
                                description:
                                    "Verken de bruisende stad Colombo, met zijn bruisende markten, culturele bezienswaardigheden en moderne attracties.",
                            },
                            mirissaWhaleWatching: {
                                title: "Walvissen spotten in Mirissa",
                                duration: "1 dag",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Vaar op een onvergetelijk walvisspotavontuur voor de kust van Mirissa, waar majestueuze blauwe walvissen op je wachten.",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "Walvissen spotten in Mirissa met comfortabele boot",
                                duration: "1 dag",
                                location: "Mirissa - Sri Lanka",
                                description:
                                    "Vaar op een onvergetelijk walvisspotavontuur voor de kust van Mirissa, waar majestueuze blauwe walvissen op je wachten.",
                            },
                            bentotaRiverSafari: {
                                title: "Bentota Rivier Safari",
                                duration: "1 dag",
                                location: "Bentota - Sri Lanka",
                                description:
                                    "Vaar over de rustige Bentota-rivier, omringd door weelderige mangroves en exotische wilde dieren, voor een serene ontsnapping.",
                            },
                            ellaYala: {
                                title: "Ella & Yala",
                                duration: "1 dag",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Ervaar de perfecte combinatie van Ella's schilderachtige schoonheid en Yala's spannende wildsafari in één dag.",
                            },
                            ellaGalle: {
                                title: "Ella & Galle",
                                duration: "1 dag",
                                location: "Ella & Galle - Sri Lanka",
                                description:
                                    "Ontdek de adembenemende landschappen van Ella en de koloniale charme van Galle in een dag vol verwondering.",
                            },
                            yalaGalle: {
                                title: "Yala & Galle",
                                duration: "1 dag",
                                location: "Yala & Galle - Sri Lanka",
                                description:
                                    "Combineer de spanning van een Yala-safari met een bezoek aan het pittoreske Galle Fort voor een echt gevarieerde ervaring.",
                            },
                            ellaYalaTwoDays: {
                                title: "Ella & Yala",
                                duration: "2 dagen",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Breng twee dagen door met het verkennen van Ella's schilderachtige hooglanden en de wildrijke landschappen van het Yala Nationaal Park.",
                            },
                            kandyTwoDays: {
                                title: "Kandy",
                                duration: "2 dagen",
                                location: "Ella & Yala - Sri Lanka",
                                description:
                                    "Breng twee dagen door met het verkennen van Ella's schilderachtige hooglanden en de wildrijke landschappen van het Yala Nationaal Park.",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "Ella/Nuwara Eliya/Kandy",
                                duration: "2 dagen",
                                location: "Ella/Nuwara Eliya/Kandy - Sri Lanka",
                                description:
                                    "Bezoek de theeplantages van Nuwara Eliya, Ella's weelderige groen en de culturele schatten van Kandy in deze tweedaagse tour.",
                            },
                            kandySigiriya: {
                                title: "Kandy & Sigiriya",
                                duration: "2 dagen",
                                location: "Kandy & Sigiriya - Sri Lanka",
                                description:
                                    "Geniet van een culturele reis naar Kandy en beklim de iconische Sigiriya Rotsvesting in dit tweedaagse avontuur.",
                            },
                            ellaNuwaraEliya: {
                                title: "Ella & Nuwara Eliya",
                                duration: "2 dagen",
                                location: "Ella & Nuwara Eliya - Sri Lanka",
                                description:
                                    "Dompel jezelf onder in Ella's natuurlijke schoonheid en de koele, serene sfeer van Nuwara Eliya gedurende twee dagen.",
                            },
                            sigiriKandyElla: {
                                title: "Sigiriya/Kandy/Ella",
                                duration: "3 dagen",
                                location: "Sigiriya/Kandy/Ella - Sri Lanka",
                                description:
                                    "Verken Sigiriya, de culturele bezienswaardigheden van Kandy en de pittoreske landschappen van Ella over drie onvergetelijke dagen.",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "Kandy/Nuwara Eliya/Ella/Yala",
                                duration: "3 dagen",
                                location: "Kandy/Nuwara Eliya/Ella/Yala - Sri Lanka",
                                description:
                                    "Ontdek de diverse hoogtepunten van Sri Lanka, van Kandy's cultuur tot Yala's wilde dieren, in een driedaagse onderdompelende tour.",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "Sigiriya/Anuradhapura/Polonnaruwa/Minneriya Nationaal Park Safari",
                                duration: "3 dagen",
                                location: "Sigiriya/Anuradhapura/Polonnaruwa/Minneriya Nationaal Park - Sri Lanka",
                                description:
                                    "Bezoek de oude steden Sigiriya, Anuradhapura en Polonnaruwa en geniet van een safari in het Minneriya Nationaal Park.",
                            },
                            twentyDayTour: {
                                title: "Tot 20 dagen reispakket",
                                duration: "20 dagen",
                                location: "Sri Lanka",
                                description:
                                    "Ga op een onvergetelijke 20-daagse reis door Sri Lanka en verken de culturele, natuurlijke en historische wonderen van Negombo tot Bentota.",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "Ravana Waterval",
                            nineArchBridge: "Negen Bogen Brug",
                            teaPlantation: "Theeplantage",
                            trainRide: "Treinreis",
                            littleAdamsPeak: "Kleine Adams Peak",
                            udawalaweElephant: "Udawalawe Olifantenmelkvoeding Observatie",
                            ayurvedicHerbalGarden: "Ayurvedische Kruidentuin",
                            templeKandeViharaya: "Tempel Kande Viharaya",
                            turtleHatchery: "Schildpaddenbroederij",
                            boatSafari: "Boot Safari",
                            moonstoneMine: "Maansteenmijn",
                            hikkaduwaBeach: "Hikkaduwa Strand - Zwemmen met schildpadden",
                            dutchFortGalle: "Nederlands Fort Galle",
                            yala: "Yala",
                            yalaSafariJeep: "Yala Safari met Jeep",
                            kandy: "Kandy",
                            royalBotanicalGarden: "Koninklijke Botanische Tuin",
                            teaFactoryPlantation: "Theefabriek en Plantage",
                            elephantFeeding: "Olifantenvoeding, Baden en Rijden",
                            ambuluwawaTowerOrTemple: "Ambuluwawa Toren of Tempel van de Tandrelikwie",
                            jewelleryGemFactory: "Sieraden- en Edelsteenfabriek",
                            silkFactory: "Zijdefabriek",
                            sigiriya: "Sigiriya",
                            sigiriyaLionRock: "Sigiriya Leeuwenrots",
                            dambullaGoldenTemple: "Dambulla Gouden Tempel",
                            villageTour: "Dorpstour met traditioneel Sri Lankaans eten",
                            pidurangalaRock: "Pidurangala Rots",
                            udawalawe: "Udawalawe",
                            udawalaweNationalPark: "Udawalawe Nationaal Park",
                            jeepSafari: "Jeep Safari",
                            elephantMilkFeeding: "Olifantenmelkvoeding",
                            lotusTower: "Lotus Toren",
                            redMosque: "Rode Moskee",
                            shopping: "Winkelen",
                            blueWhales: "Blauwe Walvissen",
                            mirissa: "Mirissa",
                            stiltFishing: "Paalvissen",
                            bentotaRiver: "Bentota Rivier",
                            bentota: "Bentota",
                            safariYalaNationalPark: "Safari Yala Nationaal Park met Jeep",
                            gadoladeniyaTemple: "Gadoladeniya Tempel",
                            templeOfTheToothRelic: "Tempel van de Tandrelikwie",
                            traditionalKandyanDance: "Traditionele Kandyan Dans",
                            luxuryHotelStay: "Verblijf in luxe hotel met ontbijt en diner",
                            teaFactory: "Theefabriek",
                            nuwaraEliyaTown: "Nuwara Eliya Stad",
                            ambuluwawaTower: "Ambuluwawa Toren",
                            hinduTemple: "Hindoetempel",
                            gregoryLake: "Gregory Meer",
                            postOffice: "Postkantoor",
                            hortanPlains: "Horton Vlakte",
                            sitaAmmanHinduKovil: "Sita Amman Hindoetempel",
                            botanicalGarden: "Botanische Tuin",
                            rambodaWaterfall: "Ramboda Waterval",
                            sigiriyaRockFortress: "Sigiriya Rotsvesting",
                            anuradhapura: "Anuradhapura",
                            polonnaruwa: "Polonnaruwa",
                            minneriyaNationalPark: "Minneriya Nationaal Park",
                            elephants: "Olifanten",
                            day1: "Dag 1: Luchthaven – Negombo: Transfer naar Negombo & vroege check-in, Boottocht door het Muthurajawela Moeras, Ontspanning – Zwemmen – Loungen – Hangmat – Wellness – Zonnen – Sport – Watersport, Overnachting en ontbijt in Negombo",
                            day2: "Dag 2: Negombo – Anuradhapura: Heilige stad Anuradhapura (UNESCO-werelderfgoed), Sri Maha Bodhi Boom, Wandeling rond pittoreske stuwmeren, Overnachting en ontbijt in Anuradhapura",
                            day3: "Dag 3: Anuradhapura – Minneriya – Habarana: Aukana Boeddha Standbeeld, Dorpssafari inclusief catamaran- en tuk-tuk-rit met lunch, Jeep Safari in Minneriya Nationaal Park, Overnachting en ontbijt in Habarana",
                            day4: "Dag 4: Habarana – Sigiriya – Ritigala – Trincomalee: Sigiriya Rotsvesting (UNESCO-werelderfgoed), Ritigala Bosklooster, Overnachting en ontbijt in Trincomalee",
                            day5: "Dag 5: Trincomalee: Ontspanning – Zwemmen – Loungen – Hangmat – Wellness – Zonnen – Sport – Watersport, Overnachting en ontbijt in Trincomalee",
                            day6: "Dag 6: Trincomalee: Stadstour Trincomalee, Verjaardag van Steffi Bäuml, Ontspanning – Zwemmen – Loungen – Hangmat – Wellness – Zonnen – Sport – Watersport, Verrassingskookles voor twee vrouwen, Overnachting en ontbijt in Trincomalee",
                            day7: "Dag 7: Trincomalee: Snorkeltrip naar Pigeon Island, Ontspanning – Zwemmen – Loungen – Hangmat – Wellness – Zonnen – Sport – Watersport, Overnachting en ontbijt in Trincomalee",
                            day8: "Dag 8: Trincomalee: Ontspanning – Zwemmen – Loungen – Hangmat – Wellness – Zonnen – Sport – Watersport, Overnachting en ontbijt in Trincomalee",
                            day9: "Dag 9: Trincomalee – Dambulla – Matale – Peradeniya – Kandy: Dambulla Grottempel (UNESCO-werelderfgoed), Kruiden- en specerijentuin in Matale, Koninklijke Botanische Tuinen Peradeniya met picknick, Wandeling door de oude stad van Kandy, Overnachting en ontbijt in Kandy",
                            day10: "Dag 10: Kandy: Tempel van de Tandrelikwie in Kandy (UNESCO-werelderfgoed), Avondvoorstelling van Kandyan-dans, Overnachting en ontbijt in Kandy",
                            day11: "Dag 11: Kandy – Nuwara Eliya – Ella: Theeplantages en theeplukken, Bezoek aan een theefabriek, Ramboda Watervallen, Nuwara Eliya – de stad boven de wolken, Wandeling door Ella, Overnachting en ontbijt in Ella",
                            day12: "Dag 12: Ella – Badulla: Treinreis van Ella naar Badulla (2e klas), Wandelingen in de omgeving van Ella, Optioneel: Ziplining, Overnachting en ontbijt in Ella",
                            day13: "Dag 13: Ella – Yala: Ravana Watervallen, Ella Gap Vallei, Jeep Safari in Yala Nationaal Park, Overnachting en ontbijt in Tissamaharama",
                            day14: "Dag 14: Yala – Udawalawe – Sinharaja: Bezoek aan het olifanten-transithuis tijdens voedertijd, Reis naar het Sinharaja Bosreservaat (UNESCO-werelderfgoed), Overnachting en ontbijt in Sinharaja",
                            day15: "Dag 15: Sinharaja: Begeleide wandeling door het Sinharaja Bosreservaat (UNESCO-natuurwerelderfgoed), Overnachting en ontbijt in Sinharaja",
                            day16: "Dag 16: Sinharaja – Galle: Oude stad van Galle, Galle Fort (UNESCO-werelderfgoed), Overnachting en ontbijt in Galle",
                            day17: "Dag 17: Galle – Mirissa – Bentota: Offshore safari vanuit Mirissa, Schildpaddenbeschermingsproject, Overnachting en ontbijt in Bentota",
                            day18_19: "Dag 18–19: Bentota: Ontspanning – Zwemmen – Loungen – Hangmat – Wellness – Zonnen – Sport – Watersport, Overnachting en ontbijt in Bentota",
                            day20: "Dag 20: Bentota – Luchthaven: Transfer naar de luchthaven",
                        },
                    },
                    ayurvedaPage: {
                        title: "Ayurveda - De oude wetenschap van het leven",
                        mainDescription: "Het woord 'Ayurveda' bestaat al meer dan drieduizend jaar. In het Sanskriet betekent het woord 'wetenschap van het leven'. De techniek is gebaseerd op de ayurvedische kijk op genezing van ziekte in plaats van de gevolgen ervan, wat vaak in strijd is met de Europese geneeskunde. Het postuleert de volgende principes:",
                        principles: {
                            energyBalance: "Het lichaam moet vrij zijn van energie en in balans zijn voor normale metabolische en hartactiviteit.",
                            muscleHormonal: "Het lichaam moet normale spiercontracties hebben met regelmatige hormonale activiteit.",
                            immuneSystem: "Het lichaam heeft een gezond immuunsysteem nodig om goed te functioneren."
                        },
                        trainingDescription: "Volgens recente gegevens zijn er in Sri Lanka meer dan 6.000 afgestudeerden opgeleid in Ayurveda. Ze ondergaan zeven jaar studie en twee jaar praktijk in openbare ziekenhuizen. Ayurvedische programma's omvatten:",
                        programs: {
                            stressRelief: "Verwijdering van stress, vermoeidheid en angst",
                            oxygenSaturation: "Zuurstofsaturatie",
                            muscularToxins: "Stimulatie van spiersystemen en verwijdering van gifstoffen",
                            nervousSystem: "Herstel van het evenwicht van het zenuwstelsel",
                            bloodFlow: "Herstel van de bloedstroom naar inwendige organen",
                            endorphins: "Productie van endorfines"
                        },
                        images: {
                            mainAlt: "Ayurveda",
                            faceTreatmentAlt: "Ayurvedische gezichtsbehandeling",
                            massageTreatmentAlt: "Ayurvedische massagebehandeling"
                        },
                        treatmentDescription: "Standaardbehandelingen omvatten lichaams- en hoofdhuidmassages met speciale oliën, kruidensauna-behandelingen en baden met kruiden. De meest populaire techniek is de 'Shirodhara-procedure', waarbij warme kruidenolie ritmisch op het voorhoofd wordt gedruppeld. Dit helpt het evenwicht van het zenuwstelsel te herstellen en ontspanning te bereiken.",
                        tipsTitle: "Tips voor ayurvedische behandelingen",
                        tips: {
                            relaxMind: "Vergeet problemen. Ontspan en maak je geest vrij voor de beste resultaten.",
                            chooseLocation: "Kies de juiste locatie. Selecteer een omgeving die aansluit bij je comfort en voorkeuren voor optimale genezing.",
                            selectProgram: "Kies het juiste programma. Bespreek je zorgen met de arts en probeer verschillende therapieën om te vinden wat het beste bij je past.",
                            warmBath: "Neem een warm bad voor de behandeling om je spieren te ontspannen en je lichaam voor te bereiden.",
                            lightMeal: "Eet een lichte maaltijd voor de procedure. Vermijd zware maaltijden om een goede bloedstroom tijdens de massage mogelijk te maken.",
                            postRelaxation: "Ontspanning na procedures is essentieel. Een goede ontspanning verbetert de effectiviteit van ayurvedische behandelingen."
                        },
                    },
                    ballooningPage: {
                        title: "Ballonvaren in Sri Lanka",
                        mainDescription: "Ballonvaren in Sri Lanka biedt een onvergetelijke ervaring van zacht zweven boven de adembenemende landschappen van het eiland. Ballonvaarten beginnen bij zonsopgang en bieden spectaculaire luchtfoto’s van glooiende heuvels, weelderige bossen, oude ruïnes en serene dorpen.",
                        dambullaDescription: "De populairste bestemming voor ballonvaren in Sri Lanka is Dambulla, gelegen in het hart van de culturele driehoek. Ballonvaarten hier voeren vaak over de iconische Sigiriya-rotsvesting, wat een ongeëvenaard perspectief biedt. Vluchten duren meestal 60-90 minuten, waardoor je ruim de tijd hebt om de schoonheid van Sri Lanka van bovenaf in je op te nemen.",
                        highlightsTitle: "Waarom ballonvaren in Sri Lanka proberen?",
                        highlightsDescription: "Ballonvaren combineert avontuur met rust, waardoor je de schoonheid van Sri Lanka op een unieke manier kunt ervaren. Enkele hoogtepunten van ballonvaren zijn:",
                        highlights: {
                            panoramicViews: "Ononderbroken panoramische uitzichten op de prachtige landschappen van het eiland.",
                            landmarks: "Vliegen over iconische bezienswaardigheden zoals de Sigiriya-rots en nabijgelegen meren.",
                            peacefulRide: "Een serene en vredige vlucht boven weelderig groen en charmante dorpen.",
                            sunrise: "Getuige zijn van een spectaculaire zonsopgang vanuit de lucht.",
                            photography: "Perfect voor fotografieliefhebbers die de schilderachtige schoonheid van bovenaf willen vastleggen."
                        },
                        images: {
                            mainAlt: "Ballonvaren in Sri Lanka",
                            sunriseAlt: "Zonsopgang ballonvaren",
                            sunriseCaption: "Geniet van adembenemende uitzichten op de zonsopgang terwijl je zacht zweeft in een luchtballon.",
                            landscapeAlt: "Landschap ballonvaren",
                            landscapeCaption: "Aanschouw de prachtige landschappen van Sri Lanka van bovenaf, inclusief glooiende heuvels en weelderige bossen."
                        },
                        tipsTitle: "Tips voor een onvergetelijke ballonvaart",
                        tips: {
                            bookEarly: "Boek je vlucht vroeg, want ballonvaren is afhankelijk van het weer en plaatsen raken snel vol.",
                            clothing: "Draag comfortabele kleding en neem een lichte jas mee, want vroege ochtenden kunnen koel zijn.",
                            camera: "Neem een camera of smartphone mee om de prachtige uitzichten vast te leggen.",
                            safety: "Luister aandachtig naar de veiligheidsinstructies van je piloot.",
                            arriveEarly: "Kom op tijd om de voorbereiding en het opblazen van de ballon te bekijken, een fascinerend proces."
                        },
                    },
                    divingPage: {
                        title: "Duiken in Sri Lanka",
                        mainDescription: "Een breed koraalrif omringt de kust van Sri Lanka op dieptes van 2 tot 40 meter. De warme wateren van de Indische Oceaan, tussen 27°C en 30°C, en de hoge transparantie van het water, van 15 tot 35 meter, bieden uitstekende omstandigheden voor duiken en snorkelen. Tijdens het duiken in Sri Lanka kun je eindeloze ongerepte koraalriffen, oude wrakken en betoverende onderwatergrotten verkennen.",
                        northeastDescription: "Het noordoosten van het eiland biedt een verscheidenheid aan meer dan 130 soorten kleurrijke koralen, die een thuis vormen voor zeedieren zoals zeeschildpadden, clownvissen, koraalduivels en zeepaardjes. Bezoek scheepswrakken nabij onderwaterrotsen en riffen voor een onvergetelijke ervaring. Zwevend in het heldere water word je ondergedompeld in het fascinerende verleden van Ceylon.",
                        facilitiesTitle: "Faciliteiten en beste duikplekken",
                        facilitiesDescription: "Duikcentra op het eiland zijn uitgerust met de nieuwste duikuitrusting van gerenommeerde fabrikanten. Gecertificeerde instructeurs met PADI- en CMAS-kwalificaties zorgen voor veilige en plezierige duiken. Duikcentra bevinden zich langs de zuidwestkust van het eiland en zijn actief van half oktober tot eind april. De noordoostkust, inclusief Nilaveli en Trincomalee, is ideaal om te duiken van maart tot oktober.",
                        popularSpots: "De koraalriffen nabij Kalpitiya in het westen en de scheepswrakduikplaatsen in Hikkaduwa behoren tot de populairste attracties voor duikers.",
                        images: {
                            mainAlt: "Duiken in Sri Lanka",
                            coralReefAlt: "Koraalrifduiken",
                            coralReefCaption: "Verken levendige koraalriffen die een thuis bieden aan diverse zeedieren.",
                            shipwreckAlt: "Scheepswrakduiken",
                            shipwreckCaption: "Ontdek historische scheepswrakken die een kijkje bieden in het maritieme verleden van Sri Lanka."
                        },
                        tipsTitle: "Tips voor duikers",
                        tips: {
                            season: "Kies het beste seizoen om te duiken op basis van de locatie: zuidwestkust (oktober tot april) of noordoostkust (maart tot oktober).",
                            certifiedCenter: "Zorg ervoor dat je duikcentrum gecertificeerd is en uitgerust met moderne uitrusting voor een veilige ervaring.",
                            instructorAdvice: "Luister naar het advies van je instructeur, vooral als je een beginner bent.",
                            respectMarineLife: "Respecteer het zeeleven door koralen niet aan te raken of de onderwateromgeving te verstoren.",
                            camera: "Neem een waterdichte camera mee om de betoverende schoonheid van de onderwaterwereld van Sri Lanka vast te leggen."
                        },
                    },
                    elephantRidePage: {
                        title: "Olifantenrit",
                        mainDescription: "Olifantentochten zijn een fascinerende, spannende activiteit en een unieke ervaring in Sri Lanka. Als je verblijft in de buurt van de culturele driehoek in gebieden zoals Habarana, Sigiriya of Dambulla, kun je deelnemen aan een olifantensafari. Deze ritten beginnen bij ongeveer $30 voor een uur onvergetelijk avontuur.",
                        rideDescription: "Voor de rit worden de olifanten uitgerust met een meerpersoonsmand die geschikt is voor 4 tot 6 personen. Deze vriendelijke reuzen nemen je mee over schilderachtige jungle-paden, steken overstroomde gebieden over en navigeren door weelderige vegetatie. Olifanten lopen meestal langzaam, zodat je volledig kunt genieten van de schoonheid van de omliggende natuur, hoewel ze snelheden tot 40 km/u kunnen bereiken.",
                        highlightsTitle: "Hoogtepunten van een olifantenrit",
                        highlightsDescription: "Een olifantenrit in Sri Lanka biedt een unieke manier om contact te maken met de natuur en het platteland te verkennen. Enkele hoogtepunten van de ervaring zijn:",
                        highlights: {
                            junglePaths: "Wandelen door dichte jungles vol met exotische vegetatie en wilde dieren.",
                            riverCrossing: "Het oversteken van rivieren en overstroomde gebieden, met prachtige uitzichten op het natuurlijke landschap.",
                            culturalConnection: "Leren over de nauwe relatie tussen olifanten en de Sri Lankaanse cultuur.",
                            comfortableRide: "Ontspannen op een comfortabel zadel terwijl de olifant je zachtjes door verschillende terreinen draagt."
                        },
                        images: {
                            mainAlt: "Olifantenrit",
                            jungleAlt: "Olifantenrit junglepad",
                            jungleCaption: "Verken dichte jungles en schilderachtige paden terwijl je op een olifant rijdt.",
                            waterAlt: "Olifant steekt water over",
                            waterCaption: "Steek rivieren over en geniet van de rustige schoonheid van het water en de vegetatie."
                        },
                        tipsTitle: "Tips voor een veilige en plezierige olifantenrit",
                        tips: {
                            clothing: "Draag comfortabele kleding en schoeisel geschikt voor buitenactiviteiten.",
                            guideInstructions: "Volg de instructies van je gids voor een veilige en plezierige rit.",
                            ethicalPractices: "Zorg ervoor dat de olifanten goed worden behandeld en dat de aanbieder ethische praktijken volgt.",
                            camera: "Neem een camera mee om het adembenemende landschap en momenten vast te leggen.",
                            respectElephants: "Respecteer de olifanten en vermijd acties die hen stress kunnen bezorgen of schaden."
                        },
                    },
                    fishingPage: {
                        title: "Vissen in Sri Lanka",
                        mainDescription: "Sri Lanka, met zijn uitgestrekte kustlijn en overvloed aan zoetwatermeren en rivieren, biedt een ongeëvenaarde viservaring. Of je nu een professionele visser bent of een hobbyist, Sri Lanka heeft iets te bieden. Van diepzeevistochten tot het traditionele paalvissen dat door lokale vissers wordt beoefend, je beleeft een onvergetelijk avontuur.",
                        destinationsDescription: "Populaire visbestemmingen zijn de zuidkust rond Galle en Mirissa, de Negombo-lagune en de rustige wateren van Trincomalee. Afhankelijk van je voorkeur kun je verschillende vistechnieken proberen, zoals trollen, bodemvissen of vliegvissen.",
                        experiencesTitle1: "Viservaringen in Sri Lanka",
                        experiencesDescription: "Vissen in Sri Lanka gaat niet alleen om het vangen van vis; het is een kans om jezelf onder te dompelen in de cultuur en tradities van het eiland. Enkele unieke viservaringen zijn:",
                        experiences: {
                            stiltFishingTitle: "Paalvissen",
                            stiltFishing: "Een traditionele methode waarbij vissers op palen zitten om vis te vangen dicht bij de kust, een praktijk die uniek is voor Sri Lanka.",
                            deepSeaFishingTitle: "Diepzeevissen",
                            deepSeaFishing: "Waag je in de Indische Oceaan om marlijnen, tonijnen, barracuda’s en andere grote vissoorten te vangen.",
                            lagoonFishingTitle: "Lagune- en riviervissen",
                            lagoonFishing: "Ontspan terwijl je vist in serene lagunes en rivieren vol met vis zoals tilapia en meerval.",
                            nightFishingTitle: "Nachtvissen",
                            nightFishing: "Ervaar de spanning van vissen onder de sterren, een gangbare praktijk in kustdorpen."
                        },
                        images: {
                            mainAlt: "Vissen in Sri Lanka",
                            stiltFishingAlt: "Paalvissen in Sri Lanka",
                            stiltFishingCaption: "Paalvissen is een traditionele methode en een iconisch beeld van het visserij-erfgoed van Sri Lanka.",
                            deepSeaFishingAlt: "Diepzeevissen in Sri Lanka",
                            deepSeaFishingCaption: "Diepzeevissen biedt een avontuurlijke ervaring, gericht op grote vissoorten in de Indische Oceaan."
                        },
                        tipsTitle: "Tips voor een plezierige visreis",
                        tips: {
                            season: "Kies het juiste seizoen voor je visexpeditie; oktober tot april is ideaal voor de zuidkust, terwijl maart tot oktober geschikt is voor de oostkust.",
                            protection: "Neem zonnebrandcrème, een hoed en beschermende kleding mee om comfortabel te blijven tijdens je reis.",
                            guide: "Boek een visgids of charter om het meeste uit je ervaring te halen en te leren van de experts.",
                            environment: "Respecteer de lokale omgeving door geen afval achter te laten en duurzame vispraktijken na te leven.",
                            hydration: "Blijf gehydrateerd en neem snacks mee voor langere vistochten."
                        },
                    },
                    jeepSafariPage: {
                        title: "Jeep Safari in Sri Lanka",
                        mainDescription: "De nationale parken van Sri Lanka bieden een spannende jeep-safari-ervaring, waarmee je de rijke biodiversiteit van het eiland kunt verkennen en wilde dieren in hun natuurlijke habitats kunt observeren. Yala Nationaal Park, Wilpattu Nationaal Park en Udawalawe Nationaal Park behoren tot de populairste bestemmingen voor jeep-safari’s.",
                        wildlifeDescription: "Deze safari’s bieden de kans om olifanten, luipaarden, luiaardberen, waterbuffels, krokodillen en een breed scala aan vogelsoorten te zien. Begeleid door ervaren natuurgidsen en trackers zijn jeep-safari’s perfect voor liefhebbers van wilde dieren en fotografen.",
                        whyChooseTitle: "Waarom kiezen voor een jeep-safari?",
                        whyChooseDescription: "Jeep-safari’s zijn een van de beste manieren om de diverse wilde dieren van Sri Lanka te verkennen. Hier zijn enkele hoogtepunten:",
                        whyChoose: {
                            encounters: "Dichtbije ontmoetingen met iconische soorten zoals olifanten en luipaarden.",
                            remoteAreas: "Toegang tot afgelegen en schilderachtige gebieden binnen nationale parken.",
                            photography: "Mogelijkheden voor natuurfotografie in een natuurlijke omgeving.",
                            guidance: "Begeleiding door deskundige natuurgidsen en parkwachters.",
                            adventure: "Een avontuur geschikt voor alle leeftijdsgroepen, dat spanning combineert met educatie."
                        },
                        images: {
                            mainAlt: "Jeep Safari in Sri Lanka",
                            wildlifeAlt: "Wilde dieren tijdens jeep-safari",
                            wildlifeCaption: "Aanschouw iconische wilde dieren zoals luipaarden, olifanten en krokodillen tijdens je safari.",
                            landscapeAlt: "Jeep Safari Landschap",
                            landscapeCaption: "Verken de adembenemende landschappen van de nationale parken van Sri Lanka, van dichte bossen tot open vlaktes."
                        },
                        tipsTitle: "Tips voor een plezierige jeep-safari",
                        tips: {
                            clothing: "Draag comfortabele, neutraal gekleurde kleding om op te gaan in de omgeving.",
                            protection: "Neem zonnebrandcrème, een hoed en insectenwerend middel mee ter bescherming.",
                            equipment: "Neem een verrekijker en camera mee om je ervaring te verbeteren en wilde dieren vast te leggen.",
                            guide: "Volg de instructies van de gids om veiligheid en respect voor de dieren te garanderen.",
                            booking: "Boek je safari vroeg, vooral tijdens piekseizoenen, om een plek te bemachtigen."
                        },
                    },
                    riverSafariPage: {
                        title: "Rivier Safari in Sri Lanka",
                        mainDescription: "Een rivier-safari in Sri Lanka biedt een unieke manier om de rijke biodiversiteit en schilderachtige schoonheid van het eiland te verkennen. Glijd langs rustige waterwegen omringd door weelderige mangroves, spot exotische wilde dieren en geniet van pittoreske zonsondergangen die je betoveren.",
                        destinationsDescription: "Populaire rivier-safari-bestemmingen zijn de Madu Ganga (Madu-rivier) en de Bentota-rivier. Deze safari’s bieden de kans om verschillende vogelsoorten, varanen, krokodillen en zelfs apen in hun natuurlijke habitats te zien. De serene omgeving is perfect voor natuurliefhebbers en fotografen.",
                        whyChooseTitle: "Waarom kiezen voor een rivier-safari?",
                        whyChooseDescription: "Een rivier-safari is een ontspannende en meeslepende ervaring die natuur, wilde dieren en culturele verkenning combineert. Hier zijn enkele hoogtepunten:",
                        whyChoose: {
                            mangroves: "Verken weelderige mangroves vol met leven.",
                            wildlife: "Spot exotische vogels, krokodillen en andere wilde dieren.",
                            villages: "Bezoek kleine eilanden en lokale dorpen langs de rivier.",
                            tranquility: "Geniet van de rust en schilderachtige schoonheid van de waterwegen van Sri Lanka.",
                            suitable: "Perfect voor gezinnen, koppels en solo-reizigers die op zoek zijn naar een vredige ontsnapping."
                        },
                        images: {
                            mainAlt: "Rivier Safari in Sri Lanka",
                            mangrovesAlt: "Mangroves tijdens rivier-safari",
                            mangrovesCaption: "Ontdek de weelderige mangroves die de schilderachtige waterwegen van Sri Lanka omzomen.",
                            wildlifeAlt: "Wilde dieren tijdens rivier-safari",
                            wildlifeCaption: "Spot exotische wilde dieren zoals krokodillen, varanen en kleurrijke vogels tijdens je safari."
                        },
                        tipsTitle: "Tips voor een plezierige rivier-safari",
                        tips: {
                            clothing: "Draag comfortabele kleding en neem een hoed en zonnebrandcrème mee ter bescherming.",
                            binoculars: "Neem een verrekijker mee om verre wilde dieren en vogels te spotten.",
                            camera: "Neem een camera of smartphone mee om de adembenemende landschappen en wilde dieren vast te leggen.",
                            guide: "Volg de instructies van je gids voor een veilige en plezierige ervaring.",
                            environment: "Respecteer de natuurlijke omgeving door geen afval achter te laten en wilde dieren niet te verstoren."
                        },
                    },
                    snorkelingPage: {
                        title: "Snorkelen in Sri Lanka",
                        mainDescription: "Snorkelen in Sri Lanka biedt een onvergetelijke onderwaterervaring, waarbij je levendige koraalriffen en diverse zeedieren kunt ontdekken. Met zijn kristalheldere wateren en rijke aquatische ecosystemen is Sri Lanka een paradijs voor snorkelaars van alle niveaus.",
                        destinationsDescription: "Enkele van de populairste snorkelplekken zijn Hikkaduwa, bekend om zijn kleurrijke koraaltuinen en schildpadden, Pigeon Island in Trincomalee, beroemd om zijn ongerepte riffen, en Mirissa, waar je tijdens het snorkelseizoen zelfs een walvis of twee kunt spotten.",
                        whyChooseTitle: "Waarom kiezen voor snorkelen in Sri Lanka?",
                        whyChooseDescription: "Snorkelen in Sri Lanka is een magische ervaring, die avontuur en natuurlijke schoonheid combineert. Hier zijn enkele hoogtepunten:",
                        whyChoose: {
                            coralReefs: "Verken levendige koraalriffen vol met leven.",
                            marineLife: "Zwem naast kleurrijke tropische vissen, schildpadden en zelfs rifhaaien.",
                            landscapes: "Ontdek ongerepte onderwaterlandschappen in helder, warm water.",
                            suitable: "Geschikt voor zowel beginners als ervaren snorkelaars.",
                            accessible: "Toegankelijk vanuit enkele van de beste strandbestemmingen in Sri Lanka."
                        },
                        images: {
                            mainAlt: "Snorkelen in Sri Lanka",
                            coralReefAlt: "Koraalriffen in Sri Lanka",
                            coralReefCaption: "Ontdek adembenemende koraalriffen en hun bruisende ecosystemen.",
                            marineLifeAlt: "Zeeleven in Sri Lanka",
                            marineLifeCaption: "Ontmoet divers zeeleven, waaronder schildpadden, tropische vissen en meer."
                        },
                        tipsTitle: "Tips voor een onvergetelijke snorkelervaring",
                        tips: {
                            mask: "Draag een comfortabel masker en snorkel om een helder zicht onder water te garanderen.",
                            sunscreen: "Gebruik rifvriendelijke zonnebrandcrème om zowel je huid als het zeeleven te beschermen.",
                            swimGently: "Zwem voorzichtig om koraalriffen en waterdieren niet te verstoren.",
                            hydration: "Blijf gehydrateerd en neem pauzes tussen sessies.",
                            guidedTour: "Doe mee aan een rondleiding met gids voor de beste snorkelplekken en veiligheidstips."
                        },
                    },
                    teaTastingPage: {
                        title: "Theeproeverij-tour in Sri Lanka",
                        mainDescription: "Sri Lanka, vaak aangeduid als de 'Parel van de Indische Oceaan', is beroemd om zijn eersteklas theeproductie. Ga op een theeproeverij-tour en verken de weelderige theeplantages in regio’s zoals Nuwara Eliya, Ella en Kandy. Leer over de kunst van theeproductie, het minutieuze proces van theeproductie en geniet van de rijke smaken van authentieke Ceylon-thee.",
                        heritageDescription: "Of je nu een theeliefhebber bent of gewoon nieuwsgierig, een theeproeverij-tour biedt een unieke kans om je te verdiepen in het thee-erfgoed van Sri Lanka en de serene schoonheid van zijn hooglanden te ervaren.",
                        whyChooseTitle: "Waarom kiezen voor een theeproeverij-tour?",
                        whyChooseDescription: "Een theeproeverij-tour in Sri Lanka draait niet alleen om het proeven van thee – het is een meeslepende culturele ervaring. Hier zijn enkele hoogtepunten:",
                        whyChoose: {
                            plantations: "Bezoek pittoreske theeplantages gelegen in de koele hooglanden.",
                            history: "Leer over de geschiedenis en betekenis van Ceylon-thee.",
                            production: "Neem deel aan het plukken van thee en observeer het productieproces in theefabrieken.",
                            varieties: "Proef verschillende theesoorten, van zwart tot groen tot gearomatiseerde mengsels.",
                            scenery: "Geniet van het adembenemende landschap van mistige bergen en kabbelende watervallen."
                        },
                        images: {
                            mainAlt: "Theeproeverij-tour in Sri Lanka",
                            teaPlantationAlt: "Theeplantage in Sri Lanka",
                            teaPlantationCaption: "Verken weelderige theeplantages en leer over theeproductie.",
                            teaPreparationAlt: "Theebereiding in Sri Lanka",
                            teaPreparationCaption: "Ontdek de kunst van theebereiding en geniet van authentieke Ceylon-thee."
                        },
                        tipsTitle: "Tips voor een plezierige theeproeverij-tour",
                        tips: {
                            clothing: "Draag comfortabele kleding en schoeisel voor wandelingen door plantages.",
                            jacket: "Neem een lichte jas mee, want hooglandgebieden kunnen koel en mistig zijn.",
                            varieties: "Probeer verschillende theesoorten en neem je favorieten mee naar huis als souvenirs.",
                            questions: "Stel vragen tijdens de tour om meer te leren over het theeproductieproces.",
                            attractions: "Combineer je theetour met bezoeken aan nabijgelegen attracties zoals watervallen en uitkijkpunten."
                        },
                    },
                    templeVisitPage: {
                        title: "Tempelbezoek in Sri Lanka",
                        mainDescription: "Sri Lanka, bekend als het Land van Boeddha, herbergt oude tempels die het rijke spirituele en culturele erfgoed weerspiegelen. Ga op reis om iconische tempels te verkennen, zoals de Tempel van de Tand in Kandy, de Dambulla Grot Tempel en Ruwanwelisaya in Anuradhapura.",
                        spiritualDescription: "Deze heilige plaatsen, versierd met ingewikkelde gravures, muurschilderingen en standbeelden, bieden een kijkje in de spirituele tradities en architectonische pracht van het eiland. Een tempelbezoek is niet alleen een culturele ervaring, maar ook een kans om rust en vrede te vinden.",
                        whyVisitTitle: "Waarom tempels in Sri Lanka bezoeken?",
                        whyVisitDescription: "Het bezoeken van tempels in Sri Lanka biedt een unieke kans om verbinding te maken met de geschiedenis, cultuur en spiritualiteit van het eiland. Hier zijn enkele hoogtepunten:",
                        whyVisit: {
                            architecture: "Bewonder de ingewikkelde architectuur en eeuwenoude standbeelden.",
                            traditions: "Leer over boeddhistische tradities en rituelen van deskundige gidsen.",
                            heritage: "Verken UNESCO-werelderfgoedlocaties zoals de Gouden Tempel van Dambulla.",
                            serenity: "Ervaar de sereniteit en spirituele sfeer van heilige ruimtes.",
                            festivals: "Wees getuige van bruisende festivals zoals Esala Perahera in de Tempel van de Tand."
                        },
                        images: {
                            mainAlt: "Tempelbezoek in Sri Lanka",
                            templeInteriorAlt: "Tempelinterieur",
                            templeInteriorCaption: "Bewonder de verbluffende interieurs versierd met ingewikkelde gravures en muurschilderingen.",
                            sacredTempleAlt: "Heilige tempel in Sri Lanka",
                            sacredTempleCaption: "Bezoek heilige tempels zoals Ruwanwelisaya en dompel je onder in spirituele tradities."
                        },
                        tipsTitle: "Tips voor het bezoeken van tempels in Sri Lanka",
                        tips: {
                            dress: "Kleed je bescheiden, bedek je schouders en knieën, als teken van respect.",
                            shoes: "Verwijder je schoenen voordat je het tempelterrein betreedt.",
                            touching: "Raak geen standbeelden of heilige objecten aan.",
                            donation: "Neem een kleine donatie mee voor de tempel als je wilt bijdragen.",
                            silence: "Respecteer de stilte en spirituele sfeer tijdens je bezoek."
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "Wildwaterraften in Sri Lanka",
                        mainDescription: "Wildwaterraften in Sri Lanka is een opwindende ervaring, vooral in Kitulgala, de avonturenhoofdstad van het eiland. De Kelani-rivier, met zijn bruisende stroomversnellingen en schilderachtige omgeving, biedt een perfecte setting voor zowel beginners als ervaren rafters.",
                        destinationsDescription: "Raftingexpedities beslaan meestal een traject van 5 kilometer met stroomversnellingen variërend van graad 2 tot graad 4. Deelnemers kunnen genieten van de spanning van het navigeren door uitdagende stromingen terwijl ze de weelderige natuur en adembenemende uitzichten op de rivieroevers in zich opnemen.",
                        whyChooseTitle: "Waarom kiezen voor wildwaterraften in Sri Lanka?",
                        whyChooseDescription: "Wildwaterraften in Sri Lanka biedt een unieke combinatie van avontuur en natuurlijke schoonheid. Hier zijn enkele hoogtepunten van de ervaring:",
                        whyChoose: {
                            rapids: "Navigeer door spannende stroomversnellingen onder begeleiding van ervaren instructeurs.",
                            views: "Geniet van prachtige uitzichten op het omliggende regenwoud en bergachtig terrein.",
                            activities: "Combineer raften met andere activiteiten zoals trekking, vogelspotten en canyoning in Kitulgala.",
                            suitable: "Perfect voor groepen, families of soloreizigers die op zoek zijn naar een adrenalinekick."
                        },
                        images: {
                            mainAlt: "Wildwaterraften in Sri Lanka",
                            actionRaftingAlt: "Wildwaterraften Actie",
                            actionRaftingCaption: "Voel de adrenalinekick terwijl je uitdagende stroomversnellingen op de Kelani-rivier overwint.",
                            scenicRaftingAlt: "Wildwaterraften Uitzichten",
                            scenicRaftingCaption: "Geniet van de serene schoonheid van de weelderige omgeving tijdens je raftingavontuur."
                        },
                        tipsTitle: "Tips voor een veilige en spannende raftingtrip",
                        tips: {
                            safetyGear: "Draag een reddingsvest en helm die door je raftinggids worden verstrekt voor veiligheid.",
                            instructions: "Luister zorgvuldig naar de veiligheidsinstructies voordat je aan je trip begint.",
                            clothing: "Draag comfortabele, sneldrogende kleding en stevig schoeisel zoals waterschoenen.",
                            changeOfClothes: "Neem reservekleding en een handdoek mee voor na de trip.",
                            operator: "Boek je raftingtrip bij een gerenommeerde aanbieder om een veilige en plezierige ervaring te garanderen."
                        },
                    },
                    wildlifeSafariPage: {
                        title: "Wildsafari in Sri Lanka",
                        mainDescription: "Sri Lanka, bekend om zijn rijke biodiversiteit, biedt ongelooflijke wildsafari's in nationale parken zoals Yala, Wilpattu, Minneriya en Udawalawe. Deze safari's bieden de kans om olifanten, luipaarden, luiaardberen en een verscheidenheid aan vogelsoorten in hun natuurlijke habitat te zien.",
                        destinationsDescription: "Verken diverse landschappen, variërend van dichte bossen tot open graslanden, en leg onvergetelijke momenten van wilde dieren in actie vast. Met deskundige gidsen en goed onderhouden safar jeeps is een wildsafari in Sri Lanka een must voor natuurliefhebbers en avonturiers.",
                        whyChooseTitle: "Waarom kiezen voor een wildsafari?",
                        whyChooseDescription: "Een wildsafari in Sri Lanka biedt een unieke kans om contact te maken met de natuur en de opmerkelijke biodiversiteit van het eiland te verkennen. Hoogtepunten zijn:",
                        whyChoose: {
                            species: "Het observeren van iconische soorten zoals olifanten, luipaarden en krokodillen.",
                            landscapes: "Het verkennen van weelderige bossen, wetlands en open vlaktes bruisend van wilde dieren.",
                            photography: "Het vastleggen van verbluffende wildlifefotografie in natuurlijke omgevingen.",
                            elusiveAnimals: "De spanning ervaren van het spotten van ongrijpbare dieren zoals de Sri Lankaanse luipaard.",
                            conservation: "Leren over inspanningen voor natuurbehoud van ervaren gidsen en natuurbeschermers."
                        },
                        images: {
                            mainAlt: "Wildsafari in Sri Lanka",
                            elephantsAlt: "Olifanten in Sri Lanka",
                            elephantsCaption: "Zie majestueuze olifanten vrij rondzwerven in de nationale parken van Sri Lanka.",
                            leopardAlt: "Sri Lankaanse Luipaard",
                            leopardCaption: "Spot de ongrijpbare Sri Lankaanse luipaard, een hoogtepunt van elke wildsafari."
                        },
                        tipsTitle: "Tips voor een spannende wildsafari",
                        tips: {
                            clothing: "Draag neutraal gekleurde kleding om op te gaan in de omgeving.",
                            protection: "Neem zonnebrandcrème, een hoed en insectenwerend middel mee voor bescherming.",
                            equipment: "Neem een verrekijker en camera mee om wilde dieren te spotten en vast te leggen.",
                            guide: "Volg de instructies van je gids voor een veilige en plezierige ervaring.",
                            booking: "Boek vroeg, vooral tijdens piekseizoenen, om een plek in populaire parken te garanderen."
                        },
                    },
                },
            },
            ja: {
                translation: {
                    home: 'ホーム',
                    about: '私たちについて',
                    srilanka: 'スリランカ',
                    excursions: 'エクスカーション',
                    tour: 'ツアーを予約',
                    things: 'できること',
                    contact: {
                        navLabel: 'お問い合わせ',
                        getInTouch: '連絡を取る',
                        address: '住所',
                        mobile: 'モバイル',
                        email: 'メール',
                        website: 'ウェブサイト',
                        sendMessage: 'メッセージを送信',
                        fullName: 'フルネーム',
                        fullNamePlaceholder: 'フルネームを入力してください',
                        country: '国',
                        countryPlaceholder: '国を入力してください',
                        emailPlaceholder: 'メールアドレスを入力してください',
                        subject: '件名',
                        subjectPlaceholder: '件名を入力してください',
                        message: 'メッセージ',
                        messagePlaceholder: 'メッセージを入力してください',
                        reset: 'リセット',
                        submit: '送信',
                        ourLocation: '私たちの所在地',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Ashan Tours Sri Lanka ゲストメッセージ',
                        manualMessage: '以下のメッセージを手動で送信してください',
                        errorMessage: 'エラーが発生しました。以下のメッセージを手動で送信してください',
                    },
                    footerSection: {
                        ashanTours: 'アシャン・ツアーズ・スリランカ',
                        getInTouch: 'お問い合わせ',
                        address: 'スリランカ、ベルワラ、モラガラ、マラダナ・ロード293/C/3',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: 'つながりを保つ',
                        emailPlaceholder: 'メールアドレスを入力してください',
                        socialMedia: {
                            facebook: 'フェイスブック',
                            instagram: 'インスタグラム',
                            youtube: 'ユーチューブ',
                            twitter: 'ツイッター',
                        },
                        copyright: '© {{year}} アシャン・ツアーズ・スリランカ。全権利予約。',
                        designedBy: 'ウェブサイトはRedev Solutionsによって設計および開発されました',
                        designedByPhone: '+94 76 460 8225',
                    },
                    aboutSection: {
                        travelWithAshan: 'Ashan Tours Sri Lankaと一緒に旅をする',
                        imageAlt: 'Ashan Tours 画像 {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lankaは、信頼できる旅行のパートナーとして、スリランカでの忘れられない旅を創り出します。探検への情熱と経験豊富なプロフェッショナルのチームにより、パーソナライズされた旅程、専門的なガイド、そして卓越したサービスを提供し、あなたの休暇を特別なものにすることをお約束します。',
                        introParagraph2: '私たちのツアーは、スリランカのエッセンスを捉えるよう丁寧に作られています—太陽が降り注ぐビーチや絵のように美しい丘陵地帯から、古代の文化的宝物や活気あふれる野生生物まで。Ashan Tours Sri Lankaでは、島の美しさと魂を発見できる本物の体験を提供することに尽力しています。',
                        introParagraph3: '冒険、静かな休息、または文化への没入を求めている場合、Ashan Tours Sri Lankaはあなたの希望に合わせたテーラーメイドのパッケージを提供します。私たちと一緒に、驚き、発見、そして永遠の思い出に満ちた旅に出かけましょう。',
                        cinnamonLuxuryVilla: 'シナモンラグジュアリーヴィラ',
                        villaImageAlt: 'シナモンラグジュアリーヴィラ 画像 {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lankaは、快適さとエレガンスを求める旅行者にプレミアムな宿泊施設を提供するシナモンラグジュアリーヴィラを誇りを持って紹介します。私たちの2つの特別なアパートメントは、スリランカの中心で自宅のような体験を提供するよう設計されています。',
                        villaParagraph2: '各アパートメントには、エアコン、専用バスルーム、デラックスダブルベッド、設備の整ったキッチンなどの最新の設備が備わっています。一人旅、カップル、または家族での旅行でも、私たちのヴィラは贅沢と利便性の完璧な融合を提供します。',
                        villaParagraph3: '静かな環境に位置するシナモンラグジュアリーヴィラは、スリランカの驚異を探索した後にリラックスしてくつろぐことができます。Ashan Tours Sri Lankaで滞在を予約し、比類ないおもてなしを体験してください。',
                    },
                    sriLankaSection: {
                        discoverSriLanka: 'スリランカを発見する',
                        mainImageAlt: 'スリランカ',
                        pearlOfIndianOcean: 'インド洋の真珠',
                        introParagraph1: 'スリランカは、愛情を込めて「{{pearl}}」と呼ばれる、息をのむような美しい島の楽園で、壮大な風景、深く根付いた伝統、そして色鮮やかな文化で知られています。',
                        introParagraph2: '2500年以上の歴史を持つ文明を誇るスリランカには、壮大な古代の首都、聖なる宗教的ランドマーク、そしてユネスコ世界遺産があります。インド、アラブ、ポルトガル、オランダ、イギリスの影響を受けたその文化的タペストリーは、時代を超えた魅力的な旅を提供します。',
                        introParagraph3: '島の風景は驚異的で、金色の砂浜やなだらかな緑の茶畑から霧に包まれた山頂まで広がっています。野生動物保護区にはゾウ、ヒョウ、鮮やかな鳥類が生息し、自然愛好家の夢の場所となっています。',
                        introParagraph4: '冒険を求める人々には、サーフィン、トレッキング、シュノーケリング、ダイビングが楽しめます。香り高いスパイス、新鮮なシーフード、トロピカルフルーツが織りなす料理は、大胆で味わい深く、島の豊かな食文化の物語を伝えています。',
                        introParagraph5: '時代を超えた遺跡を巡るもよし、穏やかなビーチでくつろぐもよし、温かいもてなしを味わうもよし、スリランカは忘れられない旅行体験を提供します。',
                        attractivePlaces: 'スリランカの魅力的な場所',
                        viewMore: 'もっと見る',
                        placeImageAlt: '{{name}} 画像 {{index}}',
                        fullImagePreviewAlt: 'フルサイズプレビュー',
                        famousThingsTitle: 'スリランカの有名なもの',
                        places: {
                            sigiriyaRockFortress: {
                                name: 'シギリヤ・ロック・フォートレス',
                                description: 'シギリヤ・ロック・フォートレスはユネスコ世界遺産であり、スリランカで最も象徴的なランドマークの一つです。古代の庭園、フレスコ画、岩の頂上からの息をのむような景色が特徴です。',
                            },
                            templeOfTheTooth: {
                                name: '仏歯寺',
                                description: 'キャンディにある聖なる仏歯の寺院は、仏陀の歯の遺物を収める神聖な仏教の場です。訪問者はその歴史的・宗教的重要性を実感できます。',
                            },
                            ella: {
                                name: 'エッラ',
                                description: 'エッラはスリランカの丘陵地帯にある小さな町で、茶畑や滝に囲まれています。ナインアーチブリッジとリトルアダムスピークで有名です。',
                            },
                            yalaNationalPark: {
                                name: 'ヤーラ国立公園',
                                description: 'ヤーラ国立公園は、ゾウ、ヒョウ、多数の鳥類を含む豊かな野生動物で知られています。自然愛好家にはサファリが必須です。',
                            },
                            galleFort: {
                                name: 'ゴール要塞',
                                description: 'ポルトガル人によって建てられ、オランダ人によって強化されたゴール要塞は、石畳の通り、植民地時代の建築、活気あるカフェがある歴史的な場所です。',
                            },
                            nuwaraEliya: {
                                name: 'ヌワラエリヤ',
                                description: '「リトルイングランド」として知られるヌワラエリヤは、涼しい気候、茶畑、植民地時代のバンガローで有名な丘の駅です。',
                            },
                            adamsPeak: {
                                name: 'アダムスピーク',
                                description: 'アダムスピークは頂上に独特の足跡がある神聖な山です。複数の宗教にとって人気のある巡礼地です。',
                            },
                            hortonPlains: {
                                name: 'ホートンプレインズ',
                                description: 'ホートンプレインズ国立公園は、なだらかな丘、滝、そして有名なワールズエンド展望台を特徴としています。',
                            },
                            bentotaBeach: {
                                name: 'ベントータビーチ',
                                description: 'ベントータビーチは、金色の砂浜、ウォータースポーツ、高級リゾートで知られる美しい海岸の目的地です。',
                            },
                            jaffna: {
                                name: 'ジャフナ',
                                description: 'スリランカ北部に位置するジャフナは、タミル文化、歴史的遺跡、そして美味しい料理で豊かです。',
                            },
                            anuradhapura: {
                                name: 'アヌラーダプラ',
                                description: 'アヌラーダプラは、聖なる仏教の場と歴史的遺跡、特にスリ・マハ・ボディ樹で知られる古代都市です。',
                            },
                            polonnaruwa: {
                                name: 'ポロンナルワ',
                                description: 'ポロンナルワは、古代の寺院、彫像、美しく保存された遺跡を持つユネスコ世界遺産です。',
                            },
                            unawatunaBeach: {
                                name: 'ウナワトゥナビーチ',
                                description: 'ウナワトゥナビーチは、シュノーケリング、日光浴、活気あるナイトライフを提供する活気ある海岸の目的地です。',
                            },
                            colomboCity: {
                                name: 'コロンボ市',
                                description: 'コロンボはスリランカの賑やかな首都で、現代的な高層ビルと植民地時代の建築、活気ある市場が融合しています。',
                            },
                            udawalawaNationalPark: {
                                name: 'ウダワラウェ国立公園',
                                description: 'ウダワラウェ国立公園は、大きなゾウの群れ、多様な鳥類、壮大な風景で有名な野生動物の楽園で、自然愛好家にとって必見の目的地です。',
                            },
                            dambullaCaveTemple: {
                                name: 'ダンブッラ洞窟寺院',
                                description: 'ダンブッラ洞窟寺院は、古代の仏教壁画と洞窟内の彫像を特徴とするユネスコ世界遺産です。',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: 'セイロンティー',
                                description: 'スリランカは、その独特の風味と品質で知られるセイロンティーで世界的に有名です。ヌワラエリヤ、ウヴァ、ディンブラ地域の茶が特に有名です。',
                            },
                            spices: {
                                title: 'スパイス',
                                description: 'スリランカは何世紀にもわたり、シナモン、カルダモン、クローブ、ナツメグなどのスパイスの中心地でした。スリランカのシナモンは世界最高とされています。',
                            },
                            gems: {
                                title: '宝石とジュエリー',
                                description: '「宝石の島」として知られるスリランカは、サファイア、ルビー、ムーンストーンで有名です。「ブルーベル・オブ・アジア」、最大級のブルーサファイアがここで発見されました。',
                            },
                            ayurveda: {
                                title: 'アーユルヴェーダ',
                                description: 'スリランカはアーユルヴェーダ医学とウェルネストリートメントで知られています。人気のサービスには、マッサージ、ハーブ療法、アーユルヴェーダリゾートがあります。',
                            },
                            handicrafts: {
                                title: '伝統工芸品',
                                description: 'スリランカは、アンバランゴダのマスク、バティック織物、木彫り、ラッカーウェアなど、精巧な工芸品を生産しています。',
                            },
                            elephants: {
                                title: 'ゾウ',
                                description: 'スリランカのゾウは文化や祭りで重要な役割を果たします。豪華な衣装をまとったゾウは、エサラ・ペラヘラなどの行列に参加します。',
                            },
                            food: {
                                title: '伝統料理',
                                description: 'スリランカは、ライスアンドカレー、ホッパー、コットゥロティ、ポルサンボル、ワッタラッパムなどの風味豊かな料理で有名です。',
                            },
                            festivals: {
                                title: '祭り',
                                description: 'スリランカは、エサラ・ペラヘラ、シンハラ・タミル新年、ウェサックなどの色鮮やかな祭りを、輝く装飾と行列で祝います。',
                            },
                            coconut: {
                                title: 'ココナッツ製品',
                                description: 'スリランカは、ココナッツオイル、ミルク、コイアファイバー（ロープやマットに使用）などのココナッツ製品で有名です。',
                            },
                            sarees: {
                                title: 'スリランカのサリー',
                                description: 'カンディアンサリー（オサリヤ）は、女性の伝統的な衣装で、その優雅さと独特なドレープスタイルで知られ、儀式の場で着用されます。',
                            },
                            dances: {
                                title: '伝統舞踊',
                                description: 'スリランカの伝統舞踊には、カンディアンダンス、デビルダンス、低地ダンスがあり、自然や民話にインスパイアされています。',
                            },
                            stiltFishing: {
                                title: '棒釣り',
                                description: 'スリランカの象徴的な光景である棒釣りは、漁師が海に打ち込まれた棒の上でバランスを取る、南部の海岸地域特有のものです。',
                            },
                            moonstones: {
                                title: 'ムーンストーン',
                                description: 'スリランカは、半貴石とされるムーンストーンで知られています。メーティヤゴダのムーンストーン鉱山は特に有名です。',
                            },
                            cricket: {
                                title: 'スリランカのクリケット',
                                description: 'クリケットはスリランカ人の情熱であり、世界クラスの選手を輩出しています。スリランカは1996年にICCクリケットワールドカップで優勝しました。',
                            },
                            herbs: {
                                title: 'アーユルヴェーダのハーブとスパイス',
                                description: 'この島は、ゴツコラ、シナモン、ニームなど、アーユルヴェーダで使用されるハーブ薬を生産しています。',
                            },
                            masks: {
                                title: 'マスク',
                                description: 'アンバランゴダの伝統的なスリランカのマスクは、ヤクシャ（悪魔のマスク）やコラムマスクなど、文化的パフォーマンスで使用されます。',
                            },
                        },
                    },
                    excursionsSection: {
                        title: 'エクスカーション',
                        excursions: {
                            oneDay: {
                                title: '1日エクスカーション',
                                description: 'ガイド付きツアーと地元の体験で、1日で魅力的な目的地を探索します。',
                                alt: 'スリランカの1日エクスカーション',
                            },
                            twoDays: {
                                title: '2日間エクスカーション',
                                description: '宿泊を伴う短い旅行で、スリランカのさらなる魅力を体験します。',
                                alt: 'スリランカの2日間エクスカーション',
                            },
                            threeDays: {
                                title: '3日間エクスカーション',
                                description: '3日間の冒険とリラクゼーションで、複数の観光地を発見します。',
                                alt: 'スリランカの3日間エクスカーション',
                            },
                            fourDays: {
                                title: '4日間エクスカーション',
                                description: '快適に複数の目的地を巡る、長期の旅に最適です。',
                                alt: 'スリランカの4日間エクスカーション',
                            },
                            twentyDays: {
                                title: '20日間エクスカーション',
                                description: 'スリランカの文化的、自然的、歴史的な驚異を探索する壮大な旅に出かけます。',
                                alt: 'スリランカの20日間エクスカーション',
                            },
                        },
                        bentotaExcursions: {
                            title: 'ベントータからのエクスカーション',
                            bentotaToYala: {
                                title: 'ベントータからヤーラへ',
                                description: 'ベントータ -> エッラ -> ヤーラ',
                            },
                            bentotaToNuwaraEliya: {
                                title: 'ベントータからヌワラエリヤへ',
                                description: 'ベントータ -> エッラ -> キャンディ -> ヌワラエリヤ',
                            },
                            bentotaToMinneriya: {
                                title: 'ベントータからミンネリヤ国立公園へ',
                                description: 'ベントータ -> シギリヤ -> アヌラーダプラ -> ポロンナルワ -> ミンネリヤ国立公園',
                            },
                            bentotaToHortonPlains: {
                                title: 'ベントータからホートンプレインズへ',
                                description: 'ベントータ -> キャンディ -> ヌワラエリヤ -> ホートンプレインズ',
                            },
                            images: {
                                bentotaToElla1: 'ベントータビーチビュー1',
                                bentotaToElla2: 'ベントータビーチビュー2',
                            },
                        },
                        airportExcursions: {
                            title: '空港からのエクスカーション',
                            airportToColombo: {
                                title: '空港からコロンボ市内ツアー',
                                description: '空港 -> コロンボフォート -> ガルフェイス -> ガンガラマヤ寺院',
                                alt1: 'コロンボ市内ツアー画像1',
                                alt2: 'コロンボ市内ツアー画像2',
                            },
                            airportToSigiriya: {
                                title: '空港からシギリヤへ',
                                description: '空港 -> ダンブッラ -> シギリヤ・ロック・フォートレス',
                                alt1: 'シギリヤエクスカーション画像1',
                                alt2: 'シギリヤエクスカーション画像2',
                            },
                            airportToKandy: {
                                title: '空港からキャンディへ',
                                description: '空港 -> ピンナワラ象の孤児院 -> キャンディ仏歯寺',
                                alt1: 'キャンディエクスカーション画像1',
                                alt2: 'キャンディエクスカーション画像2',
                            },
                            airportToGalle: {
                                title: '空港からゴールへ',
                                description: '空港 -> ベントータ -> ゴール要塞 -> ウナワトゥナビーチ',
                                alt1: 'ゴールエクスカーション画像1',
                                alt2: 'ゴールエクスカーション画像2',
                            },
                        },
                    },
                    thingsToDoSection: {
                        title: 'スリランカでできること',
                        viewMore: 'もっと見る',
                        activities: {
                            ayurveda: {
                                title: 'アーユルヴェーダ - 古代の生命科学',
                                alt: 'スリランカのアーユルヴェーダ療法',
                            },
                            diving: {
                                title: 'スリランカでのダイビング',
                                alt: 'スリランカのダイビング体験',
                            },
                            elephantRide: {
                                title: 'ゾウの背中に乗る',
                                alt: 'スリランカのゾウ乗り体験',
                            },
                            fishing: {
                                title: 'スリランカでの釣り',
                                alt: 'スリランカの釣りアクティビティ',
                            },
                            ballooning: {
                                title: 'スリランカでの熱気球',
                                alt: 'スリランカの熱気球体験',
                            },
                            jeepSafari: {
                                title: 'ジープサファリ',
                                alt: 'スリランカのジープサファリ',
                            },
                            whiteWaterRafting: {
                                title: 'ホワイトウォーターラフティング',
                                alt: 'スリランカのホワイトウォーターラフティング',
                            },
                            riverSafari: {
                                title: 'リバーサファリ',
                                alt: 'スリランカのリバーサファリ',
                            },
                            snorkeling: {
                                title: 'スリランカでのシュノーケリング',
                                alt: 'スリランカのシュノーケリング体験',
                            },
                            teaTasting: {
                                title: 'ティーテイスティングツアー',
                                alt: 'スリランカのティーテイスティングツアー',
                            },
                            templeVisit: {
                                title: '寺院訪問',
                                alt: 'スリランカの寺院訪問',
                            },
                            wildlifeSafari: {
                                title: '野生動物サファリ',
                                alt: 'スリランカの野生動物サファリ',
                            },
                        },
                    },
                    homeHeroSection: {
                        title: 'アシャン・スリランカと旅する',
                        subtitle: 'スリランカの魅惑的な美しさを忘れられない冒険で探検する',
                        bookButton: 'あなたの旅を予約する',
                        videoFallback: 'お使いのブラウザはビデオタグをサポートしていません。',
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: 'なぜAshan Tours Sri Lankaを選ぶのか',
                            specialist: {
                                title: '旅行の専門知識',
                                description: 'Ashan Tours Sri Lankaのチームは、お客様の好みに合わせたオーダーメイドの旅を創り出す経験豊富な旅行専門家で構成されています。'
                            },
                            experience: {
                                title: '忘れられない体験',
                                description: 'スリランカの豊かな文化、歴史、自然の美しさを情熱を持って紹介し、忘れられない瞬間を創り出します。'
                            },
                            priceMatch: {
                                title: '競争力のある価格',
                                description: 'Ashan Tours Sri Lankaは、手頃な価格で高品質な体験を提供し、旅行の最高の価値を保証します。'
                            },
                            support: {
                                title: '専任サポート',
                                description: '24時間365日対応のカスタマーサポートチームが、旅のすべてのステップでスムーズな体験を保証します。'
                            }
                        },
                        welcome: {
                            title: 'Ashan Tours Sri Lankaへようこそ',
                            imageAlt: 'Ashan Tours Sri Lankaのウェルカム画像',
                            description1: 'Ashan Tours Sri Lankaと一緒に、この島の楽園の驚異を探る特別な旅に出発しましょう。',
                            description2: '私たちの丁寧に企画されたツアーで、スリランカの活気ある文化、息をのむような風景、隠れた名所を発見してください。',
                            description3: '手つかずのビーチから古代の遺跡まで、私たちの旅程はスリランカの美しさの中心に浸るように設計されています。',
                            description4: '専任チームがパーソナライズされたサービスを提供し、旅行体験をスムーズで記憶に残るものにします。',
                            description5: 'Ashan Tours Sri Lankaに参加して、発見と喜びに満ちた冒険を体験してください。'
                        },
                        cinnamonLuxuryVilla: {
                            title: 'シナモンラグジュアリーヴィラ',
                            imageAlt: 'シナモンラグジュアリーヴィラの画像',
                            description1: 'Ashan Tours Sri Lankaのシナモンラグジュアリーヴィラで、静かな環境の中、比類ない快適さを体験してください。',
                            description2: '私たちの高級ヴィラは、エアコン、デラックスなベッド、完備されたキッチンなどのモダンな設備を備え、リラックスした滞在に最適です。',
                            readMore: '詳細を見る'
                        },
                        tourPackages: {
                            title: '私たちのツアーパッケージ',
                            ella: {
                                title: 'エッラ冒険',
                                subtitle: '3日間 / 2泊',
                                description: 'Ashan Tours Sri Lankaでエッラの風光明媚な美しさを探索し、ナインアーチブリッジやリトルアダムスピークを訪れます。',
                                alt: 'エッラツアー画像'
                            },
                            ellaNuwaraKandy: {
                                title: 'エッラ、ヌワラエリヤ、キャンディ',
                                subtitle: '5日間 / 4泊',
                                description: 'エッラ、ヌワラエリヤ、キャンディを巡る文化的な旅で、茶畑や歴史的な寺院を訪れます。',
                                alt: 'エッラ、ヌワラエリヤ、キャンディツアー画像'
                            },
                            kandyNuwaraEllaYala: {
                                title: 'キャンディ、ヌワラエリヤ、エッラ、ヤーラ',
                                subtitle: '7日間 / 6泊',
                                description: 'キャンディの遺産、ヌワラエリヤの茶畑、エッラの風景、ヤーラの野生動物を網羅する包括的なツアー。',
                                alt: 'キャンディ、ヌワラエリヤ、エッラ、ヤーラツアー画像'
                            },
                            viewMore: 'さらにツアーを見る'
                        },
                        popularExcursions: {
                            title: '人気のエクスカーション',
                            oneDay: {
                                title: '1日エクスカーション',
                                alt: '1日エクスカーション画像'
                            },
                            twoDays: {
                                title: '2日エクスカーション',
                                alt: '2日エクスカーション画像'
                            },
                            threeDays: {
                                title: '3日エクスカーション',
                                alt: '3日エクスカーション画像'
                            },
                            fourDays: {
                                title: '4日エクスカーション',
                                alt: '4日エクスカーション画像'
                            },
                            viewMore: 'さらにエクスカーションを見る'
                        },
                        contactUs: {
                            title: 'Ashan Tours Sri Lankaに連絡',
                            description: 'スリランカを探索する準備はできていますか？Ashan Tours Sri Lankaに連絡して、夢のバケーションを今すぐ計画しましょう！',
                            button: '連絡を取る'
                        },
                        gallery: {
                            title: '私たちのギャラリー',
                            modalAlt: 'ギャラリー画像',
                            filters: {
                                all: 'すべて',
                                tours: 'ツアー',
                                accommodation: '宿泊',
                                transportation: '交通',
                                wildlife: '野生動物'
                            },
                            tours: {
                                sigiriya2: 'シギリヤ画像2',
                                sigiriya3: 'シギリヤ画像3',
                                kandy2: 'キャンディ画像2',
                                kandy3: 'キャンディ画像3',
                                galle2: 'ゴール画像2',
                                galle3: 'ゴール画像3',
                                ella2: 'エッラ画像2',
                                ella3: 'エッラ画像3',
                                colomboCity: 'コロンボ市画像'
                            },
                            accommodation: {
                                nuwaraEliya1: 'ヌワラエリヤ宿泊画像1',
                                nuwaraEliya2: 'ヌワラエリヤ宿泊画像2',
                                nuwaraEliya3: 'ヌワラエリヤ宿泊画像3',
                                nuwaraEliya4: 'ヌワラエリヤ宿泊画像4'
                            },
                            transportation: {
                                bentotaRiverSafari1: 'ベントータ川サファリ画像1',
                                bentotaRiverSafari2: 'ベントータ川サファリ画像2'
                            },
                            wildlife: {
                                yalaSafari1: 'ヤーラサファリ画像1',
                                yalaSafari2: 'ヤーラサファリ画像2',
                                minneriya1: 'ミンネリヤ画像1',
                                minneriya2: 'ミンネリヤ画像2',
                                udawalawaSafari1: 'ウダワラワサファリ画像1',
                                udawalawaSafari2: 'ウダワラワサファリ画像2'
                            },
                        },
                    },
                    tourPackages: {
                        title: "ツアーパッケージ",
                        readMore: "詳細を見る",
                        book: "予約",
                        destinationsTitle: "目的地",
                        destinationImageAlt: "目的地画像 {{index}}",
                        clickToEnlarge: "クリックして拡大",
                        enlargedDestinationAlt: "拡大された目的地画像",
                        bookNow: "今すぐ予約",
                        importantNotices: "重要なお知らせ",
                        notices: {
                            transport: "すべてのツアーで快適な交通システムを使用しています。",
                            children: "5歳以下の子供は無料で旅行できます。",
                            hygiene: "すべてのツアーは衛生と安全に重点を置いて実施されます。",
                            tickets: "特に明記されていない限り、ツアーパッケージには入場券が含まれています。",
                            meals: "特に明記されていない限り、1日ツアーには食事は含まれていません。",
                        },
                        luxuryTransport: "私たちの豪華な交通システムに参加してください",
                        luxuryTransportAlt1: "豪華車両 1",
                        luxuryTransportAlt2: "豪華車両 2",
                        getInTouch: "パッケージについて知るためにご連絡ください",
                        getInTouchDescription: "今日ご連絡いただければ、あなたに最適な旅行プランをご案内します。",
                        contactUs: "お問い合わせ",
                        bookingMessage: "Ashan Tours 予約リクエスト\nパッケージ: {{title}}\n期間: {{duration}}\n場所: {{location}}",
                        manualBookingMessage: "以下のメッセージを{{number}}に手動で送信してください:\n\n{{message}}",
                        errorBookingMessage: "エラーが発生しました。以下のメッセージを{{number}}に手動で送信してください:\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "エッラ",
                                duration: "1日",
                                location: "エッラ - スリランカ",
                                description:
                                    "エッラの息をのむような自然の美しさを探索し、豊かな茶畑、壮大な景色、象徴的な九つのアーチ橋を訪れます。",
                            },
                            galleFort: {
                                title: "ゴール要塞",
                                duration: "1日",
                                location: "ゴール - スリランカ",
                                description:
                                    "歴史的なゴール要塞を訪れ、ユネスコ世界遺産に登録されている植民地時代の魅力と海岸の美しさに満ちた場所で過去にタイムスリップ。",
                            },
                            yalaSafari: {
                                title: "ヤーラサファリ",
                                duration: "1日",
                                location: "ヤーラ - スリランカ",
                                description:
                                    "ヤーラ国立公園で冒険的なサファリに出かけ、ヒョウ、ゾウ、そして多様なエキゾチックな野生動物が生息しています。",
                            },
                            kandy: {
                                title: "キャンディ",
                                duration: "1日",
                                location: "キャンディ - スリランカ",
                                description:
                                    "スリランカの文化的中心地であるキャンディを訪れ、聖なる仏歯寺を含むツアーをお楽しみください。",
                            },
                            sigiriya: {
                                title: "シギリヤ",
                                duration: "1日",
                                location: "シギリヤ - スリランカ",
                                description:
                                    "古代のシギリヤ岩の要塞に登り、驚くべきフレスコ画と息をのむようなパノラマの景色を堪能してください。",
                            },
                            udawalawe: {
                                title: "ウダワラウェ",
                                duration: "1日",
                                location: "ウダワラウェ - スリランカ",
                                description:
                                    "ウダワラウェ国立公園でスリリングなサファリを楽しみ、大きなゾウの群れと絵のように美しい風景で知られています。",
                            },
                            colomboCityEscape: {
                                title: "コロンボ市内脱出",
                                duration: "1日",
                                location: "コロンボ - スリランカ",
                                description:
                                    "活気あふれるコロンボ市を探索し、賑やかな市場、文化的ランドマーク、現代的なアトラクションを訪れます。",
                            },
                            mirissaWhaleWatching: {
                                title: "ミリッサでのクジラウォッチング",
                                duration: "1日",
                                location: "ミリッサ - スリランカ",
                                description:
                                    "ミリッサの海岸沖で忘れられないクジラウォッチングの冒険に出航し、壮大なシロナガスクジラがあなたを待っています。",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "快適なボートでのミリッサクジラウォッチング",
                                duration: "1日",
                                location: "ミリッサ - スリランカ",
                                description:
                                    "ミリッサの海岸沖で忘れられないクジラウォッチングの冒険に出航し、壮大なシロナガスクジラがあなたを待っています。",
                            },
                            bentotaRiverSafari: {
                                title: "ベントータ川サファリ",
                                duration: "1日",
                                location: "ベントータ - スリランカ",
                                description:
                                    "静かなベントータ川をクルーズし、豊かなマングローブとエキゾチックな野生動物に囲まれた穏やかな逃避行をお楽しみください。",
                            },
                            ellaYala: {
                                title: "エッラ＆ヤーラ",
                                duration: "1日",
                                location: "エッラ＆ヤーラ - スリランカ",
                                description:
                                    "エッラの絵のように美しい美しさとヤーラのスリリングな野生動物サファリの完璧な組み合わせを1日で体験してください。",
                            },
                            ellaGalle: {
                                title: "エッラ＆ゴール",
                                duration: "1日",
                                location: "エッラ＆ゴール - スリランカ",
                                description:
                                    "エッラの息をのむような風景とゴールの植民地時代の魅力を、驚異に満ちた1日で発見してください。",
                            },
                            yalaGalle: {
                                title: "ヤーラ＆ゴール",
                                duration: "1日",
                                location: "ヤーラ＆ゴール - スリランカ",
                                description:
                                    "ヤーラのサファリの興奮と絵のように美しいゴール要塞の訪問を組み合わせて、本当に多様な体験をしてください。",
                            },
                            ellaYalaTwoDays: {
                                title: "エッラ＆ヤーラ",
                                duration: "2日間",
                                location: "エッラ＆ヤーラ - スリランカ",
                                description:
                                    "エッラの絵のように美しい高地とヤーラ国立公園の野生動物に富んだ風景を2日間かけて探索してください。",
                            },
                            kandyTwoDays: {
                                title: "キャンディ",
                                duration: "2日間",
                                location: "エッラ＆ヤーラ - スリランカ",
                                description:
                                    "エッラの絵のように美しい高地とヤーラ国立公園の野生動物に富んだ風景を2日間かけて探索してください。",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "エッラ/ヌワラエリヤ/キャンディ",
                                duration: "2日間",
                                location: "エッラ/ヌワラエリヤ/キャンディ - スリランカ",
                                description:
                                    "ヌワラエリヤの茶畑、エッラの豊かな緑、キャンディの文化的宝物をこの2日間のツアーで訪れてください。",
                            },
                            kandySigiriya: {
                                title: "キャンディ＆シギリヤ",
                                duration: "2日間",
                                location: "キャンディ＆シギリヤ - スリランカ",
                                description:
                                    "キャンディへの文化的な旅を楽しみ、象徴的なシギリヤ岩の要塞に登る2日間の冒険をお楽しみください。",
                            },
                            ellaNuwaraEliya: {
                                title: "エッラ＆ヌワラエリヤ",
                                duration: "2日間",
                                location: "エッラ＆ヌワラエリヤ - スリランカ",
                                description:
                                    "エッラの自然の美しさとヌワラエリヤの涼しく穏やかな雰囲気に2日間浸ってください。",
                            },
                            sigiriKandyElla: {
                                title: "シギリヤ/キャンディ/エッラ",
                                duration: "3日間",
                                location: "シギリヤ/キャンディ/エッラ - スリランカ",
                                description:
                                    "シギリヤ、キャンディの文化的ランドマーク、エッラの絵のように美しい風景を3日間の忘れられない旅で探索してください。",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "キャンディ/ヌワラエリヤ/エッラ/ヤーラ",
                                duration: "3日間",
                                location: "キャンディ/ヌワラエリヤ/エッラ/ヤーラ - スリランカ",
                                description:
                                    "キャンディの文化からヤーラの野生動物まで、スリランカの多様なハイライトを3日間の没入型ツアーで発見してください。",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "シギリヤ/アヌラーダプラ/ポロンナルワ/ミンネリヤ国立公園サファリ",
                                duration: "3日間",
                                location: "シギリヤ/アヌラーダプラ/ポロンナルワ/ミンネリヤ国立公園 - スリランカ",
                                description:
                                    "シギリヤ、アヌラーダプラ、ポロンナルワの古代都市を訪れ、ミンネリヤ国立公園でサファリを楽しんでください。",
                            },
                            twentyDayTour: {
                                title: "最大20日間のツアーパッケージ",
                                duration: "20日間",
                                location: "スリランカ",
                                description:
                                    "スリランカを20日間かけて忘れられない旅に出かけ、ネゴンボからベントータまでの文化的、自然的、歴史的驚異を探索してください。",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "ラバナ滝",
                            nineArchBridge: "九つのアーチ橋",
                            teaPlantation: "茶畑",
                            trainRide: "列車の旅",
                            littleAdamsPeak: "リトルアダムスピーク",
                            udawalaweElephant: "ウダワラウェのゾウの授乳観察",
                            ayurvedicHerbalGarden: "アーユルヴェーダハーブガーデン",
                            templeKandeViharaya: "カンデ・ビハラヤ寺院",
                            turtleHatchery: "ウミガメ孵化場",
                            boatSafari: "ボートサファリ",
                            moonstoneMine: "ムーンストーン鉱山",
                            hikkaduwaBeach: "ヒッカドゥワビーチ - ウミガメと泳ぐ",
                            dutchFortGalle: "ゴールのオランダ要塞",
                            yala: "ヤーラ",
                            yalaSafariJeep: "ヤーラサファリ（ジープ）",
                            kandy: "キャンディ",
                            royalBotanicalGarden: "王立植物園",
                            teaFactoryPlantation: "茶工場とプランテーション",
                            elephantFeeding: "ゾウの餌やり、沐浴、乗馬",
                            ambuluwawaTowerOrTemple: "アンブルワワタワーまたは仏歯寺",
                            jewelleryGemFactory: "ジュエリーと宝石工場",
                            silkFactory: "シルク工場",
                            sigiriya: "シギリヤ",
                            sigiriyaLionRock: "シギリヤライオンロック",
                            dambullaGoldenTemple: "ダンブッラ黄金寺院",
                            villageTour: "伝統的なスリランカ料理付きの村ツアー",
                            pidurangalaRock: "ピドゥランガラロック",
                            udawalawe: "ウダワラウェ",
                            udawalaweNationalPark: "ウダワラウェ国立公園",
                            jeepSafari: "ジープサファリ",
                            elephantMilkFeeding: "ゾウの授乳",
                            lotusTower: "ロータスタワー",
                            redMosque: "赤いモスク",
                            shopping: "ショッピング",
                            blueWhales: "シロナガスクジラ",
                            mirissa: "ミリッサ",
                            stiltFishing: "高床式漁業",
                            bentotaRiver: "ベントータ川",
                            bentota: "ベントータ",
                            safariYalaNationalPark: "ヤーラ国立公園サファリ（ジープ）",
                            gadoladeniyaTemple: "ガドーラデニヤ寺院",
                            templeOfTheToothRelic: "仏歯寺",
                            traditionalKandyanDance: "伝統的なキャンディアンダンス",
                            luxuryHotelStay: "朝食と夕食付きの豪華ホテル滞在",
                            teaFactory: "茶工場",
                            nuwaraEliyaTown: "ヌワラエリヤの町",
                            ambuluwawaTower: "アンブルワワタワー",
                            hinduTemple: "ヒンドゥー寺院",
                            gregoryLake: "グレゴリー湖",
                            postOffice: "郵便局",
                            hortanPlains: "ホートンプレインズ",
                            sitaAmmanHinduKovil: "シータ・アンマン・ヒンドゥー寺院",
                            botanicalGarden: "植物園",
                            rambodaWaterfall: "ランボダ滝",
                            sigiriyaRockFortress: "シギリヤ岩の要塞",
                            anuradhapura: "アヌラーダプラ",
                            polonnaruwa: "ポロンナルワ",
                            minneriyaNationalPark: "ミンネリヤ国立公園",
                            elephants: "ゾウ",
                            day1: "1日目: 空港 – ネゴンボ: ネゴンボへの送迎と早期チェックイン、ムトゥラジャウェラ湿地でのボートツアー、リラクゼーション – 水泳 – くつろぎ – ハンモック – ウェルネス – 日光浴 – スポーツ – ウォータースポーツ、ネゴンボでの宿泊と朝食",
                            day2: "2日目: ネゴンボ – アヌラーダプラ: 聖なる都市アヌラーダプラ（ユネスコ世界遺産）、スリ・マハ・ボディの木、絵のように美しい貯水池の周りを散歩、アヌラーダプラでの宿泊と朝食",
                            day3: "3日目: アヌラーダプラ – ミンネリヤ – ハバラナ: アウカナ仏像、昼食付きのカタマランとトゥクトゥクの村サファリ、ミンネリヤ国立公園でのジープサファリ、ハバラナでの宿泊と朝食",
                            day4: "4日目: ハバラナ – シギリヤ – リティガラ – トリンコマリー: シギリヤ岩の要塞（ユネスコ世界遺産）、リティガラ森林修道院、トリンコマリーでの宿泊と朝食",
                            day5: "5日目: トリンコマリー: リラクゼーション – 水泳 – くつろぎ – ハンモック – ウェルネス – 日光浴 – スポーツ – ウォータースポーツ、トリンコマリーでの宿泊と朝食",
                            day6: "6日目: トリンコマリー: トリンコマリー市内ツアー、ステフィ・バウムルの誕生日、リラクゼーション – 水泳 – くつろぎ – ハンモック – ウェルネス – 日光浴 – スポーツ – ウォータースポーツ、2人の女性のためのサプライズ料理教室、トリンコマリーでの宿泊と朝食",
                            day7: "7日目: トリンコマリー: ピジョン島へのシュノーケリングトリップ、リラクゼーション – 水泳 – くつろぎ – ハンモック – ウェルネス – 日光浴 – スポーツ – ウォータースポーツ、トリンコマリーでの宿泊と朝食",
                            day8: "8日目: トリンコマリー: リラクゼーション – 水泳 – くつろぎ – ハンモック – ウェルネス – 日光浴 – スポーツ – ウォータースポーツ、トリンコマリーでの宿泊と朝食",
                            day9: "9日目: トリンコマリー – ダンブッラ – マタレ – ペラデニヤ – キャンディ: ダンブッラ洞窟寺院（ユネスコ世界遺産）、マタレのスパイスガーデン、ペラデニヤ王立植物園でのピクニック、キャンディ旧市街の散歩、キャンディでの宿泊と朝食",
                            day10: "10日目: キャンディ: キャンディの仏歯寺（ユネスコ世界遺産）、夜のキャンディアンダンスパフォーマンス、キャンディでの宿泊と朝食",
                            day11: "11日目: キャンディ – ヌワラエリヤ – エッラ: 茶畑と茶摘み、茶工場の見学、ランボダ滝、ヌワラエリヤ – 雲の上の町、エッラの散歩、エッラでの宿泊と朝食",
                            day12: "12日目: エッラ – バドゥッラ: エッラからバドゥッラへの列車旅（2等）、エッラ周辺のハイキング、オプション：ジップライニング、エッラでの宿泊と朝食",
                            day13: "13日目: エッラ – ヤーラ: ラバナ滝、エッラギャップバレー、ヤーラ国立公園でのジープサファリ、ティッサマハラマでの宿泊と朝食",
                            day14: "14日目: ヤーラ – ウダワラウェ – シンハラジャ: ゾウの移送施設の餌やり時間訪問、シンハラジャ森林保護区（ユネスコ世界遺産）への移動、シンハラジャでの宿泊と朝食",
                            day15: "15日目: シンハラジャ: シンハラジャ森林保護区（ユネスコ自然遺産）のガイド付きハイキング、シンハラジャでの宿泊と朝食",
                            day16: "16日目: シンハラジャ – ゴール: ゴールの旧市街、ゴール要塞（ユネスコ世界遺産）、ゴールでの宿泊と朝食",
                            day17: "17日目: ゴール – ミリッサ – ベントータ: ミリッサからのオフショアサファリ、ウミガメ保護プロジェクト、ベントータでの宿泊と朝食",
                            day18_19: "18～19日目: ベントータ: リラクゼーション – 水泳 – くつろぎ – ハンモック – ウェルネス – 日光浴 – スポーツ – ウォータースポーツ、ベントータでの宿泊と朝食",
                            day20: "20日目: ベントータ – 空港: 空港への送迎",
                        },
                    },
                    ayurvedaPage: {
                        title: "アーユルヴェーダ - 古代の生命科学",
                        mainDescription: "「アーユルヴェーダ」という言葉は3千年以上存在しています。サンスクリット語でこの言葉は「生命の科学」を意味します。この技術は、通常ヨーロッパの医学と対立する、病気の結果ではなくアーユルヴェーダの癒しの視点に基づいています。以下の原則を提唱しています：",
                        principles: {
                            energyBalance: "体はエネルギーから解放され、正常な代謝および心臓活動のためにバランスを保つ必要があります。",
                            muscleHormonal: "体は正常な筋収縮と定期的なホルモン活動を持つ必要があります。",
                            immuneSystem: "体は適切に機能するために健康な免疫システムが必要です。"
                        },
                        trainingDescription: "最近のデータによると、スリランカにはアーユルヴェーダの訓練を受けた卒業生が6,000人以上います。彼らは7年間の学習と公立病院での2年間の実践を経験します。アーユルヴェーダのプログラムには以下が含まれます：",
                        programs: {
                            stressRelief: "ストレス、疲労、不安の解消",
                            oxygenSaturation: "酸素飽和",
                            muscularToxins: "筋肉システムの刺激と毒素の除去",
                            nervousSystem: "神経系のバランスの回復",
                            bloodFlow: "内臓への血流の回復",
                            endorphins: "エンドルフィンの生成"
                        },
                        images: {
                            mainAlt: "アーユルヴェーダ",
                            faceTreatmentAlt: "アーユルヴェーダ顔のトリートメント",
                            massageTreatmentAlt: "アーユルヴェーダマッサージトリートメント"
                        },
                        treatmentDescription: "標準的な治療には、特別なオイルを使用したボディマッサージと頭皮マッサージ、ハーブサウナトリートメント、ハーブを浸した浴槽が含まれます。最も人気のある技術は「シロダーラ手順」で、温かいハーブオイルをリズミカルに額に滴下します。これにより神経系のバランスを回復し、リラクゼーションを達成します。",
                        tipsTitle: "アーユルヴェーダ治療のヒント",
                        tips: {
                            relaxMind: "問題を忘れてください。最高の結果を得るためにリラックスして心をクリアにしてください。",
                            chooseLocation: "正しい場所を選んでください。最適な癒しのために、快適さと好みに合った環境を選んでください。",
                            selectProgram: "正しいプログラムを選んでください。医師と懸念事項を話し、さまざまな療法を試して自分に最適なものを見つけてください。",
                            warmBath: "治療前に温かいお風呂に入って筋肉をリラックスさせ、体を準備してください。",
                            lightMeal: "手順前に軽い食事をしてください。マッサージ中の適切な血流を確保するために重い食事を避けてください。",
                            postRelaxation: "手順後のリラクゼーションは不可欠です。適切なリラクゼーションはアーユルヴェーダ治療の効果を高めます。"
                        },
                    },
                    ballooningPage: {
                        title: "スリランカでの熱気球",
                        mainDescription: "スリランカでの熱気球は、島の息をのむような風景の上を穏やかに浮かぶ忘れられない体験を提供します。日の出から始まる熱気球のフライトは、なだらかな丘、豊かな森、古代の遺跡、静かな村々の空中からの素晴らしい景色を提供します。",
                        dambullaDescription: "スリランカで最も人気のある熱気球の目的地は、文化三角地帯の中心に位置するダンブッラです。ここでの熱気球フライトは、象徴的なシギリヤ岩の要塞の上を通過することが多く、比類のない視点を提供します。フライトは通常60〜90分続き、スリランカの美しさを上空から存分に楽しむ時間があります。",
                        highlightsTitle: "スリランカで熱気球を試す理由は？",
                        highlightsDescription: "熱気球は冒険と静けさを組み合わせ、スリランカの美しさを独自の方法で体験することができます。熱気球のハイライトには以下が含まれます：",
                        highlights: {
                            panoramicViews: "島の息をのむような風景の途切れないパノラマビュー。",
                            landmarks: "シギリヤ岩や近くの湖などの象徴的なランドマークの上空を飛行。",
                            peacefulRide: "豊かな緑と魅力的な村の上を穏やかで平和な飛行。",
                            sunrise: "空から見る壮観な日の出。",
                            photography: "上空から風光明媚な美しさを捉えたい写真愛好家に最適。"
                        },
                        images: {
                            mainAlt: "スリランカでの熱気球",
                            sunriseAlt: "熱気球の日の出",
                            sunriseCaption: "熱気球で穏やかに浮かびながら、日の出の息をのむような景色を楽しむ。",
                            landscapeAlt: "熱気球の風景",
                            landscapeCaption: "なだらかな丘や豊かな森を含むスリランカの素晴らしい風景を上空から見る。"
                        },
                        tipsTitle: "思い出に残る熱気球フライトのためのヒント",
                        tips: {
                            bookEarly: "熱気球は天候に左右されるため、早めに予約してください。枠はすぐに埋まります。",
                            clothing: "快適な服装を着用し、早朝は涼しいので軽いジャケットを持参してください。",
                            camera: "素晴らしい景色を撮影するためにカメラやスマートフォンを持参してください。",
                            safety: "パイロットが提供する安全指示をよく聞いてください。",
                            arriveEarly: "準備と気球の膨らませを見るために時間通りに到着してください。これは魅力的なプロセスです。"
                        },
                    },
                    divingPage: {
                        title: "スリランカでのダイビング",
                        mainDescription: "スリランカの海岸は、2メートルから40メートルの深さに広がる広大なサンゴ礁に囲まれています。インド洋の温かい水（27°Cから30°C）と、15メートルから35メートルの高い水の透明度は、ダイビングとシュノーケリングに最適な条件を提供します。スリランカでのダイビングでは、未踏のサンゴ礁、古い沈没船、魅惑的な水中洞窟を探索できます。",
                        northeastDescription: "島の北東部では、130種以上の色鮮やかなサンゴが生息し、ウミガメ、クマノミ、ライオンフィッシュ、シーホースなどの海洋生物の住処となっています。水中岩やリーフ近くの沈没船を訪れると、忘れられない体験ができます。透明な水に浮かぶと、セイロンの魅力的な過去に浸ることができます。",
                        facilitiesTitle: "施設と最高のダイビングスポット",
                        facilitiesDescription: "島のダイビングセンターは、有名メーカーの最新のダイビング装備を備えています。PADIおよびCMAS資格を持つ認定インストラクターが、安全で楽しいダイビングを保証します。ダイビングセンターは島の南西海岸にあり、10月中旬から4月末まで営業しています。ニラベリやトリンコマリーを含む北東海岸は、3月から10月までダイビングに最適です。",
                        popularSpots: "西部のカルピティヤ近くのサンゴ礁と、ヒッカドゥワの沈没船ダイビングサイトは、ダイバーにとって最も人気のあるアトラクションです。",
                        images: {
                            mainAlt: "スリランカでのダイビング",
                            coralReefAlt: "サンゴ礁ダイビング",
                            coralReefCaption: "多様な海洋生物の住処である鮮やかなサンゴ礁を探索してください。",
                            shipwreckAlt: "沈没船ダイビング",
                            shipwreckCaption: "スリランカの海洋の過去を垣間見ることができる歴史的な沈没船を発見してください。"
                        },
                        tipsTitle: "ダイバーのためのヒント",
                        tips: {
                            season: "場所に基づいてダイビングに最適な季節を選んでください：南西海岸（10月から4月）または北東海岸（3月から10月）。",
                            certifiedCenter: "安全な体験のために、ダイビングセンターが認定されており、最新の装備を備えていることを確認してください。",
                            instructorAdvice: "特に初心者の場合は、インストラクターのアドバイスに注意深く耳を傾けてください。",
                            respectMarineLife: "サンゴに触れたり水中環境を乱したりしないことで、海洋生物を尊重してください。",
                            camera: "スリランカの水中世界の魅惑的な美しさを捉えるために、防水カメラを持参してください。"
                        },
                    },
                    elephantRidePage: {
                        title: "ゾウの背に乗る",
                        mainDescription: "ゾウのトレッキングは、スリランカでの魅力的でエキサイティングなアクティビティであり、ユニークな体験です。ハバラナ、シギリヤ、またはダンブッラなどの文化三角地帯の近くに滞在している場合、ゾウのサファリに参加できます。これらのライドは、1時間の忘れられない冒険のために約30ドルから始まります。",
                        rideDescription: "ライドの前に、ゾウには4〜6人用のマルチバスケットが装着されます。これらの穏やかな巨人は、風光明媚なジャングルの小道を通り、水で溢れたエリアを渡り、豊かな植生の中を進みます。ゾウは通常ゆっくり歩くので、周囲の自然の美しさを十分に楽しむことができますが、最高で時速40キロに達することができます。",
                        highlightsTitle: "ゾウのライドのハイライト",
                        highlightsDescription: "スリランカでのゾウのライドは、自然とつながり、田園地帯を探索するユニークな方法を提供します。体験のハイライトには以下が含まれます：",
                        highlights: {
                            junglePaths: "エキゾチックな植生と野生動物でいっぱいの密林を歩く。",
                            riverCrossing: "川や洪水地域を渡り、自然の風景の素晴らしい景色を提供する。",
                            culturalConnection: "ゾウとスリランカ文化の密接な関係について学ぶ。",
                            comfortableRide: "ゾウがさまざまな地形を優しく運んでくれる間、快適なサドルでリラックスする。"
                        },
                        images: {
                            mainAlt: "ゾウの背に乗る",
                            jungleAlt: "ゾウのライド ジャングルパス",
                            jungleCaption: "ゾウに乗って密林や風光明媚な小道を探索する。",
                            waterAlt: "ゾウが水を渡る",
                            waterCaption: "川を渡り、水と植生の静かな美しさを楽しむ。"
                        },
                        tipsTitle: "安全で楽しいゾウのライドのためのヒント",
                        tips: {
                            clothing: "アウトドア活動に適した快適な服装と靴を着用してください。",
                            guideInstructions: "安全で楽しいライドのために、ガイドの指示に従ってください。",
                            ethicalPractices: "ゾウが適切に扱われ、ライド提供者が倫理的な慣行に従っていることを確認してください。",
                            camera: "息をのむような風景や瞬間を捉えるためにカメラを持参してください。",
                            respectElephants: "ゾウを尊重し、ストレスを与えたり害を及ぼしたりする行動を避けてください。"
                        },
                    },
                    fishingPage: {
                        title: "スリランカでの釣り",
                        mainDescription: "スリランカは、広大な海岸線と豊富な淡水湖や川により、比類のない釣り体験を提供します。プロの釣り人であろうと趣味の釣り人であろうと、スリランカには何かがあります。深海釣り遠征から地元の漁師が実践する伝統的な棒釣りまで、忘れられない冒険が待っています。",
                        destinationsDescription: "人気の釣りスポットには、ガルやミリッサ周辺の南海岸、ネゴンボラグーン、トリンコマリーの穏やかな海域があります。好みに応じて、トローリング、底釣り、フライフィッシングなど、さまざまな釣り技術を試すことができます。",
                        experiencesTitle1: "スリランカでの釣り体験",
                        experiencesDescription: "スリランカでの釣りは、魚を釣るだけでなく、島の文化や伝統に浸る機会です。ユニークな釣り体験には以下が含まれます：",
                        experiences: {
                            stiltFishingTitle: "棒釣り",
                            stiltFishing: "漁師が海岸近くで魚を釣るために棒に腰掛ける伝統的な方法で、スリランカ独自の習慣です。",
                            deepSeaFishingTitle: "深海釣り",
                            deepSeaFishing: "インド洋に冒険に出て、マーリン、マグロ、バラクーダなどの大型魚を釣ります。",
                            lagoonFishingTitle: "ラグーンと川での釣り",
                            lagoonFishing: "ティラピアやナマズなどの魚が豊富な静かなラグーンや川でリラックスして釣りを楽しむ。",
                            nightFishingTitle: "夜釣り",
                            nightFishing: "星空の下での釣りのスリルを体験し、沿岸の村で一般的な習慣です。"
                        },
                        images: {
                            mainAlt: "スリランカでの釣り",
                            stiltFishingAlt: "スリランカでの棒釣り",
                            stiltFishingCaption: "棒釣りは伝統的な方法であり、スリランカの釣り遺産の象徴的なイメージです。",
                            deepSeaFishingAlt: "スリランカでの深海釣り",
                            deepSeaFishingCaption: "深海釣りは、インド洋で大型魚をターゲットにした冒険的な体験を提供します。"
                        },
                        tipsTitle: "楽しい釣り旅行のためのヒント",
                        tips: {
                            season: "釣り遠征に最適な季節を選んでください。10月から4月は南海岸、3月から10月は東海岸に適しています。",
                            protection: "旅行中に快適に過ごすために、日焼け止め、帽子、保護服を持参してください。",
                            guide: "経験を最大限に活かし、専門家から学ぶために、釣りガイドやチャーターを予約してください。",
                            environment: "ゴミを捨てず、持続可能な釣り慣行を守ることで、地元の環境を尊重してください。",
                            hydration: "長時間の釣り旅行には、水分補給を保ち、スナックを持参してください。"
                        },
                    },
                    jeepSafariPage: {
                        title: "スリランカでのジープサファリ",
                        mainDescription: "スリランカの国立公園は、島の豊かな生物多様性を探索し、自然の生息地で野生動物を観察できるスリリングなジープサファリ体験を提供します。ヤラ国立公園、ウィルパットゥ国立公園、ウダワラウェ国立公園は、ジープサファリで最も人気のある目的地です。",
                        wildlifeDescription: "これらのサファリでは、ゾウ、ヒョウ、ナマケグマ、水牛、ワニ、さまざまな鳥類を観察する機会があります。経験豊富な自然ガイドやトラッカーの指導のもと、ジープサファリは野生動物愛好家や写真家に最適です。",
                        whyChooseTitle: "ジープサファリを選ぶ理由は？",
                        whyChooseDescription: "ジープサファリは、スリランカの多様な野生動物を探索する最良の方法の1つです。以下はハイライトのいくつかです：",
                        whyChoose: {
                            encounters: "ゾウやヒョウなどの象徴的な種との密接な出会い。",
                            remoteAreas: "国立公園内の遠隔で風光明媚なエリアへのアクセス。",
                            photography: "自然環境での野生動物写真の機会。",
                            guidance: "知識豊富な自然ガイドや公園管理者の指導。",
                            adventure: "すべての年齢層に適した、興奮と教育を組み合わせた冒険。"
                        },
                        images: {
                            mainAlt: "スリランカでのジープサファリ",
                            wildlifeAlt: "ジープサファリでの野生動物",
                            wildlifeCaption: "サファリ中にヒョウ、ゾウ、ワニなどの象徴的な野生動物を観察してください。",
                            landscapeAlt: "ジープサファリの風景",
                            landscapeCaption: "密林から開けた平原まで、スリランカの国立公園の素晴らしい風景を探索してください。"
                        },
                        tipsTitle: "楽しいジープサファリのためのヒント",
                        tips: {
                            clothing: "環境に溶け込むため、快適で中間色の服装を着てください。",
                            protection: "保護のために日焼け止め、帽子、虫よけを持参してください。",
                            equipment: "体験を高め、野生動物を捉えるために、双眼鏡とカメラを持参してください。",
                            guide: "動物への安全性と敬意を確保するために、ガイドの指示に従ってください。",
                            booking: "特にピークシーズンには、早めにサファリを予約して場所を確保してください。"
                        },
                    },
                    riverSafariPage: {
                        title: "スリランカでのリバーサファリ",
                        mainDescription: "スリランカでのリバーサファリは、島の豊かな生物多様性と風光明媚な美しさを探索するユニークな方法を提供します。緑豊かなマングローブに囲まれた静かな水路を滑り、エキゾチックな野生動物を観察し、魅了される絵のように美しい夕日を楽しんでください。",
                        destinationsDescription: "人気のリバーサファリの目的地には、マドゥガンガ（マドゥ川）とベントータ川があります。これらのサファリでは、さまざまな鳥類、トカゲ、ワニ、さらにはサルを自然の生息地で観察する機会があります。静かな環境は自然愛好家や写真家に最適です。",
                        whyChooseTitle: "リバーサファリを選ぶ理由は？",
                        whyChooseDescription: "リバーサファリは、自然、野生動物、文化探検を組み合わせたリラックスした没入型の体験です。以下はハイライトのいくつかです：",
                        whyChoose: {
                            mangroves: "生命に満ちた緑豊かなマングローブを探検する。",
                            wildlife: "エキゾチックな鳥、ワニ、その他の野生動物を観察する。",
                            villages: "川沿いの小さな島や地元の村を訪れる。",
                            tranquility: "スリランカの水路の静けさと絵のように美しい美しさを楽しむ。",
                            suitable: "家族、カップル、平和な逃避行を求める一人旅に最適。"
                        },
                        images: {
                            mainAlt: "スリランカでのリバーサファリ",
                            mangrovesAlt: "リバーサファリでのマングローブ",
                            mangrovesCaption: "スリランカの風光明媚な水路を縁取る緑豊かなマングローブを発見する。",
                            wildlifeAlt: "リバーサファリでの野生動物",
                            wildlifeCaption: "サファリ中にワニ、トカゲ、カラフルな鳥などのエキゾチックな野生動物を観察する。"
                        },
                        tipsTitle: "楽しいリバーサファリのためのヒント",
                        tips: {
                            clothing: "快適な服装を着て、保護のために帽子と日焼け止めを持参してください。",
                            binoculars: "遠くの野生動物や鳥を観察するために双眼鏡を持参してください。",
                            camera: "素晴らしい景色や野生動物を捉えるためにカメラまたはスマートフォンを持参してください。",
                            guide: "安全で楽しい体験のためにガイドの指示に従ってください。",
                            environment: "ゴミを捨てず、野生動物を邪魔しないことで自然環境を尊重してください。"
                        },
                    },
                    snorkelingPage: {
                        title: "スリランカでのシュノーケリング",
                        mainDescription: "スリランカでのシュノーケリングは、鮮やかなサンゴ礁と多様な海洋生物を探索できる忘れられない水中体験を提供します。透明な海水と豊富な水生生態系により、スリランカはあらゆるスキルレベルのシュノーケラーにとって楽園です。",
                        destinationsDescription: "最も人気のあるシュノーケリングスポットには、色とりどりのサンゴ庭園とウミガメで知られるヒッカドゥワ、トリンコマリーのピジョンアイランド、原生のサンゴ礁で有名な場所、そしてミリッサがあり、シュノーケリングシーズン中にクジラを1頭か2頭見かけることもあります。",
                        whyChooseTitle: "スリランカでシュノーケリングを選ぶ理由は？",
                        whyChooseDescription: "スリランカでのシュノーケリングは、冒険と自然の美しさを組み合わせた魔法のような体験です。以下はハイライトのいくつかです：",
                        whyChoose: {
                            coralReefs: "生命に満ちた鮮やかなサンゴ礁を探索する。",
                            marineLife: "色とりどりの熱帯魚、ウミガメ、さらにはリーフシャークと一緒に泳ぐ。",
                            landscapes: "透明で温かい水中の手つかずの水中景観を発見する。",
                            suitable: "初心者から経験豊富なシュノーケラーまで適している。",
                            accessible: "スリランカの最高のビーチ目的地からアクセス可能。"
                        },
                        images: {
                            mainAlt: "スリランカでのシュノーケリング",
                            coralReefAlt: "スリランカのサンゴ礁",
                            coralReefCaption: "見事なサンゴ礁とその活気ある生態系を発見する。",
                            marineLifeAlt: "スリランカの海洋生物",
                            marineLifeCaption: "ウミガメ、熱帯魚など、多様な海洋生物に遭遇する。"
                        },
                        tipsTitle: "思い出に残るシュノーケリング体験のためのヒント",
                        tips: {
                            mask: "水中でクリアな視界を確保するために、快適なマスクとシュノーケルを着用してください。",
                            sunscreen: "肌と海洋生物を保護するために、サンゴに安全な日焼け止めを使用してください。",
                            swimGently: "サンゴ礁や水生生物を邪魔しないように、優しく泳いでください。",
                            hydration: "水分を補給し、セッションの間に休憩を取ってください。",
                            guidedTour: "最高のシュノーケリングスポットと安全のためのヒントを得るために、ガイド付きツアーに参加してください。"
                        },
                    },
                    teaTastingPage: {
                        title: "スリランカでのティーテイスティングツアー",
                        mainDescription: "「インド洋の真珠」としばしば呼ばれるスリランカは、世界クラスの紅茶生産で有名です。ティーテイスティングツアーに参加して、ヌワラエリヤ、エッラ、キャンディなどの地域の緑豊かな茶畑を探索してください。紅茶栽培の芸術、紅茶生産の緻密なプロセスを学び、本物のセイロン紅茶の豊かな風味を味わいます。",
                        heritageDescription: "紅茶愛好家であろうと単に興味があるだけでも、ティーテイスティングツアーはスリランカの紅茶遺産に深く潜り込み、その高地の静かな美しさを体験するユニークな機会を提供します。",
                        whyChooseTitle: "ティーテイスティングツアーを選ぶ理由は？",
                        whyChooseDescription: "スリランカでのティーテイスティングツアーは、紅茶を味わうだけでなく、没入型の文化的体験です。以下はハイライトのいくつかです：",
                        whyChoose: {
                            plantations: "涼しい高地に位置する絵のように美しい茶畑を訪れる。",
                            history: "セイロン紅茶の歴史と重要性を学ぶ。",
                            production: "茶摘みに参加し、茶工場での生産プロセスを観察する。",
                            varieties: "黒茶から緑茶、フレーバーブレンドまで、さまざまな紅茶を楽しむ。",
                            scenery: "霧のかかった山々や滝の息をのむような景色を楽しむ。"
                        },
                        images: {
                            mainAlt: "スリランカでのティーテイスティングツアー",
                            teaPlantationAlt: "スリランカの茶畑",
                            teaPlantationCaption: "緑豊かな茶畑を探索し、紅茶栽培について学ぶ。",
                            teaPreparationAlt: "スリランカでの紅茶調理",
                            teaPreparationCaption: "紅茶調理の芸術を発見し、本物のセイロン紅茶を味わう。"
                        },
                        tipsTitle: "楽しいティーテイスティングツアーのためのヒント",
                        tips: {
                            clothing: "プランテーションを歩くために快適な服と靴を着てください。",
                            jacket: "高地は涼しく霧がかかることがあるので、軽いジャケットを持参してください。",
                            varieties: "さまざまな紅茶を試し、お気に入りを土産として持ち帰ってください。",
                            questions: "ツアー中に質問して、紅茶製造プロセスについてもっと学んでください。",
                            attractions: "茶ツアーを近くの滝や展望台への訪問と組み合わせてください。"
                        },
                    },
                    templeVisitPage: {
                        title: "スリランカでの寺院訪問",
                        mainDescription: "仏の国として知られるスリランカは、豊かな精神的および文化的遺産を反映する古代の寺院が点在しています。キャンディの仏歯寺、ダンブッラの洞窟寺院、アヌラーダプラのルワンウェリサーヤなどの象徴的な寺院を探索する旅に出ましょう。",
                        spiritualDescription: "複雑な彫刻、壁画、像で飾られたこれらの聖地は、島の精神的伝統と建築の輝きを垣間見ることができます。寺院訪問は文化的な体験だけでなく、平和と静けさを見つける機会でもあります。",
                        whyVisitTitle: "スリランカの寺院を訪れる理由は？",
                        whyVisitDescription: "スリランカの寺院を訪れることは、島の歴史、文化、霊性とつながるユニークな機会を提供します。以下はハイライトのいくつかです：",
                        whyVisit: {
                            architecture: "複雑な建築と何世紀も前の像を賞賛する。",
                            traditions: "知識豊富なガイドから仏教の伝統と儀式について学ぶ。",
                            heritage: "ダンブッラの黄金寺院のようなユネスコ世界遺産を探索する。",
                            serenity: "聖なる空間の静けさと霊的な雰囲気を感じる。",
                            festivals: "仏歯寺でのエサラ・ペラヘラのような活気ある祭りを目撃する。"
                        },
                        images: {
                            mainAlt: "スリランカでの寺院訪問",
                            templeInteriorAlt: "寺院の内部",
                            templeInteriorCaption: "複雑な彫刻と壁画で飾られた見事な内部を賞賛する。",
                            sacredTempleAlt: "スリランカの聖なる寺院",
                            sacredTempleCaption: "ルワンウェリサーヤのような聖なる寺院を訪れ、霊的な伝統に浸る。"
                        },
                        tipsTitle: "スリランカの寺院訪問のためのヒント",
                        tips: {
                            dress: "敬意を示すために、肩と膝を覆う控えめな服装をしてください。",
                            shoes: "寺院の敷地に入る前に靴を脱いでください。",
                            touching: "像や聖なるオブジェクトに触れないようにしてください。",
                            donation: "貢献したい場合は、寺院のための小さな寄付を持参してください。",
                            silence: "訪問中に静寂と霊的な雰囲気を尊重してください。"
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "スリランカでのホワイトウォーターラフティング",
                        mainDescription: "スリランカでのホワイトウォーターラフティングは、島の冒険の中心地であるキツルガラで特にスリリングな体験です。ケラニ川は、その轟音の急流と美しい周辺環境で、初心者から経験豊富なラフティング愛好者まで完璧な舞台を提供します。",
                        destinationsDescription: "ラフティングの遠征は通常、2級から4級の急流を持つ5キロメートルの区間をカバーします。参加者は挑戦的な流れを航行する興奮を楽しみながら、緑豊かな自然と川岸の息をのむような景色を堪能できます。",
                        whyChooseTitle: "スリランカでホワイトウォーターラフティングを選ぶ理由は？",
                        whyChooseDescription: "スリランカでのホワイトウォーターラフティングは、冒険と自然の美しさを独自に組み合わせたものです。体験のハイライトは以下の通りです：",
                        whyChoose: {
                            rapids: "経験豊富なインストラクターの指導の下、スリリングな急流を航行する。",
                            views: "周辺の熱帯雨林や山岳地帯の素晴らしい景色を楽しむ。",
                            activities: "キツルガラでのトレッキング、野鳥観察、キャニオニングなどの他のアクティビティとラフティングを組み合わせる。",
                            suitable: "グループ、家族、またはアドレナリンラッシュを求める一人旅に最適。"
                        },
                        images: {
                            mainAlt: "スリランカでのホワイトウォーターラフティング",
                            actionRaftingAlt: "ホワイトウォーターラフティングのアクション",
                            actionRaftingCaption: "ケラニ川の挑戦的な急流を征服しながらアドレナリンの急上昇を感じる。",
                            scenicRaftingAlt: "ホワイトウォーターラフティングの景色",
                            scenicRaftingCaption: "ラフティングの冒険中に緑豊かな周辺の穏やかな美しさを楽しむ。"
                        },
                        tipsTitle: "安全でエキサイティングなラフティング旅行のためのヒント",
                        tips: {
                            safetyGear: "安全のために、ラフティングガイドが提供するライフジャケットとヘルメットを着用してください。",
                            instructions: "旅行開始前に安全指示を注意深く聞いてください。",
                            clothing: "快適で速乾性の衣服と、ウォーターシューズのようなしっかりした靴を着用してください。",
                            changeOfClothes: "旅行後に備えて着替えとタオルを持参してください。",
                            operator: "安全で楽しい体験を保証するために、信頼できるオペレーターでラフティング旅行を予約してください。"
                        },
                    },
                    wildlifeSafariPage: {
                        title: "スリランカでの野生動物サファリ",
                        mainDescription: "スリランカは、その豊かな生物多様性で知られ、ヤラ、ウィルパットゥ、ミンネリヤ、ウダワラウェなどの国立公園で素晴らしい野生動物サファリを提供します。これらのサファリでは、ゾウ、ヒョウ、ナマケグマ、さまざまな鳥類を自然の生息地で観察する機会があります。",
                        destinationsDescription: "密林から開けた草原まで多様な風景を探索し、野生動物のアクションの忘れられない瞬間を捉えます。専門のガイドとよく整備されたサファリジープを備えたスリランカの野生動物サファリは、自然愛好家や冒険を求める人々にとって必見です。",
                        whyChooseTitle: "野生動物サファリを選ぶ理由は？",
                        whyChooseDescription: "スリランカの野生動物サファリは、自然とつながり、島の驚くべき生物多様性を探索するユニークな機会を提供します。ハイライトには以下が含まれます：",
                        whyChoose: {
                            species: "ゾウ、ヒョウ、ワニなどの象徴的な種を観察する。",
                            landscapes: "野生動物で賑わう豊かな森、湿地、開けた平原を探索する。",
                            photography: "自然環境での見事な野生動物写真を撮影する。",
                            elusiveAnimals: "スリランカヒョウのような捉えどころのない動物を見つけるスリルを体験する。",
                            conservation: "経験豊富なガイドや自然保護者から保全活動について学ぶ。"
                        },
                        images: {
                            mainAlt: "スリランカでの野生動物サファリ",
                            elephantsAlt: "スリランカのゾウ",
                            elephantsCaption: "スリランカの国立公園で自由に歩き回る堂々としたゾウを観察する。",
                            leopardAlt: "スリランカヒョウ",
                            leopardCaption: "どんな野生動物サファリのハイライトでもある、捉えどころのないスリランカヒョウを見つける。"
                        },
                        tipsTitle: "エキサイティングな野生動物サファリのためのヒント",
                        tips: {
                            clothing: "環境に溶け込むために中立色の服を着てください。",
                            protection: "日焼け止め、帽子、虫よけ剤を携帯してください。",
                            equipment: "野生動物を観察し撮影するために、双眼鏡とカメラを持参してください。",
                            guide: "安全で楽しい体験のためにガイドの指示に従ってください。",
                            booking: "特にピークシーズンには、人気の公園でスポットを確保するために早めに予約してください。"
                        },
                    },
                },
            },
            zh: {
                translation: {
                    home: '首页',
                    about: '关于我们',
                    srilanka: '斯里兰卡',
                    excursions: '短途旅行',
                    tour: '预订游览',
                    things: '可以做的事情',
                    contact: {
                        navLabel: '联系我们',
                        getInTouch: '取得联系',
                        address: '地址',
                        mobile: '手机',
                        email: '电子邮件',
                        website: '网站',
                        sendMessage: '给我们发送消息',
                        fullName: '全名',
                        fullNamePlaceholder: '输入您的全名',
                        country: '国家',
                        countryPlaceholder: '输入您的国家',
                        emailPlaceholder: '输入您的电子邮件',
                        subject: '主题',
                        subjectPlaceholder: '输入主题',
                        message: '消息',
                        messagePlaceholder: '输入您的消息',
                        reset: '重置',
                        submit: '提交',
                        ourLocation: '我们的位置',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Ashan Tours Sri Lanka 客人消息',
                        manualMessage: '请手动将以下消息发送至',
                        errorMessage: '发生错误。请手动将以下消息发送至',
                    },
                    footerSection: {
                        ashanTours: '阿尚斯里兰卡旅游',
                        getInTouch: '联系我们',
                        address: '斯里兰卡，贝鲁瓦拉，莫拉加拉，马拉达纳路293/C/3',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: '保持联系',
                        emailPlaceholder: '请输入您的电子邮件地址',
                        socialMedia: {
                            facebook: '脸书',
                            instagram: '照片墙',
                            youtube: '优酷',
                            twitter: '推特',
                        },
                        copyright: '© {{year}} 阿尚斯里兰卡旅游。保留所有权利。',
                        designedBy: '网站由Redev Solutions设计与开发',
                        designedByPhone: '+94 76 460 8225',
                    },
                    aboutSection: {
                        travelWithAshan: '与Ashan Tours Sri Lanka一起旅行',
                        imageAlt: 'Ashan Tours 图片 {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lanka是您值得信赖的旅行伙伴，为您打造斯里兰卡的难忘旅程。凭借我们对探索的热情和经验丰富的专业团队，我们致力于提供个性化的行程、专业的指导和卓越的服务，让您的假期真正特别。',
                        introParagraph2: '我们的旅行线路经过精心设计，旨在捕捉斯里兰卡的精髓——从阳光普照的海滩和风景如画的山区，到古老的文化瑰宝和充满活力的野生动物。在Ashan Tours Sri Lanka，我们致力于提供让您发现岛屿美丽与灵魂的真实体验。',
                        introParagraph3: '无论您是寻求冒险、宁静的休憩还是文化沉浸，Ashan Tours Sri Lanka都提供量身定制的套餐，以满足您的愿望。加入我们，让我们带您踏上一段充满惊奇、发现和持久记忆的旅程。',
                        cinnamonLuxuryVilla: '肉桂豪华别墅',
                        villaImageAlt: '肉桂豪华别墅 图片 {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lanka自豪地推出我们的肉桂豪华别墅，为寻求舒适与优雅的旅行者提供高端住宿。我们的两个独特公寓旨在在斯里兰卡的中心地带提供家一般的体验。',
                        villaParagraph2: '每间公寓都配备了现代化设施，包括空调、独立浴室、豪华双人床和设备齐全的厨房。无论您是独自旅行、情侣出游还是与家人同行，我们的别墅提供奢华与便利的完美结合。',
                        villaParagraph3: '坐落在宁静的环境中，肉桂豪华别墅让您在探索斯里兰卡奇观一天后放松身心。与Ashan Tours Sri Lanka预订您的住宿，体验无与伦比的热情款待。',
                    },
                    sriLankaSection: {
                        discoverSriLanka: '发现斯里兰卡',
                        mainImageAlt: '斯里兰卡',
                        pearlOfIndianOcean: '印度洋明珠',
                        introParagraph1: '斯里兰卡，被亲切地称为“{{pearl}}”，是一个令人叹为观止的岛屿天堂，以其壮丽的风景、根深蒂固的传统和多彩的文化而闻名。',
                        introParagraph2: '斯里兰卡拥有超过2500年的文明历史，是宏伟的古代首都、神圣的宗教地标和联合国教科文组织世界遗产的所在地。其文化织锦受到印度、阿拉伯、葡萄牙、荷兰和英国的影响，提供了穿越时间的迷人旅程。',
                        introParagraph3: '岛上的景观令人惊叹——从金色的沙滩和连绵的绿色茶园到雾气缭绕的山峰。其野生动物保护区为大象、豹子和色彩鲜艳的鸟类提供了庇护，是自然爱好者的梦想之地。',
                        introParagraph4: '对于寻求冒险的人来说，斯里兰卡提供冲浪、徒步旅行、浮潜和潜水。融合了芳香香料、新鲜海鲜和热带水果的美食大胆而美味，诉说着岛上丰富的烹饪遗产。',
                        introParagraph5: '无论是在永恒的遗迹中漫步、在宁静的海滩上放松，还是享受热情的款待，斯里兰卡都提供了一次难忘的旅行体验。',
                        attractivePlaces: '斯里兰卡的迷人景点',
                        viewMore: '查看更多',
                        placeImageAlt: '{{name}} 图片 {{index}}',
                        fullImagePreviewAlt: '全尺寸预览',
                        famousThingsTitle: '斯里兰卡的著名事物',
                        places: {
                            sigiriyaRockFortress: {
                                name: '锡吉里亚岩石堡垒',
                                description: '锡吉里亚岩石堡垒是联合国教科文组织世界遗产，也是斯里兰卡最具标志性的地标之一。它以古老的花园、壁画和岩顶的壮观景色为特色。',
                            },
                            templeOfTheTooth: {
                                name: '佛牙寺',
                                description: '位于康提的圣佛牙寺是一座神圣的佛教场所，供奉着佛陀的牙齿遗物。游客可以感受到其历史和宗教意义。',
                            },
                            ella: {
                                name: '埃拉',
                                description: '埃拉是斯里兰卡丘陵地区的一个小镇，周围环绕着茶园和瀑布。它以九拱桥和小亚当峰而闻名。',
                            },
                            yalaNationalPark: {
                                name: '雅拉国家公园',
                                description: '雅拉国家公园以其丰富的野生动物而闻名，包括大象、豹子和众多鸟类。自然爱好者必须体验这里的野生动物园。',
                            },
                            galleFort: {
                                name: '加勒堡',
                                description: '加勒堡由葡萄牙人建造，荷兰人加固，是一座历史遗迹，拥有鹅卵石街道、殖民地建筑和充满活力的咖啡馆。',
                            },
                            nuwaraEliya: {
                                name: '努沃勒埃利耶',
                                description: '被誉为“小英格兰”的努沃勒埃利耶是一个以凉爽气候、茶园和殖民时期平房而闻名的山地车站。',
                            },
                            adamsPeak: {
                                name: '亚当峰',
                                description: '亚当峰是一座顶部有独特足迹的神圣山峰，是多种宗教的热门朝圣地。',
                            },
                            hortonPlains: {
                                name: '霍顿平原',
                                description: '霍顿平原国家公园以连绵起伏的丘陵、瀑布和著名的世界尽头观景台为特色。',
                            },
                            bentotaBeach: {
                                name: '本托塔海滩',
                                description: '本托塔海滩是一个原始的沿海目的地，以金色沙滩、水上运动和豪华度假村而闻名。',
                            },
                            jaffna: {
                                name: '贾夫纳',
                                description: '位于斯里兰卡北部的贾夫纳以泰米尔文化、历史遗迹和美味佳肴而闻名。',
                            },
                            anuradhapura: {
                                name: '阿努拉德普勒',
                                description: '阿努拉德普勒是一座古老城市，以其神圣的佛教场所和历史遗迹而闻名，包括斯里摩诃菩提树。',
                            },
                            polonnaruwa: {
                                name: '波隆纳鲁沃',
                                description: '波隆纳鲁沃是联合国教科文组织世界遗产，拥有古老的寺庙、雕像和保存完好的遗迹。',
                            },
                            unawatunaBeach: {
                                name: '乌纳瓦图纳海滩',
                                description: '乌纳瓦图纳海滩是一个充满活力的沿海目的地，提供浮潜、日光浴和热闹的夜生活。',
                            },
                            colomboCity: {
                                name: '科伦坡市',
                                description: '科伦坡是斯里兰卡繁华的首都，融合了现代摩天大楼、殖民地建筑和充满活力的市场。',
                            },
                            udawalawaNationalPark: {
                                name: '乌达瓦拉维国家公园',
                                description: '乌达瓦拉维国家公园是一个野生动物天堂，以其庞大的大象群、多样的鸟类和壮丽的景观而闻名，是自然爱好者的必游之地。',
                            },
                            dambullaCaveTemple: {
                                name: '丹布拉洞窟寺庙',
                                description: '丹布拉洞窟寺庙是联合国教科文组织世界遗产，以洞窟内的古老佛教壁画和雕像为特色。',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: '锡兰茶',
                                description: '斯里兰卡以其锡兰茶而闻名于世，以其独特的风味和品质而著称。来自努沃勒埃利耶、乌瓦和迪姆布拉地区的茶叶尤为著名。',
                            },
                            spices: {
                                title: '香料',
                                description: '斯里兰卡几个世纪以来一直是肉桂、豆蔻、丁香和肉豆蔻等香料的中心。斯里兰卡肉桂被认为是世界上最好的。',
                            },
                            gems: {
                                title: '宝石和珠宝',
                                description: '斯里兰卡被称为“宝石之岛”，以其蓝宝石、红宝石和月光石而闻名。“亚洲蓝铃”是这里发现的最大蓝宝石之一。',
                            },
                            ayurveda: {
                                title: '阿育吠陀',
                                description: '斯里兰卡以其阿育吠陀医学和健康疗法而闻名。受欢迎的服务包括按摩、草药疗法和阿育吠陀度假村。',
                            },
                            handicrafts: {
                                title: '传统手工艺品',
                                description: '斯里兰卡生产精美的手工艺品，包括来自安巴兰戈达的面具、蜡染纺织品、木雕和漆器。',
                            },
                            elephants: {
                                name: '大象',
                                description: '斯里兰卡大象在文化和节日中扮演着重要角色。盛装打扮的大象出现在埃萨拉佩拉赫拉等游行中。',
                            },
                            food: {
                                title: '传统美食',
                                description: '斯里兰卡以其美味的菜肴而闻名，包括米饭和咖喱、煎饼、科托罗蒂、波尔桑博和瓦塔拉帕姆。',
                            },
                            festivals: {
                                title: '节日',
                                description: '斯里兰卡庆祝色彩缤纷的节日，如埃萨拉佩拉赫拉、僧伽罗和泰米尔新年以及卫塞节，伴有灯光装饰和游行。',
                            },
                            coconut: {
                                title: '椰子产品',
                                description: '斯里兰卡以椰子产品闻名，如椰子油、椰奶和椰壳纤维，用于制作绳子和垫子。',
                            },
                            sarees: {
                                title: '斯里兰卡纱丽',
                                description: '康提纱丽（奥萨里亚）是女性的传统服饰，以其优雅和独特的披挂风格而闻名，在仪式场合穿着。',
                            },
                            dances: {
                                title: '传统舞蹈',
                                description: '斯里兰卡的传统舞蹈包括康提舞、魔鬼舞和低地舞，灵感来源于自然和民间传说。',
                            },
                            stiltFishing: {
                                title: '高跷捕鱼',
                                description: '斯里兰卡的标志性景象，高跷捕鱼涉及渔民在插入海中的杆子上保持平衡，这是南部沿海地区独有的。',
                            },
                            moonstones: {
                                title: '月光石',
                                description: '斯里兰卡以其被视为半宝石的月光石而闻名。梅蒂亚戈达的月光石矿尤其著名。',
                            },
                            cricket: {
                                title: '斯里兰卡板球',
                                description: '板球是斯里兰卡人的热情所在，该国以培养世界级选手而闻名。斯里兰卡在1996年赢得了国际板球理事会世界杯。',
                            },
                            herbs: {
                                title: '阿育吠陀草药和香料',
                                description: '该岛生产用于阿育吠陀的草药，如积雪草、肉桂和楝树。',
                            },
                            masks: {
                                title: '面具',
                                description: '来自安巴兰戈达的传统斯里兰卡面具用于文化表演，包括亚克沙（魔鬼面具）和科拉姆面具。',
                            },
                        },
                    },
                    excursionsSection: {
                        title: '短途旅行',
                        excursions: {
                            oneDay: {
                                title: '一日游',
                                description: '通过导游带领的游览和当地体验，在一天内探索迷人的目的地。',
                                alt: '斯里兰卡一日游',
                            },
                            twoDays: {
                                title: '两日游',
                                description: '享受带过夜的短途旅行，体验更多斯里兰卡的魅力。',
                                alt: '斯里兰卡两日游',
                            },
                            threeDays: {
                                title: '三日游',
                                description: '在三天的冒险与放松中，发现多个景点。',
                                alt: '斯里兰卡三日游',
                            },
                            fourDays: {
                                title: '四日游',
                                description: '适合舒适地游览多个目的地的延长旅程。',
                                alt: '斯里兰卡四日游',
                            },
                            twentyDays: {
                                title: '20日游',
                                description: '踏上穿越斯里兰卡的史诗之旅，探索其文化、自然和历史奇迹。',
                                alt: '斯里兰卡20日游',
                            },
                        },
                        bentotaExcursions: {
                            title: '从本托塔出发的短途旅行',
                            bentotaToYala: {
                                title: '本托塔到雅拉',
                                description: '本托塔 -> 埃拉 -> 雅拉',
                            },
                            bentotaToNuwaraEliya: {
                                title: '本托塔到努沃勒埃利耶',
                                description: '本托塔 -> 埃拉 -> 康提 -> 努沃勒埃利耶',
                            },
                            bentotaToMinneriya: {
                                title: '本托塔到米尼日亚国家公园',
                                description: '本托塔 -> 锡吉里亚 -> 阿努拉德普勒 -> 波隆纳鲁沃 -> 米尼日亚国家公园',
                            },
                            bentotaToHortonPlains: {
                                title: '本托塔到霍顿平原',
                                description: '本托塔 -> 康提 -> 努沃勒埃利耶 -> 霍顿平原',
                            },
                            images: {
                                bentotaToElla1: '本托塔海滩景观1',
                                bentotaToElla2: '本托塔海滩景观2',
                            },
                        },
                        airportExcursions: {
                            title: '从机场出发的短途旅行',
                            airportToColombo: {
                                title: '从机场到科伦坡市内游',
                                description: '机场 -> 科伦坡堡 -> 加勒菲斯 -> 甘加拉马亚寺',
                                alt1: '科伦坡市内游图片1',
                                alt2: '科伦坡市内游图片2',
                            },
                            airportToSigiriya: {
                                title: '从机场到锡吉里亚',
                                description: '机场 -> 丹布拉 -> 锡吉里亚岩石堡垒',
                                alt1: '锡吉里亚短途旅行图片1',
                                alt2: '锡吉里亚短途旅行图片2',
                            },
                            airportToKandy: {
                                title: '从机场到康提',
                                description: '机场 -> 平纳瓦拉大象孤儿院 -> 康提佛牙寺',
                                alt1: '康提短途旅行图片1',
                                alt2: '康提短途旅行图片2',
                            },
                            airportToGalle: {
                                title: '从机场到加勒',
                                description: '机场 -> 本托塔 -> 加勒堡 -> 乌纳瓦图纳海滩',
                                alt1: '加勒短途旅行图片1',
                                alt2: '加勒短途旅行图片2',
                            },
                        },
                    },
                    thingsToDoSection: {
                        title: '斯里兰卡的活动',
                        viewMore: '查看更多',
                        activities: {
                            ayurveda: {
                                title: '阿育吠陀 - 古老的生命科学',
                                alt: '斯里兰卡的阿育吠陀疗法',
                            },
                            diving: {
                                title: '斯里兰卡潜水',
                                alt: '斯里兰卡潜水体验',
                            },
                            elephantRide: {
                                title: '骑大象',
                                alt: '斯里兰卡骑大象体验',
                            },
                            fishing: {
                                title: '斯里兰卡钓鱼',
                                alt: '斯里兰卡钓鱼活动',
                            },
                            ballooning: {
                                title: '斯里兰卡热气球',
                                alt: '斯里兰卡热气球体验',
                            },
                            jeepSafari: {
                                title: '吉普车Safari',
                                alt: '斯里兰卡吉普车Safari',
                            },
                            whiteWaterRafting: {
                                title: '激流漂流',
                                alt: '斯里兰卡激流漂流',
                            },
                            riverSafari: {
                                title: '河上Safari',
                                alt: '斯里兰卡河上Safari',
                            },
                            snorkeling: {
                                title: '斯里兰卡浮潜',
                                alt: '斯里兰卡浮潜体验',
                            },
                            teaTasting: {
                                title: '茶叶品鉴之旅',
                                alt: '斯里兰卡茶叶品鉴之旅',
                            },
                            templeVisit: {
                                title: '寺庙参观',
                                alt: '斯里兰卡寺庙参观',
                            },
                            wildlifeSafari: {
                                title: '野生动物Safari',
                                alt: '斯里兰卡野生动物Safari',
                            },
                        },
                    },
                    homeHeroSection: {
                        title: '与阿尚斯里兰卡同行',
                        subtitle: '探索斯里兰卡迷人的美景，体验难忘的冒险',
                        bookButton: '预订您的旅程',
                        videoFallback: '您的浏览器不支持视频标签。',
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: '为什么选择Ashan Tours Sri Lanka',
                            specialist: {
                                title: '旅行专业知识',
                                description: 'Ashan Tours Sri Lanka的团队由经验丰富的旅行专家组成，根据您的喜好打造定制旅程。'
                            },
                            experience: {
                                title: '难忘的体验',
                                description: '我们通过热情展示斯里兰卡丰富的文化、历史和自然美景，创造令人难忘的时刻。'
                            },
                            priceMatch: {
                                title: '有竞争力的价格',
                                description: 'Ashan Tours Sri Lanka保证为您提供最具价值的旅行，以实惠的价格提供高质量的体验。'
                            },
                            support: {
                                title: '专业支持',
                                description: '我们的24/7客户支持团队随时为您提供帮助，确保旅程顺畅无忧。'
                            }
                        },
                        welcome: {
                            title: '欢迎体验Ashan Tours Sri Lanka',
                            imageAlt: 'Ashan Tours Sri Lanka欢迎图片',
                            description1: '与Ashan Tours Sri Lanka一起踏上非凡旅程，探索这个岛屿天堂的奇观。',
                            description2: '通过我们精心策划的旅行团，发现斯里兰卡充满活力的文化、壮丽的风景和隐藏的瑰宝。',
                            description3: '从原始的海滩到古老的遗迹，我们的行程旨在让您沉浸在斯里兰卡的美景中。',
                            description4: '我们的专业团队提供个性化服务，确保您的旅行体验顺畅且难忘。',
                            description5: '加入Ashan Tours Sri Lanka，体验充满发现和快乐的冒险之旅。'
                        },
                        cinnamonLuxuryVilla: {
                            title: '肉桂豪华别墅',
                            imageAlt: '肉桂豪华别墅图片',
                            description1: '在Ashan Tours Sri Lanka的肉桂豪华别墅中体验无与伦比的舒适，享受宁静环境中的高端住宿。',
                            description2: '我们的独家别墅配备了空调、豪华床铺和全套厨房等现代化设施，非常适合放松度假。',
                            readMore: '了解更多'
                        },
                        tourPackages: {
                            title: '我们的旅游套餐',
                            ella: {
                                title: '埃拉冒险',
                                subtitle: '3天 / 2晚',
                                description: '与Ashan Tours Sri Lanka一起探索埃拉的风景之美，包括参观九拱桥和小亚当峰。',
                                alt: '埃拉旅游图片'
                            },
                            ellaNuwaraKandy: {
                                title: '埃拉、努沃勒埃利耶和康提',
                                subtitle: '5天 / 4晚',
                                description: '穿越埃拉、努沃勒埃利耶和康提的文化之旅，参观茶园和历史寺庙。',
                                alt: '埃拉、努沃勒埃利耶和康提旅游图片'
                            },
                            kandyNuwaraEllaYala: {
                                title: '康提、努沃勒埃利耶、埃拉和亚拉',
                                subtitle: '7天 / 6晚',
                                description: '全面的旅游套餐，涵盖康提的遗产、努沃勒埃利耶的茶园、埃拉的风景和亚拉的野生动物。',
                                alt: '康提、努沃勒埃利耶、埃拉和亚拉旅游图片'
                            },
                            viewMore: '查看更多旅游'
                        },
                        popularExcursions: {
                            title: '热门短途旅行',
                            oneDay: {
                                title: '一日游',
                                alt: '一日游图片'
                            },
                            twoDays: {
                                title: '两日游',
                                alt: '两日游图片'
                            },
                            threeDays: {
                                title: '三日游',
                                alt: '三日游图片'
                            },
                            fourDays: {
                                title: '四日游',
                                alt: '四日游图片'
                            },
                            viewMore: '查看更多短途旅行'
                        },
                        contactUs: {
                            title: '联系Ashan Tours Sri Lanka',
                            description: '准备好探索斯里兰卡了吗？立即联系Ashan Tours Sri Lanka，规划您的梦想假期！',
                            button: '取得联系'
                        },
                        gallery: {
                            title: '我们的画廊',
                            modalAlt: '画廊图片',
                            filters: {
                                all: '全部',
                                tours: '旅游',
                                accommodation: '住宿',
                                transportation: '交通',
                                wildlife: '野生动物'
                            },
                            tours: {
                                sigiriya2: '锡吉里耶图片2',
                                sigiriya3: '锡吉里耶图片3',
                                kandy2: '康提图片2',
                                kandy3: '康提图片3',
                                galle2: '加勒图片2',
                                galle3: '加勒图片3',
                                ella2: '埃拉图片2',
                                ella3: '埃拉图片3',
                                colomboCity: '科伦坡城市图片'
                            },
                            accommodation: {
                                nuwaraEliya1: '努沃勒埃利耶住宿图片1',
                                nuwaraEliya2: '努沃勒埃利耶住宿图片2',
                                nuwaraEliya3: '努沃勒埃利耶住宿图片3',
                                nuwaraEliya4: '努沃勒埃利耶住宿图片4'
                            },
                            transportation: {
                                bentotaRiverSafari1: '本托塔河 safari 图片1',
                                bentotaRiverSafari2: '本托塔河 safari 图片2'
                            },
                            wildlife: {
                                yalaSafari1: '亚拉 safari 图片1',
                                yalaSafari2: '亚拉 safari 图片2',
                                minneriya1: '明尼里耶图片1',
                                minneriya2: '明尼里耶图片2',
                                udawalawaSafari1: '乌达瓦拉维 safari 图片1',
                                udawalawaSafari2: '乌达瓦拉维 safari 图片2'
                            },
                        },
                    },
                    tourPackages: {
                        title: "旅游套餐",
                        readMore: "了解更多",
                        book: "预订",
                        destinationsTitle: "目的地",
                        destinationImageAlt: "目的地图片 {{index}}",
                        clickToEnlarge: "点击放大",
                        enlargedDestinationAlt: "放大的目的地图片",
                        bookNow: "立即预订",
                        importantNotices: "重要通知",
                        notices: {
                            transport: "我们所有的旅游都使用高舒适度的交通系统。",
                            children: "5岁及以下儿童免费旅行。",
                            hygiene: "我们所有的旅游都注重卫生和安全。",
                            tickets: "除非另有说明，旅游套餐包括门票。",
                            meals: "除非明确说明，一日游不包括餐饮。",
                        },
                        luxuryTransport: "加入我们的豪华交通系统",
                        luxuryTransportAlt1: "豪华车辆 1",
                        luxuryTransportAlt2: "豪华车辆 2",
                        getInTouch: "联系我们了解我们的套餐",
                        getInTouchDescription: "今天联系我们，探索为您量身定制的最佳旅游优惠。",
                        contactUs: "联系我们",
                        bookingMessage: "Ashan Tours 预订请求\n套餐: {{title}}\n持续时间: {{duration}}\n地点: {{location}}",
                        manualBookingMessage: "请手动将以下消息发送至 {{number}}:\n\n{{message}}",
                        errorBookingMessage: "发生错误。请手动将以下消息发送至 {{number}}:\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "埃拉",
                                duration: "1天",
                                location: "埃拉 - 斯里兰卡",
                                description:
                                    "探索埃拉令人叹为观止的自然美景，包括郁郁葱葱的茶园、壮丽的景色和标志性的九拱桥。",
                            },
                            galleFort: {
                                title: "加勒堡",
                                duration: "1天",
                                location: "加勒 - 斯里兰卡",
                                description:
                                    "通过参观历史悠久的加勒堡，穿越回过去，这是一座充满殖民魅力和海岸美景的联合国教科文组织世界遗产。",
                            },
                            yalaSafari: {
                                title: "亚拉野生动物园",
                                duration: "1天",
                                location: "亚拉 - 斯里兰卡",
                                description:
                                    "在亚拉国家公园进行一次冒险的野生动物园之旅，那里居住着豹子、大象和各种奇异野生动物。",
                            },
                            kandy: {
                                title: "康提",
                                duration: "1天",
                                location: "康提 - 斯里兰卡",
                                description:
                                    "通过参观康提，包括神圣的佛牙寺，探索斯里兰卡的文化中心。",
                            },
                            sigiriya: {
                                title: "锡吉里耶",
                                duration: "1天",
                                location: "锡吉里耶 - 斯里兰卡",
                                description:
                                    "攀登古老的锡吉里耶岩石堡垒，欣赏其令人惊叹的壁画和壮观的全景。",
                            },
                            udawalawe: {
                                title: "乌达瓦拉维",
                                duration: "1天",
                                location: "乌达瓦拉维 - 斯里兰卡",
                                description:
                                    "在乌达瓦拉维国家公园享受一场激动人心的野生动物园之旅，以其庞大的大象种群和风景如画的景观而闻名。",
                            },
                            colomboCityEscape: {
                                title: "科伦坡城市逃逸",
                                duration: "1天",
                                location: "科伦坡 - 斯里兰卡",
                                description:
                                    "探索充满活力的科伦坡市，包括其繁忙的市场、文化地标和现代景点。",
                            },
                            mirissaWhaleWatching: {
                                title: "米里萨观鲸",
                                duration: "1天",
                                location: "米里萨 - 斯里兰卡",
                                description:
                                    "在米里萨海岸进行一次难忘的观鲸冒险，壮观的蓝鲸在等着你。",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "米里萨舒适船观鲸",
                                duration: "1天",
                                location: "米里萨 - 斯里兰卡",
                                description:
                                    "在米里萨海岸进行一次难忘的观鲸冒险，壮观的蓝鲸在等着你。",
                            },
                            bentotaRiverSafari: {
                                title: "本托塔河野生动物园",
                                duration: "1天",
                                location: "本托塔 - 斯里兰卡",
                                description:
                                    "沿着宁静的本托塔河航行，周围环绕着郁郁葱葱的红树林和奇异的野生动物，享受一次宁静的逃逸。",
                            },
                            ellaYala: {
                                title: "埃拉与亚拉",
                                duration: "1天",
                                location: "埃拉与亚拉 - 斯里兰卡",
                                description:
                                    "在一天内体验埃拉的风景如画之美与亚拉的激动人心的野生动物园的完美结合。",
                            },
                            ellaGalle: {
                                title: "埃拉与加勒",
                                duration: "1天",
                                location: "埃拉与加勒 - 斯里兰卡",
                                description:
                                    "在充满奇迹的一天中发现埃拉令人叹为观止的风景和加勒的殖民魅力。",
                            },
                            yalaGalle: {
                                title: "亚拉与加勒",
                                duration: "1天",
                                location: "亚拉与加勒 - 斯里兰卡",
                                description:
                                    "将亚拉野生动物园的兴奋与参观风景如画的加勒堡相结合，享受真正多样化的体验。",
                            },
                            ellaYalaTwoDays: {
                                title: "埃拉与亚拉",
                                duration: "2天",
                                location: "埃拉与亚拉 - 斯里兰卡",
                                description:
                                    "花两天时间探索埃拉风景如画的高地和亚拉国家公园丰富的野生动物景观。",
                            },
                            kandyTwoDays: {
                                title: "康提",
                                duration: "2天",
                                location: "埃拉与亚拉 - 斯里兰卡",
                                description:
                                    "花两天时间探索埃拉风景如画的高地和亚拉国家公园丰富的野生动物景观。",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "埃拉/努沃勒埃利耶/康提",
                                duration: "2天",
                                location: "埃拉/努沃勒埃利耶/康提 - 斯里兰卡",
                                description:
                                    "在这次为期两天的旅行中参观努沃勒埃利耶的茶园、埃拉的郁郁葱葱的绿色地带和康提的文化宝藏。",
                            },
                            kandySigiriya: {
                                title: "康提与锡吉里耶",
                                duration: "2天",
                                location: "康提与锡吉里耶 - 斯里兰卡",
                                description:
                                    "享受前往康提的文化之旅，并在这为期两天的冒险中攀登标志性的锡吉里耶岩石堡垒。",
                            },
                            ellaNuwaraEliya: {
                                title: "埃拉与努沃勒埃利耶",
                                duration: "2天",
                                location: "埃拉与努沃勒埃利耶 - 斯里兰卡",
                                description:
                                    "在两天内沉浸于埃拉的自然美景和努沃勒埃利耶凉爽宁静的氛围中。",
                            },
                            sigiriKandyElla: {
                                title: "锡吉里耶/康提/埃拉",
                                duration: "3天",
                                location: "锡吉里耶/康提/埃拉 - 斯里兰卡",
                                description:
                                    "在三天难忘的旅程中探索锡吉里耶、康提的文化地标和埃拉的风景如画的景观。",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "康提/努沃勒埃利耶/埃拉/亚拉",
                                duration: "3天",
                                location: "康提/努沃勒埃利耶/埃拉/亚拉 - 斯里兰卡",
                                description:
                                    "在为期三天的沉浸式旅行中发现斯里兰卡的多样化亮点，从康提的文化到亚拉的野生动物。",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "锡吉里耶/阿努拉德普勒/波隆纳鲁沃/明尼瑞亚国家公园野生动物园",
                                duration: "3天",
                                location: "锡吉里耶/阿努拉德普勒/波隆纳鲁沃/明尼瑞亚国家公园 - 斯里兰卡",
                                description:
                                    "参观锡吉里耶、阿努拉德普勒和波隆纳鲁沃的古老城市，并在明尼瑞亚国家公园享受野生动物园。",
                            },
                            twentyDayTour: {
                                title: "长达20天的旅游套餐",
                                duration: "20天",
                                location: "斯里兰卡",
                                description:
                                    "在斯里兰卡进行一次为期20天的难忘之旅，探索从尼甘布到本托塔的文化、自然和历史奇观。",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "拉瓦纳瀑布",
                            nineArchBridge: "九拱桥",
                            teaPlantation: "茶园",
                            trainRide: "火车之旅",
                            littleAdamsPeak: "小亚当峰",
                            udawalaweElephant: "乌达瓦拉维大象喂奶观察",
                            ayurvedicHerbalGarden: "阿育吠陀草药园",
                            templeKandeViharaya: "坎德维哈拉亚寺庙",
                            turtleHatchery: "海龟孵化场",
                            boatSafari: "船上野生动物园",
                            moonstoneMine: "月光石矿",
                            hikkaduwaBeach: "希卡杜瓦海滩 - 与海龟游泳",
                            dutchFortGalle: "加勒荷兰堡",
                            yala: "亚拉",
                            yalaSafariJeep: "亚拉吉普车野生动物园",
                            kandy: "康提",
                            royalBotanicalGarden: "皇家植物园",
                            teaFactoryPlantation: "茶厂和茶园",
                            elephantFeeding: "大象喂食、洗澡和骑行",
                            ambuluwawaTowerOrTemple: "安布卢瓦瓦塔或佛牙寺",
                            jewelleryGemFactory: "珠宝和宝石工厂",
                            silkFactory: "丝绸工厂",
                            sigiriya: "锡吉里耶",
                            sigiriyaLionRock: "锡吉里耶狮子岩",
                            dambullaGoldenTemple: "丹布拉黄金寺",
                            villageTour: "乡村游览，含传统斯里兰卡美食",
                            pidurangalaRock: "皮杜兰加拉岩",
                            udawalawe: "乌达瓦拉维",
                            udawalaweNationalPark: "乌达瓦拉维国家公园",
                            jeepSafari: "吉普车野生动物园",
                            elephantMilkFeeding: "大象喂奶",
                            lotusTower: "莲花塔",
                            redMosque: "红清真寺",
                            shopping: "购物",
                            blueWhales: "蓝鲸",
                            mirissa: "米里萨",
                            stiltFishing: "高跷钓鱼",
                            bentotaRiver: "本托塔河",
                            bentota: "本托塔",
                            safariYalaNationalPark: "亚拉国家公园吉普车野生动物园",
                            gadoladeniyaTemple: "加多拉德尼亚寺庙",
                            templeOfTheToothRelic: "佛牙寺",
                            traditionalKandyanDance: "传统康提舞蹈",
                            luxuryHotelStay: "豪华酒店住宿，含早餐和晚餐",
                            teaFactory: "茶厂",
                            nuwaraEliyaTown: "努沃勒埃利耶镇",
                            ambuluwawaTower: "安布卢瓦瓦塔",
                            hinduTemple: "印度教寺庙",
                            gregoryLake: "格雷戈里湖",
                            postOffice: "邮局",
                            hortanPlains: "霍顿平原",
                            sitaAmmanHinduKovil: "西塔阿曼印度教寺庙",
                            botanicalGarden: "植物园",
                            rambodaWaterfall: "兰博达瀑布",
                            sigiriyaRockFortress: "锡吉里耶岩石堡垒",
                            anuradhapura: "阿努拉德普勒",
                            polonnaruwa: "波隆纳鲁沃",
                            minneriyaNationalPark: "明尼瑞亚国家公园",
                            elephants: "大象",
                            day1: "第1天：机场 - 尼甘布：前往尼甘布并提前入住，穆图拉贾维拉湿地游船，放松 - 游泳 - 休闲 - 吊床 - 健康 - 日光浴 - 运动 - 水上运动，尼甘布住宿和早餐",
                            day2: "第2天：尼甘布 - 阿努拉德普勒：神圣城市阿努拉德普勒（联合国教科文组织世界遗产），斯里摩诃菩提树，风景如画的水库散步，阿努拉德普勒住宿和早餐",
                            day3: "第3天：阿努拉德普勒 - 明尼瑞亚 - 哈巴拉纳：奥卡纳佛像，含午餐的双体船和嘟嘟车乡村野生动物园，明尼瑞亚国家公园吉普车野生动物园，哈巴拉纳住宿和早餐",
                            day4: "第4天：哈巴拉纳 - 锡吉里耶 - 里蒂加拉 - 亭可马里：锡吉里耶岩石堡垒（联合国教科文组织世界遗产），里蒂加拉森林修道院，亭可马里住宿和早餐",
                            day5: "第5天：亭可马里：放松 - 游泳 - 休闲 - 吊床 - 健康 - 日光浴 - 运动 - 水上运动，亭可马里住宿和早餐",
                            day6: "第6天：亭可马里：亭可马里城市游，Steffi Bäuml生日，放松 - 游泳 - 休闲 - 吊床 - 健康 - 日光浴 - 运动 - 水上运动，为两位女士准备的惊喜烹饪课程，亭可马里住宿和早餐",
                            day7: "第7天：亭可马里：鸽子岛浮潜之旅，放松 - 游泳 - 休闲 - 吊床 - 健康 - 日光浴 - 运动 - 水上运动，亭可马里住宿和早餐",
                            day8: "第8天：亭可马里：放松 - 游泳 - 休闲 - 吊床 - 健康 - 日光浴 - 运动 - 水上运动，亭可马里住宿和早餐",
                            day9: "第9天：亭可马里 - 丹布拉 - 马塔莱 - 佩拉德尼亚 - 康提：丹布拉洞窟寺（联合国教科文组织世界遗产），马塔莱香料园，佩拉德尼亚皇家植物园野餐，康提老城散步，康提住宿和早餐",
                            day10: "第10天：康提：康提佛牙寺（联合国教科文组织世界遗产），晚间康提舞蹈表演，康提住宿和早餐",
                            day11: "第11天：康提 - 努沃勒埃利耶 - 埃拉：茶园和采茶，参观茶厂，兰博达瀑布，努沃勒埃利耶 - 云端之城，埃拉散步，埃拉住宿和早餐",
                            day12: "第12天：埃拉 - 巴杜勒：从埃拉到巴杜勒的火车之旅（二等舱），埃拉周边徒步，可选：滑索，埃拉住宿和早餐",
                            day13: "第13天：埃拉 - 亚拉：拉瓦纳瀑布，埃拉峡谷，亚拉国家公园吉普车野生动物园，蒂萨马哈拉马住宿和早餐",
                            day14: "第14天：亚拉 - 乌达瓦拉维 - 辛哈拉贾：喂食时间参观大象中转站，前往辛哈拉贾森林保护区（联合国教科文组织世界遗产），辛哈拉贾住宿和早餐",
                            day15: "第15天：辛哈拉贾：辛哈拉贾森林保护区（联合国教科文组织自然遗产）导览徒步，辛哈拉贾住宿和早餐",
                            day16: "第16天：辛哈拉贾 - 加勒：加勒老城，加勒堡（联合国教科文组织世界遗产），加勒住宿和早餐",
                            day17: "第17天：加勒 - 米里萨 - 本托塔：米里萨近海野生动物园，海龟保护项目，本托塔住宿和早餐",
                            day18_19: "第18-19天：本托塔：放松 - 游泳 - 休闲 - 吊床 - 健康 - 日光浴 - 运动 - 水上运动，本托塔住宿和早餐",
                            day20: "第20天：本托塔 - 机场：机场接送",
                        },
                    },
                    ayurvedaPage: {
                        title: "阿育吠陀 - 古老的生命科学",
                        mainDescription: "“阿育吠陀”这个词已有三千多年的历史。在梵文中，这个词的意思是“生命科学”。该技术基于阿育吠陀对疾病的治疗观点，而非其后果，这通常与欧洲医学相冲突。它提出了以下原则：",
                        principles: {
                            energyBalance: "身体应无能量阻塞，并保持平衡以维持正常的代谢和心脏活动。",
                            muscleHormonal: "身体应具有正常的肌肉收缩和规律的激素活动。",
                            immuneSystem: "身体需要健康的免疫系统以正常运作。"
                        },
                        trainingDescription: "根据最新数据，斯里兰卡有超过6,000名接受过阿育吠陀培训的毕业生。他们经过七年的学习和公立医院两年的实践。阿育吠陀项目包括：",
                        programs: {
                            stressRelief: "缓解压力、疲劳和焦虑",
                            oxygenSaturation: "氧气饱和",
                            muscularToxins: "刺激肌肉系统并消除毒素",
                            nervousSystem: "恢复神经系统的平衡",
                            bloodFlow: "恢复内脏器官的血流",
                            endorphins: "产生内啡肽"
                        },
                        images: {
                            mainAlt: "阿育吠陀",
                            faceTreatmentAlt: "阿育吠陀面部治疗",
                            massageTreatmentAlt: "阿育吠陀按摩治疗"
                        },
                        treatmentDescription: "标准治疗包括使用特殊油进行身体和头皮按摩、草药桑拿治疗以及草药浸泡浴。最受欢迎的技术是“Shirodhara程序”，将温热的草药油有节奏地滴在前额上。这有助于恢复神经系统的平衡并实现放松。",
                        tipsTitle: "阿育吠陀治疗的建议",
                        tips: {
                            relaxMind: "忘记烦恼。放松并清空思绪以获得最佳效果。",
                            chooseLocation: "选择正确的地点。选择一个符合您舒适度和偏好的环境，以实现最佳治疗效果。",
                            selectProgram: "选择正确的项目。与医生讨论您的问题，并尝试不同的疗法以找到最适合您的。",
                            warmBath: "在治疗前洗个热水澡，以放松肌肉并准备好身体。",
                            lightMeal: "在程序前吃一顿清淡的饭菜。避免重餐以确保按摩期间的正常血流。",
                            postRelaxation: "程序后的放松至关重要。适当的放松能增强阿育吠陀治疗的效果。"
                        },
                    },
                    ballooningPage: {
                        title: "斯里兰卡热气球之旅",
                        mainDescription: "斯里兰卡的热气球之旅提供了一种在岛上壮丽景观上空轻柔漂浮的难忘体验。热气球飞行从日出开始，提供连绵起伏的山丘、茂密的森林、古老的遗迹和宁静村庄的壮观空中景观。",
                        dambullaDescription: "斯里兰卡最受欢迎的热气球目的地是位于文化三角中心地带的丹布拉。这里的热气球飞行通常会经过标志性的锡吉里耶岩石堡垒，提供无与伦比的视角。飞行通常持续60至90分钟，让您有足够的时间从高空领略斯里兰卡的美景。",
                        highlightsTitle: "为什么要在斯里兰卡尝试热气球？",
                        highlightsDescription: "热气球将冒险与宁静相结合，让您以独特的方式体验斯里兰卡的美景。热气球的一些亮点包括：",
                        highlights: {
                            panoramicViews: "岛上壮丽景观的不间断全景视野。",
                            landmarks: "飞越锡吉里耶岩石堡垒和附近湖泊等标志性地标。",
                            peacefulRide: "在郁郁葱葱的绿地和迷人村庄上空的宁静和平和飞行。",
                            sunrise: "从空中见证壮观的日出。",
                            photography: "适合摄影爱好者从高空捕捉风景如画的美景。"
                        },
                        images: {
                            mainAlt: "斯里兰卡热气球",
                            sunriseAlt: "热气球日出",
                            sunriseCaption: "在热气球中轻柔漂浮，享受日出的壮丽景色。",
                            landscapeAlt: "热气球景观",
                            landscapeCaption: "从高空见证斯里兰卡的壮丽景观，包括连绵起伏的山丘和茂密的森林。"
                        },
                        tipsTitle: "难忘热气球之旅的建议",
                        tips: {
                            bookEarly: "尽早预订您的飞行，因为热气球依赖天气，位置很快就会被订满。",
                            clothing: "穿舒适的衣服并带一件轻便夹克，因为清晨可能较凉爽。",
                            camera: "带上相机或智能手机以捕捉壮丽的景色。",
                            safety: "仔细聆听飞行员提供的安全说明。",
                            arriveEarly: "准时到达以观看气球的准备和充气过程，这是一个引人入胜的过程。"
                        },
                    },
                    divingPage: {
                        title: "斯里兰卡潜水",
                        mainDescription: "斯里兰卡海岸被2至40米深的广阔珊瑚礁环绕。印度洋的温暖水域（27°C至30°C）和15至35米的高水质透明度为潜水和浮潜提供了绝佳条件。在斯里兰卡潜水时，您可以探索无尽的原始珊瑚礁、古老的沉船和迷人的水下洞穴。",
                        northeastDescription: "岛的东北部拥有超过130种色彩鲜艳的珊瑚，是海龟、 clownfish、狮子鱼和海马等海洋生物的家园。探访水下岩石和珊瑚礁附近的沉船，将带来难忘的体验。漂浮在清澈的水中，您会沉浸在锡兰迷人的历史中。",
                        facilitiesTitle: "设施和最佳潜水点",
                        facilitiesDescription: "岛上的潜水中心配备了知名制造商的最新潜水设备。拥有PADI和CMAS资质的认证教练确保安全且愉快的潜水体验。潜水中心位于岛的西南海岸，运营时间为10月中旬至4月底。包括尼拉维利和亭可马里在内的东北海岸在3月至10月期间是潜水的理想之地。",
                        popularSpots: "西部的卡尔皮蒂亚附近的珊瑚礁和希卡杜瓦的沉船潜水点是潜水者最受欢迎的景点。",
                        images: {
                            mainAlt: "斯里兰卡潜水",
                            coralReefAlt: "珊瑚礁潜水",
                            coralReefCaption: "探索充满多样海洋生物的鲜艳珊瑚礁。",
                            shipwreckAlt: "沉船潜水",
                            shipwreckCaption: "发现提供斯里兰卡海洋历史一瞥的古老沉船。"
                        },
                        tipsTitle: "潜水者建议",
                        tips: {
                            season: "根据地点选择最佳潜水季节：西南海岸（10月至4月）或东北海岸（3月至10月）。",
                            certifiedCenter: "确保您的潜水中心获得认证并配备现代装备，以获得安全的体验。",
                            instructorAdvice: "仔细聆听教练的建议，尤其是如果您是初学者。",
                            respectMarineLife: "通过不触碰珊瑚或干扰水下环境来尊重海洋生物。",
                            camera: "携带防水相机以捕捉斯里兰卡水下世界的迷人美景。"
                        },
                    },
                    elephantRidePage: {
                        title: "骑大象",
                        mainDescription: "骑大象是一项迷人且激动人心的活动，也是斯里兰卡的独特体验。如果您住在哈巴拉纳、锡吉里耶或丹布拉等文化三角地带附近，可以参加大象 safari。这些骑行大约从30美元起，带来一小时难忘的冒险。",
                        rideDescription: "在骑行前，大象会被装上可容纳4至6人的多座篮筐。这些温和的巨兽将带您穿过风景如画的丛林小径，跨越被水淹没的区域，并穿过郁郁葱葱的植被。大象通常走得很慢，让您可以充分欣赏周围自然的美景，尽管它们的速度最高可达每小时40公里。",
                        highlightsTitle: "骑大象的亮点",
                        highlightsDescription: "在斯里兰卡骑大象提供了一种与自然联系并探索乡村的独特方式。体验的亮点包括：",
                        highlights: {
                            junglePaths: "穿过充满异国植被和野生动物的茂密丛林。",
                            riverCrossing: "跨越河流和被淹没的区域，呈现自然景观的壮丽景色。",
                            culturalConnection: "了解大象与斯里兰卡文化的密切关系。",
                            comfortableRide: "在大象柔和地带您穿越各种地形时，放松地坐在舒适的鞍座上。"
                        },
                        images: {
                            mainAlt: "骑大象",
                            jungleAlt: "大象骑行丛林小径",
                            jungleCaption: "骑着大象探索茂密的丛林和风景如画的小径。",
                            waterAlt: "大象过水",
                            waterCaption: "跨越河流，享受水域和植被的宁静美景。"
                        },
                        tipsTitle: "安全且愉快的大象骑行建议",
                        tips: {
                            clothing: "穿着适合户外活动的舒适服装和鞋子。",
                            guideInstructions: "遵循导游的指示，以确保安全和愉快的骑行。",
                            ethicalPractices: "确保大象受到良好对待，且骑行提供者遵循道德实践。",
                            camera: "带上相机捕捉令人叹为观止的风景和时刻。",
                            respectElephants: "尊重大象，避免可能导致它们压力或伤害的行为。"
                        },
                    },
                    fishingPage: {
                        title: "斯里兰卡钓鱼",
                        mainDescription: "斯里兰卡凭借其广阔的海岸线和丰富的淡水湖泊与河流，提供了无与伦比的钓鱼体验。无论您是职业钓鱼者还是业余爱好者，斯里兰卡都有所提供。从深海钓鱼探险到当地渔民实践的传统竿钓，您将体验到一次难忘的冒险。",
                        destinationsDescription: "受欢迎的钓鱼目的地包括加勒和米里萨附近的南海岸、尼甘布泻湖以及亭可马里的平静水域。根据您的喜好，您可以尝试不同的钓鱼技术，如拖钓、底钓或飞蝇钓。",
                        experiencesTitle1: "斯里兰卡的钓鱼体验",
                        experiencesDescription: "在斯里兰卡钓鱼不仅仅是捕鱼；它是一个沉浸于岛上文化和传统的机会。一些独特的钓鱼体验包括：",
                        experiences: {
                            stiltFishingTitle: "竿钓",
                            stiltFishing: "一种传统方法，渔民坐在岸边的木竿上捕鱼，这是斯里兰卡独有的做法。",
                            deepSeaFishingTitle: "深海钓鱼",
                            deepSeaFishing: "冒险进入印度洋，捕捉马林鱼、金枪鱼、梭鱼等大型鱼类。",
                            lagoonFishingTitle: "泻湖和河流钓鱼",
                            lagoonFishing: "在充满罗非鱼和鲶鱼的宁静泻湖和河流中放松钓鱼。",
                            nightFishingTitle: "夜钓",
                            nightFishing: "体验在星空下钓鱼的刺激，这是沿海村庄的常见做法。"
                        },
                        images: {
                            mainAlt: "斯里兰卡钓鱼",
                            stiltFishingAlt: "斯里兰卡竿钓",
                            stiltFishingCaption: "竿钓是一种传统方法，也是斯里兰卡钓鱼遗产的标志性形象。",
                            deepSeaFishingAlt: "斯里兰卡深海钓鱼",
                            deepSeaFishingCaption: "深海钓鱼提供了一种冒险体验，目标是印度洋中的大型鱼类。"
                        },
                        tipsTitle: "愉快钓鱼之旅的建议",
                        tips: {
                            season: "为您的钓鱼探险选择合适的季节；10月至4月适合南海岸，3月至10月适合东海岸。",
                            protection: "带上防晒霜、帽子和防护服，以在旅途中保持舒适。",
                            guide: "预订钓鱼向导或包船，以充分利用您的体验并向专家学习。",
                            environment: "通过不乱扔垃圾和遵循可持续钓鱼实践来尊重当地环境。",
                            hydration: "在较长的钓鱼之旅中保持水分充足并携带零食。"
                        },
                    },
                    jeepSafariPage: {
                        title: "斯里兰卡吉普车 safari",
                        mainDescription: "斯里兰卡的国立公园提供了一种激动人心的吉普车 safari 体验，让您可以探索岛上的丰富生物多样性，并在其自然栖息地中观察野生动物。亚拉国立公园、威尔帕图国立公园和乌达瓦拉维国立公园是最受欢迎的吉普车 safari 目的地。",
                        wildlifeDescription: "这些 safari 提供了观察大象、豹子、树懒熊、水牛、鳄鱼和各种鸟类的机会。在经验丰富的自然学家和追踪者的指导下，吉普车 safari 非常适合野生动物爱好者和摄影师。",
                        whyChooseTitle: "为什么选择吉普车 safari？",
                        whyChooseDescription: "吉普车 safari 是探索斯里兰卡多样化野生动物的最佳方式之一。以下是一些亮点：",
                        whyChoose: {
                            encounters: "与大象和豹子等标志性物种的近距离接触。",
                            remoteAreas: "进入国立公园内的偏远和风景优美的区域。",
                            photography: "在自然环境中进行野生动物摄影的机会。",
                            guidance: "由知识渊博的自然学家和公园管理员提供指导。",
                            adventure: "适合所有年龄段的冒险，结合了兴奋和教育。"
                        },
                        images: {
                            mainAlt: "斯里兰卡吉普车 safari",
                            wildlifeAlt: "吉普车 safari 中的野生动物",
                            wildlifeCaption: "在 safari 中观察豹子、大象和鳄鱼等标志性野生动物。",
                            landscapeAlt: "吉普车 safari 景观",
                            landscapeCaption: "探索斯里兰卡国立公园的壮丽景观，从茂密的森林到开阔的平原。"
                        },
                        tipsTitle: "愉快吉普车 safari 的建议",
                        tips: {
                            clothing: "穿着舒适的中性色服装，以便融入环境。",
                            protection: "携带防晒霜、帽子和驱虫剂以保护自己。",
                            equipment: "携带双筒望远镜和相机，以增强体验并捕捉野生动物。",
                            guide: "遵循向导的指示，确保安全并尊重动物。",
                            booking: "特别是在旺季，尽早预订 safari 以确保名额。"
                        },
                    },
                    riverSafariPage: {
                        title: "斯里兰卡河上 safari",
                        mainDescription: "斯里兰卡的河上 safari 提供了一种探索岛上丰富生物多样性和风景之美的独特方式。沿着被郁郁葱葱的红树林环绕的宁静水道滑行，观察异国野生动物，享受令人陶醉的美丽日落。",
                        destinationsDescription: "受欢迎的河上 safari 目的地包括马杜河（Madu Ganga）和本托塔河。这些 safari 提供了观察各种鸟类、巨蜥、鳄鱼甚至猴子的机会，它们生活在自然栖息地中。宁静的环境非常适合自然爱好者和摄影师。",
                        whyChooseTitle: "为什么选择河上 safari？",
                        whyChooseDescription: "河上 safari 是一种放松且沉浸式的体验，结合了自然、野生动物和文化探索。以下是一些亮点：",
                        whyChoose: {
                            mangroves: "探索充满生机的郁郁葱葱的红树林。",
                            wildlife: "观察异国鸟类、鳄鱼和其他野生动物。",
                            villages: "访问河边的小岛和当地村庄。",
                            tranquility: "享受斯里兰卡水道的宁静和风景之美。",
                            suitable: "适合家庭、情侣和寻求宁静度假的独行旅客。"
                        },
                        images: {
                            mainAlt: "斯里兰卡河上 safari",
                            mangrovesAlt: "河上 safari 中的红树林",
                            mangrovesCaption: "发现环绕斯里兰卡风景优美水道的郁郁葱葱的红树林。",
                            wildlifeAlt: "河上 safari 中的野生动物",
                            wildlifeCaption: "在 safari 中观察鳄鱼、巨蜥和多彩鸟类等异国野生动物。"
                        },
                        tipsTitle: "愉快河上 safari 的建议",
                        tips: {
                            clothing: "穿着舒适的衣服，并带上帽子和防晒霜以保护自己。",
                            binoculars: "携带双筒望远镜以观察远处的野生动物和鸟类。",
                            camera: "带上相机或智能手机，捕捉壮丽的风景和野生动物。",
                            guide: "遵循向导的指示，确保安全且愉快的体验。",
                            environment: "通过不乱扔垃圾和不干扰野生动物来尊重自然环境。"
                        },
                    },
                    snorkelingPage: {
                        title: "斯里兰卡浮潜",
                        mainDescription: "斯里兰卡的浮潜提供了一次难忘的水下体验，您可以探索充满活力的珊瑚礁和多样的海洋生物。凭借其清澈的海水和丰富的海洋生态系统，斯里兰卡是各种技能水平浮潜者的天堂。",
                        destinationsDescription: "一些最受欢迎的浮潜地点包括以多彩珊瑚花园和海龟闻名的希卡杜瓦、亭可马里的鸽子岛以其原始珊瑚礁而著名，以及米里萨，在浮潜季节您甚至可能看到一两头鲸鱼。",
                        whyChooseTitle: "为什么选择在斯里兰卡浮潜？",
                        whyChooseDescription: "斯里兰卡的浮潜是一种神奇的体验，结合了冒险与自然之美。以下是一些亮点：",
                        whyChoose: {
                            coralReefs: "探索充满生命的鲜艳珊瑚礁。",
                            marineLife: "与多彩的热带鱼、海龟甚至礁鲨一起游泳。",
                            landscapes: "在清澈温暖的水中发现原始的水下景观。",
                            suitable: "适合初学者和有经验的浮潜者。",
                            accessible: "可从斯里兰卡一些最佳海滩目的地访问。"
                        },
                        images: {
                            mainAlt: "斯里兰卡浮潜",
                            coralReefAlt: "斯里兰卡珊瑚礁",
                            coralReefCaption: "发现令人惊叹的珊瑚礁及其充满活力的生态系统。",
                            marineLifeAlt: "斯里兰卡海洋生物",
                            marineLifeCaption: "邂逅多样的海洋生物，包括海龟、热带鱼等。"
                        },
                        tipsTitle: "难忘浮潜体验的建议",
                        tips: {
                            mask: "佩戴舒适的面罩和呼吸管，以确保水下清晰的视野。",
                            sunscreen: "使用对珊瑚礁安全的防晒霜，以保护您的皮肤和海洋生物。",
                            swimGently: "轻轻游泳，以避免扰乱珊瑚礁和水生生物。",
                            hydration: "保持水分充足，并在浮潜间隙休息。",
                            guidedTour: "参加导游带领的游览，了解最佳浮潜点和安全建议。"
                        },
                    },
                    teaTastingPage: {
                        title: "斯里兰卡品茶之旅",
                        mainDescription: "斯里兰卡，常被称为“印度洋明珠”，以其世界级的茶叶生产而闻名。参加品茶之旅，探索努瓦拉埃利亚、埃拉和康提等地区的郁郁葱葱的茶园。了解茶叶种植的艺术、茶叶生产的精细过程，并品尝正宗锡兰茶的丰富风味。",
                        heritageDescription: "无论您是茶叶爱好者还是仅仅出于好奇，品茶之旅提供了深入了解斯里兰卡茶叶遗产和体验其高地宁静之美的独特机会。",
                        whyChooseTitle: "为什么选择品茶之旅？",
                        whyChooseDescription: "斯里兰卡的品茶之旅不仅仅是品尝茶叶——它是一种沉浸式的文化体验。以下是一些亮点：",
                        whyChoose: {
                            plantations: "参观位于凉爽高地的风景如画的茶园。",
                            history: "了解锡兰茶的历史和重要性。",
                            production: "参与茶叶采摘并观察茶厂中的生产过程。",
                            varieties: "品尝从红茶到绿茶再到调味混合茶的各种茶叶。",
                            scenery: "欣赏薄雾笼罩的山脉和瀑布的壮丽景色。"
                        },
                        images: {
                            mainAlt: "斯里兰卡品茶之旅",
                            teaPlantationAlt: "斯里兰卡茶园",
                            teaPlantationCaption: "探索郁郁葱葱的茶园并了解茶叶种植。",
                            teaPreparationAlt: "斯里兰卡茶叶制作",
                            teaPreparationCaption: "发现茶叶制作的艺术并品尝正宗的锡兰茶。"
                        },
                        tipsTitle: "愉快品茶之旅的建议",
                        tips: {
                            clothing: "穿着舒适的衣服和鞋子以便在茶园中行走。",
                            jacket: "带上一件轻便夹克，因为高地地区可能凉爽且有雾。",
                            varieties: "尝试不同的茶叶品种，并将您喜欢的带回家作为纪念品。",
                            questions: "在游览期间提问，以了解更多关于制茶过程的信息。",
                            attractions: "将您的品茶之旅与附近的景点（如瀑布和观景点）结合。"
                        },
                    },
                    templeVisitPage: {
                        title: "斯里兰卡寺庙参观",
                        mainDescription: "斯里兰卡，被称为佛陀之地，拥有反映其丰富精神和文化遗产的古老寺庙。踏上旅程，探索标志性的寺庙，如康提的佛牙寺、丹布拉洞窟寺和阿努拉德普勒的卢旺威利塞亚。",
                        spiritualDescription: "这些圣地装饰着精美的雕刻、壁画和雕塑，提供了岛上精神传统和建筑辉煌的一瞥。寺庙参观不仅是一种文化体验，也是寻找和平与宁静的机会。",
                        whyVisitTitle: "为什么参观斯里兰卡的寺庙？",
                        whyVisitDescription: "参观斯里兰卡的寺庙提供了与岛上的历史、文化和灵性联系的独特机会。以下是一些亮点：",
                        whyVisit: {
                            architecture: "欣赏精美的建筑和数百年的雕塑。",
                            traditions: "从知识渊博的导游那里了解佛教传统和仪式。",
                            heritage: "探索联合国教科文组织世界遗产，如丹布拉金寺。",
                            serenity: "体验圣地的宁静和精神氛围。",
                            festivals: "见证佛牙寺的埃萨拉佩拉赫拉等充满活力的节日。"
                        },
                        images: {
                            mainAlt: "斯里兰卡寺庙参观",
                            templeInteriorAlt: "寺庙内部",
                            templeInteriorCaption: "惊叹于装饰着精美雕刻和壁画的壮丽内部。",
                            sacredTempleAlt: "斯里兰卡圣寺",
                            sacredTempleCaption: "参观卢旺威利塞亚等圣寺，沉浸在精神传统中。"
                        },
                        tipsTitle: "参观斯里兰卡寺庙的建议",
                        tips: {
                            dress: "穿着得体，遮盖肩膀和膝盖，以示尊重。",
                            shoes: "在进入寺庙场地之前脱鞋。",
                            touching: "避免触摸雕塑或圣物。",
                            donation: "如想捐助，可带上小额捐款给寺庙。",
                            silence: "在参观期间尊重安静和精神氛围。"
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "斯里兰卡激流漂流",
                        mainDescription: "斯里兰卡的激流漂流是一次令人兴奋的体验，特别是在岛上的冒险之都基图尔加拉。凯拉尼河以其湍急的激流和风景优美的环境，为初学者和有经验的漂流者提供了完美的场所。",
                        destinationsDescription: "漂流探险通常覆盖5公里的河段，激流等级从2级到4级不等。参与者可以享受挑战急流的刺激，同时欣赏郁郁葱葱的绿色植物和河岸的壮丽景色。",
                        whyChooseTitle: "为什么选择斯里兰卡激流漂流？",
                        whyChooseDescription: "斯里兰卡的激流漂流提供了冒险与自然美景的独特结合。以下是一些体验亮点：",
                        whyChoose: {
                            rapids: "在经验丰富的教练指导下，挑战刺激的激流。",
                            views: "欣赏周围雨林和山地地形的壮丽景色。",
                            activities: "将漂流与基图尔加拉的其他活动如徒步、观鸟和峡谷漂流结合。",
                            suitable: "适合团体、家庭或寻求肾上腺素激增的独行旅客。"
                        },
                        images: {
                            mainAlt: "斯里兰卡激流漂流",
                            actionRaftingAlt: "激流漂流动作",
                            actionRaftingCaption: "在凯拉尼河上征服具有挑战性的激流，感受肾上腺素的激增。",
                            scenicRaftingAlt: "激流漂流风景",
                            scenicRaftingCaption: "在漂流冒险中享受周围郁郁葱葱的宁静美景。"
                        },
                        tipsTitle: "安全且刺激的漂流之旅建议",
                        tips: {
                            safetyGear: "佩戴漂流向导提供的救生衣和头盔以确保安全。",
                            instructions: "在开始行程前仔细聆听安全说明。",
                            clothing: "穿着舒适、快干的衣服和安全的鞋子，如水鞋。",
                            changeOfClothes: "携带一套换洗衣服和毛巾，供漂流后使用。",
                            operator: "与信誉良好的运营商预订漂流行程，以确保安全和愉快的体验。"
                        },
                    },
                    wildlifeSafariPage: {
                        title: "斯里兰卡野生动物Safari",
                        mainDescription: "斯里兰卡以其丰富的生物多样性而闻名，在亚拉、威尔帕图、明尼里亚和乌达瓦拉维等国家公园提供令人难以置信的野生动物Safari。这些Safari提供了在自然栖息地中观赏大象、豹子、树懒熊和各种鸟类的机会。",
                        destinationsDescription: "探索从茂密森林到开阔草原的多样化景观，捕捉野生动物行动中的难忘时刻。在专业导游和维护良好的Safari吉普车的陪同下，斯里兰卡的野生动物Safari是自然爱好者和冒险寻求者的必游之地。",
                        whyChooseTitle: "为什么选择野生动物Safari？",
                        whyChooseDescription: "斯里兰卡的野生动物Safari提供了与自然联系并探索岛上卓越生物多样性的独特机会。亮点包括：",
                        whyChoose: {
                            species: "观赏大象、豹子和鳄鱼等标志性物种。",
                            landscapes: "探索充满野生动物的茂密森林、湿地和开阔平原。",
                            photography: "在自然环境中捕捉令人惊叹的野生动物摄影。",
                            elusiveAnimals: "体验发现斯里兰卡豹等难以捉摸的动物的刺激。",
                            conservation: "从经验丰富的导游和自然学家那里了解保护工作。"
                        },
                        images: {
                            mainAlt: "斯里兰卡野生动物Safari",
                            elephantsAlt: "斯里兰卡大象",
                            elephantsCaption: "在斯里兰卡国家公园中见证自由漫步的雄伟大象。",
                            leopardAlt: "斯里兰卡豹",
                            leopardCaption: "发现难以捉摸的斯里兰卡豹，这是任何野生动物Safari的亮点。"
                        },
                        tipsTitle: "刺激的野生动物Safari建议",
                        tips: {
                            clothing: "穿着中性色服装以融入环境。",
                            protection: "携带防晒霜、帽子和驱虫剂以保护自己。",
                            equipment: "携带双筒望远镜和相机以观察和捕捉野生动物。",
                            guide: "遵循导游的指示，确保安全且愉快的体验。",
                            booking: "特别是在旺季，尽早预订以确保在热门公园中的名额。"
                        },
                    },
                },
            },
            cs: {
                translation: {
                    home: 'Domů',
                    about: 'O nás',
                    srilanka: 'Srí Lanka',
                    excursions: 'Výlety',
                    tour: 'Rezervovat cestu',
                    things: 'Co lze dělat',
                    contact: {
                        navLabel: 'Kontaktujte nás',
                        getInTouch: 'Spojte se s námi',
                        address: 'Adresa',
                        mobile: 'Mobil',
                        email: 'E-mail',
                        website: 'Webová stránka',
                        sendMessage: 'Pošlete nám zprávu',
                        fullName: 'Celé jméno',
                        fullNamePlaceholder: 'Zadejte své celé jméno',
                        country: 'Země',
                        countryPlaceholder: 'Zadejte svou zemi',
                        emailPlaceholder: 'Zadejte svůj e-mail',
                        subject: 'Předmět',
                        subjectPlaceholder: 'Zadejte předmět',
                        message: 'Zpráva',
                        messagePlaceholder: 'Zadejte svou zprávu',
                        reset: 'Resetovat',
                        submit: 'Odeslat',
                        ourLocation: 'Naše poloha',
                        mapTitle: 'Google Maps - Ashan Tours Sri Lanka',
                        whatsappMessage: 'Zpráva hosta Ashan Tours Sri Lanka',
                        manualMessage: 'Prosím, odešlete následující zprávu ručně na',
                        errorMessage: 'Došlo k chybě. Prosím, odešlete následující zprávu ručně na',
                    },
                    aboutSection: {
                        travelWithAshan: 'Cestujte s Ashan Tours Sri Lanka',
                        imageAlt: 'Obrázek Ashan Tours {{index}}',
                        introParagraph1: 'Ashan Tours Sri Lanka je vaším důvěryhodným společníkem na cestách, který vytváří nezapomenutelné cesty po Srí Lance. S naší vášní pro objevování a týmem zkušených profesionálů se zavazujeme nabízet personalizované itineráře, odborné vedení a výjimečné služby, aby byl váš dovolenkový zážitek skutečně výjimečný.',
                        introParagraph2: 'Naše zájezdy jsou pečlivě navrženy tak, aby zachytily podstatu Srí Lanky — od sluncem zalitých pláží a malebných kopcovitých oblastí po starověké kulturní poklady a živou divokou přírodu. V Ashan Tours Sri Lanka se zavazujeme poskytovat autentické zážitky, které vám umožní objevit krásu a duši ostrova.',
                        introParagraph3: 'Ať už hledáte dobrodružství, klidné útočiště nebo kulturní ponoření, Ashan Tours Sri Lanka nabízí balíčky šité na míru vašim přáním. Připojte se k nám a nechte se vést na cestě plné úžasu, objevů a trvalých vzpomínek.',
                        cinnamonLuxuryVilla: 'Cinnamon Luxusní Vila',
                        villaImageAlt: 'Obrázek Cinnamon Luxusní Vily {{index}}',
                        villaParagraph1: 'Ashan Tours Sri Lanka hrdě představuje naši Cinnamon Luxusní Vilu, která nabízí prvotřídní ubytování pro cestovatele hledající pohodlí a eleganci. Naše dva exkluzivní apartmány jsou navrženy tak, aby poskytovaly domácí zážitek v srdci Srí Lanky.',
                        villaParagraph2: 'Každý apartmán je vybaven moderními vymoženostmi, včetně klimatizace, připojených koupelen, luxusních manželských postelí a plně vybavených kuchyní. Ať už cestujete sami, jako pár nebo s rodinou, naše vily nabízejí dokonalou kombinaci luxusu a pohodlí.',
                        villaParagraph3: 'Cinnamon Luxusní Vila, zasazená do klidného prostředí, vám umožní relaxovat a odpočinout si po dni stráveném objevováním divů Srí Lanky. Zarezervujte si pobyt s Ashan Tours Sri Lanka a zažijte nepřekonatelnou pohostinnost.',
                    },
                    homeHeroSection: {
                        title: 'Cestujte s Ashan Srí Lanka',
                        subtitle: 'Objevte okouzlující krásu Srí Lanky s nezapomenutelnými dobrodružstvími',
                        bookButton: 'Rezervujte si svou cestu',
                        videoFallback: 'Váš prohlížeč nepodporuje tag videa.',
                    },
                    tourPackages: {
                        title: "Cestovní balíčky",
                        readMore: "Číst více",
                        book: "Rezervovat",
                        destinationsTitle: "Destinace",
                        destinationImageAlt: "Obrázek destinace {{index}}",
                        clickToEnlarge: "Kliknutím zvětšíte",
                        enlargedDestinationAlt: "Zvětšený obrázek destinace",
                        bookNow: "Rezervovat nyní",
                        importantNotices: "Důležitá upozornění",
                        notices: {
                            transport: "Na všech našich cestách využíváme vysoce komfortní dopravní systémy.",
                            children: "Děti do 5 let věku cestují zdarma.",
                            hygiene: "Všechny naše cesty jsou prováděny s důrazem na hygienu a bezpečnost.",
                            tickets: "Cestovní balíčky zahrnují vstupenky na destinace, pokud není uvedeno jinak.",
                            meals: "Jednodenní cesty nezahrnují jídla, pokud není výslovně uvedeno.",
                        },
                        luxuryTransport: "Připojte se k našemu luxusnímu dopravnímu systému",
                        luxuryTransportAlt1: "Luxusní dopravní vozidlo 1",
                        luxuryTransportAlt2: "Luxusní dopravní vozidlo 2",
                        getInTouch: "Kontaktujte nás a zjistěte o našich balíčcích",
                        getInTouchDescription: "Kontaktujte nás ještě dnes a objevte nejlepší cestovní nabídky přizpůsobené vám.",
                        contactUs: "Kontaktujte nás",
                        bookingMessage: "Žádost o rezervaci Ashan Tours\nBalíček: {{title}}\nDoba trvání: {{duration}}\nMísto: {{location}}",
                        manualBookingMessage: "Prosím, ručně odešlete následující zprávu na {{number}}:\n\n{{message}}",
                        errorBookingMessage: "Došlo k chybě. Prosím, ručně odešlete následující zprávu na {{number}}:\n\n{{message}}",
                        packages: {
                            ella: {
                                title: "Ella",
                                duration: "1 den",
                                location: "Ella - Srí Lanka",
                                description: "Objevte ohromující přírodní krásu Elly s jejími bujnými čajovými plantážemi, úchvatnými výhledy a ikonickým Mostem devíti oblouků.",
                            },
                            galleFort: {
                                title: "Pevnost Galle",
                                duration: "1 den",
                                location: "Galle - Srí Lanka",
                                description: "Vraťte se v čase s návštěvou historické pevnosti Galle, místa světového dědictví UNESCO plného koloniálního kouzla a pobřežní krásy.",
                            },
                            yalaSafari: {
                                title: "Safari v Yala",
                                duration: "1 den",
                                location: "Yala - Srí Lanka",
                                description: "Vydejte se na dobrodružné safari v Národním parku Yala, domově leopardů, slonů a řady exotických zvířat.",
                            },
                            kandy: {
                                title: "Kandy",
                                duration: "1 den",
                                location: "Kandy - Srí Lanka",
                                description: "Objevte kulturní srdce Srí Lanky s návštěvou Kandy, včetně posvátného Chrámu Buddhova zubu.",
                            },
                            sigiriya: {
                                title: "Sigiriya",
                                duration: "1 den",
                                location: "Sigiriya - Srí Lanka",
                                description: "Vylezte na starověkou skalní pevnost Sigiriya a obdivujte její úžasné fresky a dechberoucí panoramatické výhledy.",
                            },
                            udawalawe: {
                                title: "Udawalawe",
                                duration: "1 den",
                                location: "Udawalawe - Srí Lanka",
                                description: "Užijte si vzrušující safari v Národním parku Udawalawe, proslulém velkou populací slonů a malebnými krajinami.",
                            },
                            colomboCityEscape: {
                                title: "Únik do města Kolombo",
                                duration: "1 den",
                                location: "Kolombo - Srí Lanka",
                                description: "Prozkoumejte pulzující město Kolombo s jeho rušnými trhy, kulturními památkami a moderními zajímavostmi.",
                            },
                            mirissaWhaleWatching: {
                                title: "Pozorování velryb v Mirisse",
                                duration: "1 den",
                                location: "Mirissa - Srí Lanka",
                                description: "Vyplujte na nezapomenutelné dobrodružství při pozorování velryb u pobřeží Mirissy, kde na vás čekají majestátní modré velryby.",
                            },
                            mirissaWhaleWatchingComfort: {
                                title: "Pozorování velryb v Mirisse s vysoce komfortní lodí",
                                duration: "1 den",
                                location: "Mirissa - Srí Lanka",
                                description: "Vyplujte na nezapomenutelné dobrodružství při pozorování velryb u pobřeží Mirissy, kde na vás čekají majestátní modré velryby.",
                            },
                            bentotaRiverSafari: {
                                title: "Říční safari v Bentotě",
                                duration: "1 den",
                                location: "Bentota - Srí Lanka",
                                description: "Plujte po klidné řece Bentota, obklopeni bujnými mangrovy a exotickou divokou přírodou, pro klidný únik.",
                            },
                            ellaYala: {
                                title: "Ella a Yala",
                                duration: "1 den",
                                location: "Ella a Yala - Srí Lanka",
                                description: "Zažijte dokonalou kombinaci malebné krásy Elly a vzrušujícího safari s divokou přírodou v Yala během jednoho dne.",
                            },
                            ellaGalle: {
                                title: "Ella a Galle",
                                duration: "1 den",
                                location: "Ella a Galle - Srí Lanka",
                                description: "Objevte dechberoucí krajiny Elly a koloniální kouzlo Galle během dne plného divů.",
                            },
                            yalaGalle: {
                                title: "Yala a Galle",
                                duration: "1 den",
                                location: "Yala a Galle - Srí Lanka",
                                description: "Spojte vzrušení ze safari v Yala s návštěvou malebné pevnosti Galle pro skutečně rozmanitý zážitek.",
                            },
                            ellaYalaTwoDays: {
                                title: "Ella a Yala",
                                duration: "2 dny",
                                location: "Ella a Yala - Srí Lanka",
                                description: "Stravte dva dny prozkoumáváním malebných vysočin Elly a krajin bohatých na divokou přírodu v Národním parku Yala.",
                            },
                            kandyTwoDays: {
                                title: "Kandy",
                                duration: "2 dny",
                                location: "Ella a Yala - Srí Lanka",
                                description: "Stravte dva dny prozkoumáváním malebných vysočin Elly a krajin bohatých na divokou přírodu v Národním parku Yala.",
                            },
                            ellaNuwaraEliyaKandy: {
                                title: "Ella/Nuwara Eliya/Kandy",
                                duration: "2 dny",
                                location: "Ella/Nuwara Eliya/Kandy - Srí Lanka",
                                description: "Navštivte čajové plantáže Nuwara Eliya, bujnou zeleň Elly a kulturní skvosty Kandy během dvoudenní cesty.",
                            },
                            kandySigiriya: {
                                title: "Kandy a Sigiriya",
                                duration: "2 dny",
                                location: "Kandy a Sigiriya - Srí Lanka",
                                description: "Užijte si kulturní cestu do Kandy a vylezte na ikonickou skalní pevnost Sigiriya během dvoudenního dobrodružství.",
                            },
                            ellaNuwaraEliya: {
                                title: "Ella a Nuwara Eliya",
                                duration: "2 dny",
                                location: "Ella a Nuwara Eliya - Srí Lanka",
                                description: "Ponořte se do přírodní krásy Elly a chladné, klidné atmosféry Nuwara Eliya během dvou dnů.",
                            },
                            sigiriKandyElla: {
                                title: "Sigiriya/Kandy/Ella",
                                duration: "3 dny",
                                location: "Sigiriya/Kandy/Ella - Srí Lanka",
                                description: "Prozkoumejte Sigiriyu, kulturní památky Kandy a malebné krajiny Elly během tří nezapomenutelných dnů.",
                            },
                            kandyNuwaraEliyaEllaYala: {
                                title: "Kandy/Nuwara Eliya/Ella/Yala",
                                duration: "3 dny",
                                location: "Kandy/Nuwara Eliya/Ella/Yala - Srí Lanka",
                                description: "Objevte rozmanité zajímavosti Srí Lanky, od kultury Kandy po divokou přírodu Yala, během třídenní pohlcující cesty.",
                            },
                            sigiriyaAnuradhapuraPolonnaruwaMinneriya: {
                                title: "Sigiriya/Anuradhapura/Polonnaruwa/Safari v Národním parku Minneriya",
                                duration: "3 dny",
                                location: "Sigiriya/Anuradhapura/Polonnaruwa/Národní park Minneriya - Srí Lanka",
                                description: "Navštivte starověká města Sigiriya, Anuradhapura a Polonnaruwa a užijte si safari v Národním parku Minneriya.",
                            },
                            twentyDayTour: {
                                title: "Až 20denní cestovní balíček",
                                duration: "20 dní",
                                location: "Srí Lanka",
                                description: "Vydejte se na nezapomenutelnou 20denní cestu po Srí Lance a prozkoumejte její kulturní, přírodní a historické divy od Negomba po Bentotu.",
                            },
                        },
                        destinations: {
                            ravanaWaterfall: "Vodopád Ravana",
                            nineArchBridge: "Most devíti oblouků",
                            teaPlantation: "Čajová plantáž",
                            trainRide: "Jízda vlakem",
                            littleAdamsPeak: "Malý Adamův vrch",
                            udawalaweElephant: "Krmení slonů mlékem v Udawalawe",
                            ayurvedicHerbalGarden: "Ájurvédská bylinná zahrada",
                            templeKandeViharaya: "Chrám Kande Viharaya",
                            turtleHatchery: "Líheň želv",
                            boatSafari: "Lodní safari",
                            moonstoneMine: "Důl na měsíční kameny",
                            hikkaduwaBeach: "Pláž Hikkaduwa - Plavání s želvami",
                            dutchFortGalle: "Nizozemská pevnost Galle",
                            yala: "Yala",
                            yalaSafariJeep: "Safari v Yala džípem",
                            kandy: "Kandy",
                            royalBotanicalGarden: "Královská botanická zahrada",
                            teaFactoryPlantation: "Továrna na čaj a plantáž",
                            elephantFeeding: "Krmení, koupání a jízda na slonech",
                            ambuluwawaTowerOrTemple: "Věž Ambuluwawa nebo Chrám Buddhova zubu",
                            jewelleryGemFactory: "Továrna na šperky a drahokamy",
                            silkFactory: "Továrna na hedvábí",
                            sigiriya: "Sigiriya",
                            sigiriyaLionRock: "Lví skála Sigiriya",
                            dambullaGoldenTemple: "Zlatý chrám Dambulla",
                            villageTour: "Prohlídka vesnice s tradičním srílanským jídlem",
                            pidurangalaRock: "Skála Pidurangala",
                            udawalawe: "Udawalawe",
                            udawalaweNationalPark: "Národní park Udawalawe",
                            jeepSafari: "Safari džípem",
                            elephantMilkFeeding: "Krmení slonů mlékem",
                            lotusTower: "Věž Lotus",
                            redMosque: "Červená mešita",
                            shopping: "Nakupování",
                            blueWhales: "Modré velryby",
                            mirissa: "Mirissa",
                            stiltFishing: "Chůdové rybaření",
                            bentotaRiver: "Řeka Bentota",
                            bentota: "Bentota",
                            safariYalaNationalPark: "Safari v Národním parku Yala džípem",
                            gadoladeniyaTemple: "Chrám Gadoladeniya",
                            templeOfTheToothRelic: "Chrám Buddhova zubu",
                            traditionalKandyanDance: "Tradiční kandyjský tanec",
                            luxuryHotelStay: "Pobyt v luxusním hotelu se snídaní a večeří",
                            teaFactory: "Továrna na čaj",
                            nuwaraEliyaTown: "Město Nuwara Eliya",
                            ambuluwawaTower: "Věž Ambuluwawa",
                            hinduTemple: "Hinduistický chrám",
                            gregoryLake: "Jezero Gregory",
                            postOffice: "Pošta",
                            hortanPlains: "Hortonovy pláně",
                            sitaAmmanHinduKovil: "Hinduistický chrám Sita Amman",
                            botanicalGarden: "Botanická zahrada",
                            rambodaWaterfall: "Vodopád Ramboda",
                            sigiriyaRockFortress: "Skalní pevnost Sigiriya",
                            anuradhapura: "Anuradhapura",
                            polonnaruwa: "Polonnaruwa",
                            minneriyaNationalPark: "Národní park Minneriya",
                            elephants: "Sloni",
                            day1: "Den 1: Letiště – Negombo: Přejezd do Negomba a časný check-in, Lodní výlet přes močál Muthurajawela, Relaxace – Plavání – Lenšení – Houpací síť – Wellness – Opalování – Sporty – Vodní sporty, Přenocování a snídaně v Negombu",
                            day2: "Den 2: Negombo – Anuradhapura: Posvátné město Anuradhapura (místo světového dědictví UNESCO), Strom Srí Maha Bodhi, Procházka kolem malebných nádrží, Přenocování a snídaně v Anuradhapuře",
                            day3: "Den 3: Anuradhapura – Minneriya – Habarana: Socha Buddhy v Aukaně, Vesnické safari včetně jízdy na katamaránu a tuk-tuku s obědem, Safari džípem v Národním parku Minneriya, Přenocování a snídaně v Habaraně",
                            day4: "Den 4: Habarana – Sigiriya – Ritigala – Trincomalee: Skalní pevnost Sigiriya (místo světového dědictví UNESCO), Klášter Ritigala, Přenocování a snídaně v Trincomalee",
                            day5: "Den 5: Trincomalee: Relaxace – Plavání – Lenšení – Houpací síť – Wellness – Opalování – Sporty – Vodní sporty, Přenocování a snídaně v Trincomalee",
                            day6: "Den 6: Trincomalee: Prohlídka města Trincomalee, Narozeniny Steffi Bäuml, Relaxace – Plavání – Lenšení – Houpací síť – Wellness – Opalování – Sporty – Vodní sporty, Překvapivý kuchařský kurz pro dvě ženy, Přenocování a snídaně v Trincomalee",
                            day7: "Den 7: Trincomalee: Šnorchlovací výlet na Ostrov holubů, Relaxace – Plavání – Lenšení – Houpací síť – Wellness – Opalování – Sporty – Vodní sporty, Přenocování a snídaně v Trincomalee",
                            day8: "Den 8: Trincomalee: Relaxace – Plavání – Lenšení – Houpací síť – Wellness – Opalování – Sporty – Vodní sporty, Přenocování a snídaně v Trincomalee",
                            day9: "Den 9: Trincomalee – Dambulla – Matale – Peradeniya – Kandy: Jeskyňní chrám Dambulla (místo světového dědictví UNESCO), Kořenová zahrada v Matale, Královské botanické zahrady Peradeniya s piknikem, Procházka starým městem Kandy, Přenocování a snídaně v Kandy",
                            day10: "Den 10: Kandy: Chrám Buddhova zubu v Kandy (místo světového dědictví UNESCO), Večerní představení kandyjského tance, Přenocování a snídaně v Kandy",
                            day11: "Den 11: Kandy – Nuwara Eliya – Ella: Čajové plantáže a sběr čaje, Návštěva továrny na čaj, Vodopády Ramboda, Nuwara Eliya – město nad oblaky, Procházka Elly, Přenocování a snídaně v Elle",
                            day12: "Den 12: Ella – Badulla: Jízda vlakem z Elly do Badully (2. třída), Pěší túry v okolí Elly, Volitelné: Zip lining, Přenocování a snídaně v Elle",
                            day13: "Den 13: Ella – Yala: Vodopády Ravana, Údolí Ella Gap, Safari džípem v Národním parku Yala, Přenocování a snídaně v Tissamaharamě",
                            day14: "Den 14: Yala – Udawalawe – Sinharaja: Návštěva Domova pro slony během krmení, Jízda do pralesní rezervace Sinharaja (místo světového dědictví UNESCO), Přenocování a snídaně v Sinharaje",
                            day15: "Den 15: Sinharaja: Prohlídka pralesní rezervace Sinharaja s průvodcem (přírodní místo světového dědictví UNESCO), Přenocování a snídaně v Sinharaje",
                            day16: "Den 16: Sinharaja – Galle: Staré město Galle, Pevnost Galle (místo světového dědictví UNESCO), Přenocování a snídaně v Galle",
                            day17: "Den 17: Galle – Mirissa – Bentota: Pobřežní safari z Mirissy, Projekt ochrany želv, Přenocování a snídaně v Bentotě",
                            day18_19: "Den 18–19: Bentota: Relaxace – Plavání – Lenšení – Houpací síť – Wellness – Opalování – Sporty – Vodní sporty, Přenocování a snídaně v Bentotě",
                            day20: "Den 20: Bentota – Letiště: Přejezd na letiště",
                        },
                    },
                    footerSection: {
                        ashanTours: 'Ashan Tours Srí Lanka',
                        getInTouch: 'Kontaktujte nás',
                        address: '293/C/3, Maradana Road, Moragalla, Beruwala, Srí Lanka',
                        email: 'ashantourssl@gmail.com',
                        phone: '+94 77 959 0011',
                        stayConnected: 'Zůstaňte v kontaktu',
                        emailPlaceholder: 'Zadejte svou e-mailovou adresu',
                        socialMedia: {
                            facebook: 'Facebook',
                            instagram: 'Instagram',
                            youtube: 'YouTube',
                            twitter: 'Twitter',
                        },
                        copyright: '© {{year}} Ashan Tours Srí Lanka. Všechna práva vyhrazena.',
                        designedBy: 'Web navržen a vyvinut společností Redev Solutions',
                        designedByPhone: '+94 76 460 8225',
                    },
                    ayurvedaPage: {
                        title: "Ájurvéda - starověká věda o životě",
                        mainDescription: "Slovo 'Ájurvéda' existuje již více než tři tisíce let. V sanskrtu znamená 'věda o životě'. Tato technika vychází z ájurvédského pohledu na léčení nemocí, nikoli jejich důsledků, což je obvykle v rozporu s evropskou medicínou. Základními principy jsou:",
                        principles: {
                            energyBalance: "Tělo by mělo být bez přebytečné energie a udržovat rovnováhu pro normální metabolickou a srdeční činnost.",
                            muscleHormonal: "Tělo by mělo mít normální svalové kontrakce s pravidelnou hormonální aktivitou.",
                            immuneSystem: "Tělo potřebuje zdravý imunitní systém, aby správně fungovalo."
                        },
                        trainingDescription: "Podle nedávných údajů je na Srí Lance více než 6 000 absolventů vyškolených v ájurvédě. Absolvují sedm let studia a dva roky praxe ve veřejných nemocnicích. Ájurvédské programy zahrnují:",
                        programs: {
                            stressRelief: "Odstranění stresu, únavy a úzkosti",
                            oxygenSaturation: "Saturace kyslíkem",
                            muscularToxins: "Stimulace svalových systémů a eliminace toxinů",
                            nervousSystem: "Obnovení rovnováhy nervového systému",
                            bloodFlow: "Obnovení krevního oběhu do vnitřních orgánů",
                            endorphins: "Produkce endorfinů"
                        },
                        images: {
                            mainAlt: "Ájurvéda",
                            faceTreatmentAlt: "Ájurvédská péče o obličej",
                            massageTreatmentAlt: "Ájurvédská masážní terapie"
                        },
                        treatmentDescription: "Standardní procedury zahrnují masáže těla a pokožky hlavy pomocí speciálních olejů, bylinné saunové procedury a koupele s bylinami. Nejpopulárnější technikou je procedura 'Shirodhara', při které se teplý bylinný olej rytmicky kape na čelo. To pomáhá obnovit rovnováhu nervového systému a dosáhnout relaxace.",
                        tipsTitle: "Tipy pro ájurvédskou léčbu",
                        tips: {
                            relaxMind: "Zapomeňte na problémy. Uvolněte se a vyčistěte si mysl pro nejlepší výsledky.",
                            chooseLocation: "Vyberte správné místo. Zvolte prostředí, které odpovídá vašemu pohodlí a preferencím pro optimální léčení.",
                            selectProgram: "Vyberte správný program. Proberte své potíže s lékařem a vyzkoušejte různé terapie, abyste našli tu nejvhodnější.",
                            warmBath: "Před procedurou si dejte teplou koupel, abyste uvolnili svaly a připravili tělo.",
                            lightMeal: "Před procedurou jezte lehké jídlo. Vyhněte se těžkým jídlům, aby během masáže byl zajištěn správný krevní oběh.",
                            postRelaxation: "Relaxace po procedurách je nezbytná. Správná relaxace zvyšuje účinnost ájurvédských terapií."
                        },
                    },
                    ballooningPage: {
                        title: "Let balónem na Srí Lance",
                        mainDescription: "Let horkovzdušným balónem na Srí Lance nabízí nezapomenutelný zážitek z jemného vznášení se nad úchvatnou krajinou ostrova. Výlety začínají při východu slunce a poskytují dechberoucí letecké výhledy na zvlněné kopce, bujné lesy, starověké ruiny a klidné vesnice.",
                        dambullaDescription: "Nejpopulárnější destinací pro let balónem na Srí Lance je Dambulla, která se nachází v srdci kulturního trojúhelníku. Lety zde často zahrnují pohled na ikonickou skalní pevnost Sigiriya, což nabízí jedinečný pohled. Lety obvykle trvají 60–90 minut, což vám dává dostatek času na vychutnání krás Srí Lanky shora.",
                        highlightsTitle: "Proč vyzkoušet let horkovzdušným balónem na Srí Lance?",
                        highlightsDescription: "Let horkovzdušným balónem kombinuje dobrodružství s klidem a umožňuje zažít krásu Srí Lanky jedinečným způsobem. Mezi hlavní přednosti patří:",
                        highlights: {
                            panoramicViews: "Nepřerušované panoramatické výhledy na úchvatnou krajinu ostrova.",
                            landmarks: "Let nad ikonickými památkami, jako je Skalní pevnost Sigiriya a blízká jezera.",
                            peacefulRide: "Klidná a mírumilovná jízda nad bujnou zelení a okouzlujícími vesnicemi.",
                            sunrise: "Pozorování nádherného východu slunce z nebe.",
                            photography: "Ideální pro milovníky fotografování, kteří chtějí zachytit malebnou krásu shora."
                        },
                        images: {
                            mainAlt: "Let horkovzdušným balónem na Srí Lance",
                            sunriseAlt: "Východ slunce při letu balónem",
                            sunriseCaption: "Užijte si dechberoucí výhledy na východ slunce při klidném vznášení v horkovzdušném balónu.",
                            landscapeAlt: "Krajina při letu balónem",
                            landscapeCaption: "Objevte úchvatné krajiny Srí Lanky shora, včetně zvlněných kopců a bujných lesů."
                        },
                        tipsTitle: "Tipy pro nezapomenutelný let balónem",
                        tips: {
                            bookEarly: "Rezervujte si let brzy, protože balónové lety závisí na počasí a místa se rychle plní.",
                            clothing: "Noste pohodlné oblečení a vezměte si lehkou bundu, protože časná rána mohou být chladná.",
                            camera: "Vezměte si fotoaparát nebo chytrý telefon, abyste zachytili úžasné výhledy.",
                            safety: "Pozorně poslouchejte bezpečnostní pokyny poskytnuté vaším pilotem.",
                            arriveEarly: "Přijďte včas, abyste mohli sledovat přípravu a nafukování balónu, což je fascinující proces."
                        },
                    },
                    divingPage: {
                        title: "Potápění na Srí Lance",
                        mainDescription: "Rozsáhlý korálový útes obklopuje pobřeží Srí Lanky v hloubkách od 2 do 40 metrů. Teplé vody Indického oceánu, mezi 27 °C a 30 °C, a vysoká průzračnost vody, od 15 do 35 metrů, poskytují vynikající podmínky pro potápění a šnorchlování. Při potápění na Srí Lance můžete prozkoumat nekonečné nedotčené korálové útesy, staré vraky a fascinující podvodní jeskyně.",
                        northeastDescription: "Severovýchod ostrova nabízí více než 130 druhů barevných korálů, které jsou domovem mořského života, jako jsou mořské želvy, klauni, lví ryby a mořští koníci. Navštivte vraky lodí poblíž podvodních skal a útesů pro nezapomenutelný zážitek. Při plavání v průzračných vodách se ponoříte do fascinující minulosti Cejlonu.",
                        facilitiesTitle: "Vybavení a nejlepší potápěčská místa",
                        facilitiesDescription: "Potápěčská centra na ostrově jsou vybavena nejnovějším potápěčským vybavením od renomovaných výrobců. Certifikovaní instruktoři s kvalifikacemi PADI a CMAS zajišťují bezpečné a příjemné potápění. Potápěčská centra se nacházejí podél jihozápadního pobřeží ostrova a fungují od poloviny října do konce dubna. Severovýchodní pobřeží, včetně Nilaveli a Trincomalee, je ideální pro potápění od března do října.",
                        popularSpots: "Korálové útesy poblíž Kalpitiya na západě a potápěčská místa s vraky lodí v Hikkaduwě patří mezi nejoblíbenější atrakce pro potápěče.",
                        images: {
                            mainAlt: "Potápění na Srí Lance",
                            coralReefAlt: "Potápění u korálových útesů",
                            coralReefCaption: "Prozkoumejte živé korálové útesy, které jsou domovem rozmanitého mořského života.",
                            shipwreckAlt: "Potápění k vrakům lodí",
                            shipwreckCaption: "Objevte historické vraky lodí, které nabízejí pohled do námořní minulosti Srí Lanky."
                        },
                        tipsTitle: "Tipy pro potápěče",
                        tips: {
                            season: "Vyberte nejlepší sezónu pro potápění podle lokality: jihozápadní pobřeží (říjen až duben) nebo severovýchodní pobřeží (březen až říjen).",
                            certifiedCenter: "Ujistěte se, že vaše potápěčské centrum je certifikované a vybavené moderním vybavením pro bezpečný zážitek.",
                            instructorAdvice: "Poslouchejte rady svého instruktora, zejména pokud jste začátečník.",
                            respectMarineLife: "Respektujte mořský život tím, že se nedotýkáte korálů ani nerušíte podvodní prostředí.",
                            camera: "Vezměte si vodotěsný fotoaparát, abyste zachytili fascinující krásu podvodního světa Srí Lanky."
                        },
                    },
                    elephantRidePage: {
                        title: "Jízda na slonovi",
                        mainDescription: "Jízda na slonovi je fascinující a vzrušující aktivitou a jedinečným zážitkem na Srí Lance. Pokud pobýváte poblíž kulturního trojúhelníku v oblastech jako Habarana, Sigiriya nebo Dambulla, můžete se zúčastnit safari na slonech. Tyto jízdy začínají přibližně na 30 USD za hodinu nezapomenutelného dobrodružství.",
                        rideDescription: "Před jízdou jsou sloni osedláni vícekošovým sedlem určeným pro 4 až 6 osob. Tyto jemné obry vás provedou malebnými stezkami v džungli, překročí zaplavené oblasti a procházejí bujnou vegetací. Sloni obvykle kráčejí pomalu, což vám umožní plně si vychutnat krásu okolní přírody, i když mohou dosáhnout rychlosti až 40 km/h.",
                        highlightsTitle: "Hlavní přednosti jízdy na slonovi",
                        highlightsDescription: "Jízda na slonovi na Srí Lance poskytuje jedinečný způsob, jak se spojit s přírodou a prozkoumat venkov. Mezi hlavní přednosti zážitku patří:",
                        highlights: {
                            junglePaths: "Procházka hustými džunglemi plnými exotické vegetace a divoké přírody.",
                            riverCrossing: "Překračování řek a zaplavených oblastí s nádhernými výhledy na přírodní krajinu.",
                            culturalConnection: "Seznámení se s blízkým vztahem mezi slony a srílanskou kulturou.",
                            comfortableRide: "Relaxace na pohodlném sedle, zatímco vás slon jemně nese přes různé terény."
                        },
                        images: {
                            mainAlt: "Jízda na slonovi",
                            jungleAlt: "Stezka v džungli při jízdě na slonovi",
                            jungleCaption: "Prozkoumejte husté džungle a malebné stezky při jízdě na slonovi.",
                            waterAlt: "Slon překračující vodu",
                            waterCaption: "Překročte řeky a užijte si klidnou krásu vody a vegetace."
                        },
                        tipsTitle: "Tipy pro bezpečnou a příjemnou jízdu na slonovi",
                        tips: {
                            clothing: "Noste pohodlné oblečení a obuv vhodnou pro venkovní aktivity.",
                            guideInstructions: "Dodržujte pokyny svého průvodce pro bezpečnou a příjemnou jízdu.",
                            ethicalPractices: "Ujistěte se, že se se slony zachází dobře a poskytovatel jízdy dodržuje etické postupy.",
                            camera: "Vezměte si fotoaparát, abyste zachytili dechberoucí scenérie a momenty.",
                            respectElephants: "Respektujte slony a vyhněte se činnostem, které by je mohly stresovat nebo jim ublížit."
                        },
                    },
                    fishingPage: {
                        title: "Rybaření na Srí Lance",
                        mainDescription: "Srí Lanka se svým rozsáhlým pobřežím a hojností sladkovodních jezer a řek nabízí jedinečný rybářský zážitek. Ať už jste profesionální rybář nebo amatér, Srí Lanka má co nabídnout. Od výprav na hlubinné rybaření po tradiční chůdové rybaření praktikované místními rybáři, zažijete nezapomenutelné dobrodružství.",
                        destinationsDescription: "Mezi oblíbené rybářské destinace patří jižní pobřeží kolem Galle a Mirissy, laguna Negombo a klidné vody Trincomalee. V závislosti na vašich preferencích můžete vyzkoušet různé rybářské techniky, jako je trolling, rybaření na dně nebo muškaření.",
                        experiencesTitle1: "Rybářské zážitky na Srí Lance",
                        experiencesDescription: "Rybaření na Srí Lance není jen o chytání ryb; je to příležitost ponořit se do kultury a tradic ostrova. Mezi jedinečné rybářské zážitky patří:",
                        experiences: {
                            stiltFishingTitle: "Chůdové rybaření",
                            stiltFishing: "Tradiční metoda, při které rybáři sedí na chůdách a loví ryby poblíž břehu, což je pro Srí Lanku jedinečné.",
                            deepSeaFishingTitle: "Hlubinové rybaření",
                            deepSeaFishing: "Vydejte se do Indického oceánu chytat marlíny, tuňáky, barakudy a další velké druhy ryb.",
                            lagoonFishingTitle: "Rybaření v lagunách a řekách",
                            lagoonFishing: "Relaxujte při rybaření v klidných lagunách a řekách plných ryb, jako jsou tilapie a sumci.",
                            nightFishingTitle: "Noční rybaření",
                            nightFishing: "Zažijte vzrušení z rybaření pod hvězdami, což je běžná praxe v pobřežních vesnicích."
                        },
                        images: {
                            mainAlt: "Rybaření na Srí Lance",
                            stiltFishingAlt: "Chůdové rybaření na Srí Lance",
                            stiltFishingCaption: "Chůdové rybaření je tradiční metoda a ikonický obraz rybářského dědictví Srí Lanky.",
                            deepSeaFishingAlt: "Hlubinové rybaření na Srí Lance",
                            deepSeaFishingCaption: "Hlubinové rybaření nabízí dobrodružný zážitek při lovu velkých druhů ryb v Indickém oceánu."
                        },
                        tipsTitle: "Tipy pro příjemný rybářský výlet",
                        tips: {
                            season: "Vyberte správnou sezónu pro váš rybářský výlet; říjen až duben je ideální pro jižní pobřeží, zatímco březen až říjen vyhovuje východnímu pobřeží.",
                            protection: "Vezměte si opalovací krém, klobouk a ochranné oblečení, abyste byli během výletu v pohodlí.",
                            guide: "Rezervujte si rybářského průvodce nebo pronájem lodi, abyste svůj zážitek co nejvíce využili a učili se od odborníků.",
                            environment: "Respektujte místní prostředí tím, že nebudete odhazovat odpadky a budete dodržovat udržitelné rybářské praktiky.",
                            hydration: "Zůstaňte hydratovaní a vezměte si svačiny na delší rybářské výlety."
                        },
                    },
                    jeepSafariPage: {
                        title: "Safari džípem na Srí Lance",
                        mainDescription: "Národní parky Srí Lanky nabízejí vzrušující zážitek ze safari džípem, který vám umožní prozkoumat bohatou biodiverzitu ostrova a pozorovat divokou přírodu v jejich přirozených stanovištích. Národní parky Yala, Wilpattu a Udawalawe patří mezi nejoblíbenější destinace pro safari džípem.",
                        wildlifeDescription: "Tato safari poskytují příležitost spatřit slony, leopardy, medvědy pyskaté, buvoly, krokodýly a širokou škálu druhů ptáků. Safari vedená zkušenými přírodovědci a stopaři jsou ideální pro milovníky divoké přírody a fotografy.",
                        whyChooseTitle: "Proč si vybrat safari džípem?",
                        whyChooseDescription: "Safari džípem je jedním z nejlepších způsobů, jak prozkoumat rozmanitou divokou přírodu Srí Lanky. Mezi hlavní přednosti patří:",
                        whyChoose: {
                            encounters: "Blízká setkání s ikonickými druhy, jako jsou sloni a leopardy.",
                            remoteAreas: "Přístup do odlehlých a malebných oblastí v národních parcích.",
                            photography: "Příležitosti pro fotografování divoké přírody v přirozeném prostředí.",
                            guidance: "Vedení zkušenými přírodovědci a strážci parků.",
                            adventure: "Dobrodružství vhodné pro všechny věkové skupiny, kombinující vzrušení s vzděláváním."
                        },
                        images: {
                            mainAlt: "Safari džípem na Srí Lance",
                            wildlifeAlt: "Divoká příroda při safari džípem",
                            wildlifeCaption: "Pozorujte ikonickou divokou přírodu, jako jsou leopardy, sloni a krokodýli, během vašeho safari.",
                            landscapeAlt: "Krajina při safari džípem",
                            landscapeCaption: "Prozkoumejte úchvatné krajiny národních parků Srí Lanky, od hustých lesů po otevřené pláně."
                        },
                        tipsTitle: "Tipy pro příjemné safari džípem",
                        tips: {
                            clothing: "Noste pohodlné oblečení v neutrálních barvách, aby se sladilo s prostředím.",
                            protection: "Vezměte si opalovací krém, klobouk a repelent proti hmyzu pro ochranu.",
                            equipment: "Vezměte si dalekohled a fotoaparát, abyste mohli lépe pozorovat a zachytit divokou přírodu.",
                            guide: "Dodržujte pokyny průvodce, abyste zajistili bezpečnost a respekt vůči zvířatům.",
                            booking: "Rezervujte si safari brzy, zejména během hlavní sezóny, abyste si zajistili místo."
                        },
                    },
                    riverSafariPage: {
                        title: "Říční safari na Srí Lance",
                        mainDescription: "Říční safari na Srí Lance nabízí jedinečný způsob, jak prozkoumat bohatou biodiverzitu a malebnou krásu ostrova. Klouzejte po klidných vodních cestách obklopených bujnými mangrovy, pozorujte exotickou divokou přírodu a vychutnejte si malebné západy slunce, které vás okouzlí.",
                        destinationsDescription: "Mezi oblíbené destinace pro říční safari patří Madu Ganga (řeka Madu) a řeka Bentota. Tato safari poskytují příležitost spatřit různé druhy ptáků, varany, krokodýly a dokonce i opice v jejich přirozených stanovištích. Klidné prostředí je ideální pro milovníky přírody a fotografy.",
                        whyChooseTitle: "Proč si vybrat říční safari?",
                        whyChooseDescription: "Říční safari je relaxační a pohlcující zážitek, který kombinuje přírodu, divokou přírodu a kulturní průzkum. Mezi hlavní přednosti patří:",
                        whyChoose: {
                            mangroves: "Prozkoumání bujných mangrovů plných života.",
                            wildlife: "Pozorování exotických ptáků, krokodýlů a další divoké přírody.",
                            villages: "Návštěva malých ostrovů a místních vesnic podél řeky.",
                            tranquility: "Užití klidu a malebné krásy vodních cest Srí Lanky.",
                            suitable: "Ideální pro rodiny, páry a samostatné cestovatele hledající klidný únik."
                        },
                        images: {
                            mainAlt: "Říční safari na Srí Lance",
                            mangrovesAlt: "Mangrovy při říčním safari",
                            mangrovesCaption: "Objevte bujné mangrovy lemující malebné vodní cesty Srí Lanky.",
                            wildlifeAlt: "Divoká příroda při říčním safari",
                            wildlifeCaption: "Pozorujte exotickou divokou přírodu, jako jsou krokodýli, varani a barevní ptáci, během vašeho safari."
                        },
                        tipsTitle: "Tipy pro příjemné říční safari",
                        tips: {
                            clothing: "Noste pohodlné oblečení a vezměte si klobouk a opalovací krém pro ochranu.",
                            binoculars: "Vezměte si dalekohled, abyste mohli pozorovat vzdálenou divokou přírodu a ptáky.",
                            camera: "Vezměte si fotoaparát nebo chytrý telefon, abyste zachytili úžasné scenérie a divokou přírodu.",
                            guide: "Dodržujte pokyny svého průvodce pro bezpečný a příjemný zážitek.",
                            environment: "Respektujte přírodní prostředí tím, že nebudete odhazovat odpadky a rušit divokou přírodu."
                        },
                    },
                    snorkelingPage: {
                        title: "Šnorchlování na Srí Lance",
                        mainDescription: "Šnorchlování na Srí Lance nabízí nezapomenutelný podvodní zážitek, při kterém můžete prozkoumat živé korálové útesy a rozmanitý mořský život. Díky průzračným vodám a bohatým vodním ekosystémům je Srí Lanka rájem pro šnorchlaře všech úrovní dovedností.",
                        destinationsDescription: "Mezi nejoblíbenější místa pro šnorchlování patří Hikkaduwa, známá svými barevnými korálovými zahradami a želvami, Ostrov holubů v Trincomalee, proslulý svými nedotčenými útesy, a Mirissa, kde během šnorchlovací sezóny můžete dokonce spatřit velrybu.",
                        whyChooseTitle: "Proč si vybrat šnorchlování na Srí Lance?",
                        whyChooseDescription: "Šnorchlování na Srí Lance je magický zážitek, který kombinuje dobrodružství a přírodní krásu. Mezi hlavní přednosti patří:",
                        whyChoose: {
                            coralReefs: "Prozkoumání živých korálových útesů plných života.",
                            marineLife: "Plavání vedle barevných tropických ryb, želv a dokonce útesových žraloků.",
                            landscapes: "Objevování nedotčených podvodních krajin v průzračných, teplých vodách.",
                            suitable: "Vhodné pro začátečníky i zkušené šnorchlaře.",
                            accessible: "Dostupné z některých nejlepších plážových destinací na Srí Lance."
                        },
                        images: {
                            mainAlt: "Šnorchlování na Srí Lance",
                            coralReefAlt: "Korálové útesy na Srí Lance",
                            coralReefCaption: "Objevte úchvatné korálové útesy a jejich živé ekosystémy.",
                            marineLifeAlt: "Mořský život na Srí Lance",
                            marineLifeCaption: "Setkejte se s rozmanitým mořským životem, včetně želv, tropických ryb a dalších."
                        },
                        tipsTitle: "Tipy pro nezapomenutelný zážitek ze šnorchlování",
                        tips: {
                            mask: "Noste pohodlnou masku a šnorchl, abyste zajistili jasný výhled pod vodou.",
                            sunscreen: "Používejte opalovací krém bezpečný pro útesy, abyste chránili svou kůži i mořský život.",
                            swimGently: "Plavte jemně, abyste nerušili korálové útesy a vodní tvory.",
                            hydration: "Zůstaňte hydratovaní a dělejte si přestávky mezi sezeními.",
                            guidedTour: "Připojte se k prohlídce s průvodcem pro nejlepší šnorchlovací místa a bezpečnostní tipy."
                        },
                    },
                    teaTastingPage: {
                        title: "Prohlídka s ochutnávkou čaje na Srí Lance",
                        mainDescription: "Srí Lanka, často označovaná jako 'Perla Indického oceánu', je proslulá svou prvotřídní produkcí čaje. Vydejte se na prohlídku s ochutnávkou čaje a prozkoumejte bujné čajové plantáže v oblastech jako Nuwara Eliya, Ella a Kandy. Dozvěděte se o umění pěstování čaje, pečlivém procesu výroby čaje a vychutnejte si bohaté chutě autentického cejlonského čaje.",
                        heritageDescription: "Ať už jste milovníkem čaje nebo jen zvědaví, prohlídka s ochutnávkou čaje nabízí jedinečnou příležitost ponořit se do čajového dědictví Srí Lanky a zažít klidnou krásu jejích vysočin.",
                        whyChooseTitle: "Proč si vybrat prohlídku s ochutnávkou čaje?",
                        whyChooseDescription: "Prohlídka s ochutnávkou čaje na Srí Lance není jen o ochutnávání čaje – je to pohlcující kulturní zážitek. Mezi hlavní přednosti patří:",
                        whyChoose: {
                            plantations: "Návštěva malebných čajových plantáží zasazených do chladných vysočin.",
                            history: "Seznámení s historií a významem cejlonského čaje.",
                            production: "Účast na sběru čaje a pozorování výrobního procesu v továrnách na čaj.",
                            varieties: "Ochutnávka různých druhů čaje, od černého přes zelený až po ochucené směsi.",
                            scenery: "Užití dechberoucí scenérie mlžných hor a kaskádovitých vodopádů."
                        },
                        images: {
                            mainAlt: "Prohlídka s ochutnávkou čaje na Srí Lance",
                            teaPlantationAlt: "Čajová plantáž na Srí Lance",
                            teaPlantationCaption: "Prozkoumejte bujné čajové plantáže a dozvěděte se o pěstování čaje.",
                            teaPreparationAlt: "Příprava čaje na Srí Lance",
                            teaPreparationCaption: "Objevte umění přípravy čaje a vychutnejte si autentický cejlonský čaj."
                        },
                        tipsTitle: "Tipy pro příjemnou prohlídku s ochutnávkou čaje",
                        tips: {
                            clothing: "Noste pohodlné oblečení a obuv vhodnou pro procházky po plantážích.",
                            jacket: "Vezměte si lehkou bundu, protože oblasti vysočin mohou být chladné a mlžné.",
                            varieties: "Vyzkoušejte různé druhy čaje a vezměte si domů své oblíbené jako suvenýry.",
                            questions: "Ptejte se během prohlídky, abyste se dozvěděli více o procesu výroby čaje.",
                            attractions: "Spojte svou čajovou prohlídku s návštěvami blízkých atrakcí, jako jsou vodopády a vyhlídky."
                        },
                    },
                    templeVisitPage: {
                        title: "Návštěva chrámů na Srí Lance",
                        mainDescription: "Srí Lanka, známá jako Země Buddhy, je domovem starověkých chrámů, které odrážejí její bohaté duchovní a kulturní dědictví. Vydejte se na cestu za objevováním ikonických chrámů, jako je Chrám Buddhova zubu v Kandy, Jeskyňní chrám Dambulla a Ruwanwelisaya v Anuradhapuře.",
                        spiritualDescription: "Tyto posvátné lokality, zdobené složitými řezbami, nástěnnými malbami a sochami, nabízejí pohled do duchovních tradic a architektonické nádhery ostrova. Návštěva chrámu není jen kulturním zážitkem, ale také příležitostí najít klid a pohodu.",
                        whyVisitTitle: "Proč navštívit chrámy na Srí Lance?",
                        whyVisitDescription: "Návštěva chrámů na Srí Lance nabízí jedinečnou příležitost spojit se s historií, kulturou a spiritualitou ostrova. Mezi hlavní přednosti patří:",
                        whyVisit: {
                            architecture: "Obdivování složité architektury a staletých soch.",
                            traditions: "Seznámení s buddhistickými tradicemi a rituály od zkušených průvodců.",
                            heritage: "Prozkoumání míst světového dědictví UNESCO, jako je Zlatý chrám Dambulla.",
                            serenity: "Zažití klidu a duchovní atmosféry posvátných prostor.",
                            festivals: "Pozorování živých festivalů, jako je Esala Perahera v Chrámu Buddhova zubu."
                        },
                        images: {
                            mainAlt: "Návštěva chrámů na Srí Lance",
                            templeInteriorAlt: "Interiér chrámu",
                            templeInteriorCaption: "Obdivujte úchvatné interiéry zdobené složitými řezbami a nástěnnými malbami.",
                            sacredTempleAlt: "Posvátný chrám na Srí Lance",
                            sacredTempleCaption: "Navštivte posvátné chrámy jako Ruwanwelisaya a ponořte se do duchovních tradic."
                        },
                        tipsTitle: "Tipy pro návštěvu chrámů na Srí Lance",
                        tips: {
                            dress: "Oblečte se skromně, zakryjte si ramena a kolena jako projev respektu.",
                            shoes: "Před vstupem do chrámových prostor si sundejte boty.",
                            touching: "Zdržte se dotýkání soch nebo posvátných předmětů.",
                            donation: "Přineste malý dar pro chrám, pokud chcete přispět.",
                            silence: "Respektujte ticho a duchovní atmosféru během vaší návštěvy."
                        },
                    },
                    whiteWaterRaftingPage: {
                        title: "Rafting na divoké vodě na Srí Lance",
                        mainDescription: "Rafting na divoké vodě na Srí Lance je vzrušující zážitek, zejména v Kitulgale, dobrodružném hlavním městě ostrova. Řeka Kelani se svými burácejícími peřejemi a malebným okolím nabízí ideální prostředí pro začátečníky i zkušené raftaře.",
                        destinationsDescription: "Raftingové výpravy obvykle pokrývají 5kilometrový úsek s peřejemi od stupně 2 do stupně 4. Účastníci si mohou užít vzrušení z navigace náročných proudů a přitom obdivovat bujnou zeleň a dechberoucí výhledy na břehy řeky.",
                        whyChooseTitle: "Proč si vybrat rafting na divoké vodě na Srí Lance?",
                        whyChooseDescription: "Rafting na divoké vodě na Srí Lance nabízí jedinečnou kombinaci dobrodružství a přírodní krásy. Mezi hlavní přednosti zážitku patří:",
                        whyChoose: {
                            rapids: "Navigace přes vzrušující peřeje pod vedením zkušených instruktorů.",
                            views: "Užití úchvatných výhledů na okolní deštný prales a horský terén.",
                            activities: "Kombinace raftingu s dalšími aktivitami, jako je pěší turistika, pozorování ptáků a canyoning v Kitulgale.",
                            suitable: "Ideální pro skupiny, rodiny nebo samostatné cestovatele hledající příval adrenalinu."
                        },
                        images: {
                            mainAlt: "Rafting na divoké vodě na Srí Lance",
                            actionRaftingAlt: "Akce při raftingu na divoké vodě",
                            actionRaftingCaption: "Pociťte příval adrenalinu při zdolávání náročných peřejí na řece Kelani.",
                            scenicRaftingAlt: "Malebné výhledy při raftingu na divoké vodě",
                            scenicRaftingCaption: "Užijte si klidnou krásu bujného okolí během vašeho raftingového dobrodružství."
                        },
                        tipsTitle: "Tipy pro bezpečný a vzrušující raftingový výlet",
                        tips: {
                            safetyGear: "Noste záchrannou vestu a helmu poskytnuté vaším raftingovým průvodcem pro bezpečnost.",
                            instructions: "Pozorně poslouchejte bezpečnostní pokyny před začátkem výletu.",
                            clothing: "Noste pohodlné, rychleschnoucí oblečení a bezpečnou obuv, jako jsou vodní boty.",
                            changeOfClothes: "Vezměte si náhradní oblečení a ručník na po výletu.",
                            operator: "Rezervujte si raftingový výlet u renomovaného operátora, abyste zajistili bezpečný a příjemný zážitek."
                        },
                    },
                    wildlifeSafariPage: {
                        title: "Safari za divokou přírodou na Srí Lance",
                        mainDescription: "Srí Lanka, známá svou bohatou biodiverzitou, nabízí neuvěřitelná safari za divokou přírodou v národních parcích jako Yala, Wilpattu, Minneriya a Udawalawe. Tato safari poskytují příležitost spatřit slony, leopardy, medvědy pyskaté a různé druhy ptáků v jejich přirozených stanovištích.",
                        destinationsDescription: "Prozkoumejte rozmanité krajiny od hustých lesů po otevřené pastviny a zachyťte nezapomenutelné momenty divoké přírody v akci. S odbornými průvodci a dobře udržovanými safari džípy je safari za divokou přírodou na Srí Lance nezbytností pro milovníky přírody a dobrodruhy.",
                        whyChooseTitle: "Proč si vybrat safari za divokou přírodou?",
                        whyChooseDescription: "Safari za divokou přírodou na Srí Lance nabízí jedinečnou příležitost spojit se s přírodou a prozkoumat pozoruhodnou biodiverzitu ostrova. Mezi hlavní přednosti patří:",
                        whyChoose: {
                            species: "Pozorování ikonických druhů, jako jsou sloni, leopardy a krokodýli.",
                            landscapes: "Prozkoumání bujných lesů, mokřadů a otevřených plání plných divoké přírody.",
                            photography: "Zachytení úchvatných fotografií divoké přírody v přirozeném prostředí.",
                            elusiveAnimals: "Zažití vzrušení z pozorování nepolapitelných zvířat, jako je srílanský leopard.",
                            conservation: "Seznámení s úsilím o ochranu přírody od zkušených průvodců a přírodovědců."
                        },
                        images: {
                            mainAlt: "Safari za divokou přírodou na Srí Lance",
                            elephantsAlt: "Sloni na Srí Lance",
                            elephantsCaption: "Pozorujte majestátní slony volně se pohybující v národních parcích Srí Lanky.",
                            leopardAlt: "Srílanský leopard",
                            leopardCaption: "Spatřete nepolapitelného srílanského leoparda, vrchol jakéhokoli safari za divokou přírodou."
                        },
                        tipsTitle: "Tipy pro vzrušující safari za divokou přírodou",
                        tips: {
                            clothing: "Noste oblečení v neutrálních barvách, aby se sladilo s prostředím.",
                            protection: "Vezměte si opalovací krém, klobouk a repelent proti hmyzu pro ochranu.",
                            equipment: "Vezměte si dalekohled a fotoaparát, abyste mohli lépe pozorovat a zachytit divokou přírodu.",
                            guide: "Dodržujte pokyny svého průvodce pro bezpečný a příjemný zážitek.",
                            booking: "Rezervujte si safari brzy, zejména během hlavní sezóny, abyste si zajistili místo v oblíbených parcích."
                        },
                    },
                    thingsToDoSection: {
                        title: 'Co dělat na Srí Lance',
                        viewMore: 'Zobrazit více',
                        activities: {
                            ayurveda: {
                                title: 'Ájurvéda - starověká věda o životě',
                                alt: 'Ájurvédská terapie na Srí Lance',
                            },
                            diving: {
                                title: 'Potápění na Srí Lance',
                                alt: 'Zážitky z potápění na Srí Lance',
                            },
                            elephantRide: {
                                title: 'Jízda na slonovi',
                                alt: 'Jízda na slonovi na Srí Lance',
                            },
                            fishing: {
                                title: 'Rybaření na Srí Lance',
                                alt: 'Rybářská aktivita na Srí Lance',
                            },
                            ballooning: {
                                title: 'Let balónem na Srí Lance',
                                alt: 'Let horkovzdušným balónem na Srí Lance',
                            },
                            jeepSafari: {
                                title: 'Safari v džípu',
                                alt: 'Safari v džípu na Srí Lance',
                            },
                            whiteWaterRafting: {
                                title: 'Rafting na divoké vodě',
                                alt: 'Rafting na divoké vodě na Srí Lance',
                            },
                            riverSafari: {
                                title: 'Říční safari',
                                alt: 'Říční safari na Srí Lance',
                            },
                            snorkeling: {
                                title: 'Šnorchlování na Srí Lance',
                                alt: 'Zážitky ze šnorchlování na Srí Lance',
                            },
                            teaTasting: {
                                title: 'Prohlídka s ochutnávkou čaje',
                                alt: 'Prohlídka s ochutnávkou čaje na Srí Lance',
                            },
                            templeVisit: {
                                title: 'Návštěva chrámů',
                                alt: 'Návštěva chrámů na Srí Lance',
                            },
                            wildlifeSafari: {
                                title: 'Safari za divokou přírodou',
                                alt: 'Safari za divokou přírodou na Srí Lance',
                            },
                        },
                    },
                    excursionsSection: {
                        title: 'Výlety',
                        excursions: {
                            oneDay: {
                                title: 'Jednodenní výlety',
                                description: 'Objevte úchvatné destinace během jednoho dne s průvodcem a místními zážitky.',
                                alt: 'Jednodenní výlet na Srí Lance',
                            },
                            twoDays: {
                                title: 'Dvoudenní výlety',
                                description: 'Užijte si krátké výlety s přenocováním a zažijte ještě více ze Srí Lanky.',
                                alt: 'Dvoudenní výlet na Srí Lance',
                            },
                            threeDays: {
                                title: 'Třídenní výlety',
                                description: 'Objevte více zajímavostí během tří dnů plných dobrodružství a odpočinku.',
                                alt: 'Třídenní výlet na Srí Lance',
                            },
                            fourDays: {
                                title: 'Čtyřdenní výlety',
                                description: 'Ideální pro delší cestu pokrývající více destinací v pohodlí.',
                                alt: 'Čtyřdenní výlet na Srí Lance',
                            },
                            twentyDays: {
                                title: '20denní výlety',
                                description: 'Vydejte se na epickou cestu po Srí Lance a prozkoumejte její kulturní, přírodní a historické divy.',
                                alt: '20denní výlet na Srí Lance',
                            },
                        },
                        bentotaExcursions: {
                            title: 'Výlety z Bentoty',
                            bentotaToYala: {
                                title: 'Bentota do Yaly',
                                description: 'Bentota -> Ella -> Yala',
                            },
                            bentotaToNuwaraEliya: {
                                title: 'Bentota do Nuwara Eliya',
                                description: 'Bentota -> Ella -> Kandy -> Nuwara Eliya',
                            },
                            bentotaToMinneriya: {
                                title: 'Bentota do Národního parku Minneriya',
                                description: 'Bentota -> Sigiriya -> Anuradhapura -> Polonnaruwa -> Národní park Minneriya',
                            },
                            bentotaToHortonPlains: {
                                title: 'Bentota do Hortonových plání',
                                description: 'Bentota -> Kandy -> Nuwara Eliya -> Hortonovy pláně',
                            },
                            images: {
                                bentotaToElla1: 'Pohled na pláž Bentota 1',
                                bentotaToElla2: 'Pohled na pláž Bentota 2',
                            },
                        },
                        airportExcursions: {
                            title: 'Výlety z letiště',
                            airportToColombo: {
                                title: 'Letiště na prohlídku města Kolombo',
                                description: 'Letiště -> Pevnost Kolombo -> Galle Face -> Chrám Gangaramaya',
                                alt1: 'Obrázek prohlídky města Kolombo 1',
                                alt2: 'Obrázek prohlídky města Kolombo 2',
                            },
                            airportToSigiriya: {
                                title: 'Letiště do Sigiriye',
                                description: 'Letiště -> Dambulla -> Skalní pevnost Sigiriya',
                                alt1: 'Obrázek výletu do Sigiriye 1',
                                alt2: 'Obrázek výletu do Sigiriye 2',
                            },
                            airportToKandy: {
                                title: 'Letiště do Kandy',
                                description: 'Letiště -> Sloní sirotčinec Pinnawala -> Chrám Buddhova zubu v Kandy',
                                alt1: 'Obrázek výletu do Kandy 1',
                                alt2: 'Obrázek výletu do Kandy 2',
                            },
                            airportToGalle: {
                                title: 'Letiště do Galle',
                                description: 'Letiště -> Bentota -> Pevnost Galle -> Pláž Unawatuna',
                                alt1: 'Obrázek výletu do Galle 1',
                                alt2: 'Obrázek výletu do Galle 2',
                            },
                        },
                    },
                    sriLankaSection: {
                        discoverSriLanka: 'Objevte Srí Lanku',
                        mainImageAlt: 'Srí Lanka',
                        pearlOfIndianOcean: 'Perla Indického oceánu',
                        introParagraph1: 'Srí Lanka, láskyplně nazývána „{{pearl}}“, je ohromující ostrovní ráj proslulý svými dechberoucími scenériemi, hlubokými tradicemi a pestrou kulturou.',
                        introParagraph2: 'S civilizací starší než 2 500 let je Srí Lanka domovem majestátních starověkých hlavních měst, posvátných náboženských památek a míst světového dědictví UNESCO. Její kulturní gobelín obohacují indické, arabské, portugalské, nizozemské a britské vlivy, které nabízejí fascinující cestu časem.',
                        introParagraph3: 'Krajina ostrova je mimořádná – od zlatých písečných pláží a rozlehlých čajových plantáží až po mlžné horské vrcholy. Přírodní rezervace ukrývají slony, leopardy a pestrý ptačí život, což je sen pro milovníky přírody.',
                        introParagraph4: 'Pro dobrodruhy nabízí Srí Lanka surfování, trekking, šnorchlování a potápění. Kuchyně, prodchnutá aromatickým kořením, čerstvými mořskými plody a tropickým ovocem, je výrazná a chutná, vypráví příběh bohatého kulinářského dědictví ostrova.',
                        introParagraph5: 'Ať už procházíte starobylými ruinami, odpočíváte na klidných plážích nebo si užíváte vřelé pohostinnosti, Srí Lanka nabízí nezapomenutelný cestovatelský zážitek.',
                        attractivePlaces: 'Atraktivní místa na Srí Lance',
                        viewMore: 'Zobrazit více',
                        placeImageAlt: 'Obrázek {{name}} {{index}}',
                        fullImagePreviewAlt: 'Náhled v plné velikosti',
                        famousThingsTitle: 'Známé věci na Srí Lance',
                        places: {
                            sigiriyaRockFortress: {
                                name: 'Skalní pevnost Sigiriya',
                                description: 'Skalní pevnost Sigiriya je místem světového dědictví UNESCO a jedním z nejikoničtějších památek Srí Lanky. Nabízí starověké zahrady, fresky a úchvatné výhledy z vrcholu skály.',
                            },
                            templeOfTheTooth: {
                                name: 'Chrám Buddhova zubu',
                                description: 'Chrám posvátné relikvie zubu v Kandy je posvátné buddhistické místo, které ukrývá relikvii Buddhova zubu. Návštěvníci mohou zažít jeho historický a náboženský význam.',
                            },
                            ella: {
                                name: 'Ella',
                                description: 'Ella je malé město v horské oblasti Srí Lanky, obklopené čajovými plantážemi a vodopády. Je proslulé mostem Devíti oblouků a Malým Adamovým vrchem.',
                            },
                            yalaNationalPark: {
                                name: 'Národní park Yala',
                                description: 'Národní park Yala je známý svou bohatou divokou přírodou, včetně slonů, leopardů a četných druhů ptáků. Safari zde je nezbytností pro milovníky přírody.',
                            },
                            galleFort: {
                                name: 'Pevnost Galle',
                                description: 'Pevnost Galle, vybudovaná Portugalci a opevněná Nizozemci, je historické místo s dlážděnými uličkami, koloniální architekturou a živými kavárnami.',
                            },
                            nuwaraEliya: {
                                name: 'Nuwara Eliya',
                                description: 'Známá jako „Malá Anglie“, Nuwara Eliya je horská stanice proslulá chladným klimatem, čajovými plantážemi a koloniálními bungalovy.',
                            },
                            adamsPeak: {
                                name: 'Adamův vrch',
                                description: 'Adamův vrch je posvátná hora s jedinečným otiskem na vrcholu. Je oblíbeným poutním místem pro více náboženství.',
                            },
                            hortonPlains: {
                                name: 'Hortonovy pláně',
                                description: 'Národní park Hortonovy pláně nabízí zvlněné kopce, vodopády a slavný vyhlídkový bod Světový konec.',
                            },
                            bentotaBeach: {
                                name: 'Pláž Bentota',
                                description: 'Pláž Bentota je nedotčená pobřežní destinace známá svými zlatými písky, vodními sporty a luxusními resorty.',
                            },
                            jaffna: {
                                name: 'Jaffna',
                                description: 'Jaffna v severní oblasti Srí Lanky je bohatá na tamilskou kulturu, historická místa a vynikající kuchyni.',
                            },
                            anuradhapura: {
                                name: 'Anuradhapura',
                                description: 'Anuradhapura je starověké město známé svými posvátnými buddhistickými místy a historickými ruinami, včetně stromu Srí Maha Bodhi.',
                            },
                            polonnaruwa: {
                                name: 'Polonnaruwa',
                                description: 'Polonnaruwa je místem světového dědictví UNESCO s starověkými chrámy, sochami a krásně zachovalými ruinami.',
                            },
                            unawatunaBeach: {
                                name: 'Pláž Unawatuna',
                                description: 'Pláž Unawatuna je živá pobřežní destinace nabízející šnorchlování, opalování a rušný noční život.',
                            },
                            colomboCity: {
                                name: 'Město Kolombo',
                                description: 'Kolombo je rušné hlavní město Srí Lanky, které kombinuje moderní mrakodrapy s koloniální architekturou a živými trhy.',
                            },
                            udawalawaNationalPark: {
                                name: 'Národní park Udawalawa',
                                description: 'Národní park Udawalawa je útočištěm divoké přírody proslulé velkými stády slonů, různými druhy ptáků a ohromujícími krajinami, což z něj činí nezbytnou destinaci pro milovníky přírody.',
                            },
                            dambullaCaveTemple: {
                                name: 'Jeskyňní chrám Dambulla',
                                description: 'Jeskyňní chrám Dambulla je místem světového dědictví UNESCO s starověkými buddhistickými freskami a sochami v jeskyních.',
                            },
                        },
                        famousThings: {
                            ceylonTea: {
                                title: 'CeJlonský čaj',
                                description: 'Srí Lanka je celosvětově proslulá svým cejlonským čajem, známým pro svou výraznou chuť a kvalitu. Čaj z oblastí Nuwara Eliya, Uva a Dimbula je obzvláště slavný.',
                            },
                            spices: {
                                title: 'Koření',
                                description: 'Srí Lanka je po staletí centrem koření, jako je skořice, kardamom, hřebíček a muškátový oříšek. Srílanská skořice je považována za nejlepší na světě.',
                            },
                            gems: {
                                title: 'Drahokamy a šperky',
                                description: 'Známá jako „Ostrov drahokamů“, Srí Lanka je proslulá svými safíry, rubíny a měsíčními kameny. „Modrá kráska Asie“, jeden z největších modrých safírů, byl objeven zde.',
                            },
                            ayurveda: {
                                title: 'Ájurvéda',
                                description: 'Srí Lanka je známá svou ájurvédskou medicínou a wellness procedurami. Oblíbené nabídky zahrnují masáže, bylinné terapie a ájurvédské resorty.',
                            },
                            handicrafts: {
                                title: 'Tradiční řemesla',
                                description: 'Srí Lanka vyrábí nádherná řemesla, včetně masek z Ambalangody, batikovaných textilií, dřevěných vyřezávaných předmětů a lakovaného zboží.',
                            },
                            elephants: {
                                title: 'Sloni',
                                description: 'Srílanští sloni hrají významnou roli v kultuře a festivalech. Sloni zdobení velkolepými kostýmy se objevují v průvodech, jako je Esala Perahera.',
                            },
                            food: {
                                title: 'Tradiční jídlo',
                                description: 'Srí Lanka je proslulá svou chutnou kuchyní, včetně rýže s kari, hopperů, kottu roti, pol sambol a wattalappam.',
                            },
                            festivals: {
                                title: 'Festivaly',
                                description: 'Srí Lanka slaví barevné festivaly, jako je Esala Perahera, Sinhálský a Tamilský Nový rok a Vesak, s osvětlenými dekoracemi a průvody.',
                            },
                            coconut: {
                                title: 'Kokosové produkty',
                                description: 'Srí Lanka je známá kokosovými produkty, jako je kokosový olej, mléko a kokosové vlákno používané na lana a rohože.',
                            },
                            sarees: {
                                title: 'Srílanské sárí',
                                description: 'Kandyjské sárí (Osariya) je tradiční ženský oděv známý svou elegancí a jedinečným stylem nošení při slavnostních příležitostech.',
                            },
                            dances: {
                                title: 'Tradiční tance',
                                description: 'Tradiční tance Srí Lanky zahrnují kandyjský tanec, ďábelské tance a tance nížinné oblasti, inspirované přírodou a folklórem.',
                            },
                            stiltFishing: {
                                title: 'Chůdové rybaření',
                                description: 'Ikoničtější pohled na Srí Lance, chůdové rybaření zahrnuje rybáře balancující na kůlech zapíchnutých do moře, jedinečné pro jižní pobřežní oblasti.',
                            },
                            moonstones: {
                                title: 'Měsíční kameny',
                                description: 'Srí Lanka je proslulá svými měsíčními kameny, považovanými za polodrahokamy. Doly na měsíční kameny v Meetiyagoda jsou obzvláště známé.',
                            },
                            cricket: {
                                title: 'Srílanský kriket',
                                description: 'Kriket je vášní Srílančanů, země je známá produkcí světových hráčů. Srí Lanka vyhrála Světový pohár v kriketu ICC v roce 1996.',
                            },
                            herbs: {
                                title: 'Ájurvédské byliny a koření',
                                description: 'Ostrov produkuje bylinné léky používané v ájurvédě, jako je gotu kola, skořice a neem.',
                            },
                            masks: {
                                title: 'Masky',
                                description: 'Tradiční srílanské masky z Ambalangody jsou používány v kulturních vystoupeních, včetně masek Yaksha (ďábelských) a Kolam masek.',
                            },
                        },
                    },
                    homeSection: {
                        whyChooseUs: {
                            title: 'Proč si vybrat Ashan Tours Sri Lanka',
                            specialist: {
                                title: 'Cestovní odbornost',
                                description: 'Náš tým v Ashan Tours Sri Lanka tvoří zkušení cestovní odborníci, kteří vytvářejí cesty na míru podle vašich přání.'
                            },
                            experience: {
                                title: 'Nezapomenutelné zážitky',
                                description: 'Vytváříme nezapomenutelné chvíle tím, že s vášní představujeme bohatou kulturu, historii a přírodní krásy Srí Lanky.'
                            },
                            priceMatch: {
                                title: 'Konkurenční ceny',
                                description: 'Ashan Tours Sri Lanka zaručuje nejlepší hodnotu za vaše cestování a nabízí kvalitní zážitky za dostupné ceny.'
                            },
                            support: {
                                title: 'Specializovaná podpora',
                                description: 'Náš tým zákaznické podpory je k dispozici 24/7, aby vám pomohl na každém kroku a zajistil plynulý cestovní zážitek.'
                            }
                        },
                        welcome: {
                            title: 'Vítejte u Ashan Tours Sri Lanka',
                            imageAlt: 'Uvítací obrázek Ashan Tours Sri Lanka',
                            description1: 'Vydejte se na výjimečnou cestu s Ashan Tours Sri Lanka, vaším hlavním průvodcem po divu tohoto ostrovního ráje.',
                            description2: 'Objevte živou kulturu, dechberoucí krajiny a skryté poklady Srí Lanky s našimi pečlivě sestavenými zájezdy.',
                            description3: 'Od nedotčených pláží po starověké ruiny, naše itineráře jsou navrženy tak, aby vás ponořily do srdce krásy Srí Lanky.',
                            description4: 'Náš oddaný tým zajišťuje personalizovanou službu, díky čemuž je váš cestovní zážitek plynulý a nezapomenutelný.',
                            description5: 'Připojte se k Ashan Tours Sri Lanka a nechte se vést dobrodružstvím plným objevů a radosti.'
                        },
                        cinnamonLuxuryVilla: {
                            title: 'Luxusní vila Cinnamon',
                            imageAlt: 'Obrázek luxusní vily Cinnamon',
                            description1: 'Zažijte bezkonkurenční pohodlí v luxusní vile Cinnamon od Ashan Tours Sri Lanka, která nabízí prvotřídní ubytování v klidném prostředí.',
                            description2: 'Naše exkluzivní vily jsou vybaveny moderními vymoženostmi, jako je klimatizace, luxusní postele a plně vybavené kuchyně, ideální pro relaxační pobyt.',
                            readMore: 'Přečtěte si více'
                        },
                        tourPackages: {
                            title: 'Naše cestovní balíčky',
                            ella: {
                                title: 'Dobrodružství v Elle',
                                subtitle: '3 dny / 2 noci',
                                description: 'Prozkoumejte malebnou krásu Elly s Ashan Tours Sri Lanka, včetně návštěv Mostu devíti oblouků a Malého Adamova vrchu.',
                                alt: 'Obrázek zájezdu do Elly'
                            },
                            ellaNuwaraKandy: {
                                title: 'Ella, Nuwara Eliya a Kandy',
                                subtitle: '5 dní / 4 noci',
                                description: 'Kulturní cesta přes Ellu, Nuwara Eliya a Kandy s čajovými plantážemi a historickými chrámy.',
                                alt: 'Obrázek zájezdu do Elly, Nuwara Eliya a Kandy'
                            },
                            kandyNuwaraEllaYala: {
                                title: 'Kandy, Nuwara Eliya, Ella a Yala',
                                subtitle: '7 dní / 6 nocí',
                                description: 'Komplexní zájezd zahrnující dědictví Kandy, čajové plantáže Nuwara Eliya, krajiny Elly a divokou přírodu Yaly.',
                                alt: 'Obrázek zájezdu do Kandy, Nuwara Eliya, Elly a Yaly'
                            },
                            viewMore: 'Zobrazit další zájezdy'
                        },
                        popularExcursions: {
                            title: 'Populární výlety',
                            oneDay: {
                                title: 'Jednodenní výlet',
                                alt: 'Obrázek jednodenního výletu'
                            },
                            twoDays: {
                                title: 'Dvoudenní výlet',
                                alt: 'Obrázek dvoudenního výletu'
                            },
                            threeDays: {
                                title: 'Třídenní výlet',
                                alt: 'Obrázek třídenního výletu'
                            },
                            fourDays: {
                                title: 'Čtyřdenní výlet',
                                alt: 'Obrázek čtyřdenního výletu'
                            },
                            viewMore: 'Zobrazit další výlety'
                        },
                        contactUs: {
                            title: 'Kontaktujte Ashan Tours Sri Lanka',
                            description: 'Jste připraveni objevovat Srí Lanku? Kontaktujte Ashan Tours Sri Lanka a naplánujte si svou vysněnou dovolenou ještě dnes!',
                            button: 'Spojte se s námi'
                        },
                        gallery: {
                            title: 'Naše galerie',
                            modalAlt: 'Obrázek galerie',
                            filters: {
                                all: 'Vše',
                                tours: 'Zájezdy',
                                accommodation: 'Ubytování',
                                transportation: 'Doprava',
                                wildlife: 'Divoká příroda'
                            },
                            tours: {
                                sigiriya2: 'Obrázek Sigiriya 2',
                                sigiriya3: 'Obrázek Sigiriya 3',
                                kandy2: 'Obrázek Kandy 2',
                                kandy3: 'Obrázek Kandy 3',
                                galle2: 'Obrázek Galle 2',
                                galle3: 'Obrázek Galle 3',
                                ella2: 'Obrázek Ella 2',
                                ella3: 'Obrázek Ella 3',
                                colomboCity: 'Obrázek města Colombo'
                            },
                            accommodation: {
                                nuwaraEliya1: 'Obrázek ubytování Nuwara Eliya 1',
                                nuwaraEliya2: 'Obrázek ubytování Nuwara Eliya 2',
                                nuwaraEliya3: 'Obrázek ubytování Nuwara Eliya 3',
                                nuwaraEliya4: 'Obrázek ubytování Nuwara Eliya 4'
                            },
                            transportation: {
                                bentotaRiverSafari1: 'Obrázek safari na řece Bentota 1',
                                bentotaRiverSafari2: 'Obrázek safari na řece Bentota 2'
                            },
                            wildlife: {
                                yalaSafari1: 'Obrázek safari Yala 1',
                                yalaSafari2: 'Obrázek safari Yala 2',
                                minneriya1: 'Obrázek Minneriya 1',
                                minneriya2: 'Obrázek Minneriya 2',
                                udawalawaSafari1: 'Obrázek safari Udawalawa 1',
                                udawalawaSafari2: 'Obrázek safari Udawalawa 2'
                            },
                        },
                    },
                },
            },

        },
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        debug: true,
    })
    .catch((error) => {
        console.error('i18next initialization failed:', error);
    });

export default i18n;